(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6a47"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6a47"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4w9fm", function(module, exports) {

var $3J8Kb = parcelRequire("3J8Kb");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $3J8Kb._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)["catch"](function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        char: true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var _final = jQuery.cssProps[name] || vendorProps[name];
        if (_final) return _final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s["throws"]) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("3J8Kb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b6c5b70e8ae252c$export$5f0017c582d45a2d; });
function $2b6c5b70e8ae252c$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("d5T4O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $9886770c6a2c3c2e$export$2e2bcd8739ae039; });
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $9886770c6a2c3c2e$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $9886770c6a2c3c2e$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($9886770c6a2c3c2e$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $9886770c6a2c3c2e$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $9886770c6a2c3c2e$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $9886770c6a2c3c2e$var$timeoutDuration);
        }
    };
}
var $9886770c6a2c3c2e$var$supportsMicroTasks = $9886770c6a2c3c2e$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $9886770c6a2c3c2e$var$debounce = $9886770c6a2c3c2e$var$supportsMicroTasks ? $9886770c6a2c3c2e$var$microtaskDebounce : $9886770c6a2c3c2e$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $9886770c6a2c3c2e$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $9886770c6a2c3c2e$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var _$window = element.ownerDocument.defaultView;
    var css = _$window.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $9886770c6a2c3c2e$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $9886770c6a2c3c2e$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $9886770c6a2c3c2e$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $9886770c6a2c3c2e$var$getScrollParent($9886770c6a2c3c2e$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $9886770c6a2c3c2e$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $9886770c6a2c3c2e$var$isIE11 = $9886770c6a2c3c2e$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $9886770c6a2c3c2e$var$isIE10 = $9886770c6a2c3c2e$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $9886770c6a2c3c2e$var$isIE(version) {
    if (version === 11) return $9886770c6a2c3c2e$var$isIE11;
    if (version === 10) return $9886770c6a2c3c2e$var$isIE10;
    return $9886770c6a2c3c2e$var$isIE11 || $9886770c6a2c3c2e$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $9886770c6a2c3c2e$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $9886770c6a2c3c2e$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $9886770c6a2c3c2e$var$getStyleComputedProperty(offsetParent, "position") === "static") return $9886770c6a2c3c2e$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $9886770c6a2c3c2e$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $9886770c6a2c3c2e$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $9886770c6a2c3c2e$var$getRoot(node) {
    if (node.parentNode !== null) return $9886770c6a2c3c2e$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $9886770c6a2c3c2e$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($9886770c6a2c3c2e$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $9886770c6a2c3c2e$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $9886770c6a2c3c2e$var$getRoot(element1);
    if (element1root.host) return $9886770c6a2c3c2e$var$findCommonOffsetParent(element1root.host, element2);
    else return $9886770c6a2c3c2e$var$findCommonOffsetParent(element1, $9886770c6a2c3c2e$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $9886770c6a2c3c2e$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $9886770c6a2c3c2e$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $9886770c6a2c3c2e$var$getScroll(element, "top");
    var scrollLeft = $9886770c6a2c3c2e$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $9886770c6a2c3c2e$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $9886770c6a2c3c2e$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $9886770c6a2c3c2e$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $9886770c6a2c3c2e$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $9886770c6a2c3c2e$var$isIE(10) && getComputedStyle(html);
    return {
        height: $9886770c6a2c3c2e$var$getSize("Height", body, html, computedStyle),
        width: $9886770c6a2c3c2e$var$getSize("Width", body, html, computedStyle)
    };
}
var $9886770c6a2c3c2e$var$classCallCheck = function classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $9886770c6a2c3c2e$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $9886770c6a2c3c2e$var$defineProperty = function defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $9886770c6a2c3c2e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $9886770c6a2c3c2e$var$getClientRect(offsets) {
    return $9886770c6a2c3c2e$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $9886770c6a2c3c2e$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($9886770c6a2c3c2e$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $9886770c6a2c3c2e$var$getScroll(element, "top");
            var scrollLeft = $9886770c6a2c3c2e$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $9886770c6a2c3c2e$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $9886770c6a2c3c2e$var$getStyleComputedProperty(element);
        horizScrollbar -= $9886770c6a2c3c2e$var$getBordersSize(styles, "x");
        vertScrollbar -= $9886770c6a2c3c2e$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $9886770c6a2c3c2e$var$getClientRect(result);
}
function $9886770c6a2c3c2e$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $9886770c6a2c3c2e$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $9886770c6a2c3c2e$var$getBoundingClientRect(children);
    var parentRect = $9886770c6a2c3c2e$var$getBoundingClientRect(parent);
    var scrollParent = $9886770c6a2c3c2e$var$getScrollParent(children);
    var styles = $9886770c6a2c3c2e$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $9886770c6a2c3c2e$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $9886770c6a2c3c2e$var$includeScroll(offsets, parent);
    return offsets;
}
function $9886770c6a2c3c2e$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $9886770c6a2c3c2e$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $9886770c6a2c3c2e$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $9886770c6a2c3c2e$var$getScroll(html, "left") : 0;
    var _$offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $9886770c6a2c3c2e$var$getClientRect(_$offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $9886770c6a2c3c2e$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($9886770c6a2c3c2e$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $9886770c6a2c3c2e$var$getParentNode(element);
    if (!parentNode) return false;
    return $9886770c6a2c3c2e$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $9886770c6a2c3c2e$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $9886770c6a2c3c2e$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $9886770c6a2c3c2e$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $9886770c6a2c3c2e$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $9886770c6a2c3c2e$var$getFixedPositionOffsetParent(popper) : $9886770c6a2c3c2e$var$findCommonOffsetParent(popper, $9886770c6a2c3c2e$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $9886770c6a2c3c2e$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $9886770c6a2c3c2e$var$getScrollParent($9886770c6a2c3c2e$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $9886770c6a2c3c2e$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$9886770c6a2c3c2e$var$isFixed(offsetParent)) {
            var _getWindowSizes = $9886770c6a2c3c2e$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $9886770c6a2c3c2e$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $9886770c6a2c3c2e$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $9886770c6a2c3c2e$var$_extends({
            key: key
        }, rects[key], {
            area: $9886770c6a2c3c2e$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $9886770c6a2c3c2e$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $9886770c6a2c3c2e$var$getFixedPositionOffsetParent(popper) : $9886770c6a2c3c2e$var$findCommonOffsetParent(popper, $9886770c6a2c3c2e$var$getReferenceNode(reference));
    return $9886770c6a2c3c2e$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $9886770c6a2c3c2e$var$getOuterSizes(element) {
    var _$window = element.ownerDocument.defaultView;
    var styles = _$window.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $9886770c6a2c3c2e$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $9886770c6a2c3c2e$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $9886770c6a2c3c2e$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$9886770c6a2c3c2e$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $9886770c6a2c3c2e$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $9886770c6a2c3c2e$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $9886770c6a2c3c2e$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $9886770c6a2c3c2e$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $9886770c6a2c3c2e$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $9886770c6a2c3c2e$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $9886770c6a2c3c2e$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $9886770c6a2c3c2e$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $9886770c6a2c3c2e$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $9886770c6a2c3c2e$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $9886770c6a2c3c2e$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $9886770c6a2c3c2e$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $9886770c6a2c3c2e$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $9886770c6a2c3c2e$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $9886770c6a2c3c2e$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $9886770c6a2c3c2e$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($9886770c6a2c3c2e$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$9886770c6a2c3c2e$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $9886770c6a2c3c2e$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $9886770c6a2c3c2e$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $9886770c6a2c3c2e$var$attachToScrollParents($9886770c6a2c3c2e$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $9886770c6a2c3c2e$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $9886770c6a2c3c2e$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $9886770c6a2c3c2e$var$getScrollParent(reference);
    $9886770c6a2c3c2e$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $9886770c6a2c3c2e$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $9886770c6a2c3c2e$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $9886770c6a2c3c2e$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $9886770c6a2c3c2e$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $9886770c6a2c3c2e$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $9886770c6a2c3c2e$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $9886770c6a2c3c2e$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $9886770c6a2c3c2e$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $9886770c6a2c3c2e$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $9886770c6a2c3c2e$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $9886770c6a2c3c2e$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $9886770c6a2c3c2e$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $9886770c6a2c3c2e$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $9886770c6a2c3c2e$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $9886770c6a2c3c2e$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $9886770c6a2c3c2e$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $9886770c6a2c3c2e$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $9886770c6a2c3c2e$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $9886770c6a2c3c2e$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $9886770c6a2c3c2e$var$isFirefox = $9886770c6a2c3c2e$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $9886770c6a2c3c2e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $9886770c6a2c3c2e$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $9886770c6a2c3c2e$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $9886770c6a2c3c2e$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$9886770c6a2c3c2e$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $9886770c6a2c3c2e$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $9886770c6a2c3c2e$var$_extends({}, attributes, data.attributes);
    data.styles = $9886770c6a2c3c2e$var$_extends({}, styles, data.styles);
    data.arrowStyles = $9886770c6a2c3c2e$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $9886770c6a2c3c2e$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $9886770c6a2c3c2e$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$9886770c6a2c3c2e$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $9886770c6a2c3c2e$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $9886770c6a2c3c2e$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $9886770c6a2c3c2e$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $9886770c6a2c3c2e$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $9886770c6a2c3c2e$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $9886770c6a2c3c2e$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $9886770c6a2c3c2e$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $9886770c6a2c3c2e$var$validPlacements = $9886770c6a2c3c2e$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $9886770c6a2c3c2e$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $9886770c6a2c3c2e$var$validPlacements.indexOf(placement);
    var arr = $9886770c6a2c3c2e$var$validPlacements.slice(index + 1).concat($9886770c6a2c3c2e$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $9886770c6a2c3c2e$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($9886770c6a2c3c2e$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $9886770c6a2c3c2e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $9886770c6a2c3c2e$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $9886770c6a2c3c2e$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $9886770c6a2c3c2e$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $9886770c6a2c3c2e$var$clockwise(placement);
            break;
        case $9886770c6a2c3c2e$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $9886770c6a2c3c2e$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $9886770c6a2c3c2e$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $9886770c6a2c3c2e$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $9886770c6a2c3c2e$var$_extends({}, data.offsets.popper, $9886770c6a2c3c2e$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $9886770c6a2c3c2e$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $9886770c6a2c3c2e$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $9886770c6a2c3c2e$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $9886770c6a2c3c2e$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($9886770c6a2c3c2e$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $9886770c6a2c3c2e$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($9886770c6a2c3c2e$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$offset(data, _ref) {
    var _$offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($9886770c6a2c3c2e$var$isNumeric(+_$offset)) offsets = [
        +_$offset,
        0
    ];
    else offsets = $9886770c6a2c3c2e$var$parseOffset(_$offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $9886770c6a2c3c2e$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $9886770c6a2c3c2e$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $9886770c6a2c3c2e$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $9886770c6a2c3c2e$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $9886770c6a2c3c2e$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $9886770c6a2c3c2e$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $9886770c6a2c3c2e$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $9886770c6a2c3c2e$var$defineProperty({}, side, reference[side]),
            end: $9886770c6a2c3c2e$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $9886770c6a2c3c2e$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$hide(data) {
    if (!$9886770c6a2c3c2e$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $9886770c6a2c3c2e$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $9886770c6a2c3c2e$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $9886770c6a2c3c2e$var$getOppositePlacement(placement);
    data.offsets.popper = $9886770c6a2c3c2e$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $9886770c6a2c3c2e$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $9886770c6a2c3c2e$var$applyStyle,
        /** @prop {Function} */ onLoad: $9886770c6a2c3c2e$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $9886770c6a2c3c2e$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $9886770c6a2c3c2e$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $9886770c6a2c3c2e$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $9886770c6a2c3c2e$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $9886770c6a2c3c2e$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $9886770c6a2c3c2e$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($9886770c6a2c3c2e$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $9886770c6a2c3c2e$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $9886770c6a2c3c2e$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $9886770c6a2c3c2e$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $9886770c6a2c3c2e$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $9886770c6a2c3c2e$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $9886770c6a2c3c2e$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $9886770c6a2c3c2e$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $9886770c6a2c3c2e$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $9886770c6a2c3c2e$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$9886770c6a2c3c2e$var$Popper.placements = $9886770c6a2c3c2e$var$placements;
$9886770c6a2c3c2e$var$Popper.Defaults = $9886770c6a2c3c2e$var$Defaults;
var $9886770c6a2c3c2e$export$2e2bcd8739ae039 = $9886770c6a2c3c2e$var$Popper;

});


var $4w9fm = parcelRequire("4w9fm");
globalThis.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)));


parcelRequire("4w9fm");
var $f8fe9cf70f113cc7$exports = {};

var $3J8Kb = parcelRequire("3J8Kb");


/*!
  * Bootstrap v4.6.2 (https://getbootstrap.com/)
  * Copyright 2011-2022 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory($f8fe9cf70f113cc7$exports, (parcelRequire("4w9fm")), (parcelRequire("d5T4O")));
})(undefined, function(exports1, $, Popper) {
    "use strict";
    function _interopDefaultLegacy(e) {
        return e && typeof e === "object" && "default" in e ? e : {
            "default": e
        };
    }
    var $__default = /*#__PURE__*/ _interopDefaultLegacy($);
    var Popper__default = /*#__PURE__*/ _interopDefaultLegacy(Popper);
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _inheritsLoose(subClass, superClass) {
        subClass.prototype = Object.create(superClass.prototype);
        subClass.prototype.constructor = subClass;
        _setPrototypeOf(subClass, superClass);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): util.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Private TransitionEnd Helpers
   */ var TRANSITION_END = "transitionend";
    var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000; // Shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        if (obj === null || typeof obj === "undefined") return "" + obj;
        return ({}).toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: TRANSITION_END,
            delegateType: TRANSITION_END,
            handle: function handle(event) {
                if ($__default["default"](event.target).is(this)) return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
                return undefined;
            }
        };
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $__default["default"](this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        $__default["default"].fn.emulateTransitionEnd = transitionEndEmulator;
        $__default["default"].event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * Public Util API
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function getUID(prefix) {
            do // eslint-disable-next-line no-bitwise
            prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function getSelectorFromElement(element) {
            var selector = element.getAttribute("data-target");
            if (!selector || selector === "#") {
                var hrefAttr = element.getAttribute("href");
                selector = hrefAttr && hrefAttr !== "#" ? hrefAttr.trim() : "";
            }
            try {
                return document.querySelector(selector) ? selector : null;
            } catch (_) {
                return null;
            }
        },
        getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
            if (!element) return 0;
             // Get transition-duration of the element
            var transitionDuration = $__default["default"](element).css("transition-duration");
            var transitionDelay = $__default["default"](element).css("transition-delay");
            var floatTransitionDuration = parseFloat(transitionDuration);
            var floatTransitionDelay = parseFloat(transitionDelay); // Return 0 if element or transition duration is not found
            if (!floatTransitionDuration && !floatTransitionDelay) return 0;
             // If multiple durations are defined, take the first
            transitionDuration = transitionDuration.split(",")[0];
            transitionDelay = transitionDelay.split(",")[0];
            return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
        },
        reflow: function reflow(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function triggerTransitionEnd(element) {
            $__default["default"](element).trigger(TRANSITION_END);
        },
        supportsTransitionEnd: function supportsTransitionEnd() {
            return Boolean(TRANSITION_END);
        },
        isElement: function isElement(obj) {
            return (obj[0] || obj).nodeType;
        },
        typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
            for(var property in configTypes)if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && Util.isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error(componentName.toUpperCase() + ": " + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
            }
        },
        findShadowRoot: function findShadowRoot(element) {
            if (!document.documentElement.attachShadow) return null;
             // Can find the shadow root otherwise it'll return the document
            if (typeof element.getRootNode === "function") {
                var root = element.getRootNode();
                return root instanceof ShadowRoot ? root : null;
            }
            if (element instanceof ShadowRoot) return element;
             // when we don't find a shadow root
            if (!element.parentNode) return null;
            return Util.findShadowRoot(element.parentNode);
        },
        jQueryDetection: function jQueryDetection() {
            if (typeof $__default["default"] === "undefined") throw new TypeError("Bootstrap's JavaScript requires jQuery. jQuery must be included before Bootstrap's JavaScript.");
            var version = $__default["default"].fn.jquery.split(" ")[0].split(".");
            var minMajor = 1;
            var ltMajor = 2;
            var minMinor = 9;
            var minPatch = 1;
            var maxMajor = 4;
            if (version[0] < ltMajor && version[1] < minMinor || version[0] === minMajor && version[1] === minMinor && version[2] < minPatch || version[0] >= maxMajor) throw new Error("Bootstrap's JavaScript requires at least jQuery v1.9.1 but less than v4.0.0");
        }
    };
    Util.jQueryDetection();
    setTransitionEndSupport();
    /**
   * Constants
   */ var NAME$a = "alert";
    var VERSION$a = "4.6.2";
    var DATA_KEY$a = "bs.alert";
    var EVENT_KEY$a = "." + DATA_KEY$a;
    var DATA_API_KEY$7 = ".data-api";
    var JQUERY_NO_CONFLICT$a = $__default["default"].fn[NAME$a];
    var CLASS_NAME_ALERT = "alert";
    var CLASS_NAME_FADE$5 = "fade";
    var CLASS_NAME_SHOW$7 = "show";
    var EVENT_CLOSE = "close" + EVENT_KEY$a;
    var EVENT_CLOSED = "closed" + EVENT_KEY$a;
    var EVENT_CLICK_DATA_API$6 = "click" + EVENT_KEY$a + DATA_API_KEY$7;
    var SELECTOR_DISMISS = '[data-dismiss="alert"]';
    /**
   * Class definition
   */ var Alert = /*#__PURE__*/ function() {
        function Alert(element) {
            this._element = element;
        } // Getters
        var _proto = Alert.prototype;
        // Public
        _proto.close = function close(element) {
            var rootElement = this._element;
            if (element) rootElement = this._getRootElement(element);
            var customEvent = this._triggerCloseEvent(rootElement);
            if (customEvent.isDefaultPrevented()) return;
            this._removeElement(rootElement);
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$a);
            this._element = null;
        } // Private
        ;
        _proto._getRootElement = function _getRootElement(element) {
            var selector = Util.getSelectorFromElement(element);
            var parent = false;
            if (selector) parent = document.querySelector(selector);
            if (!parent) parent = $__default["default"](element).closest("." + CLASS_NAME_ALERT)[0];
            return parent;
        };
        _proto._triggerCloseEvent = function _triggerCloseEvent(element) {
            var closeEvent = $__default["default"].Event(EVENT_CLOSE);
            $__default["default"](element).trigger(closeEvent);
            return closeEvent;
        };
        _proto._removeElement = function _removeElement(element) {
            var _this = this;
            $__default["default"](element).removeClass(CLASS_NAME_SHOW$7);
            if (!$__default["default"](element).hasClass(CLASS_NAME_FADE$5)) {
                this._destroyElement(element);
                return;
            }
            var transitionDuration = Util.getTransitionDurationFromElement(element);
            $__default["default"](element).one(Util.TRANSITION_END, function(event) {
                return _this._destroyElement(element, event);
            }).emulateTransitionEnd(transitionDuration);
        };
        _proto._destroyElement = function _destroyElement(element) {
            $__default["default"](element).detach().trigger(EVENT_CLOSED).remove();
        } // Static
        ;
        Alert._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$a);
                if (!data) {
                    data = new Alert(this);
                    $element.data(DATA_KEY$a, data);
                }
                if (config === "close") data[config](this);
            });
        };
        Alert._handleDismiss = function _handleDismiss(alertInstance) {
            return function(event) {
                if (event) event.preventDefault();
                alertInstance.close(this);
            };
        };
        _createClass(Alert, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$a;
                }
            }
        ]);
        return Alert;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$6, SELECTOR_DISMISS, Alert._handleDismiss(new Alert()));
    /**
   * jQuery
   */ $__default["default"].fn[NAME$a] = Alert._jQueryInterface;
    $__default["default"].fn[NAME$a].Constructor = Alert;
    $__default["default"].fn[NAME$a].noConflict = function() {
        $__default["default"].fn[NAME$a] = JQUERY_NO_CONFLICT$a;
        return Alert._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$9 = "button";
    var VERSION$9 = "4.6.2";
    var DATA_KEY$9 = "bs.button";
    var EVENT_KEY$9 = "." + DATA_KEY$9;
    var DATA_API_KEY$6 = ".data-api";
    var JQUERY_NO_CONFLICT$9 = $__default["default"].fn[NAME$9];
    var CLASS_NAME_ACTIVE$3 = "active";
    var CLASS_NAME_BUTTON = "btn";
    var CLASS_NAME_FOCUS = "focus";
    var EVENT_CLICK_DATA_API$5 = "click" + EVENT_KEY$9 + DATA_API_KEY$6;
    var EVENT_FOCUS_BLUR_DATA_API = "focus" + EVENT_KEY$9 + DATA_API_KEY$6 + " " + ("blur" + EVENT_KEY$9 + DATA_API_KEY$6);
    var EVENT_LOAD_DATA_API$2 = "load" + EVENT_KEY$9 + DATA_API_KEY$6;
    var SELECTOR_DATA_TOGGLE_CARROT = '[data-toggle^="button"]';
    var SELECTOR_DATA_TOGGLES = '[data-toggle="buttons"]';
    var SELECTOR_DATA_TOGGLE$4 = '[data-toggle="button"]';
    var SELECTOR_DATA_TOGGLES_BUTTONS = '[data-toggle="buttons"] .btn';
    var SELECTOR_INPUT = 'input:not([type="hidden"])';
    var SELECTOR_ACTIVE$2 = ".active";
    var SELECTOR_BUTTON = ".btn";
    /**
   * Class definition
   */ var Button = /*#__PURE__*/ function() {
        function Button(element) {
            this._element = element;
            this.shouldAvoidTriggerChange = false;
        } // Getters
        var _proto = Button.prototype;
        // Public
        _proto.toggle = function toggle() {
            var triggerChangeEvent = true;
            var addAriaPressed = true;
            var rootElement = $__default["default"](this._element).closest(SELECTOR_DATA_TOGGLES)[0];
            if (rootElement) {
                var input = this._element.querySelector(SELECTOR_INPUT);
                if (input) {
                    if (input.type === "radio") {
                        if (input.checked && this._element.classList.contains(CLASS_NAME_ACTIVE$3)) triggerChangeEvent = false;
                        else {
                            var activeElement = rootElement.querySelector(SELECTOR_ACTIVE$2);
                            if (activeElement) $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$3);
                        }
                    }
                    if (triggerChangeEvent) {
                        // if it's not a radio button or checkbox don't add a pointless/invalid checked property to the input
                        if (input.type === "checkbox" || input.type === "radio") input.checked = !this._element.classList.contains(CLASS_NAME_ACTIVE$3);
                        if (!this.shouldAvoidTriggerChange) $__default["default"](input).trigger("change");
                    }
                    input.focus();
                    addAriaPressed = false;
                }
            }
            if (!(this._element.hasAttribute("disabled") || this._element.classList.contains("disabled"))) {
                if (addAriaPressed) this._element.setAttribute("aria-pressed", !this._element.classList.contains(CLASS_NAME_ACTIVE$3));
                if (triggerChangeEvent) $__default["default"](this._element).toggleClass(CLASS_NAME_ACTIVE$3);
            }
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$9);
            this._element = null;
        } // Static
        ;
        Button._jQueryInterface = function _jQueryInterface(config, avoidTriggerChange) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$9);
                if (!data) {
                    data = new Button(this);
                    $element.data(DATA_KEY$9, data);
                }
                data.shouldAvoidTriggerChange = avoidTriggerChange;
                if (config === "toggle") data[config]();
            });
        };
        _createClass(Button, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$9;
                }
            }
        ]);
        return Button;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$5, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = event.target;
        var initialButton = button;
        if (!$__default["default"](button).hasClass(CLASS_NAME_BUTTON)) button = $__default["default"](button).closest(SELECTOR_BUTTON)[0];
        if (!button || button.hasAttribute("disabled") || button.classList.contains("disabled")) event.preventDefault(); // work around Firefox bug #1540995
        else {
            var inputBtn = button.querySelector(SELECTOR_INPUT);
            if (inputBtn && (inputBtn.hasAttribute("disabled") || inputBtn.classList.contains("disabled"))) {
                event.preventDefault(); // work around Firefox bug #1540995
                return;
            }
            if (initialButton.tagName === "INPUT" || button.tagName !== "LABEL") Button._jQueryInterface.call($__default["default"](button), "toggle", initialButton.tagName === "INPUT");
        }
    }).on(EVENT_FOCUS_BLUR_DATA_API, SELECTOR_DATA_TOGGLE_CARROT, function(event) {
        var button = $__default["default"](event.target).closest(SELECTOR_BUTTON)[0];
        $__default["default"](button).toggleClass(CLASS_NAME_FOCUS, /^focus(in)?$/.test(event.type));
    });
    $__default["default"](window).on(EVENT_LOAD_DATA_API$2, function() {
        // ensure correct active class is set to match the controls' actual values/states
        // find all checkboxes/readio buttons inside data-toggle groups
        var buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLES_BUTTONS));
        for(var i = 0, len = buttons.length; i < len; i++){
            var button = buttons[i];
            var input = button.querySelector(SELECTOR_INPUT);
            if (input.checked || input.hasAttribute("checked")) button.classList.add(CLASS_NAME_ACTIVE$3);
            else button.classList.remove(CLASS_NAME_ACTIVE$3);
        } // find all button toggles
        buttons = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$4));
        for(var _i = 0, _len = buttons.length; _i < _len; _i++){
            var _button = buttons[_i];
            if (_button.getAttribute("aria-pressed") === "true") _button.classList.add(CLASS_NAME_ACTIVE$3);
            else _button.classList.remove(CLASS_NAME_ACTIVE$3);
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$9] = Button._jQueryInterface;
    $__default["default"].fn[NAME$9].Constructor = Button;
    $__default["default"].fn[NAME$9].noConflict = function() {
        $__default["default"].fn[NAME$9] = JQUERY_NO_CONFLICT$9;
        return Button._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$8 = "carousel";
    var VERSION$8 = "4.6.2";
    var DATA_KEY$8 = "bs.carousel";
    var EVENT_KEY$8 = "." + DATA_KEY$8;
    var DATA_API_KEY$5 = ".data-api";
    var JQUERY_NO_CONFLICT$8 = $__default["default"].fn[NAME$8];
    var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
    var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
    var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
    var SWIPE_THRESHOLD = 40;
    var CLASS_NAME_CAROUSEL = "carousel";
    var CLASS_NAME_ACTIVE$2 = "active";
    var CLASS_NAME_SLIDE = "slide";
    var CLASS_NAME_RIGHT = "carousel-item-right";
    var CLASS_NAME_LEFT = "carousel-item-left";
    var CLASS_NAME_NEXT = "carousel-item-next";
    var CLASS_NAME_PREV = "carousel-item-prev";
    var CLASS_NAME_POINTER_EVENT = "pointer-event";
    var DIRECTION_NEXT = "next";
    var DIRECTION_PREV = "prev";
    var DIRECTION_LEFT = "left";
    var DIRECTION_RIGHT = "right";
    var EVENT_SLIDE = "slide" + EVENT_KEY$8;
    var EVENT_SLID = "slid" + EVENT_KEY$8;
    var EVENT_KEYDOWN = "keydown" + EVENT_KEY$8;
    var EVENT_MOUSEENTER = "mouseenter" + EVENT_KEY$8;
    var EVENT_MOUSELEAVE = "mouseleave" + EVENT_KEY$8;
    var EVENT_TOUCHSTART = "touchstart" + EVENT_KEY$8;
    var EVENT_TOUCHMOVE = "touchmove" + EVENT_KEY$8;
    var EVENT_TOUCHEND = "touchend" + EVENT_KEY$8;
    var EVENT_POINTERDOWN = "pointerdown" + EVENT_KEY$8;
    var EVENT_POINTERUP = "pointerup" + EVENT_KEY$8;
    var EVENT_DRAG_START = "dragstart" + EVENT_KEY$8;
    var EVENT_LOAD_DATA_API$1 = "load" + EVENT_KEY$8 + DATA_API_KEY$5;
    var EVENT_CLICK_DATA_API$4 = "click" + EVENT_KEY$8 + DATA_API_KEY$5;
    var SELECTOR_ACTIVE$1 = ".active";
    var SELECTOR_ACTIVE_ITEM = ".active.carousel-item";
    var SELECTOR_ITEM = ".carousel-item";
    var SELECTOR_ITEM_IMG = ".carousel-item img";
    var SELECTOR_NEXT_PREV = ".carousel-item-next, .carousel-item-prev";
    var SELECTOR_INDICATORS = ".carousel-indicators";
    var SELECTOR_DATA_SLIDE = "[data-slide], [data-slide-to]";
    var SELECTOR_DATA_RIDE = '[data-ride="carousel"]';
    var Default$7 = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: "hover",
        wrap: true,
        touch: true
    };
    var DefaultType$7 = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean"
    };
    var PointerType = {
        TOUCH: "touch",
        PEN: "pen"
    };
    /**
   * Class definition
   */ var Carousel = /*#__PURE__*/ function() {
        function Carousel(element, config) {
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this.touchTimeout = null;
            this.touchStartX = 0;
            this.touchDeltaX = 0;
            this._config = this._getConfig(config);
            this._element = element;
            this._indicatorsElement = this._element.querySelector(SELECTOR_INDICATORS);
            this._touchSupported = "ontouchstart" in document.documentElement || navigator.maxTouchPoints > 0;
            this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);
            this._addEventListeners();
        } // Getters
        var _proto = Carousel.prototype;
        // Public
        _proto.next = function next() {
            if (!this._isSliding) this._slide(DIRECTION_NEXT);
        };
        _proto.nextWhenVisible = function nextWhenVisible() {
            var $element = $__default["default"](this._element); // Don't call next when the page isn't visible
            // or the carousel or its parent isn't visible
            if (!document.hidden && $element.is(":visible") && $element.css("visibility") !== "hidden") this.next();
        };
        _proto.prev = function prev() {
            if (!this._isSliding) this._slide(DIRECTION_PREV);
        };
        _proto.pause = function pause(event) {
            if (!event) this._isPaused = true;
            if (this._element.querySelector(SELECTOR_NEXT_PREV)) {
                Util.triggerTransitionEnd(this._element);
                this.cycle(true);
            }
            clearInterval(this._interval);
            this._interval = null;
        };
        _proto.cycle = function cycle(event) {
            if (!event) this._isPaused = false;
            if (this._interval) {
                clearInterval(this._interval);
                this._interval = null;
            }
            if (this._config.interval && !this._isPaused) {
                this._updateInterval();
                this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
            }
        };
        _proto.to = function to(index) {
            var _this = this;
            this._activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeIndex = this._getItemIndex(this._activeElement);
            if (index > this._items.length - 1 || index < 0) return;
            if (this._isSliding) {
                $__default["default"](this._element).one(EVENT_SLID, function() {
                    return _this.to(index);
                });
                return;
            }
            if (activeIndex === index) {
                this.pause();
                this.cycle();
                return;
            }
            var direction = index > activeIndex ? DIRECTION_NEXT : DIRECTION_PREV;
            this._slide(direction, this._items[index]);
        };
        _proto.dispose = function dispose() {
            $__default["default"](this._element).off(EVENT_KEY$8);
            $__default["default"].removeData(this._element, DATA_KEY$8);
            this._items = null;
            this._config = null;
            this._element = null;
            this._interval = null;
            this._isPaused = null;
            this._isSliding = null;
            this._activeElement = null;
            this._indicatorsElement = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$7, config);
            Util.typeCheckConfig(NAME$8, config, DefaultType$7);
            return config;
        };
        _proto._handleSwipe = function _handleSwipe() {
            var absDeltax = Math.abs(this.touchDeltaX);
            if (absDeltax <= SWIPE_THRESHOLD) return;
            var direction = absDeltax / this.touchDeltaX;
            this.touchDeltaX = 0; // swipe left
            if (direction > 0) this.prev();
             // swipe right
            if (direction < 0) this.next();
        };
        _proto._addEventListeners = function _addEventListeners() {
            var _this2 = this;
            if (this._config.keyboard) $__default["default"](this._element).on(EVENT_KEYDOWN, function(event) {
                return _this2._keydown(event);
            });
            if (this._config.pause === "hover") $__default["default"](this._element).on(EVENT_MOUSEENTER, function(event) {
                return _this2.pause(event);
            }).on(EVENT_MOUSELEAVE, function(event) {
                return _this2.cycle(event);
            });
            if (this._config.touch) this._addTouchEventListeners();
        };
        _proto._addTouchEventListeners = function _addTouchEventListeners() {
            var _this3 = this;
            if (!this._touchSupported) return;
            var start = function start(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchStartX = event.originalEvent.clientX;
                else if (!_this3._pointerEvent) _this3.touchStartX = event.originalEvent.touches[0].clientX;
            };
            var move = function move(event) {
                // ensure swiping with one touch and not pinching
                _this3.touchDeltaX = event.originalEvent.touches && event.originalEvent.touches.length > 1 ? 0 : event.originalEvent.touches[0].clientX - _this3.touchStartX;
            };
            var end = function end(event) {
                if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
                _this3._handleSwipe();
                if (_this3._config.pause === "hover") {
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this3.pause();
                    if (_this3.touchTimeout) clearTimeout(_this3.touchTimeout);
                    _this3.touchTimeout = setTimeout(function(event) {
                        return _this3.cycle(event);
                    }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
                }
            };
            $__default["default"](this._element.querySelectorAll(SELECTOR_ITEM_IMG)).on(EVENT_DRAG_START, function(e) {
                return e.preventDefault();
            });
            if (this._pointerEvent) {
                $__default["default"](this._element).on(EVENT_POINTERDOWN, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_POINTERUP, function(event) {
                    return end(event);
                });
                this._element.classList.add(CLASS_NAME_POINTER_EVENT);
            } else {
                $__default["default"](this._element).on(EVENT_TOUCHSTART, function(event) {
                    return start(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHMOVE, function(event) {
                    return move(event);
                });
                $__default["default"](this._element).on(EVENT_TOUCHEND, function(event) {
                    return end(event);
                });
            }
        };
        _proto._keydown = function _keydown(event) {
            if (/input|textarea/i.test(event.target.tagName)) return;
            switch(event.which){
                case ARROW_LEFT_KEYCODE:
                    event.preventDefault();
                    this.prev();
                    break;
                case ARROW_RIGHT_KEYCODE:
                    event.preventDefault();
                    this.next();
                    break;
            }
        };
        _proto._getItemIndex = function _getItemIndex(element) {
            this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(SELECTOR_ITEM)) : [];
            return this._items.indexOf(element);
        };
        _proto._getItemByDirection = function _getItemByDirection(direction, activeElement) {
            var isNextDirection = direction === DIRECTION_NEXT;
            var isPrevDirection = direction === DIRECTION_PREV;
            var activeIndex = this._getItemIndex(activeElement);
            var lastItemIndex = this._items.length - 1;
            var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
            if (isGoingToWrap && !this._config.wrap) return activeElement;
            var delta = direction === DIRECTION_PREV ? -1 : 1;
            var itemIndex = (activeIndex + delta) % this._items.length;
            return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
        };
        _proto._triggerSlideEvent = function _triggerSlideEvent(relatedTarget, eventDirectionName) {
            var targetIndex = this._getItemIndex(relatedTarget);
            var fromIndex = this._getItemIndex(this._element.querySelector(SELECTOR_ACTIVE_ITEM));
            var slideEvent = $__default["default"].Event(EVENT_SLIDE, {
                relatedTarget: relatedTarget,
                direction: eventDirectionName,
                from: fromIndex,
                to: targetIndex
            });
            $__default["default"](this._element).trigger(slideEvent);
            return slideEvent;
        };
        _proto._setActiveIndicatorElement = function _setActiveIndicatorElement(element) {
            if (this._indicatorsElement) {
                var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(SELECTOR_ACTIVE$1));
                $__default["default"](indicators).removeClass(CLASS_NAME_ACTIVE$2);
                var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                if (nextIndicator) $__default["default"](nextIndicator).addClass(CLASS_NAME_ACTIVE$2);
            }
        };
        _proto._updateInterval = function _updateInterval() {
            var element = this._activeElement || this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            if (!element) return;
            var elementInterval = parseInt(element.getAttribute("data-interval"), 10);
            if (elementInterval) {
                this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
                this._config.interval = elementInterval;
            } else this._config.interval = this._config.defaultInterval || this._config.interval;
        };
        _proto._slide = function _slide(direction, element) {
            var _this4 = this;
            var activeElement = this._element.querySelector(SELECTOR_ACTIVE_ITEM);
            var activeElementIndex = this._getItemIndex(activeElement);
            var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
            var nextElementIndex = this._getItemIndex(nextElement);
            var isCycling = Boolean(this._interval);
            var directionalClassName;
            var orderClassName;
            var eventDirectionName;
            if (direction === DIRECTION_NEXT) {
                directionalClassName = CLASS_NAME_LEFT;
                orderClassName = CLASS_NAME_NEXT;
                eventDirectionName = DIRECTION_LEFT;
            } else {
                directionalClassName = CLASS_NAME_RIGHT;
                orderClassName = CLASS_NAME_PREV;
                eventDirectionName = DIRECTION_RIGHT;
            }
            if (nextElement && $__default["default"](nextElement).hasClass(CLASS_NAME_ACTIVE$2)) {
                this._isSliding = false;
                return;
            }
            var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
            if (slideEvent.isDefaultPrevented()) return;
            if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
            return;
            this._isSliding = true;
            if (isCycling) this.pause();
            this._setActiveIndicatorElement(nextElement);
            this._activeElement = nextElement;
            var slidEvent = $__default["default"].Event(EVENT_SLID, {
                relatedTarget: nextElement,
                direction: eventDirectionName,
                from: activeElementIndex,
                to: nextElementIndex
            });
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SLIDE)) {
                $__default["default"](nextElement).addClass(orderClassName);
                Util.reflow(nextElement);
                $__default["default"](activeElement).addClass(directionalClassName);
                $__default["default"](nextElement).addClass(directionalClassName);
                var transitionDuration = Util.getTransitionDurationFromElement(activeElement);
                $__default["default"](activeElement).one(Util.TRANSITION_END, function() {
                    $__default["default"](nextElement).removeClass(directionalClassName + " " + orderClassName).addClass(CLASS_NAME_ACTIVE$2);
                    $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2 + " " + orderClassName + " " + directionalClassName);
                    _this4._isSliding = false;
                    setTimeout(function() {
                        return $__default["default"](_this4._element).trigger(slidEvent);
                    }, 0);
                }).emulateTransitionEnd(transitionDuration);
            } else {
                $__default["default"](activeElement).removeClass(CLASS_NAME_ACTIVE$2);
                $__default["default"](nextElement).addClass(CLASS_NAME_ACTIVE$2);
                this._isSliding = false;
                $__default["default"](this._element).trigger(slidEvent);
            }
            if (isCycling) this.cycle();
        } // Static
        ;
        Carousel._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$8);
                var _config = _extends({}, Default$7, $__default["default"](this).data());
                if (typeof config === "object") _config = _extends({}, _config, config);
                var action = typeof config === "string" ? config : _config.slide;
                if (!data) {
                    data = new Carousel(this, _config);
                    $__default["default"](this).data(DATA_KEY$8, data);
                }
                if (typeof config === "number") data.to(config);
                else if (typeof action === "string") {
                    if (typeof data[action] === "undefined") throw new TypeError('No method named "' + action + '"');
                    data[action]();
                } else if (_config.interval && _config.ride) {
                    data.pause();
                    data.cycle();
                }
            });
        };
        Carousel._dataApiClickHandler = function _dataApiClickHandler(event) {
            var selector = Util.getSelectorFromElement(this);
            if (!selector) return;
            var target = $__default["default"](selector)[0];
            if (!target || !$__default["default"](target).hasClass(CLASS_NAME_CAROUSEL)) return;
            var config = _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
            var slideIndex = this.getAttribute("data-slide-to");
            if (slideIndex) config.interval = false;
            Carousel._jQueryInterface.call($__default["default"](target), config);
            if (slideIndex) $__default["default"](target).data(DATA_KEY$8).to(slideIndex);
            event.preventDefault();
        };
        _createClass(Carousel, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$8;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$7;
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$4, SELECTOR_DATA_SLIDE, Carousel._dataApiClickHandler);
    $__default["default"](window).on(EVENT_LOAD_DATA_API$1, function() {
        var carousels = [].slice.call(document.querySelectorAll(SELECTOR_DATA_RIDE));
        for(var i = 0, len = carousels.length; i < len; i++){
            var $carousel = $__default["default"](carousels[i]);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$8] = Carousel._jQueryInterface;
    $__default["default"].fn[NAME$8].Constructor = Carousel;
    $__default["default"].fn[NAME$8].noConflict = function() {
        $__default["default"].fn[NAME$8] = JQUERY_NO_CONFLICT$8;
        return Carousel._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$7 = "collapse";
    var VERSION$7 = "4.6.2";
    var DATA_KEY$7 = "bs.collapse";
    var EVENT_KEY$7 = "." + DATA_KEY$7;
    var DATA_API_KEY$4 = ".data-api";
    var JQUERY_NO_CONFLICT$7 = $__default["default"].fn[NAME$7];
    var CLASS_NAME_SHOW$6 = "show";
    var CLASS_NAME_COLLAPSE = "collapse";
    var CLASS_NAME_COLLAPSING = "collapsing";
    var CLASS_NAME_COLLAPSED = "collapsed";
    var DIMENSION_WIDTH = "width";
    var DIMENSION_HEIGHT = "height";
    var EVENT_SHOW$4 = "show" + EVENT_KEY$7;
    var EVENT_SHOWN$4 = "shown" + EVENT_KEY$7;
    var EVENT_HIDE$4 = "hide" + EVENT_KEY$7;
    var EVENT_HIDDEN$4 = "hidden" + EVENT_KEY$7;
    var EVENT_CLICK_DATA_API$3 = "click" + EVENT_KEY$7 + DATA_API_KEY$4;
    var SELECTOR_ACTIVES = ".show, .collapsing";
    var SELECTOR_DATA_TOGGLE$3 = '[data-toggle="collapse"]';
    var Default$6 = {
        toggle: true,
        parent: ""
    };
    var DefaultType$6 = {
        toggle: "boolean",
        parent: "(string|element)"
    };
    /**
   * Class definition
   */ var Collapse = /*#__PURE__*/ function() {
        function Collapse(element, config) {
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));
            var toggleList = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$3));
            for(var i = 0, len = toggleList.length; i < len; i++){
                var elem = toggleList[i];
                var selector = Util.getSelectorFromElement(elem);
                var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function(foundElem) {
                    return foundElem === element;
                });
                if (selector !== null && filterElement.length > 0) {
                    this._selector = selector;
                    this._triggerArray.push(elem);
                }
            }
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        } // Getters
        var _proto = Collapse.prototype;
        // Public
        _proto.toggle = function toggle() {
            if ($__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) this.hide();
            else this.show();
        };
        _proto.show = function show() {
            var _this = this;
            if (this._isTransitioning || $__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var actives;
            var activesData;
            if (this._parent) {
                actives = [].slice.call(this._parent.querySelectorAll(SELECTOR_ACTIVES)).filter(function(elem) {
                    if (typeof _this._config.parent === "string") return elem.getAttribute("data-parent") === _this._config.parent;
                    return elem.classList.contains(CLASS_NAME_COLLAPSE);
                });
                if (actives.length === 0) actives = null;
            }
            if (actives) {
                activesData = $__default["default"](actives).not(this._selector).data(DATA_KEY$7);
                if (activesData && activesData._isTransitioning) return;
            }
            var startEvent = $__default["default"].Event(EVENT_SHOW$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            if (actives) {
                Collapse._jQueryInterface.call($__default["default"](actives).not(this._selector), "hide");
                if (!activesData) $__default["default"](actives).data(DATA_KEY$7, null);
            }
            var dimension = this._getDimension();
            $__default["default"](this._element).removeClass(CLASS_NAME_COLLAPSE).addClass(CLASS_NAME_COLLAPSING);
            this._element.style[dimension] = 0;
            if (this._triggerArray.length) $__default["default"](this._triggerArray).removeClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", true);
            this.setTransitioning(true);
            var complete = function complete() {
                $__default["default"](_this._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
                _this._element.style[dimension] = "";
                _this.setTransitioning(false);
                $__default["default"](_this._element).trigger(EVENT_SHOWN$4);
            };
            var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
            var scrollSize = "scroll" + capitalizedDimension;
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            this._element.style[dimension] = this._element[scrollSize] + "px";
        };
        _proto.hide = function hide() {
            var _this2 = this;
            if (this._isTransitioning || !$__default["default"](this._element).hasClass(CLASS_NAME_SHOW$6)) return;
            var startEvent = $__default["default"].Event(EVENT_HIDE$4);
            $__default["default"](this._element).trigger(startEvent);
            if (startEvent.isDefaultPrevented()) return;
            var dimension = this._getDimension();
            this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + "px";
            Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_COLLAPSING).removeClass(CLASS_NAME_COLLAPSE + " " + CLASS_NAME_SHOW$6);
            var triggerArrayLength = this._triggerArray.length;
            if (triggerArrayLength > 0) for(var i = 0; i < triggerArrayLength; i++){
                var trigger = this._triggerArray[i];
                var selector = Util.getSelectorFromElement(trigger);
                if (selector !== null) {
                    var $elem = $__default["default"]([].slice.call(document.querySelectorAll(selector)));
                    if (!$elem.hasClass(CLASS_NAME_SHOW$6)) $__default["default"](trigger).addClass(CLASS_NAME_COLLAPSED).attr("aria-expanded", false);
                }
            }
            this.setTransitioning(true);
            var complete = function complete() {
                _this2.setTransitioning(false);
                $__default["default"](_this2._element).removeClass(CLASS_NAME_COLLAPSING).addClass(CLASS_NAME_COLLAPSE).trigger(EVENT_HIDDEN$4);
            };
            this._element.style[dimension] = "";
            var transitionDuration = Util.getTransitionDurationFromElement(this._element);
            $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
        };
        _proto.setTransitioning = function setTransitioning(isTransitioning) {
            this._isTransitioning = isTransitioning;
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$7);
            this._config = null;
            this._parent = null;
            this._element = null;
            this._triggerArray = null;
            this._isTransitioning = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$6, config);
            config.toggle = Boolean(config.toggle); // Coerce string values
            Util.typeCheckConfig(NAME$7, config, DefaultType$6);
            return config;
        };
        _proto._getDimension = function _getDimension() {
            var hasWidth = $__default["default"](this._element).hasClass(DIMENSION_WIDTH);
            return hasWidth ? DIMENSION_WIDTH : DIMENSION_HEIGHT;
        };
        _proto._getParent = function _getParent() {
            var _this3 = this;
            var parent;
            if (Util.isElement(this._config.parent)) {
                parent = this._config.parent; // It's a jQuery object
                if (typeof this._config.parent.jquery !== "undefined") parent = this._config.parent[0];
            } else parent = document.querySelector(this._config.parent);
            var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';
            var children = [].slice.call(parent.querySelectorAll(selector));
            $__default["default"](children).each(function(i, element) {
                _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                    element
                ]);
            });
            return parent;
        };
        _proto._addAriaAndCollapsedClass = function _addAriaAndCollapsedClass(element, triggerArray) {
            var isOpen = $__default["default"](element).hasClass(CLASS_NAME_SHOW$6);
            if (triggerArray.length) $__default["default"](triggerArray).toggleClass(CLASS_NAME_COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
        } // Static
        ;
        Collapse._getTargetFromElement = function _getTargetFromElement(element) {
            var selector = Util.getSelectorFromElement(element);
            return selector ? document.querySelector(selector) : null;
        };
        Collapse._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$7);
                var _config = _extends({}, Default$6, $element.data(), typeof config === "object" && config ? config : {});
                if (!data && _config.toggle && typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                if (!data) {
                    data = new Collapse(this, _config);
                    $element.data(DATA_KEY$7, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Collapse, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$7;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$6;
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.currentTarget.tagName === "A") event.preventDefault();
        var $trigger = $__default["default"](this);
        var selector = Util.getSelectorFromElement(this);
        var selectors = [].slice.call(document.querySelectorAll(selector));
        $__default["default"](selectors).each(function() {
            var $target = $__default["default"](this);
            var data = $target.data(DATA_KEY$7);
            var config = data ? "toggle" : $trigger.data();
            Collapse._jQueryInterface.call($target, config);
        });
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$7] = Collapse._jQueryInterface;
    $__default["default"].fn[NAME$7].Constructor = Collapse;
    $__default["default"].fn[NAME$7].noConflict = function() {
        $__default["default"].fn[NAME$7] = JQUERY_NO_CONFLICT$7;
        return Collapse._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$6 = "dropdown";
    var VERSION$6 = "4.6.2";
    var DATA_KEY$6 = "bs.dropdown";
    var EVENT_KEY$6 = "." + DATA_KEY$6;
    var DATA_API_KEY$3 = ".data-api";
    var JQUERY_NO_CONFLICT$6 = $__default["default"].fn[NAME$6];
    var ESCAPE_KEYCODE$1 = 27; // KeyboardEvent.which value for Escape (Esc) key
    var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
    var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
    var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
    var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
    var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
    var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + "|" + ARROW_DOWN_KEYCODE + "|" + ESCAPE_KEYCODE$1);
    var CLASS_NAME_DISABLED$1 = "disabled";
    var CLASS_NAME_SHOW$5 = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPRIGHT = "dropright";
    var CLASS_NAME_DROPLEFT = "dropleft";
    var CLASS_NAME_MENURIGHT = "dropdown-menu-right";
    var CLASS_NAME_POSITION_STATIC = "position-static";
    var EVENT_HIDE$3 = "hide" + EVENT_KEY$6;
    var EVENT_HIDDEN$3 = "hidden" + EVENT_KEY$6;
    var EVENT_SHOW$3 = "show" + EVENT_KEY$6;
    var EVENT_SHOWN$3 = "shown" + EVENT_KEY$6;
    var EVENT_CLICK = "click" + EVENT_KEY$6;
    var EVENT_CLICK_DATA_API$2 = "click" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYDOWN_DATA_API = "keydown" + EVENT_KEY$6 + DATA_API_KEY$3;
    var EVENT_KEYUP_DATA_API = "keyup" + EVENT_KEY$6 + DATA_API_KEY$3;
    var SELECTOR_DATA_TOGGLE$2 = '[data-toggle="dropdown"]';
    var SELECTOR_FORM_CHILD = ".dropdown form";
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = "top-start";
    var PLACEMENT_TOPEND = "top-end";
    var PLACEMENT_BOTTOM = "bottom-start";
    var PLACEMENT_BOTTOMEND = "bottom-end";
    var PLACEMENT_RIGHT = "right-start";
    var PLACEMENT_LEFT = "left-start";
    var Default$5 = {
        offset: 0,
        flip: true,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null
    };
    var DefaultType$5 = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)"
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function() {
        function Dropdown(element, config) {
            this._element = element;
            this._popper = null;
            this._config = this._getConfig(config);
            this._menu = this._getMenuElement();
            this._inNavbar = this._detectNavbar();
            this._addEventListeners();
        } // Getters
        var _proto = Dropdown.prototype;
        // Public
        _proto.toggle = function toggle() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1)) return;
            var isActive = $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5);
            Dropdown._clearMenus();
            if (isActive) return;
            this.show(true);
        };
        _proto.show = function show(usePopper) {
            if (usePopper === void 0) usePopper = false;
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || $__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var showEvent = $__default["default"].Event(EVENT_SHOW$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
             // Totally disable Popper for Dropdowns in Navbar
            if (!this._inNavbar && usePopper) {
                // Check for Popper dependency
                if (typeof Popper__default["default"] === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                var referenceElement = this._element;
                if (this._config.reference === "parent") referenceElement = parent;
                else if (Util.isElement(this._config.reference)) {
                    referenceElement = this._config.reference; // Check if it's jQuery element
                    if (typeof this._config.reference.jquery !== "undefined") referenceElement = this._config.reference[0];
                } // If boundary is not `scrollParent`, then set position to `static`
                // to allow the menu to "escape" the scroll parent's boundaries
                // https://github.com/twbs/bootstrap/issues/24251
                if (this._config.boundary !== "scrollParent") $__default["default"](parent).addClass(CLASS_NAME_POSITION_STATIC);
                this._popper = new Popper__default["default"](referenceElement, this._menu, this._getPopperConfig());
            } // If this is a touch-enabled device we add extra
            // empty mouseover listeners to the body's immediate children;
            // only needed because of broken event delegation on iOS
            // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
            if ("ontouchstart" in document.documentElement && $__default["default"](parent).closest(SELECTOR_NAVBAR_NAV).length === 0) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
            this._element.focus();
            this._element.setAttribute("aria-expanded", true);
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_SHOWN$3, relatedTarget));
        };
        _proto.hide = function hide() {
            if (this._element.disabled || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED$1) || !$__default["default"](this._menu).hasClass(CLASS_NAME_SHOW$5)) return;
            var relatedTarget = {
                relatedTarget: this._element
            };
            var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
            var parent = Dropdown._getParentFromElement(this._element);
            $__default["default"](parent).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            if (this._popper) this._popper.destroy();
            $__default["default"](this._menu).toggleClass(CLASS_NAME_SHOW$5);
            $__default["default"](parent).toggleClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$6);
            $__default["default"](this._element).off(EVENT_KEY$6);
            this._element = null;
            this._menu = null;
            if (this._popper !== null) {
                this._popper.destroy();
                this._popper = null;
            }
        };
        _proto.update = function update() {
            this._inNavbar = this._detectNavbar();
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Private
        ;
        _proto._addEventListeners = function _addEventListeners() {
            var _this = this;
            $__default["default"](this._element).on(EVENT_CLICK, function(event) {
                event.preventDefault();
                event.stopPropagation();
                _this.toggle();
            });
        };
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, this.constructor.Default, $__default["default"](this._element).data(), config);
            Util.typeCheckConfig(NAME$6, config, this.constructor.DefaultType);
            return config;
        };
        _proto._getMenuElement = function _getMenuElement() {
            if (!this._menu) {
                var parent = Dropdown._getParentFromElement(this._element);
                if (parent) this._menu = parent.querySelector(SELECTOR_MENU);
            }
            return this._menu;
        };
        _proto._getPlacement = function _getPlacement() {
            var $parentDropdown = $__default["default"](this._element.parentNode);
            var placement = PLACEMENT_BOTTOM; // Handle dropup
            if ($parentDropdown.hasClass(CLASS_NAME_DROPUP)) placement = $__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT) ? PLACEMENT_TOPEND : PLACEMENT_TOP;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPRIGHT)) placement = PLACEMENT_RIGHT;
            else if ($parentDropdown.hasClass(CLASS_NAME_DROPLEFT)) placement = PLACEMENT_LEFT;
            else if ($__default["default"](this._menu).hasClass(CLASS_NAME_MENURIGHT)) placement = PLACEMENT_BOTTOMEND;
            return placement;
        };
        _proto._detectNavbar = function _detectNavbar() {
            return $__default["default"](this._element).closest(".navbar").length > 0;
        };
        _proto._getOffset = function _getOffset() {
            var _this2 = this;
            var offset = {};
            if (typeof this._config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element));
                return data;
            };
            else offset.offset = this._config.offset;
            return offset;
        };
        _proto._getPopperConfig = function _getPopperConfig() {
            var popperConfig = {
                placement: this._getPlacement(),
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        enabled: this._config.flip
                    },
                    preventOverflow: {
                        boundariesElement: this._config.boundary
                    }
                }
            }; // Disable Popper if we have a static display
            if (this._config.display === "static") popperConfig.modifiers.applyStyle = {
                enabled: false
            };
            return _extends({}, popperConfig, this._config.popperConfig);
        } // Static
        ;
        Dropdown._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$6);
                var _config = typeof config === "object" ? config : null;
                if (!data) {
                    data = new Dropdown(this, _config);
                    $__default["default"](this).data(DATA_KEY$6, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        Dropdown._clearMenus = function _clearMenus(event) {
            if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === "keyup" && event.which !== TAB_KEYCODE)) return;
            var toggles = [].slice.call(document.querySelectorAll(SELECTOR_DATA_TOGGLE$2));
            for(var i = 0, len = toggles.length; i < len; i++){
                var parent = Dropdown._getParentFromElement(toggles[i]);
                var context = $__default["default"](toggles[i]).data(DATA_KEY$6);
                var relatedTarget = {
                    relatedTarget: toggles[i]
                };
                if (event && event.type === "click") relatedTarget.clickEvent = event;
                if (!context) continue;
                var dropdownMenu = context._menu;
                if (!$__default["default"](parent).hasClass(CLASS_NAME_SHOW$5)) continue;
                if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "keyup" && event.which === TAB_KEYCODE) && $__default["default"].contains(parent, event.target)) continue;
                var hideEvent = $__default["default"].Event(EVENT_HIDE$3, relatedTarget);
                $__default["default"](parent).trigger(hideEvent);
                if (hideEvent.isDefaultPrevented()) continue;
                 // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
                toggles[i].setAttribute("aria-expanded", "false");
                if (context._popper) context._popper.destroy();
                $__default["default"](dropdownMenu).removeClass(CLASS_NAME_SHOW$5);
                $__default["default"](parent).removeClass(CLASS_NAME_SHOW$5).trigger($__default["default"].Event(EVENT_HIDDEN$3, relatedTarget));
            }
        };
        Dropdown._getParentFromElement = function _getParentFromElement(element) {
            var parent;
            var selector = Util.getSelectorFromElement(element);
            if (selector) parent = document.querySelector(selector);
            return parent || element.parentNode;
        } // eslint-disable-next-line complexity
        ;
        Dropdown._dataApiKeydownHandler = function _dataApiKeydownHandler(event) {
            // If not input/textarea:
            //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
            // If input/textarea:
            //  - If space key => not a dropdown command
            //  - If key is other than escape
            //    - If key is not up or down => not a dropdown command
            //    - If trigger inside the menu => not a dropdown command
            if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE$1 && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || $__default["default"](event.target).closest(SELECTOR_MENU).length) : !REGEXP_KEYDOWN.test(event.which)) return;
            if (this.disabled || $__default["default"](this).hasClass(CLASS_NAME_DISABLED$1)) return;
            var parent = Dropdown._getParentFromElement(this);
            var isActive = $__default["default"](parent).hasClass(CLASS_NAME_SHOW$5);
            if (!isActive && event.which === ESCAPE_KEYCODE$1) return;
            event.preventDefault();
            event.stopPropagation();
            if (!isActive || event.which === ESCAPE_KEYCODE$1 || event.which === SPACE_KEYCODE) {
                if (event.which === ESCAPE_KEYCODE$1) $__default["default"](parent.querySelector(SELECTOR_DATA_TOGGLE$2)).trigger("focus");
                $__default["default"](this).trigger("click");
                return;
            }
            var items = [].slice.call(parent.querySelectorAll(SELECTOR_VISIBLE_ITEMS)).filter(function(item) {
                return $__default["default"](item).is(":visible");
            });
            if (items.length === 0) return;
            var index = items.indexOf(event.target);
            if (event.which === ARROW_UP_KEYCODE && index > 0) // Up
            index--;
            if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) // Down
            index++;
            if (index < 0) index = 0;
            items[index].focus();
        };
        _createClass(Dropdown, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$6;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$5;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$5;
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$2, Dropdown._dataApiKeydownHandler).on(EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown._dataApiKeydownHandler).on(EVENT_CLICK_DATA_API$2 + " " + EVENT_KEYUP_DATA_API, Dropdown._clearMenus).on(EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function(event) {
        event.preventDefault();
        event.stopPropagation();
        Dropdown._jQueryInterface.call($__default["default"](this), "toggle");
    }).on(EVENT_CLICK_DATA_API$2, SELECTOR_FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$6] = Dropdown._jQueryInterface;
    $__default["default"].fn[NAME$6].Constructor = Dropdown;
    $__default["default"].fn[NAME$6].noConflict = function() {
        $__default["default"].fn[NAME$6] = JQUERY_NO_CONFLICT$6;
        return Dropdown._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$5 = "modal";
    var VERSION$5 = "4.6.2";
    var DATA_KEY$5 = "bs.modal";
    var EVENT_KEY$5 = "." + DATA_KEY$5;
    var DATA_API_KEY$2 = ".data-api";
    var JQUERY_NO_CONFLICT$5 = $__default["default"].fn[NAME$5];
    var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
    var CLASS_NAME_SCROLLABLE = "modal-dialog-scrollable";
    var CLASS_NAME_SCROLLBAR_MEASURER = "modal-scrollbar-measure";
    var CLASS_NAME_BACKDROP = "modal-backdrop";
    var CLASS_NAME_OPEN = "modal-open";
    var CLASS_NAME_FADE$4 = "fade";
    var CLASS_NAME_SHOW$4 = "show";
    var CLASS_NAME_STATIC = "modal-static";
    var EVENT_HIDE$2 = "hide" + EVENT_KEY$5;
    var EVENT_HIDE_PREVENTED = "hidePrevented" + EVENT_KEY$5;
    var EVENT_HIDDEN$2 = "hidden" + EVENT_KEY$5;
    var EVENT_SHOW$2 = "show" + EVENT_KEY$5;
    var EVENT_SHOWN$2 = "shown" + EVENT_KEY$5;
    var EVENT_FOCUSIN = "focusin" + EVENT_KEY$5;
    var EVENT_RESIZE = "resize" + EVENT_KEY$5;
    var EVENT_CLICK_DISMISS$1 = "click.dismiss" + EVENT_KEY$5;
    var EVENT_KEYDOWN_DISMISS = "keydown.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss" + EVENT_KEY$5;
    var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss" + EVENT_KEY$5;
    var EVENT_CLICK_DATA_API$1 = "click" + EVENT_KEY$5 + DATA_API_KEY$2;
    var SELECTOR_DIALOG = ".modal-dialog";
    var SELECTOR_MODAL_BODY = ".modal-body";
    var SELECTOR_DATA_TOGGLE$1 = '[data-toggle="modal"]';
    var SELECTOR_DATA_DISMISS$1 = '[data-dismiss="modal"]';
    var SELECTOR_FIXED_CONTENT = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top";
    var SELECTOR_STICKY_CONTENT = ".sticky-top";
    var Default$4 = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType$4 = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    };
    /**
   * Class definition
   */ var Modal = /*#__PURE__*/ function() {
        function Modal(element, config) {
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = element.querySelector(SELECTOR_DIALOG);
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._scrollbarWidth = 0;
        } // Getters
        var _proto = Modal.prototype;
        // Public
        _proto.toggle = function toggle(relatedTarget) {
            return this._isShown ? this.hide() : this.show(relatedTarget);
        };
        _proto.show = function show(relatedTarget) {
            var _this = this;
            if (this._isShown || this._isTransitioning) return;
            var showEvent = $__default["default"].Event(EVENT_SHOW$2, {
                relatedTarget: relatedTarget
            });
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._isShown = true;
            if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) this._isTransitioning = true;
            this._checkScrollbar();
            this._setScrollbar();
            this._adjustDialog();
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, SELECTOR_DATA_DISMISS$1, function(event) {
                return _this.hide(event);
            });
            $__default["default"](this._dialog).on(EVENT_MOUSEDOWN_DISMISS, function() {
                $__default["default"](_this._element).one(EVENT_MOUSEUP_DISMISS, function(event) {
                    if ($__default["default"](event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                });
            });
            this._showBackdrop(function() {
                return _this._showElement(relatedTarget);
            });
        };
        _proto.hide = function hide(event) {
            var _this2 = this;
            if (event) event.preventDefault();
            if (!this._isShown || this._isTransitioning) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE$2);
            $__default["default"](this._element).trigger(hideEvent);
            if (!this._isShown || hideEvent.isDefaultPrevented()) return;
            this._isShown = false;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            if (transition) this._isTransitioning = true;
            this._setEscapeEvent();
            this._setResizeEvent();
            $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"](this._element).removeClass(CLASS_NAME_SHOW$4);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS$1);
            $__default["default"](this._dialog).off(EVENT_MOUSEDOWN_DISMISS);
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, function(event) {
                    return _this2._hideModal(event);
                }).emulateTransitionEnd(transitionDuration);
            } else this._hideModal();
        };
        _proto.dispose = function dispose() {
            [
                window,
                this._element,
                this._dialog
            ].forEach(function(htmlElement) {
                return $__default["default"](htmlElement).off(EVENT_KEY$5);
            });
            /**
       * `document` has 2 events `EVENT_FOCUSIN` and `EVENT_CLICK_DATA_API`
       * Do not move `document` in `htmlElements` array
       * It will remove `EVENT_CLICK_DATA_API` event that should remain
       */ $__default["default"](document).off(EVENT_FOCUSIN);
            $__default["default"].removeData(this._element, DATA_KEY$5);
            this._config = null;
            this._element = null;
            this._dialog = null;
            this._backdrop = null;
            this._isShown = null;
            this._isBodyOverflowing = null;
            this._ignoreBackdropClick = null;
            this._isTransitioning = null;
            this._scrollbarWidth = null;
        };
        _proto.handleUpdate = function handleUpdate() {
            this._adjustDialog();
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$4, config);
            Util.typeCheckConfig(NAME$5, config, DefaultType$4);
            return config;
        };
        _proto._triggerBackdropTransition = function _triggerBackdropTransition() {
            var _this3 = this;
            var hideEventPrevented = $__default["default"].Event(EVENT_HIDE_PREVENTED);
            $__default["default"](this._element).trigger(hideEventPrevented);
            if (hideEventPrevented.isDefaultPrevented()) return;
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!isModalOverflowing) this._element.style.overflowY = "hidden";
            this._element.classList.add(CLASS_NAME_STATIC);
            var modalTransitionDuration = Util.getTransitionDurationFromElement(this._dialog);
            $__default["default"](this._element).off(Util.TRANSITION_END);
            $__default["default"](this._element).one(Util.TRANSITION_END, function() {
                _this3._element.classList.remove(CLASS_NAME_STATIC);
                if (!isModalOverflowing) $__default["default"](_this3._element).one(Util.TRANSITION_END, function() {
                    _this3._element.style.overflowY = "";
                }).emulateTransitionEnd(_this3._element, modalTransitionDuration);
            }).emulateTransitionEnd(modalTransitionDuration);
            this._element.focus();
        };
        _proto._showElement = function _showElement(relatedTarget) {
            var _this4 = this;
            var transition = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4);
            var modalBody = this._dialog ? this._dialog.querySelector(SELECTOR_MODAL_BODY) : null;
            if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // Don't move modal's DOM position
            document.body.appendChild(this._element);
            this._element.style.display = "block";
            this._element.removeAttribute("aria-hidden");
            this._element.setAttribute("aria-modal", true);
            this._element.setAttribute("role", "dialog");
            if ($__default["default"](this._dialog).hasClass(CLASS_NAME_SCROLLABLE) && modalBody) modalBody.scrollTop = 0;
            else this._element.scrollTop = 0;
            if (transition) Util.reflow(this._element);
            $__default["default"](this._element).addClass(CLASS_NAME_SHOW$4);
            if (this._config.focus) this._enforceFocus();
            var shownEvent = $__default["default"].Event(EVENT_SHOWN$2, {
                relatedTarget: relatedTarget
            });
            var transitionComplete = function transitionComplete() {
                if (_this4._config.focus) _this4._element.focus();
                _this4._isTransitioning = false;
                $__default["default"](_this4._element).trigger(shownEvent);
            };
            if (transition) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._dialog);
                $__default["default"](this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
            } else transitionComplete();
        };
        _proto._enforceFocus = function _enforceFocus() {
            var _this5 = this;
            $__default["default"](document).off(EVENT_FOCUSIN) // Guard against infinite focus loop
            .on(EVENT_FOCUSIN, function(event) {
                if (document !== event.target && _this5._element !== event.target && $__default["default"](_this5._element).has(event.target).length === 0) _this5._element.focus();
            });
        };
        _proto._setEscapeEvent = function _setEscapeEvent() {
            var _this6 = this;
            if (this._isShown) $__default["default"](this._element).on(EVENT_KEYDOWN_DISMISS, function(event) {
                if (_this6._config.keyboard && event.which === ESCAPE_KEYCODE) {
                    event.preventDefault();
                    _this6.hide();
                } else if (!_this6._config.keyboard && event.which === ESCAPE_KEYCODE) _this6._triggerBackdropTransition();
            });
            else if (!this._isShown) $__default["default"](this._element).off(EVENT_KEYDOWN_DISMISS);
        };
        _proto._setResizeEvent = function _setResizeEvent() {
            var _this7 = this;
            if (this._isShown) $__default["default"](window).on(EVENT_RESIZE, function(event) {
                return _this7.handleUpdate(event);
            });
            else $__default["default"](window).off(EVENT_RESIZE);
        };
        _proto._hideModal = function _hideModal() {
            var _this8 = this;
            this._element.style.display = "none";
            this._element.setAttribute("aria-hidden", true);
            this._element.removeAttribute("aria-modal");
            this._element.removeAttribute("role");
            this._isTransitioning = false;
            this._showBackdrop(function() {
                $__default["default"](document.body).removeClass(CLASS_NAME_OPEN);
                _this8._resetAdjustments();
                _this8._resetScrollbar();
                $__default["default"](_this8._element).trigger(EVENT_HIDDEN$2);
            });
        };
        _proto._removeBackdrop = function _removeBackdrop() {
            if (this._backdrop) {
                $__default["default"](this._backdrop).remove();
                this._backdrop = null;
            }
        };
        _proto._showBackdrop = function _showBackdrop(callback) {
            var _this9 = this;
            var animate = $__default["default"](this._element).hasClass(CLASS_NAME_FADE$4) ? CLASS_NAME_FADE$4 : "";
            if (this._isShown && this._config.backdrop) {
                this._backdrop = document.createElement("div");
                this._backdrop.className = CLASS_NAME_BACKDROP;
                if (animate) this._backdrop.classList.add(animate);
                $__default["default"](this._backdrop).appendTo(document.body);
                $__default["default"](this._element).on(EVENT_CLICK_DISMISS$1, function(event) {
                    if (_this9._ignoreBackdropClick) {
                        _this9._ignoreBackdropClick = false;
                        return;
                    }
                    if (event.target !== event.currentTarget) return;
                    if (_this9._config.backdrop === "static") _this9._triggerBackdropTransition();
                    else _this9.hide();
                });
                if (animate) Util.reflow(this._backdrop);
                $__default["default"](this._backdrop).addClass(CLASS_NAME_SHOW$4);
                if (!callback) return;
                if (!animate) {
                    callback();
                    return;
                }
                var backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                $__default["default"](this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
            } else if (!this._isShown && this._backdrop) {
                $__default["default"](this._backdrop).removeClass(CLASS_NAME_SHOW$4);
                var callbackRemove = function callbackRemove() {
                    _this9._removeBackdrop();
                    if (callback) callback();
                };
                if ($__default["default"](this._element).hasClass(CLASS_NAME_FADE$4)) {
                    var _backdropTransitionDuration = Util.getTransitionDurationFromElement(this._backdrop);
                    $__default["default"](this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
                } else callbackRemove();
            } else if (callback) callback();
        } // ----------------------------------------------------------------------
        ;
        _proto._adjustDialog = function _adjustDialog() {
            var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
            if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = this._scrollbarWidth + "px";
            if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = this._scrollbarWidth + "px";
        };
        _proto._resetAdjustments = function _resetAdjustments() {
            this._element.style.paddingLeft = "";
            this._element.style.paddingRight = "";
        };
        _proto._checkScrollbar = function _checkScrollbar() {
            var rect = document.body.getBoundingClientRect();
            this._isBodyOverflowing = Math.round(rect.left + rect.right) < window.innerWidth;
            this._scrollbarWidth = this._getScrollbarWidth();
        };
        _proto._setScrollbar = function _setScrollbar() {
            var _this10 = this;
            if (this._isBodyOverflowing) {
                // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
                //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
                var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
                var stickyContent = [].slice.call(document.querySelectorAll(SELECTOR_STICKY_CONTENT)); // Adjust fixed content padding
                $__default["default"](fixedContent).each(function(index, element) {
                    var actualPadding = element.style.paddingRight;
                    var calculatedPadding = $__default["default"](element).css("padding-right");
                    $__default["default"](element).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + _this10._scrollbarWidth + "px");
                }); // Adjust sticky content margin
                $__default["default"](stickyContent).each(function(index, element) {
                    var actualMargin = element.style.marginRight;
                    var calculatedMargin = $__default["default"](element).css("margin-right");
                    $__default["default"](element).data("margin-right", actualMargin).css("margin-right", parseFloat(calculatedMargin) - _this10._scrollbarWidth + "px");
                }); // Adjust body padding
                var actualPadding = document.body.style.paddingRight;
                var calculatedPadding = $__default["default"](document.body).css("padding-right");
                $__default["default"](document.body).data("padding-right", actualPadding).css("padding-right", parseFloat(calculatedPadding) + this._scrollbarWidth + "px");
            }
            $__default["default"](document.body).addClass(CLASS_NAME_OPEN);
        };
        _proto._resetScrollbar = function _resetScrollbar() {
            // Restore fixed content padding
            var fixedContent = [].slice.call(document.querySelectorAll(SELECTOR_FIXED_CONTENT));
            $__default["default"](fixedContent).each(function(index, element) {
                var padding = $__default["default"](element).data("padding-right");
                $__default["default"](element).removeData("padding-right");
                element.style.paddingRight = padding ? padding : "";
            }); // Restore sticky content
            var elements = [].slice.call(document.querySelectorAll("" + SELECTOR_STICKY_CONTENT));
            $__default["default"](elements).each(function(index, element) {
                var margin = $__default["default"](element).data("margin-right");
                if (typeof margin !== "undefined") $__default["default"](element).css("margin-right", margin).removeData("margin-right");
            }); // Restore body padding
            var padding = $__default["default"](document.body).data("padding-right");
            $__default["default"](document.body).removeData("padding-right");
            document.body.style.paddingRight = padding ? padding : "";
        };
        _proto._getScrollbarWidth = function _getScrollbarWidth() {
            // thx d.walsh
            var scrollDiv = document.createElement("div");
            scrollDiv.className = CLASS_NAME_SCROLLBAR_MEASURER;
            document.body.appendChild(scrollDiv);
            var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
            return scrollbarWidth;
        } // Static
        ;
        Modal._jQueryInterface = function _jQueryInterface(config, relatedTarget) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$5);
                var _config = _extends({}, Default$4, $__default["default"](this).data(), typeof config === "object" && config ? config : {});
                if (!data) {
                    data = new Modal(this, _config);
                    $__default["default"](this).data(DATA_KEY$5, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](relatedTarget);
                } else if (_config.show) data.show(relatedTarget);
            });
        };
        _createClass(Modal, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$5;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$4;
                }
            }
        ]);
        return Modal;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function(event) {
        var _this11 = this;
        var target;
        var selector = Util.getSelectorFromElement(this);
        if (selector) target = document.querySelector(selector);
        var config = $__default["default"](target).data(DATA_KEY$5) ? "toggle" : _extends({}, $__default["default"](target).data(), $__default["default"](this).data());
        if (this.tagName === "A" || this.tagName === "AREA") event.preventDefault();
        var $target = $__default["default"](target).one(EVENT_SHOW$2, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // Only register focus restorer if modal will actually get shown
            return;
            $target.one(EVENT_HIDDEN$2, function() {
                if ($__default["default"](_this11).is(":visible")) _this11.focus();
            });
        });
        Modal._jQueryInterface.call($__default["default"](target), config, this);
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$5] = Modal._jQueryInterface;
    $__default["default"].fn[NAME$5].Constructor = Modal;
    $__default["default"].fn[NAME$5].noConflict = function() {
        $__default["default"].fn[NAME$5] = JQUERY_NO_CONFLICT$5;
        return Modal._jQueryInterface;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap (v4.6.2): tools/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var uriAttrs = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href"
    ];
    var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
    var DefaultWhitelist = {
        // Global attributes allowed on any supplied element below.
        "*": [
            "class",
            "dir",
            "id",
            "lang",
            "role",
            ARIA_ATTRIBUTE_PATTERN
        ],
        a: [
            "target",
            "href",
            "title",
            "rel"
        ],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height"
        ],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: []
    };
    /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
    /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;
    function allowedAttribute(attr, allowedAttributeList) {
        var attrName = attr.nodeName.toLowerCase();
        if (allowedAttributeList.indexOf(attrName) !== -1) {
            if (uriAttrs.indexOf(attrName) !== -1) return Boolean(SAFE_URL_PATTERN.test(attr.nodeValue) || DATA_URL_PATTERN.test(attr.nodeValue));
            return true;
        }
        var regExp = allowedAttributeList.filter(function(attrRegex) {
            return attrRegex instanceof RegExp;
        }); // Check if a regular expression validates the attribute.
        for(var i = 0, len = regExp.length; i < len; i++){
            if (regExp[i].test(attrName)) return true;
        }
        return false;
    }
    function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
        if (unsafeHtml.length === 0) return unsafeHtml;
        if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeHtml);
        var domParser = new window.DOMParser();
        var createdDocument = domParser.parseFromString(unsafeHtml, "text/html");
        var whitelistKeys = Object.keys(whiteList);
        var elements = [].slice.call(createdDocument.body.querySelectorAll("*"));
        var _loop = function _loop(i, len) {
            var el = elements[i];
            var elName = el.nodeName.toLowerCase();
            if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
                el.parentNode.removeChild(el);
                return "continue";
            }
            var attributeList = [].slice.call(el.attributes); // eslint-disable-next-line unicorn/prefer-spread
            var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
            attributeList.forEach(function(attr) {
                if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
            });
        };
        for(var i = 0, len = elements.length; i < len; i++){
            var _ret = _loop(i);
            if (_ret === "continue") continue;
        }
        return createdDocument.body.innerHTML;
    }
    /**
   * Constants
   */ var NAME$4 = "tooltip";
    var VERSION$4 = "4.6.2";
    var DATA_KEY$4 = "bs.tooltip";
    var EVENT_KEY$4 = "." + DATA_KEY$4;
    var JQUERY_NO_CONFLICT$4 = $__default["default"].fn[NAME$4];
    var CLASS_PREFIX$1 = "bs-tooltip";
    var BSCLS_PREFIX_REGEX$1 = new RegExp("(^|\\s)" + CLASS_PREFIX$1 + "\\S+", "g");
    var DISALLOWED_ATTRIBUTES = [
        "sanitize",
        "whiteList",
        "sanitizeFn"
    ];
    var CLASS_NAME_FADE$3 = "fade";
    var CLASS_NAME_SHOW$3 = "show";
    var HOVER_STATE_SHOW = "show";
    var HOVER_STATE_OUT = "out";
    var SELECTOR_TOOLTIP_INNER = ".tooltip-inner";
    var SELECTOR_ARROW = ".arrow";
    var TRIGGER_HOVER = "hover";
    var TRIGGER_FOCUS = "focus";
    var TRIGGER_CLICK = "click";
    var TRIGGER_MANUAL = "manual";
    var AttachmentMap = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left"
    };
    var Default$3 = {
        animation: true,
        template: '<div class="tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: false,
        selector: false,
        placement: "top",
        offset: 0,
        container: false,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        customClass: "",
        sanitize: true,
        sanitizeFn: null,
        whiteList: DefaultWhitelist,
        popperConfig: null
    };
    var DefaultType$3 = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        customClass: "(string|function)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)"
    };
    var Event$1 = {
        HIDE: "hide" + EVENT_KEY$4,
        HIDDEN: "hidden" + EVENT_KEY$4,
        SHOW: "show" + EVENT_KEY$4,
        SHOWN: "shown" + EVENT_KEY$4,
        INSERTED: "inserted" + EVENT_KEY$4,
        CLICK: "click" + EVENT_KEY$4,
        FOCUSIN: "focusin" + EVENT_KEY$4,
        FOCUSOUT: "focusout" + EVENT_KEY$4,
        MOUSEENTER: "mouseenter" + EVENT_KEY$4,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$4
    };
    /**
   * Class definition
   */ var Tooltip = /*#__PURE__*/ function() {
        function Tooltip(element, config) {
            if (typeof Popper__default["default"] === "undefined") throw new TypeError("Bootstrap's tooltips require Popper (https://popper.js.org)");
             // Private
            this._isEnabled = true;
            this._timeout = 0;
            this._hoverState = "";
            this._activeTrigger = {};
            this._popper = null; // Protected
            this.element = element;
            this.config = this._getConfig(config);
            this.tip = null;
            this._setListeners();
        } // Getters
        var _proto = Tooltip.prototype;
        // Public
        _proto.enable = function enable() {
            this._isEnabled = true;
        };
        _proto.disable = function disable() {
            this._isEnabled = false;
        };
        _proto.toggleEnabled = function toggleEnabled() {
            this._isEnabled = !this._isEnabled;
        };
        _proto.toggle = function toggle(event) {
            if (!this._isEnabled) return;
            if (event) {
                var dataKey = this.constructor.DATA_KEY;
                var context = $__default["default"](event.currentTarget).data(dataKey);
                if (!context) {
                    context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                    $__default["default"](event.currentTarget).data(dataKey, context);
                }
                context._activeTrigger.click = !context._activeTrigger.click;
                if (context._isWithActiveTrigger()) context._enter(null, context);
                else context._leave(null, context);
            } else {
                if ($__default["default"](this.getTipElement()).hasClass(CLASS_NAME_SHOW$3)) {
                    this._leave(null, this);
                    return;
                }
                this._enter(null, this);
            }
        };
        _proto.dispose = function dispose() {
            clearTimeout(this._timeout);
            $__default["default"].removeData(this.element, this.constructor.DATA_KEY);
            $__default["default"](this.element).off(this.constructor.EVENT_KEY);
            $__default["default"](this.element).closest(".modal").off("hide.bs.modal", this._hideModalHandler);
            if (this.tip) $__default["default"](this.tip).remove();
            this._isEnabled = null;
            this._timeout = null;
            this._hoverState = null;
            this._activeTrigger = null;
            if (this._popper) this._popper.destroy();
            this._popper = null;
            this.element = null;
            this.config = null;
            this.tip = null;
        };
        _proto.show = function show() {
            var _this = this;
            if ($__default["default"](this.element).css("display") === "none") throw new Error("Please use show on visible elements");
            var showEvent = $__default["default"].Event(this.constructor.Event.SHOW);
            if (this.isWithContent() && this._isEnabled) {
                $__default["default"](this.element).trigger(showEvent);
                var shadowRoot = Util.findShadowRoot(this.element);
                var isInTheDom = $__default["default"].contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);
                if (showEvent.isDefaultPrevented() || !isInTheDom) return;
                var tip = this.getTipElement();
                var tipId = Util.getUID(this.constructor.NAME);
                tip.setAttribute("id", tipId);
                this.element.setAttribute("aria-describedby", tipId);
                this.setContent();
                if (this.config.animation) $__default["default"](tip).addClass(CLASS_NAME_FADE$3);
                var placement = typeof this.config.placement === "function" ? this.config.placement.call(this, tip, this.element) : this.config.placement;
                var attachment = this._getAttachment(placement);
                this.addAttachmentClass(attachment);
                var container = this._getContainer();
                $__default["default"](tip).data(this.constructor.DATA_KEY, this);
                if (!$__default["default"].contains(this.element.ownerDocument.documentElement, this.tip)) $__default["default"](tip).appendTo(container);
                $__default["default"](this.element).trigger(this.constructor.Event.INSERTED);
                this._popper = new Popper__default["default"](this.element, tip, this._getPopperConfig(attachment));
                $__default["default"](tip).addClass(CLASS_NAME_SHOW$3);
                $__default["default"](tip).addClass(this.config.customClass); // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().on("mouseover", null, $__default["default"].noop);
                var complete = function complete() {
                    if (_this.config.animation) _this._fixTransition();
                    var prevHoverState = _this._hoverState;
                    _this._hoverState = null;
                    $__default["default"](_this.element).trigger(_this.constructor.Event.SHOWN);
                    if (prevHoverState === HOVER_STATE_OUT) _this._leave(null, _this);
                };
                if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                    var transitionDuration = Util.getTransitionDurationFromElement(this.tip);
                    $__default["default"](this.tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
                } else complete();
            }
        };
        _proto.hide = function hide(callback) {
            var _this2 = this;
            var tip = this.getTipElement();
            var hideEvent = $__default["default"].Event(this.constructor.Event.HIDE);
            var complete = function complete() {
                if (_this2._hoverState !== HOVER_STATE_SHOW && tip.parentNode) tip.parentNode.removeChild(tip);
                _this2._cleanTipClass();
                _this2.element.removeAttribute("aria-describedby");
                $__default["default"](_this2.element).trigger(_this2.constructor.Event.HIDDEN);
                if (_this2._popper !== null) _this2._popper.destroy();
                if (callback) callback();
            };
            $__default["default"](this.element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            $__default["default"](tip).removeClass(CLASS_NAME_SHOW$3); // If this is a touch-enabled device we remove the extra
            // empty mouseover listeners we added for iOS support
            if ("ontouchstart" in document.documentElement) $__default["default"](document.body).children().off("mouseover", null, $__default["default"].noop);
            this._activeTrigger[TRIGGER_CLICK] = false;
            this._activeTrigger[TRIGGER_FOCUS] = false;
            this._activeTrigger[TRIGGER_HOVER] = false;
            if ($__default["default"](this.tip).hasClass(CLASS_NAME_FADE$3)) {
                var transitionDuration = Util.getTransitionDurationFromElement(tip);
                $__default["default"](tip).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
            this._hoverState = "";
        };
        _proto.update = function update() {
            if (this._popper !== null) this._popper.scheduleUpdate();
        } // Protected
        ;
        _proto.isWithContent = function isWithContent() {
            return Boolean(this.getTitle());
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX$1 + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var tip = this.getTipElement();
            this.setElementContent($__default["default"](tip.querySelectorAll(SELECTOR_TOOLTIP_INNER)), this.getTitle());
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3 + " " + CLASS_NAME_SHOW$3);
        };
        _proto.setElementContent = function setElementContent($element, content) {
            if (typeof content === "object" && (content.nodeType || content.jquery)) {
                // Content is a DOM node or a jQuery
                if (this.config.html) {
                    if (!$__default["default"](content).parent().is($element)) $element.empty().append(content);
                } else $element.text($__default["default"](content).text());
                return;
            }
            if (this.config.html) {
                if (this.config.sanitize) content = sanitizeHtml(content, this.config.whiteList, this.config.sanitizeFn);
                $element.html(content);
            } else $element.text(content);
        };
        _proto.getTitle = function getTitle() {
            var title = this.element.getAttribute("data-original-title");
            if (!title) title = typeof this.config.title === "function" ? this.config.title.call(this.element) : this.config.title;
            return title;
        } // Private
        ;
        _proto._getPopperConfig = function _getPopperConfig(attachment) {
            var _this3 = this;
            var defaultBsConfig = {
                placement: attachment,
                modifiers: {
                    offset: this._getOffset(),
                    flip: {
                        behavior: this.config.fallbackPlacement
                    },
                    arrow: {
                        element: SELECTOR_ARROW
                    },
                    preventOverflow: {
                        boundariesElement: this.config.boundary
                    }
                },
                onCreate: function onCreate(data) {
                    if (data.originalPlacement !== data.placement) _this3._handlePopperPlacementChange(data);
                },
                onUpdate: function onUpdate(data) {
                    return _this3._handlePopperPlacementChange(data);
                }
            };
            return _extends({}, defaultBsConfig, this.config.popperConfig);
        };
        _proto._getOffset = function _getOffset() {
            var _this4 = this;
            var offset = {};
            if (typeof this.config.offset === "function") offset.fn = function(data) {
                data.offsets = _extends({}, data.offsets, _this4.config.offset(data.offsets, _this4.element));
                return data;
            };
            else offset.offset = this.config.offset;
            return offset;
        };
        _proto._getContainer = function _getContainer() {
            if (this.config.container === false) return document.body;
            if (Util.isElement(this.config.container)) return $__default["default"](this.config.container);
            return $__default["default"](document).find(this.config.container);
        };
        _proto._getAttachment = function _getAttachment(placement) {
            return AttachmentMap[placement.toUpperCase()];
        };
        _proto._setListeners = function _setListeners() {
            var _this5 = this;
            var triggers = this.config.trigger.split(" ");
            triggers.forEach(function(trigger) {
                if (trigger === "click") $__default["default"](_this5.element).on(_this5.constructor.Event.CLICK, _this5.config.selector, function(event) {
                    return _this5.toggle(event);
                });
                else if (trigger !== TRIGGER_MANUAL) {
                    var eventIn = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSEENTER : _this5.constructor.Event.FOCUSIN;
                    var eventOut = trigger === TRIGGER_HOVER ? _this5.constructor.Event.MOUSELEAVE : _this5.constructor.Event.FOCUSOUT;
                    $__default["default"](_this5.element).on(eventIn, _this5.config.selector, function(event) {
                        return _this5._enter(event);
                    }).on(eventOut, _this5.config.selector, function(event) {
                        return _this5._leave(event);
                    });
                }
            });
            this._hideModalHandler = function() {
                if (_this5.element) _this5.hide();
            };
            $__default["default"](this.element).closest(".modal").on("hide.bs.modal", this._hideModalHandler);
            if (this.config.selector) this.config = _extends({}, this.config, {
                trigger: "manual",
                selector: ""
            });
            else this._fixTitle();
        };
        _proto._fixTitle = function _fixTitle() {
            var titleType = (0, $3J8Kb._)(this.element.getAttribute("data-original-title"));
            if (this.element.getAttribute("title") || titleType !== "string") {
                this.element.setAttribute("data-original-title", this.element.getAttribute("title") || "");
                this.element.setAttribute("title", "");
            }
        };
        _proto._enter = function _enter(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusin" ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
            if ($__default["default"](context.getTipElement()).hasClass(CLASS_NAME_SHOW$3) || context._hoverState === HOVER_STATE_SHOW) {
                context._hoverState = HOVER_STATE_SHOW;
                return;
            }
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_SHOW;
            if (!context.config.delay || !context.config.delay.show) {
                context.show();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_SHOW) context.show();
            }, context.config.delay.show);
        };
        _proto._leave = function _leave(event, context) {
            var dataKey = this.constructor.DATA_KEY;
            context = context || $__default["default"](event.currentTarget).data(dataKey);
            if (!context) {
                context = new this.constructor(event.currentTarget, this._getDelegateConfig());
                $__default["default"](event.currentTarget).data(dataKey, context);
            }
            if (event) context._activeTrigger[event.type === "focusout" ? TRIGGER_FOCUS : TRIGGER_HOVER] = false;
            if (context._isWithActiveTrigger()) return;
            clearTimeout(context._timeout);
            context._hoverState = HOVER_STATE_OUT;
            if (!context.config.delay || !context.config.delay.hide) {
                context.hide();
                return;
            }
            context._timeout = setTimeout(function() {
                if (context._hoverState === HOVER_STATE_OUT) context.hide();
            }, context.config.delay.hide);
        };
        _proto._isWithActiveTrigger = function _isWithActiveTrigger() {
            for(var trigger in this._activeTrigger){
                if (this._activeTrigger[trigger]) return true;
            }
            return false;
        };
        _proto._getConfig = function _getConfig(config) {
            var dataAttributes = $__default["default"](this.element).data();
            Object.keys(dataAttributes).forEach(function(dataAttr) {
                if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) delete dataAttributes[dataAttr];
            });
            config = _extends({}, this.constructor.Default, dataAttributes, typeof config === "object" && config ? config : {});
            if (typeof config.delay === "number") config.delay = {
                show: config.delay,
                hide: config.delay
            };
            if (typeof config.title === "number") config.title = config.title.toString();
            if (typeof config.content === "number") config.content = config.content.toString();
            Util.typeCheckConfig(NAME$4, config, this.constructor.DefaultType);
            if (config.sanitize) config.template = sanitizeHtml(config.template, config.whiteList, config.sanitizeFn);
            return config;
        };
        _proto._getDelegateConfig = function _getDelegateConfig() {
            var config = {};
            if (this.config) {
                for(var key in this.config)if (this.constructor.Default[key] !== this.config[key]) config[key] = this.config[key];
            }
            return config;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX$1);
            if (tabClass !== null && tabClass.length) $tip.removeClass(tabClass.join(""));
        };
        _proto._handlePopperPlacementChange = function _handlePopperPlacementChange(popperData) {
            this.tip = popperData.instance.popper;
            this._cleanTipClass();
            this.addAttachmentClass(this._getAttachment(popperData.placement));
        };
        _proto._fixTransition = function _fixTransition() {
            var tip = this.getTipElement();
            var initConfigAnimation = this.config.animation;
            if (tip.getAttribute("x-placement") !== null) return;
            $__default["default"](tip).removeClass(CLASS_NAME_FADE$3);
            this.config.animation = false;
            this.hide();
            this.show();
            this.config.animation = initConfigAnimation;
        } // Static
        ;
        Tooltip._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY$4);
                var _config = typeof config === "object" && config;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Tooltip(this, _config);
                    $element.data(DATA_KEY$4, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tooltip, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$4;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$3;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$4;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$4;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event$1;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$4;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$3;
                }
            }
        ]);
        return Tooltip;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME$4] = Tooltip._jQueryInterface;
    $__default["default"].fn[NAME$4].Constructor = Tooltip;
    $__default["default"].fn[NAME$4].noConflict = function() {
        $__default["default"].fn[NAME$4] = JQUERY_NO_CONFLICT$4;
        return Tooltip._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$3 = "popover";
    var VERSION$3 = "4.6.2";
    var DATA_KEY$3 = "bs.popover";
    var EVENT_KEY$3 = "." + DATA_KEY$3;
    var JQUERY_NO_CONFLICT$3 = $__default["default"].fn[NAME$3];
    var CLASS_PREFIX = "bs-popover";
    var BSCLS_PREFIX_REGEX = new RegExp("(^|\\s)" + CLASS_PREFIX + "\\S+", "g");
    var CLASS_NAME_FADE$2 = "fade";
    var CLASS_NAME_SHOW$2 = "show";
    var SELECTOR_TITLE = ".popover-header";
    var SELECTOR_CONTENT = ".popover-body";
    var Default$2 = _extends({}, Tooltip.Default, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
    });
    var DefaultType$2 = _extends({}, Tooltip.DefaultType, {
        content: "(string|element|function)"
    });
    var Event = {
        HIDE: "hide" + EVENT_KEY$3,
        HIDDEN: "hidden" + EVENT_KEY$3,
        SHOW: "show" + EVENT_KEY$3,
        SHOWN: "shown" + EVENT_KEY$3,
        INSERTED: "inserted" + EVENT_KEY$3,
        CLICK: "click" + EVENT_KEY$3,
        FOCUSIN: "focusin" + EVENT_KEY$3,
        FOCUSOUT: "focusout" + EVENT_KEY$3,
        MOUSEENTER: "mouseenter" + EVENT_KEY$3,
        MOUSELEAVE: "mouseleave" + EVENT_KEY$3
    };
    /**
   * Class definition
   */ var Popover = /*#__PURE__*/ function(_Tooltip) {
        _inheritsLoose(Popover, _Tooltip);
        function Popover() {
            return _Tooltip.apply(this, arguments) || this;
        }
        var _proto = Popover.prototype;
        // Overrides
        _proto.isWithContent = function isWithContent() {
            return this.getTitle() || this._getContent();
        };
        _proto.addAttachmentClass = function addAttachmentClass(attachment) {
            $__default["default"](this.getTipElement()).addClass(CLASS_PREFIX + "-" + attachment);
        };
        _proto.getTipElement = function getTipElement() {
            this.tip = this.tip || $__default["default"](this.config.template)[0];
            return this.tip;
        };
        _proto.setContent = function setContent() {
            var $tip = $__default["default"](this.getTipElement()); // We use append for html objects to maintain js events
            this.setElementContent($tip.find(SELECTOR_TITLE), this.getTitle());
            var content = this._getContent();
            if (typeof content === "function") content = content.call(this.element);
            this.setElementContent($tip.find(SELECTOR_CONTENT), content);
            $tip.removeClass(CLASS_NAME_FADE$2 + " " + CLASS_NAME_SHOW$2);
        } // Private
        ;
        _proto._getContent = function _getContent() {
            return this.element.getAttribute("data-content") || this.config.content;
        };
        _proto._cleanTipClass = function _cleanTipClass() {
            var $tip = $__default["default"](this.getTipElement());
            var tabClass = $tip.attr("class").match(BSCLS_PREFIX_REGEX);
            if (tabClass !== null && tabClass.length > 0) $tip.removeClass(tabClass.join(""));
        } // Static
        ;
        Popover._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$3);
                var _config = typeof config === "object" ? config : null;
                if (!data && /dispose|hide/.test(config)) return;
                if (!data) {
                    data = new Popover(this, _config);
                    $__default["default"](this).data(DATA_KEY$3, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Popover, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$3;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$2;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME$3;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return DATA_KEY$3;
                }
            },
            {
                key: "Event",
                get: function get() {
                    return Event;
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return EVENT_KEY$3;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType$2;
                }
            }
        ]);
        return Popover;
    }(Tooltip);
    /**
   * jQuery
   */ $__default["default"].fn[NAME$3] = Popover._jQueryInterface;
    $__default["default"].fn[NAME$3].Constructor = Popover;
    $__default["default"].fn[NAME$3].noConflict = function() {
        $__default["default"].fn[NAME$3] = JQUERY_NO_CONFLICT$3;
        return Popover._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$2 = "scrollspy";
    var VERSION$2 = "4.6.2";
    var DATA_KEY$2 = "bs.scrollspy";
    var EVENT_KEY$2 = "." + DATA_KEY$2;
    var DATA_API_KEY$1 = ".data-api";
    var JQUERY_NO_CONFLICT$2 = $__default["default"].fn[NAME$2];
    var CLASS_NAME_DROPDOWN_ITEM = "dropdown-item";
    var CLASS_NAME_ACTIVE$1 = "active";
    var EVENT_ACTIVATE = "activate" + EVENT_KEY$2;
    var EVENT_SCROLL = "scroll" + EVENT_KEY$2;
    var EVENT_LOAD_DATA_API = "load" + EVENT_KEY$2 + DATA_API_KEY$1;
    var METHOD_OFFSET = "offset";
    var METHOD_POSITION = "position";
    var SELECTOR_DATA_SPY = '[data-spy="scroll"]';
    var SELECTOR_NAV_LIST_GROUP$1 = ".nav, .list-group";
    var SELECTOR_NAV_LINKS = ".nav-link";
    var SELECTOR_NAV_ITEMS = ".nav-item";
    var SELECTOR_LIST_ITEMS = ".list-group-item";
    var SELECTOR_DROPDOWN$1 = ".dropdown";
    var SELECTOR_DROPDOWN_ITEMS = ".dropdown-item";
    var SELECTOR_DROPDOWN_TOGGLE$1 = ".dropdown-toggle";
    var Default$1 = {
        offset: 10,
        method: "auto",
        target: ""
    };
    var DefaultType$1 = {
        offset: "number",
        method: "string",
        target: "(string|element)"
    };
    /**
   * Class definition
   */ var ScrollSpy = /*#__PURE__*/ function() {
        function ScrollSpy(element, config) {
            var _this = this;
            this._element = element;
            this._scrollElement = element.tagName === "BODY" ? window : element;
            this._config = this._getConfig(config);
            this._selector = this._config.target + " " + SELECTOR_NAV_LINKS + "," + (this._config.target + " " + SELECTOR_LIST_ITEMS + ",") + (this._config.target + " " + SELECTOR_DROPDOWN_ITEMS);
            this._offsets = [];
            this._targets = [];
            this._activeTarget = null;
            this._scrollHeight = 0;
            $__default["default"](this._scrollElement).on(EVENT_SCROLL, function(event) {
                return _this._process(event);
            });
            this.refresh();
            this._process();
        } // Getters
        var _proto = ScrollSpy.prototype;
        // Public
        _proto.refresh = function refresh() {
            var _this2 = this;
            var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
            var offsetMethod = this._config.method === "auto" ? autoMethod : this._config.method;
            var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
            this._offsets = [];
            this._targets = [];
            this._scrollHeight = this._getScrollHeight();
            var targets = [].slice.call(document.querySelectorAll(this._selector));
            targets.map(function(element) {
                var target;
                var targetSelector = Util.getSelectorFromElement(element);
                if (targetSelector) target = document.querySelector(targetSelector);
                if (target) {
                    var targetBCR = target.getBoundingClientRect();
                    if (targetBCR.width || targetBCR.height) // TODO (fat): remove sketch reliance on jQuery position/offset
                    return [
                        $__default["default"](target)[offsetMethod]().top + offsetBase,
                        targetSelector
                    ];
                }
                return null;
            }).filter(Boolean).sort(function(a, b) {
                return a[0] - b[0];
            }).forEach(function(item) {
                _this2._offsets.push(item[0]);
                _this2._targets.push(item[1]);
            });
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$2);
            $__default["default"](this._scrollElement).off(EVENT_KEY$2);
            this._element = null;
            this._scrollElement = null;
            this._config = null;
            this._selector = null;
            this._offsets = null;
            this._targets = null;
            this._activeTarget = null;
            this._scrollHeight = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default$1, typeof config === "object" && config ? config : {});
            if (typeof config.target !== "string" && Util.isElement(config.target)) {
                var id = $__default["default"](config.target).attr("id");
                if (!id) {
                    id = Util.getUID(NAME$2);
                    $__default["default"](config.target).attr("id", id);
                }
                config.target = "#" + id;
            }
            Util.typeCheckConfig(NAME$2, config, DefaultType$1);
            return config;
        };
        _proto._getScrollTop = function _getScrollTop() {
            return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
        };
        _proto._getScrollHeight = function _getScrollHeight() {
            return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
        };
        _proto._getOffsetHeight = function _getOffsetHeight() {
            return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
        };
        _proto._process = function _process() {
            var scrollTop = this._getScrollTop() + this._config.offset;
            var scrollHeight = this._getScrollHeight();
            var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();
            if (this._scrollHeight !== scrollHeight) this.refresh();
            if (scrollTop >= maxScroll) {
                var target = this._targets[this._targets.length - 1];
                if (this._activeTarget !== target) this._activate(target);
                return;
            }
            if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
                this._activeTarget = null;
                this._clear();
                return;
            }
            for(var i = this._offsets.length; i--;){
                var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === "undefined" || scrollTop < this._offsets[i + 1]);
                if (isActiveTarget) this._activate(this._targets[i]);
            }
        };
        _proto._activate = function _activate(target) {
            this._activeTarget = target;
            this._clear();
            var queries = this._selector.split(",").map(function(selector) {
                return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
            });
            var $link = $__default["default"]([].slice.call(document.querySelectorAll(queries.join(","))));
            if ($link.hasClass(CLASS_NAME_DROPDOWN_ITEM)) {
                $link.closest(SELECTOR_DROPDOWN$1).find(SELECTOR_DROPDOWN_TOGGLE$1).addClass(CLASS_NAME_ACTIVE$1);
                $link.addClass(CLASS_NAME_ACTIVE$1);
            } else {
                // Set triggered link as active
                $link.addClass(CLASS_NAME_ACTIVE$1); // Set triggered links parents as active
                // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_LINKS + ", " + SELECTOR_LIST_ITEMS).addClass(CLASS_NAME_ACTIVE$1); // Handle special case when .nav-link is inside .nav-item
                $link.parents(SELECTOR_NAV_LIST_GROUP$1).prev(SELECTOR_NAV_ITEMS).children(SELECTOR_NAV_LINKS).addClass(CLASS_NAME_ACTIVE$1);
            }
            $__default["default"](this._scrollElement).trigger(EVENT_ACTIVATE, {
                relatedTarget: target
            });
        };
        _proto._clear = function _clear() {
            [].slice.call(document.querySelectorAll(this._selector)).filter(function(node) {
                return node.classList.contains(CLASS_NAME_ACTIVE$1);
            }).forEach(function(node) {
                return node.classList.remove(CLASS_NAME_ACTIVE$1);
            });
        } // Static
        ;
        ScrollSpy._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var data = $__default["default"](this).data(DATA_KEY$2);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new ScrollSpy(this, _config);
                    $__default["default"](this).data(DATA_KEY$2, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(ScrollSpy, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$2;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default$1;
                }
            }
        ]);
        return ScrollSpy;
    }();
    /**
   * Data API implementation
   */ $__default["default"](window).on(EVENT_LOAD_DATA_API, function() {
        var scrollSpys = [].slice.call(document.querySelectorAll(SELECTOR_DATA_SPY));
        var scrollSpysLength = scrollSpys.length;
        for(var i = scrollSpysLength; i--;){
            var $spy = $__default["default"](scrollSpys[i]);
            ScrollSpy._jQueryInterface.call($spy, $spy.data());
        }
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$2] = ScrollSpy._jQueryInterface;
    $__default["default"].fn[NAME$2].Constructor = ScrollSpy;
    $__default["default"].fn[NAME$2].noConflict = function() {
        $__default["default"].fn[NAME$2] = JQUERY_NO_CONFLICT$2;
        return ScrollSpy._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME$1 = "tab";
    var VERSION$1 = "4.6.2";
    var DATA_KEY$1 = "bs.tab";
    var EVENT_KEY$1 = "." + DATA_KEY$1;
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT$1 = $__default["default"].fn[NAME$1];
    var CLASS_NAME_DROPDOWN_MENU = "dropdown-menu";
    var CLASS_NAME_ACTIVE = "active";
    var CLASS_NAME_DISABLED = "disabled";
    var CLASS_NAME_FADE$1 = "fade";
    var CLASS_NAME_SHOW$1 = "show";
    var EVENT_HIDE$1 = "hide" + EVENT_KEY$1;
    var EVENT_HIDDEN$1 = "hidden" + EVENT_KEY$1;
    var EVENT_SHOW$1 = "show" + EVENT_KEY$1;
    var EVENT_SHOWN$1 = "shown" + EVENT_KEY$1;
    var EVENT_CLICK_DATA_API = "click" + EVENT_KEY$1 + DATA_API_KEY;
    var SELECTOR_DROPDOWN = ".dropdown";
    var SELECTOR_NAV_LIST_GROUP = ".nav, .list-group";
    var SELECTOR_ACTIVE = ".active";
    var SELECTOR_ACTIVE_UL = "> li > .active";
    var SELECTOR_DATA_TOGGLE = '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]';
    var SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    var SELECTOR_DROPDOWN_ACTIVE_CHILD = "> .dropdown-menu .active";
    /**
   * Class definition
   */ var Tab = /*#__PURE__*/ function() {
        function Tab(element) {
            this._element = element;
        } // Getters
        var _proto = Tab.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && $__default["default"](this._element).hasClass(CLASS_NAME_ACTIVE) || $__default["default"](this._element).hasClass(CLASS_NAME_DISABLED) || this._element.hasAttribute("disabled")) return;
            var target;
            var previous;
            var listElement = $__default["default"](this._element).closest(SELECTOR_NAV_LIST_GROUP)[0];
            var selector = Util.getSelectorFromElement(this._element);
            if (listElement) {
                var itemSelector = listElement.nodeName === "UL" || listElement.nodeName === "OL" ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
                previous = $__default["default"].makeArray($__default["default"](listElement).find(itemSelector));
                previous = previous[previous.length - 1];
            }
            var hideEvent = $__default["default"].Event(EVENT_HIDE$1, {
                relatedTarget: this._element
            });
            var showEvent = $__default["default"].Event(EVENT_SHOW$1, {
                relatedTarget: previous
            });
            if (previous) $__default["default"](previous).trigger(hideEvent);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return;
            if (selector) target = document.querySelector(selector);
            this._activate(this._element, listElement);
            var complete = function complete() {
                var hiddenEvent = $__default["default"].Event(EVENT_HIDDEN$1, {
                    relatedTarget: _this._element
                });
                var shownEvent = $__default["default"].Event(EVENT_SHOWN$1, {
                    relatedTarget: previous
                });
                $__default["default"](previous).trigger(hiddenEvent);
                $__default["default"](_this._element).trigger(shownEvent);
            };
            if (target) this._activate(target, target.parentNode, complete);
            else complete();
        };
        _proto.dispose = function dispose() {
            $__default["default"].removeData(this._element, DATA_KEY$1);
            this._element = null;
        } // Private
        ;
        _proto._activate = function _activate(element, container, callback) {
            var _this2 = this;
            var activeElements = container && (container.nodeName === "UL" || container.nodeName === "OL") ? $__default["default"](container).find(SELECTOR_ACTIVE_UL) : $__default["default"](container).children(SELECTOR_ACTIVE);
            var active = activeElements[0];
            var isTransitioning = callback && active && $__default["default"](active).hasClass(CLASS_NAME_FADE$1);
            var complete = function complete() {
                return _this2._transitionComplete(element, active, callback);
            };
            if (active && isTransitioning) {
                var transitionDuration = Util.getTransitionDurationFromElement(active);
                $__default["default"](active).removeClass(CLASS_NAME_SHOW$1).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._transitionComplete = function _transitionComplete(element, active, callback) {
            if (active) {
                $__default["default"](active).removeClass(CLASS_NAME_ACTIVE);
                var dropdownChild = $__default["default"](active.parentNode).find(SELECTOR_DROPDOWN_ACTIVE_CHILD)[0];
                if (dropdownChild) $__default["default"](dropdownChild).removeClass(CLASS_NAME_ACTIVE);
                if (active.getAttribute("role") === "tab") active.setAttribute("aria-selected", false);
            }
            $__default["default"](element).addClass(CLASS_NAME_ACTIVE);
            if (element.getAttribute("role") === "tab") element.setAttribute("aria-selected", true);
            Util.reflow(element);
            if (element.classList.contains(CLASS_NAME_FADE$1)) element.classList.add(CLASS_NAME_SHOW$1);
            var parent = element.parentNode;
            if (parent && parent.nodeName === "LI") parent = parent.parentNode;
            if (parent && $__default["default"](parent).hasClass(CLASS_NAME_DROPDOWN_MENU)) {
                var dropdownElement = $__default["default"](element).closest(SELECTOR_DROPDOWN)[0];
                if (dropdownElement) {
                    var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(SELECTOR_DROPDOWN_TOGGLE));
                    $__default["default"](dropdownToggleList).addClass(CLASS_NAME_ACTIVE);
                }
                element.setAttribute("aria-expanded", true);
            }
            if (callback) callback();
        } // Static
        ;
        Tab._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $this = $__default["default"](this);
                var data = $this.data(DATA_KEY$1);
                if (!data) {
                    data = new Tab(this);
                    $this.data(DATA_KEY$1, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config]();
                }
            });
        };
        _createClass(Tab, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION$1;
                }
            }
        ]);
        return Tab;
    }();
    /**
   * Data API implementation
   */ $__default["default"](document).on(EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Tab._jQueryInterface.call($__default["default"](this), "show");
    });
    /**
   * jQuery
   */ $__default["default"].fn[NAME$1] = Tab._jQueryInterface;
    $__default["default"].fn[NAME$1].Constructor = Tab;
    $__default["default"].fn[NAME$1].noConflict = function() {
        $__default["default"].fn[NAME$1] = JQUERY_NO_CONFLICT$1;
        return Tab._jQueryInterface;
    };
    /**
   * Constants
   */ var NAME = "toast";
    var VERSION = "4.6.2";
    var DATA_KEY = "bs.toast";
    var EVENT_KEY = "." + DATA_KEY;
    var JQUERY_NO_CONFLICT = $__default["default"].fn[NAME];
    var CLASS_NAME_FADE = "fade";
    var CLASS_NAME_HIDE = "hide";
    var CLASS_NAME_SHOW = "show";
    var CLASS_NAME_SHOWING = "showing";
    var EVENT_CLICK_DISMISS = "click.dismiss" + EVENT_KEY;
    var EVENT_HIDE = "hide" + EVENT_KEY;
    var EVENT_HIDDEN = "hidden" + EVENT_KEY;
    var EVENT_SHOW = "show" + EVENT_KEY;
    var EVENT_SHOWN = "shown" + EVENT_KEY;
    var SELECTOR_DATA_DISMISS = '[data-dismiss="toast"]';
    var Default = {
        animation: true,
        autohide: true,
        delay: 500
    };
    var DefaultType = {
        animation: "boolean",
        autohide: "boolean",
        delay: "number"
    };
    /**
   * Class definition
   */ var Toast = /*#__PURE__*/ function() {
        function Toast(element, config) {
            this._element = element;
            this._config = this._getConfig(config);
            this._timeout = null;
            this._setListeners();
        } // Getters
        var _proto = Toast.prototype;
        // Public
        _proto.show = function show() {
            var _this = this;
            var showEvent = $__default["default"].Event(EVENT_SHOW);
            $__default["default"](this._element).trigger(showEvent);
            if (showEvent.isDefaultPrevented()) return;
            this._clearTimeout();
            if (this._config.animation) this._element.classList.add(CLASS_NAME_FADE);
            var complete = function complete() {
                _this._element.classList.remove(CLASS_NAME_SHOWING);
                _this._element.classList.add(CLASS_NAME_SHOW);
                $__default["default"](_this._element).trigger(EVENT_SHOWN);
                if (_this._config.autohide) _this._timeout = setTimeout(function() {
                    _this.hide();
                }, _this._config.delay);
            };
            this._element.classList.remove(CLASS_NAME_HIDE);
            Util.reflow(this._element);
            this._element.classList.add(CLASS_NAME_SHOWING);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto.hide = function hide() {
            if (!this._element.classList.contains(CLASS_NAME_SHOW)) return;
            var hideEvent = $__default["default"].Event(EVENT_HIDE);
            $__default["default"](this._element).trigger(hideEvent);
            if (hideEvent.isDefaultPrevented()) return;
            this._close();
        };
        _proto.dispose = function dispose() {
            this._clearTimeout();
            if (this._element.classList.contains(CLASS_NAME_SHOW)) this._element.classList.remove(CLASS_NAME_SHOW);
            $__default["default"](this._element).off(EVENT_CLICK_DISMISS);
            $__default["default"].removeData(this._element, DATA_KEY);
            this._element = null;
            this._config = null;
        } // Private
        ;
        _proto._getConfig = function _getConfig(config) {
            config = _extends({}, Default, $__default["default"](this._element).data(), typeof config === "object" && config ? config : {});
            Util.typeCheckConfig(NAME, config, this.constructor.DefaultType);
            return config;
        };
        _proto._setListeners = function _setListeners() {
            var _this2 = this;
            $__default["default"](this._element).on(EVENT_CLICK_DISMISS, SELECTOR_DATA_DISMISS, function() {
                return _this2.hide();
            });
        };
        _proto._close = function _close() {
            var _this3 = this;
            var complete = function complete() {
                _this3._element.classList.add(CLASS_NAME_HIDE);
                $__default["default"](_this3._element).trigger(EVENT_HIDDEN);
            };
            this._element.classList.remove(CLASS_NAME_SHOW);
            if (this._config.animation) {
                var transitionDuration = Util.getTransitionDurationFromElement(this._element);
                $__default["default"](this._element).one(Util.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
            } else complete();
        };
        _proto._clearTimeout = function _clearTimeout() {
            clearTimeout(this._timeout);
            this._timeout = null;
        } // Static
        ;
        Toast._jQueryInterface = function _jQueryInterface(config) {
            return this.each(function() {
                var $element = $__default["default"](this);
                var data = $element.data(DATA_KEY);
                var _config = typeof config === "object" && config;
                if (!data) {
                    data = new Toast(this, _config);
                    $element.data(DATA_KEY, data);
                }
                if (typeof config === "string") {
                    if (typeof data[config] === "undefined") throw new TypeError('No method named "' + config + '"');
                    data[config](this);
                }
            });
        };
        _createClass(Toast, null, [
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * jQuery
   */ $__default["default"].fn[NAME] = Toast._jQueryInterface;
    $__default["default"].fn[NAME].Constructor = Toast;
    $__default["default"].fn[NAME].noConflict = function() {
        $__default["default"].fn[NAME] = JQUERY_NO_CONFLICT;
        return Toast._jQueryInterface;
    };
    exports1.Alert = Alert;
    exports1.Button = Button;
    exports1.Carousel = Carousel;
    exports1.Collapse = Collapse;
    exports1.Dropdown = Dropdown;
    exports1.Modal = Modal;
    exports1.Popover = Popover;
    exports1.Scrollspy = ScrollSpy;
    exports1.Tab = Tab;
    exports1.Toast = Toast;
    exports1.Tooltip = Tooltip;
    exports1.Util = Util;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});



var $4w9fm = parcelRequire("4w9fm");
/* back-to-top button */ (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(document).ready(function() {
    var back_to_top_button = [
        '<a href="#top" class="back-to-top">Top</a>'
    ].join("");
    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("body").append(back_to_top_button);
    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".back-to-top").hide();
    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(window).scroll(function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).scrollTop() > 100) (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".back-to-top").fadeIn();
            else (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".back-to-top").fadeOut();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".back-to-top").click(function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("body,html").animate({
                scrollTop: 0
            }, 800);
            return false;
        });
    });
});



var $4w9fm = parcelRequire("4w9fm");
var $a031a4fe76b2bbb5$exports = {};
!function(n, t) {
    $a031a4fe76b2bbb5$exports = t();
}($a031a4fe76b2bbb5$exports, function() {
    "use strict";
    function n() {
        return n = Object.assign || function(n) {
            for(var t = 1; t < arguments.length; t++){
                var e = arguments[t];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
            }
            return n;
        }, n.apply(this, arguments);
    }
    var t = "undefined" != typeof window, e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), i = t && "IntersectionObserver" in window, o = t && "classList" in document.createElement("p"), a = t && window.devicePixelRatio > 1, r = {
        elements_selector: ".lazy",
        container: e || t ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, c = function c(t) {
        return n({}, r, t);
    }, l = function l(n, t) {
        var e, i = "LazyLoad::Initialized", o = new n(t);
        try {
            e = new CustomEvent(i, {
                detail: {
                    instance: o
                }
            });
        } catch (n) {
            (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, {
                instance: o
            });
        }
        window.dispatchEvent(e);
    }, u = "src", s = "srcset", d = "sizes", f = "poster", _ = "llOriginalAttrs", g = "data", v = "loading", b = "loaded", p = "applied", m = "error", h = "native", E = "data-", I = "ll-status", y = function y(n, t) {
        return n.getAttribute(E + t);
    }, k = function k(n) {
        return y(n, I);
    }, w = function w(n, t) {
        return function(n, t, e) {
            var i = "data-ll-status";
            null !== e ? n.setAttribute(i, e) : n.removeAttribute(i);
        }(n, 0, t);
    }, A = function A(n) {
        return w(n, null);
    }, L = function L(n) {
        return null === k(n);
    }, O = function O(n) {
        return k(n) === h;
    }, x = [
        v,
        b,
        p,
        m
    ], C = function C(n, t, e, i) {
        n && "function" == typeof n && (void 0 === i ? void 0 === e ? n(t) : n(t, e) : n(t, e, i));
    }, N = function N(n, t) {
        "" !== t && (o ? n.classList.add(t) : n.className += (n.className ? " " : "") + t);
    }, M = function M(n, t) {
        "" !== t && (o ? n.classList.remove(t) : n.className = n.className.replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, ""));
    }, z = function z(n) {
        return n.llTempImage;
    }, T = function T(n, t) {
        if (t) {
            var e = t._observer;
            e && e.unobserve(n);
        }
    }, R = function R(n, t) {
        n && (n.loadingCount += t);
    }, G = function G(n, t) {
        n && (n.toLoadCount = t);
    }, j = function j(n) {
        for(var t, e = [], i = 0; t = n.children[i]; i += 1)"SOURCE" === t.tagName && e.push(t);
        return e;
    }, D = function D(n, t) {
        var e = n.parentNode;
        e && "PICTURE" === e.tagName && j(e).forEach(t);
    }, H = function H(n, t) {
        j(n).forEach(t);
    }, V = [
        u
    ], F = [
        u,
        f
    ], B = [
        u,
        s,
        d
    ], J = [
        g
    ], P = function P(n) {
        return !!n[_];
    }, S = function S(n) {
        return n[_];
    }, U = function U(n) {
        return delete n[_];
    }, $ = function $(n, t) {
        if (!P(n)) {
            var e = {};
            t.forEach(function(t) {
                e[t] = n.getAttribute(t);
            }), n[_] = e;
        }
    }, q = function q(n, t) {
        if (P(n)) {
            var e = S(n);
            t.forEach(function(t) {
                !function(n, t, e) {
                    e ? n.setAttribute(t, e) : n.removeAttribute(t);
                }(n, t, e[t]);
            });
        }
    }, K = function K(n, t, e) {
        N(n, t.class_applied), w(n, p), e && (t.unobserve_completed && T(n, t), C(t.callback_applied, n, e));
    }, Q = function Q(n, t, e) {
        N(n, t.class_loading), w(n, v), e && (R(e, 1), C(t.callback_loading, n, e));
    }, W = function W(n, t, e) {
        e && n.setAttribute(t, e);
    }, X = function X(n, t) {
        W(n, d, y(n, t.data_sizes)), W(n, s, y(n, t.data_srcset)), W(n, u, y(n, t.data_src));
    }, Y = {
        IMG: function IMG(n, t) {
            D(n, function(n) {
                $(n, B), X(n, t);
            }), $(n, B), X(n, t);
        },
        IFRAME: function IFRAME(n, t) {
            $(n, V), W(n, u, y(n, t.data_src));
        },
        VIDEO: function VIDEO(n, t) {
            H(n, function(n) {
                $(n, V), W(n, u, y(n, t.data_src));
            }), $(n, F), W(n, f, y(n, t.data_poster)), W(n, u, y(n, t.data_src)), n.load();
        },
        OBJECT: function OBJECT(n, t) {
            $(n, J), W(n, g, y(n, t.data_src));
        }
    }, Z = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], nn = function nn(n, t) {
        !t || function(n) {
            return n.loadingCount > 0;
        }(t) || function(n) {
            return n.toLoadCount > 0;
        }(t) || C(n.callback_finish, t);
    }, tn = function tn(n, t, e) {
        n.addEventListener(t, e), n.llEvLisnrs[t] = e;
    }, en = function en(n, t, e) {
        n.removeEventListener(t, e);
    }, on = function on(n) {
        return !!n.llEvLisnrs;
    }, an = function an(n) {
        if (on(n)) {
            var t = n.llEvLisnrs;
            for(var e in t){
                var i = t[e];
                en(n, e, i);
            }
            delete n.llEvLisnrs;
        }
    }, rn = function rn(n, t, e) {
        !function(n) {
            delete n.llTempImage;
        }(n), R(e, -1), function(n) {
            n && (n.toLoadCount -= 1);
        }(e), M(n, t.class_loading), t.unobserve_completed && T(n, e);
    }, cn = function cn(n, t, e) {
        var i = z(n) || n;
        on(i) || function(n, t, e) {
            on(n) || (n.llEvLisnrs = {});
            var i = "VIDEO" === n.tagName ? "loadeddata" : "load";
            tn(n, i, t), tn(n, "error", e);
        }(i, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_loaded), w(t, b), C(e.callback_loaded, t, i), o || nn(e, i);
            }(0, n, t, e), an(i);
        }, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_error), w(t, m), C(e.callback_error, t, i), e.restore_on_error && q(t, B), o || nn(e, i);
            }(0, n, t, e), an(i);
        });
    }, ln = function ln(n, t, e) {
        !function(n) {
            return Z.indexOf(n.tagName) > -1;
        }(n) ? function(n, t, e) {
            !function(n) {
                n.llTempImage = document.createElement("IMG");
            }(n), cn(n, t, e), function(n) {
                P(n) || (n[_] = {
                    backgroundImage: n.style.backgroundImage
                });
            }(n), function(n, t, e) {
                var i = y(n, t.data_bg), o = y(n, t.data_bg_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = 'url("'.concat(r, '")'), z(n).setAttribute(u, r), Q(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_multi), o = y(n, t.data_bg_multi_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = r, K(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_set);
                if (i) {
                    var o = i.split("|"), a = o.map(function(n) {
                        return "image-set(".concat(n, ")");
                    });
                    n.style.backgroundImage = a.join(), "" === n.style.backgroundImage && (a = o.map(function(n) {
                        return "-webkit-image-set(".concat(n, ")");
                    }), n.style.backgroundImage = a.join()), K(n, t, e);
                }
            }(n, t, e);
        }(n, t, e) : function(n, t, e) {
            cn(n, t, e), function(n, t, e) {
                var i = Y[n.tagName];
                i && (i(n, t), Q(n, t, e));
            }(n, t, e);
        }(n, t, e);
    }, un = function un(n) {
        n.removeAttribute(u), n.removeAttribute(s), n.removeAttribute(d);
    }, sn = function sn(n) {
        D(n, function(n) {
            q(n, B);
        }), q(n, B);
    }, dn = {
        IMG: sn,
        IFRAME: function IFRAME(n) {
            q(n, V);
        },
        VIDEO: function VIDEO(n) {
            H(n, function(n) {
                q(n, V);
            }), q(n, F), n.load();
        },
        OBJECT: function OBJECT(n) {
            q(n, J);
        }
    }, fn = function fn(n, t) {
        (function(n) {
            var _$t = dn[n.tagName];
            _$t ? _$t(n) : function(n) {
                if (P(n)) {
                    var _$t = S(n);
                    n.style.backgroundImage = _$t.backgroundImage;
                }
            }(n);
        })(n), function(n, t) {
            L(n) || O(n) || (M(n, t.class_entered), M(n, t.class_exited), M(n, t.class_applied), M(n, t.class_loading), M(n, t.class_loaded), M(n, t.class_error));
        }(n, t), A(n), U(n);
    }, _n = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], gn = function gn(n) {
        return n.use_native && "loading" in HTMLImageElement.prototype;
    }, vn = function vn(n, t, e) {
        n.forEach(function(n) {
            return function(n) {
                return n.isIntersecting || n.intersectionRatio > 0;
            }(n) ? function(n, t, e, i) {
                var o = function(n) {
                    return x.indexOf(k(n)) >= 0;
                }(n);
                w(n, "entered"), N(n, e.class_entered), M(n, e.class_exited), function(n, t, e) {
                    t.unobserve_entered && T(n, e);
                }(n, e, i), C(e.callback_enter, n, t, i), o || ln(n, e, i);
            }(n.target, n, t, e) : function(n, t, e, i) {
                L(n) || (N(n, e.class_exited), function(n, t, e, i) {
                    e.cancel_on_exit && function(n) {
                        return k(n) === v;
                    }(n) && "IMG" === n.tagName && (an(n), function(n) {
                        D(n, function(n) {
                            un(n);
                        }), un(n);
                    }(n), sn(n), M(n, e.class_loading), R(i, -1), A(n), C(e.callback_cancel, n, t, i));
                }(n, t, e, i), C(e.callback_exit, n, t, i));
            }(n.target, n, t, e);
        });
    }, bn = function bn(n) {
        return Array.prototype.slice.call(n);
    }, pn = function pn(n) {
        return n.container.querySelectorAll(n.elements_selector);
    }, mn = function mn(n) {
        return function(n) {
            return k(n) === m;
        }(n);
    }, hn = function hn(n, t) {
        return function(n) {
            return bn(n).filter(L);
        }(n || pn(t));
    }, En = function En(n, e) {
        var o = c(n);
        this._settings = o, this.loadingCount = 0, function(n, t) {
            i && !gn(n) && (t._observer = new IntersectionObserver(function(e) {
                vn(e, n, t);
            }, function(n) {
                return {
                    root: n.container === document ? null : n.container,
                    rootMargin: n.thresholds || n.threshold + "px"
                };
            }(n)));
        }(o, this), function(n, e) {
            t && (e._onlineHandler = function() {
                !function(n, t) {
                    var _$e;
                    (_$e = pn(n), bn(_$e).filter(mn)).forEach(function(t) {
                        M(t, n.class_error), A(t);
                    }), t.update();
                }(n, e);
            }, window.addEventListener("online", e._onlineHandler));
        }(o, this), this.update(e);
    };
    return En.prototype = {
        update: function update(n) {
            var t, o, a = this._settings, r = hn(n, a);
            G(this, r.length), !e && i ? gn(a) ? function(n, t, e) {
                n.forEach(function(n) {
                    -1 !== _n.indexOf(n.tagName) && function(n, t, e) {
                        n.setAttribute("loading", "lazy"), cn(n, t, e), function(n, t) {
                            var _$e = Y[n.tagName];
                            _$e && _$e(n, t);
                        }(n, t), w(n, h);
                    }(n, t, e);
                }), G(e, 0);
            }(r, a, this) : (o = r, function(n) {
                n.disconnect();
            }(t = this._observer), function(n, t) {
                t.forEach(function(t) {
                    n.observe(t);
                });
            }(t, o)) : this.loadAll(r);
        },
        destroy: function destroy() {
            this._observer && this._observer.disconnect(), t && window.removeEventListener("online", this._onlineHandler), pn(this._settings).forEach(function(n) {
                U(n);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function loadAll(n) {
            var t = this, e = this._settings;
            hn(n, e).forEach(function(n) {
                T(n, t), ln(n, e, t);
            });
        },
        restoreAll: function restoreAll() {
            var n = this._settings;
            pn(n).forEach(function(t) {
                fn(t, n);
            });
        }
    }, En.load = function(n, t) {
        var e = c(t);
        ln(n, e);
    }, En.resetStatus = function(n) {
        A(n);
    }, t && function(n, t) {
        if (t) {
            if (t.length) for(var e, i = 0; e = t[i]; i += 1)l(n, e);
            else l(n, t);
        }
    }(En, window.lazyLoadOptions), En;
});


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)));
var $2e444fead9f2ba6c$var$aLazyLoad = new (0, (/*@__PURE__*/$parcel$interopDefault($a031a4fe76b2bbb5$exports)))({
    threshold: 0
});



var $4w9fm = parcelRequire("4w9fm");
(function($) {
    var focused = true;
    //FlexSlider: Object Instance
    $.flexslider = function(el, options) {
        var slider = $(el);
        // making variables public
        //if rtl value was not passed and html is in rtl..enable it by default.
        if (typeof options.rtl == "undefined" && $("html").attr("dir") == "rtl") options.rtl = true;
        slider.vars = $.extend({}, $.flexslider.defaults, options);
        var namespace = slider.vars.namespace, msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture, touch = ("ontouchstart" in window || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch, // deprecating this idea, as devices are being released with both of these events
        eventType = "click touchend MSPointerUp keyup", watchedEvent = "", watchedEventClearTimer, vertical = slider.vars.direction === "vertical", reverse = slider.vars.reverse, carousel = slider.vars.itemWidth > 0, fade = slider.vars.animation === "fade", asNav = slider.vars.asNavFor !== "", methods = {};
        // Store a reference to the slider object
        $.data(el, "flexslider", slider);
        // Private slider methods
        methods = {
            init: function init() {
                slider.animating = false;
                // Get current slide and make sure it is a number
                slider.currentSlide = parseInt(slider.vars.startAt ? slider.vars.startAt : 0, 10);
                if (isNaN(slider.currentSlide)) slider.currentSlide = 0;
                slider.animatingTo = slider.currentSlide;
                slider.atEnd = slider.currentSlide === 0 || slider.currentSlide === slider.last;
                slider.containerSelector = slider.vars.selector.substr(0, slider.vars.selector.search(" "));
                slider.slides = $(slider.vars.selector, slider);
                slider.container = $(slider.containerSelector, slider);
                slider.count = slider.slides.length;
                // SYNC:
                slider.syncExists = $(slider.vars.sync).length > 0;
                // SLIDE:
                if (slider.vars.animation === "slide") slider.vars.animation = "swing";
                slider.prop = vertical ? "top" : slider.vars.rtl ? "marginRight" : "marginLeft";
                slider.args = {};
                // SLIDESHOW:
                slider.manualPause = false;
                slider.stopped = false;
                //PAUSE WHEN INVISIBLE
                slider.started = false;
                slider.startTimeout = null;
                // TOUCH/USECSS:
                slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && function() {
                    var obj = document.createElement("div"), props = [
                        "perspectiveProperty",
                        "WebkitPerspective",
                        "MozPerspective",
                        "OPerspective",
                        "msPerspective"
                    ];
                    for(var i in props)if (obj.style[props[i]] !== undefined) {
                        slider.pfx = props[i].replace("Perspective", "").toLowerCase();
                        slider.prop = "-" + slider.pfx + "-transform";
                        return true;
                    }
                    return false;
                }();
                slider.isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
                slider.ensureAnimationEnd = "";
                // CONTROLSCONTAINER:
                if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
                // MANUAL:
                if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);
                // CUSTOM DIRECTION NAV:
                if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);
                // RANDOMIZE:
                if (slider.vars.randomize) {
                    slider.slides.sort(function() {
                        return Math.round(Math.random()) - 0.5;
                    });
                    slider.container.empty().append(slider.slides);
                }
                slider.doMath();
                // INIT
                slider.setup("init");
                // CONTROLNAV:
                if (slider.vars.controlNav) methods.controlNav.setup();
                // DIRECTIONNAV:
                if (slider.vars.directionNav) methods.directionNav.setup();
                // KEYBOARD:
                if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) $(document).bind("keyup", function(event) {
                    var keycode = event.keyCode;
                    if (!slider.animating && (keycode === 39 || keycode === 37)) {
                        var target = slider.vars.rtl ? keycode === 37 ? slider.getTarget("next") : keycode === 39 ? slider.getTarget("prev") : false : keycode === 39 ? slider.getTarget("next") : keycode === 37 ? slider.getTarget("prev") : false;
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                    }
                });
                // MOUSEWHEEL:
                if (slider.vars.mousewheel) slider.bind("mousewheel", function(event, delta, deltaX, deltaY) {
                    event.preventDefault();
                    var target = delta < 0 ? slider.getTarget("next") : slider.getTarget("prev");
                    slider.flexAnimate(target, slider.vars.pauseOnAction);
                });
                // PAUSEPLAY
                if (slider.vars.pausePlay) methods.pausePlay.setup();
                //PAUSE WHEN INVISIBLE
                if (slider.vars.slideshow && slider.vars.pauseInvisible) methods.pauseInvisible.init();
                // SLIDSESHOW
                if (slider.vars.slideshow) {
                    if (slider.vars.pauseOnHover) slider.hover(function() {
                        if (!slider.manualPlay && !slider.manualPause) slider.pause();
                    }, function() {
                        if (!slider.manualPause && !slider.manualPlay && !slider.stopped) slider.play();
                    });
                    // initialize animation
                    //If we're visible, or we don't use PageVisibility API
                    if (!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) slider.vars.initDelay > 0 ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
                }
                // ASNAV:
                if (asNav) methods.asNav.setup();
                // TOUCH
                if (touch && slider.vars.touch) methods.touch();
                // FADE&&SMOOTHHEIGHT || SLIDE:
                if (!fade || fade && slider.vars.smoothHeight) $(window).bind("resize orientationchange focus", methods.resize);
                slider.find("img").attr("draggable", "false");
                // API: start() Callback
                setTimeout(function() {
                    slider.vars.start(slider);
                }, 200);
            },
            asNav: {
                setup: function setup() {
                    slider.asNav = true;
                    slider.animatingTo = Math.floor(slider.currentSlide / slider.move);
                    slider.currentItem = slider.currentSlide;
                    slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
                    if (!msGesture) slider.slides.on(eventType, function(e) {
                        e.preventDefault();
                        var $slide = $(this), target = $slide.index();
                        var posFromX;
                        if (slider.vars.rtl) posFromX = -1 * ($slide.offset().right - $(slider).scrollLeft()); // Find position of slide relative to right of slider container
                        else posFromX = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                        if (posFromX <= 0 && $slide.hasClass(namespace + "active-slide")) slider.flexAnimate(slider.getTarget("prev"), true);
                        else if (!$(slider.vars.asNavFor).data("flexslider").animating && !$slide.hasClass(namespace + "active-slide")) {
                            slider.direction = slider.currentItem < target ? "next" : "prev";
                            slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                        }
                    });
                    else {
                        el._slider = slider;
                        slider.slides.each(function() {
                            var that = this;
                            that._gesture = new MSGesture();
                            that._gesture.target = that;
                            that.addEventListener("MSPointerDown", function(e) {
                                e.preventDefault();
                                if (e.currentTarget._gesture) e.currentTarget._gesture.addPointer(e.pointerId);
                            }, false);
                            that.addEventListener("MSGestureTap", function(e) {
                                e.preventDefault();
                                var $slide = $(this), target = $slide.index();
                                if (!$(slider.vars.asNavFor).data("flexslider").animating && !$slide.hasClass("active")) {
                                    slider.direction = slider.currentItem < target ? "next" : "prev";
                                    slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                                }
                            });
                        });
                    }
                }
            },
            controlNav: {
                setup: function setup() {
                    if (!slider.manualControls) methods.controlNav.setupPaging();
                    else methods.controlNav.setupManual();
                },
                setupPaging: function setupPaging() {
                    var type = slider.vars.controlNav === "thumbnails" ? "control-thumbs" : "control-paging", j = 1, item, slide;
                    slider.controlNavScaffold = $('<ol class="' + namespace + "control-nav " + namespace + type + '"></ol>');
                    if (slider.pagingCount > 1) for(var i = 0; i < slider.pagingCount; i++){
                        slide = slider.slides.eq(i);
                        if (undefined === slide.attr("data-thumb-alt")) slide.attr("data-thumb-alt", "");
                        item = $("<a></a>").attr("href", "#").text(j);
                        if (slider.vars.controlNav === "thumbnails") item = $("<img/>").attr("src", slide.attr("data-thumb"));
                        if ("" !== slide.attr("data-thumb-alt")) item.attr("alt", slide.attr("data-thumb-alt"));
                        if ("thumbnails" === slider.vars.controlNav && true === slider.vars.thumbCaptions) {
                            var captn = slide.attr("data-thumbcaption");
                            if ("" !== captn && undefined !== captn) {
                                var caption = $("<span></span>").addClass(namespace + "caption").text(captn);
                                item.append(caption);
                            }
                        }
                        var liElement = $("<li>");
                        item.appendTo(liElement);
                        liElement.append("</li>");
                        slider.controlNavScaffold.append(liElement);
                        j++;
                    }
                    // CONTROLSCONTAINER:
                    slider.controlsContainer ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
                    methods.controlNav.set();
                    methods.controlNav.active();
                    slider.controlNavScaffold.delegate("a, img", eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            var $this = $(this), target = slider.controlNav.index($this);
                            if (!$this.hasClass(namespace + "active")) {
                                slider.direction = target > slider.currentSlide ? "next" : "prev";
                                slider.flexAnimate(target, slider.vars.pauseOnAction);
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                setupManual: function setupManual() {
                    slider.controlNav = slider.manualControls;
                    methods.controlNav.active();
                    slider.controlNav.bind(eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            var $this = $(this), target = slider.controlNav.index($this);
                            if (!$this.hasClass(namespace + "active")) {
                                target > slider.currentSlide ? slider.direction = "next" : slider.direction = "prev";
                                slider.flexAnimate(target, slider.vars.pauseOnAction);
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                set: function set() {
                    var selector = slider.vars.controlNav === "thumbnails" ? "img" : "a";
                    slider.controlNav = $("." + namespace + "control-nav li " + selector, slider.controlsContainer ? slider.controlsContainer : slider);
                },
                active: function active() {
                    slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
                },
                update: function update(action, pos) {
                    if (slider.pagingCount > 1 && action === "add") slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + "</a></li>"));
                    else if (slider.pagingCount === 1) slider.controlNavScaffold.find("li").remove();
                    else slider.controlNav.eq(pos).closest("li").remove();
                    methods.controlNav.set();
                    slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length ? slider.update(pos, action) : methods.controlNav.active();
                }
            },
            directionNav: {
                setup: function setup() {
                    var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + "</a></li></ul>");
                    // CUSTOM DIRECTION NAV:
                    if (slider.customDirectionNav) slider.directionNav = slider.customDirectionNav;
                    else if (slider.controlsContainer) {
                        $(slider.controlsContainer).append(directionNavScaffold);
                        slider.directionNav = $("." + namespace + "direction-nav li a", slider.controlsContainer);
                    } else {
                        slider.append(directionNavScaffold);
                        slider.directionNav = $("." + namespace + "direction-nav li a", slider);
                    }
                    methods.directionNav.update();
                    slider.directionNav.bind(eventType, function(event) {
                        event.preventDefault();
                        var target;
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            target = $(this).hasClass(namespace + "next") ? slider.getTarget("next") : slider.getTarget("prev");
                            slider.flexAnimate(target, slider.vars.pauseOnAction);
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                update: function update() {
                    var disabledClass = namespace + "disabled";
                    if (slider.pagingCount === 1) slider.directionNav.addClass(disabledClass).attr("tabindex", "-1");
                    else if (!slider.vars.animationLoop) {
                        if (slider.animatingTo === 0) slider.directionNav.removeClass(disabledClass).filter("." + namespace + "prev").addClass(disabledClass).attr("tabindex", "-1");
                        else if (slider.animatingTo === slider.last) slider.directionNav.removeClass(disabledClass).filter("." + namespace + "next").addClass(disabledClass).attr("tabindex", "-1");
                        else slider.directionNav.removeClass(disabledClass).removeAttr("tabindex");
                    } else slider.directionNav.removeClass(disabledClass).removeAttr("tabindex");
                }
            },
            pausePlay: {
                setup: function setup() {
                    var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');
                    // CONTROLSCONTAINER:
                    if (slider.controlsContainer) {
                        slider.controlsContainer.append(pausePlayScaffold);
                        slider.pausePlay = $("." + namespace + "pauseplay a", slider.controlsContainer);
                    } else {
                        slider.append(pausePlayScaffold);
                        slider.pausePlay = $("." + namespace + "pauseplay a", slider);
                    }
                    methods.pausePlay.update(slider.vars.slideshow ? namespace + "pause" : namespace + "play");
                    slider.pausePlay.bind(eventType, function(event) {
                        event.preventDefault();
                        if (watchedEvent === "" || watchedEvent === event.type) {
                            if ($(this).hasClass(namespace + "pause")) {
                                slider.manualPause = true;
                                slider.manualPlay = false;
                                slider.pause();
                            } else {
                                slider.manualPause = false;
                                slider.manualPlay = true;
                                slider.play();
                            }
                        }
                        // setup flags to prevent event duplication
                        if (watchedEvent === "") watchedEvent = event.type;
                        methods.setToClearWatchedEvent();
                    });
                },
                update: function update(state) {
                    state === "play" ? slider.pausePlay.removeClass(namespace + "pause").addClass(namespace + "play").html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + "play").addClass(namespace + "pause").html(slider.vars.pauseText);
                }
            },
            touch: function touch() {
                var startX, startY, offset, cwidth, dx, startT, onTouchStart, onTouchMove, onTouchEnd, scrolling = false, localX = 0, localY = 0, accDx = 0;
                if (!msGesture) {
                    onTouchStart = function onTouchStart(e) {
                        if (slider.animating) e.preventDefault();
                        else if (window.navigator.msPointerEnabled || e.touches.length === 1) {
                            slider.pause();
                            // CAROUSEL:
                            cwidth = vertical ? slider.h : slider.w;
                            startT = Number(new Date());
                            // CAROUSEL:
                            // Local vars for X and Y points.
                            localX = e.touches[0].pageX;
                            localY = e.touches[0].pageY;
                            offset = carousel && reverse && slider.animatingTo === slider.last ? 0 : carousel && reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : carousel && slider.currentSlide === slider.last ? slider.limit : carousel ? (slider.itemW + slider.vars.itemMargin) * slider.move * slider.currentSlide : reverse ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                            startX = vertical ? localY : localX;
                            startY = vertical ? localX : localY;
                            el.addEventListener("touchmove", onTouchMove, false);
                            el.addEventListener("touchend", onTouchEnd, false);
                        }
                    };
                    onTouchMove = function onTouchMove(e) {
                        // Local vars for X and Y points.
                        localX = e.touches[0].pageX;
                        localY = e.touches[0].pageY;
                        dx = vertical ? startX - localY : (slider.vars.rtl ? -1 : 1) * (startX - localX);
                        scrolling = vertical ? Math.abs(dx) < Math.abs(localX - startY) : Math.abs(dx) < Math.abs(localY - startY);
                        var fxms = 500;
                        if (!scrolling || Number(new Date()) - startT > fxms) {
                            e.preventDefault();
                            if (!fade && slider.transitions) {
                                if (!slider.vars.animationLoop) dx = dx / (slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0 ? Math.abs(dx) / cwidth + 2 : 1);
                                slider.setProps(offset + dx, "setTouch");
                            }
                        }
                    };
                    onTouchEnd = function(e) {
                        // finish the touch by undoing the touch session
                        el.removeEventListener("touchmove", onTouchMove, false);
                        if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                            var updateDx = reverse ? -dx : dx, target = updateDx > 0 ? slider.getTarget("next") : slider.getTarget("prev");
                            if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth / 2)) slider.flexAnimate(target, slider.vars.pauseOnAction);
                            else if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                        }
                        el.removeEventListener("touchend", onTouchEnd, false);
                        startX = null;
                        startY = null;
                        dx = null;
                        offset = null;
                    };
                    el.addEventListener("touchstart", onTouchStart, false);
                } else {
                    var onMSPointerDown = function onMSPointerDown(e) {
                        e.stopPropagation();
                        if (slider.animating) e.preventDefault();
                        else {
                            slider.pause();
                            el._gesture.addPointer(e.pointerId);
                            accDx = 0;
                            cwidth = vertical ? slider.h : slider.w;
                            startT = Number(new Date());
                            // CAROUSEL:
                            offset = carousel && reverse && slider.animatingTo === slider.last ? 0 : carousel && reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : carousel && slider.currentSlide === slider.last ? slider.limit : carousel ? (slider.itemW + slider.vars.itemMargin) * slider.move * slider.currentSlide : reverse ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                        }
                    };
                    var onMSGestureChange = function onMSGestureChange(e) {
                        e.stopPropagation();
                        var slider = e.target._slider;
                        if (!slider) return;
                        var transX = -e.translationX, transY = -e.translationY;
                        //Accumulate translations.
                        accDx = accDx + (vertical ? transY : transX);
                        dx = (slider.vars.rtl ? -1 : 1) * accDx;
                        scrolling = vertical ? Math.abs(accDx) < Math.abs(-transX) : Math.abs(accDx) < Math.abs(-transY);
                        if (e.detail === e.MSGESTURE_FLAG_INERTIA) {
                            setImmediate(function() {
                                el._gesture.stop();
                            });
                            return;
                        }
                        if (!scrolling || Number(new Date()) - startT > 500) {
                            e.preventDefault();
                            if (!fade && slider.transitions) {
                                if (!slider.vars.animationLoop) dx = accDx / (slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0 ? Math.abs(accDx) / cwidth + 2 : 1);
                                slider.setProps(offset + dx, "setTouch");
                            }
                        }
                    };
                    var onMSGestureEnd = function onMSGestureEnd(e) {
                        e.stopPropagation();
                        var slider = e.target._slider;
                        if (!slider) return;
                        if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                            var updateDx = reverse ? -dx : dx, target = updateDx > 0 ? slider.getTarget("next") : slider.getTarget("prev");
                            if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth / 2)) slider.flexAnimate(target, slider.vars.pauseOnAction);
                            else if (!fade) slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true);
                        }
                        startX = null;
                        startY = null;
                        dx = null;
                        offset = null;
                        accDx = 0;
                    };
                    el.style.msTouchAction = "none";
                    el._gesture = new MSGesture();
                    el._gesture.target = el;
                    el.addEventListener("MSPointerDown", onMSPointerDown, false);
                    el._slider = slider;
                    el.addEventListener("MSGestureChange", onMSGestureChange, false);
                    el.addEventListener("MSGestureEnd", onMSGestureEnd, false);
                }
            },
            resize: function resize() {
                if (!slider.animating && slider.is(":visible")) {
                    if (!carousel) slider.doMath();
                    if (fade) // SMOOTH HEIGHT:
                    methods.smoothHeight();
                    else if (carousel) {
                        slider.slides.width(slider.computedW);
                        slider.update(slider.pagingCount);
                        slider.setProps();
                    } else if (vertical) {
                        slider.viewport.height(slider.h);
                        slider.setProps(slider.h, "setTotal");
                    } else {
                        // SMOOTH HEIGHT:
                        if (slider.vars.smoothHeight) methods.smoothHeight();
                        slider.newSlides.width(slider.computedW);
                        slider.setProps(slider.computedW, "setTotal");
                    }
                }
            },
            smoothHeight: function smoothHeight(dur) {
                if (!vertical || fade) {
                    var $obj = fade ? slider : slider.viewport;
                    dur ? $obj.animate({
                        height: slider.slides.eq(slider.animatingTo).innerHeight()
                    }, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
                }
            },
            sync: function sync(action) {
                var $obj = $(slider.vars.sync).data("flexslider"), target = slider.animatingTo;
                switch(action){
                    case "animate":
                        $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true);
                        break;
                    case "play":
                        if (!$obj.playing && !$obj.asNav) $obj.play();
                        break;
                    case "pause":
                        $obj.pause();
                        break;
                }
            },
            uniqueID: function uniqueID($clone) {
                // Append _clone to current level and children elements with id attributes
                $clone.filter("[id]").add($clone.find("[id]")).each(function() {
                    var $this = $(this);
                    $this.attr("id", $this.attr("id") + "_clone");
                });
                return $clone;
            },
            pauseInvisible: {
                visProp: null,
                init: function init() {
                    var visProp = methods.pauseInvisible.getHiddenProp();
                    if (visProp) {
                        var evtname = visProp.replace(/[H|h]idden/, "") + "visibilitychange";
                        document.addEventListener(evtname, function() {
                            if (methods.pauseInvisible.isHidden()) {
                                if (slider.startTimeout) clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                                else slider.pause(); //Or just pause
                            } else {
                                if (slider.started) slider.play(); //Initiated before, just play
                                else if (slider.vars.initDelay > 0) setTimeout(slider.play, slider.vars.initDelay);
                                else slider.play(); //Didn't init before: simply init or wait for it
                            }
                        });
                    }
                },
                isHidden: function isHidden() {
                    var prop = methods.pauseInvisible.getHiddenProp();
                    if (!prop) return false;
                    return document[prop];
                },
                getHiddenProp: function getHiddenProp() {
                    var prefixes = [
                        "webkit",
                        "moz",
                        "ms",
                        "o"
                    ];
                    // if 'hidden' is natively supported just return it
                    if ("hidden" in document) return "hidden";
                    // otherwise loop over all the known prefixes until we find one
                    for(var i = 0; i < prefixes.length; i++){
                        if (prefixes[i] + "Hidden" in document) return prefixes[i] + "Hidden";
                    }
                    // otherwise it's not supported
                    return null;
                }
            },
            setToClearWatchedEvent: function setToClearWatchedEvent() {
                clearTimeout(watchedEventClearTimer);
                watchedEventClearTimer = setTimeout(function() {
                    watchedEvent = "";
                }, 3000);
            }
        };
        // public methods
        slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
            if (!slider.vars.animationLoop && target !== slider.currentSlide) slider.direction = target > slider.currentSlide ? "next" : "prev";
            if (asNav && slider.pagingCount === 1) slider.direction = slider.currentItem < target ? "next" : "prev";
            if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
                if (asNav && withSync) {
                    var master = $(slider.vars.asNavFor).data("flexslider");
                    slider.atEnd = target === 0 || target === slider.count - 1;
                    master.flexAnimate(target, true, false, true, fromNav);
                    slider.direction = slider.currentItem < target ? "next" : "prev";
                    master.direction = slider.direction;
                    if (Math.ceil((target + 1) / slider.visible) - 1 !== slider.currentSlide && target !== 0) {
                        slider.currentItem = target;
                        slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                        target = Math.floor(target / slider.visible);
                    } else {
                        slider.currentItem = target;
                        slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                        return false;
                    }
                }
                slider.animating = true;
                slider.animatingTo = target;
                // SLIDESHOW:
                if (pause) slider.pause();
                // API: before() animation Callback
                slider.vars.before(slider);
                // SYNC:
                if (slider.syncExists && !fromNav) methods.sync("animate");
                // CONTROLNAV
                if (slider.vars.controlNav) methods.controlNav.active();
                // !CAROUSEL:
                // CANDIDATE: slide active class (for add/remove slide)
                if (!carousel) slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
                // INFINITE LOOP:
                // CANDIDATE: atEnd
                slider.atEnd = target === 0 || target === slider.last;
                // DIRECTIONNAV:
                if (slider.vars.directionNav) methods.directionNav.update();
                if (target === slider.last) {
                    // API: end() of cycle Callback
                    slider.vars.end(slider);
                    // SLIDESHOW && !INFINITE LOOP:
                    if (!slider.vars.animationLoop) slider.pause();
                }
                // SLIDE:
                if (!fade) {
                    var dimension = vertical ? slider.slides.filter(":first").height() : slider.computedW, margin, slideString, calcNext;
                    // INFINITE LOOP / REVERSE:
                    if (carousel) {
                        margin = slider.vars.itemMargin;
                        calcNext = (slider.itemW + margin) * slider.move * slider.animatingTo;
                        slideString = calcNext > slider.limit && slider.visible !== 1 ? slider.limit : calcNext;
                    } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") slideString = reverse ? (slider.count + slider.cloneOffset) * dimension : 0;
                    else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") slideString = reverse ? 0 : (slider.count + 1) * dimension;
                    else slideString = reverse ? (slider.count - 1 - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
                    slider.setProps(slideString, "", slider.vars.animationSpeed);
                    if (slider.transitions) {
                        if (!slider.vars.animationLoop || !slider.atEnd) {
                            slider.animating = false;
                            slider.currentSlide = slider.animatingTo;
                        }
                        // Unbind previous transitionEnd events and re-bind new transitionEnd event
                        slider.container.unbind("webkitTransitionEnd transitionend");
                        slider.container.bind("webkitTransitionEnd transitionend", function() {
                            clearTimeout(slider.ensureAnimationEnd);
                            slider.wrapup(dimension);
                        });
                        // Insurance for the ever-so-fickle transitionEnd event
                        clearTimeout(slider.ensureAnimationEnd);
                        slider.ensureAnimationEnd = setTimeout(function() {
                            slider.wrapup(dimension);
                        }, slider.vars.animationSpeed + 100);
                    } else slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function() {
                        slider.wrapup(dimension);
                    });
                } else if (!touch) {
                    slider.slides.eq(slider.currentSlide).css({
                        zIndex: 1
                    }).animate({
                        opacity: 0
                    }, slider.vars.animationSpeed, slider.vars.easing);
                    slider.slides.eq(target).css({
                        zIndex: 2
                    }).animate({
                        opacity: 1
                    }, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
                } else {
                    slider.slides.eq(slider.currentSlide).css({
                        opacity: 0,
                        zIndex: 1
                    });
                    slider.slides.eq(target).css({
                        opacity: 1,
                        zIndex: 2
                    });
                    slider.wrapup(dimension);
                }
                // SMOOTH HEIGHT:
                if (slider.vars.smoothHeight) methods.smoothHeight(slider.vars.animationSpeed);
            }
        };
        slider.wrapup = function(dimension) {
            // SLIDE:
            if (!fade && !carousel) {
                if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) slider.setProps(dimension, "jumpEnd");
                else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) slider.setProps(dimension, "jumpStart");
            }
            slider.animating = false;
            slider.currentSlide = slider.animatingTo;
            // API: after() animation Callback
            slider.vars.after(slider);
        };
        // SLIDESHOW:
        slider.animateSlides = function() {
            if (!slider.animating && focused) slider.flexAnimate(slider.getTarget("next"));
        };
        // SLIDESHOW:
        slider.pause = function() {
            clearInterval(slider.animatedSlides);
            slider.animatedSlides = null;
            slider.playing = false;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) methods.pausePlay.update("play");
            // SYNC:
            if (slider.syncExists) methods.sync("pause");
        };
        // SLIDESHOW:
        slider.play = function() {
            if (slider.playing) clearInterval(slider.animatedSlides);
            slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
            slider.started = slider.playing = true;
            // PAUSEPLAY:
            if (slider.vars.pausePlay) methods.pausePlay.update("pause");
            // SYNC:
            if (slider.syncExists) methods.sync("play");
        };
        // STOP:
        slider.stop = function() {
            slider.pause();
            slider.stopped = true;
        };
        slider.canAdvance = function(target, fromNav) {
            // ASNAV:
            var last = asNav ? slider.pagingCount - 1 : slider.last;
            return fromNav ? true : asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev" ? true : asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next" ? false : target === slider.currentSlide && !asNav ? false : slider.vars.animationLoop ? true : slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next" ? false : slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next" ? false : true;
        };
        slider.getTarget = function(dir) {
            slider.direction = dir;
            if (dir === "next") return slider.currentSlide === slider.last ? 0 : slider.currentSlide + 1;
            else return slider.currentSlide === 0 ? slider.last : slider.currentSlide - 1;
        };
        // SLIDE:
        slider.setProps = function(pos, special, dur) {
            var target = function() {
                var posCheck = pos ? pos : (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo, posCalc = function() {
                    if (carousel) return special === "setTouch" ? pos : reverse && slider.animatingTo === slider.last ? 0 : reverse ? slider.limit - (slider.itemW + slider.vars.itemMargin) * slider.move * slider.animatingTo : slider.animatingTo === slider.last ? slider.limit : posCheck;
                    else switch(special){
                        case "setTotal":
                            return reverse ? (slider.count - 1 - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                        case "setTouch":
                            return reverse ? pos : pos;
                        case "jumpEnd":
                            return reverse ? pos : slider.count * pos;
                        case "jumpStart":
                            return reverse ? slider.count * pos : pos;
                        default:
                            return pos;
                    }
                }();
                return posCalc * (slider.vars.rtl ? 1 : -1) + "px";
            }();
            if (slider.transitions) {
                if (slider.isFirefox) target = vertical ? "translate3d(0," + target + ",0)" : "translate3d(" + (parseInt(target) + "px") + ",0,0)";
                else target = vertical ? "translate3d(0," + target + ",0)" : "translate3d(" + ((slider.vars.rtl ? -1 : 1) * parseInt(target) + "px") + ",0,0)";
                dur = dur !== undefined ? dur / 1000 + "s" : "0s";
                slider.container.css("-" + slider.pfx + "-transition-duration", dur);
                slider.container.css("transition-duration", dur);
            }
            slider.args[slider.prop] = target;
            if (slider.transitions || dur === undefined) slider.container.css(slider.args);
            slider.container.css("transform", target);
        };
        slider.setup = function(type) {
            // SLIDE:
            if (!fade) {
                var sliderOffset, arr;
                if (type === "init") {
                    slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({
                        overflow: "hidden",
                        position: "relative"
                    }).appendTo(slider).append(slider.container);
                    // INFINITE LOOP:
                    slider.cloneCount = 0;
                    slider.cloneOffset = 0;
                    // REVERSE:
                    if (reverse) {
                        arr = $.makeArray(slider.slides).reverse();
                        slider.slides = $(arr);
                        slider.container.empty().append(slider.slides);
                    }
                }
                // INFINITE LOOP && !CAROUSEL:
                if (slider.vars.animationLoop && !carousel) {
                    slider.cloneCount = 2;
                    slider.cloneOffset = 1;
                    // clear out old clones
                    if (type !== "init") slider.container.find(".clone").remove();
                    slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass("clone")).attr("aria-hidden", "true")).prepend(methods.uniqueID(slider.slides.last().clone().addClass("clone")).attr("aria-hidden", "true"));
                }
                slider.newSlides = $(slider.vars.selector, slider);
                sliderOffset = reverse ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
                // VERTICAL:
                if (vertical && !carousel) {
                    slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
                    setTimeout(function() {
                        slider.newSlides.css({
                            display: "block"
                        });
                        slider.doMath();
                        slider.viewport.height(slider.h);
                        slider.setProps(sliderOffset * slider.h, "init");
                    }, type === "init" ? 100 : 0);
                } else {
                    slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
                    slider.setProps(sliderOffset * slider.computedW, "init");
                    setTimeout(function() {
                        slider.doMath();
                        if (slider.vars.rtl) {
                            if (slider.isFirefox) slider.newSlides.css({
                                width: slider.computedW,
                                marginRight: slider.computedM,
                                float: "right",
                                display: "block"
                            });
                            else slider.newSlides.css({
                                width: slider.computedW,
                                marginRight: slider.computedM,
                                float: "left",
                                display: "block"
                            });
                        } else slider.newSlides.css({
                            width: slider.computedW,
                            marginRight: slider.computedM,
                            float: "left",
                            display: "block"
                        });
                        // SMOOTH HEIGHT:
                        if (slider.vars.smoothHeight) methods.smoothHeight();
                    }, type === "init" ? 100 : 0);
                }
            } else {
                if (slider.vars.rtl) slider.slides.css({
                    width: "100%",
                    float: "right",
                    marginLeft: "-100%",
                    position: "relative"
                });
                else slider.slides.css({
                    width: "100%",
                    float: "left",
                    marginRight: "-100%",
                    position: "relative"
                });
                if (type === "init") {
                    if (!touch) {
                        //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
                        if (slider.vars.fadeFirstSlide == false) slider.slides.css({
                            opacity: 0,
                            display: "block",
                            zIndex: 1
                        }).eq(slider.currentSlide).css({
                            zIndex: 2
                        }).css({
                            opacity: 1
                        });
                        else slider.slides.css({
                            opacity: 0,
                            display: "block",
                            zIndex: 1
                        }).eq(slider.currentSlide).css({
                            zIndex: 2
                        }).animate({
                            opacity: 1
                        }, slider.vars.animationSpeed, slider.vars.easing);
                    } else slider.slides.css({
                        opacity: 0,
                        display: "block",
                        webkitTransition: "opacity " + slider.vars.animationSpeed / 1000 + "s ease",
                        zIndex: 1
                    }).eq(slider.currentSlide).css({
                        opacity: 1,
                        zIndex: 2
                    });
                }
                // SMOOTH HEIGHT:
                if (slider.vars.smoothHeight) methods.smoothHeight();
            }
            // !CAROUSEL:
            // CANDIDATE: active slide
            if (!carousel) slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide");
            //FlexSlider: init() Callback
            slider.vars.init(slider);
        };
        slider.doMath = function() {
            var slide = slider.slides.first(), slideMargin = slider.vars.itemMargin, minItems = slider.vars.minItems, maxItems = slider.vars.maxItems;
            slider.w = slider.viewport === undefined ? slider.width() : slider.viewport.width();
            if (slider.isFirefox) slider.w = slider.width();
            slider.h = slide.height();
            slider.boxPadding = slide.outerWidth() - slide.width();
            // CAROUSEL:
            if (carousel) {
                slider.itemT = slider.vars.itemWidth + slideMargin;
                slider.itemM = slideMargin;
                slider.minW = minItems ? minItems * slider.itemT : slider.w;
                slider.maxW = maxItems ? maxItems * slider.itemT - slideMargin : slider.w;
                slider.itemW = slider.minW > slider.w ? (slider.w - slideMargin * (minItems - 1)) / minItems : slider.maxW < slider.w ? (slider.w - slideMargin * (maxItems - 1)) / maxItems : slider.vars.itemWidth > slider.w ? slider.w : slider.vars.itemWidth;
                slider.visible = Math.floor(slider.w / slider.itemW);
                slider.move = slider.vars.move > 0 && slider.vars.move < slider.visible ? slider.vars.move : slider.visible;
                slider.pagingCount = Math.ceil((slider.count - slider.visible) / slider.move + 1);
                slider.last = slider.pagingCount - 1;
                slider.limit = slider.pagingCount === 1 ? 0 : slider.vars.itemWidth > slider.w ? slider.itemW * (slider.count - 1) + slideMargin * (slider.count - 1) : (slider.itemW + slideMargin) * slider.count - slider.w - slideMargin;
            } else {
                slider.itemW = slider.w;
                slider.itemM = slideMargin;
                slider.pagingCount = slider.count;
                slider.last = slider.count - 1;
            }
            slider.computedW = slider.itemW - slider.boxPadding;
            slider.computedM = slider.itemM;
        };
        slider.update = function(pos, action) {
            slider.doMath();
            // update currentSlide and slider.animatingTo if necessary
            if (!carousel) {
                if (pos < slider.currentSlide) slider.currentSlide += 1;
                else if (pos <= slider.currentSlide && pos !== 0) slider.currentSlide -= 1;
                slider.animatingTo = slider.currentSlide;
            }
            // update controlNav
            if (slider.vars.controlNav && !slider.manualControls) {
                if (action === "add" && !carousel || slider.pagingCount > slider.controlNav.length) methods.controlNav.update("add");
                else if (action === "remove" && !carousel || slider.pagingCount < slider.controlNav.length) {
                    if (carousel && slider.currentSlide > slider.last) {
                        slider.currentSlide -= 1;
                        slider.animatingTo -= 1;
                    }
                    methods.controlNav.update("remove", slider.last);
                }
            }
            // update directionNav
            if (slider.vars.directionNav) methods.directionNav.update();
        };
        slider.addSlide = function(obj, pos) {
            var $obj = $(obj);
            slider.count += 1;
            slider.last = slider.count - 1;
            // append new slide
            if (vertical && reverse) pos !== undefined ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
            else pos !== undefined ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.update(pos, "add");
            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();
            //FlexSlider: added() Callback
            slider.vars.added(slider);
        };
        slider.removeSlide = function(obj) {
            var pos = isNaN(obj) ? slider.slides.index($(obj)) : obj;
            // update count
            slider.count -= 1;
            slider.last = slider.count - 1;
            // remove slide
            if (isNaN(obj)) $(obj, slider.slides).remove();
            else vertical && reverse ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
            // update currentSlide, animatingTo, controlNav, and directionNav
            slider.doMath();
            slider.update(pos, "remove");
            // update slider.slides
            slider.slides = $(slider.vars.selector + ":not(.clone)", slider);
            // re-setup the slider to accomdate new slide
            slider.setup();
            // FlexSlider: removed() Callback
            slider.vars.removed(slider);
        };
        //FlexSlider: Initialize
        methods.init();
    };
    // Ensure the slider isn't focussed if the window loses focus.
    $(window).blur(function(e) {
        focused = false;
    }).focus(function(e) {
        focused = true;
    });
    //FlexSlider: Default Settings
    $.flexslider.defaults = {
        namespace: "flex-",
        selector: ".slides > li",
        animation: "fade",
        easing: "swing",
        direction: "horizontal",
        reverse: false,
        animationLoop: true,
        smoothHeight: false,
        startAt: 0,
        slideshow: true,
        slideshowSpeed: 7000,
        animationSpeed: 600,
        initDelay: 0,
        randomize: false,
        fadeFirstSlide: true,
        thumbCaptions: false,
        // Usability features
        pauseOnAction: true,
        pauseOnHover: false,
        pauseInvisible: true,
        useCSS: true,
        touch: true,
        video: false,
        // Primary Controls
        controlNav: true,
        directionNav: true,
        prevText: "Previous",
        nextText: "Next",
        // Secondary Navigation
        keyboard: true,
        multipleKeyboard: false,
        mousewheel: false,
        pausePlay: false,
        pauseText: "Pause",
        playText: "Play",
        // Special properties
        controlsContainer: "",
        manualControls: "",
        customDirectionNav: "",
        sync: "",
        asNavFor: "",
        // Carousel Options
        itemWidth: 0,
        itemMargin: 0,
        minItems: 1,
        maxItems: 0,
        move: 0,
        allowOneSlide: true,
        // Browser Specific
        isFirefox: false,
        // Callback API
        start: function start() {},
        before: function before() {},
        after: function after() {},
        end: function end() {},
        added: function added() {},
        removed: function removed() {},
        init: function init() {},
        rtl: false //{NEW} Boolean: Whether or not to enable RTL mode
    };
    //FlexSlider: Plugin Function
    $.fn.flexslider = function(options) {
        if (options === undefined) options = {};
        if (typeof options === "object") return this.each(function() {
            var $this = $(this), selector = options.selector ? options.selector : ".slides > li", $slides = $this.find(selector);
            if ($slides.length === 1 && options.allowOneSlide === false || $slides.length === 0) {
                $slides.fadeIn(400);
                if (options.start) options.start($this);
            } else if ($this.data("flexslider") === undefined) new $.flexslider(this, options);
        });
        else {
            // Helper strings to quickly perform functions on the slider
            var $slider = $(this).data("flexslider");
            switch(options){
                case "play":
                    $slider.play();
                    break;
                case "pause":
                    $slider.pause();
                    break;
                case "stop":
                    $slider.stop();
                    break;
                case "next":
                    $slider.flexAnimate($slider.getTarget("next"), true);
                    break;
                case "prev":
                case "previous":
                    $slider.flexAnimate($slider.getTarget("prev"), true);
                    break;
                default:
                    if (typeof options === "number") $slider.flexAnimate(options, true);
            }
        }
    };
})(jQuery);


(0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(document).ready(function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".mainslider").length) (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".flexslider").flexslider({
        animation: "slide",
        slideshow: true,
        slideshowSpeed: 6000,
        controlNav: true,
        animationLoop: true,
        touch: true,
        pauseOnHover: false,
        pauseOnAction: true,
        controlsContainer: ".flexcontrols"
    });
});



var $4w9fm = parcelRequire("4w9fm");
/*!
 * mmenu.js
 * mmenujs.com
 *
 * Copyright (c) Fred Heusschen
 * frebsite.nl
 *
 * License: CC-BY-NC-4.0
 * http://creativecommons.org/licenses/by-nc/4.0/
 */ //	Core
var $705b1bb7572e1f39$export$2e2bcd8739ae039 = "8.5.1";


var $17aff3062705e314$var$options = {
    hooks: {},
    extensions: [],
    wrappers: [],
    navbar: {
        add: true,
        sticky: true,
        title: "Menu",
        titleLink: "parent"
    },
    onClick: {
        close: null,
        preventDefault: null,
        setSelected: true
    },
    slidingSubmenus: true
};
var $17aff3062705e314$export$2e2bcd8739ae039 = $17aff3062705e314$var$options;


var $fa45e5db20850c20$var$configs = {
    classNames: {
        inset: "Inset",
        nolistview: "NoListview",
        nopanel: "NoPanel",
        panel: "Panel",
        selected: "Selected",
        vertical: "Vertical"
    },
    language: null,
    openingInterval: 25,
    panelNodetype: [
        "ul",
        "ol",
        "div"
    ],
    transitionDuration: 400
};
var $fa45e5db20850c20$export$2e2bcd8739ae039 = $fa45e5db20850c20$var$configs;


/**
 * Deep extend an object with the given defaults.
 * Note that the extended object is not a clone, meaning the original object will also be updated.
 *
 * @param 	{object}	orignl	The object to extend to.
 * @param 	{object}	dfault	The object to extend from.
 * @return	{object}			The extended "orignl" object.
 */ function $48055557806f998e$export$8b58be045bf06082(orignl, dfault) {
    if ($48055557806f998e$export$bf9fb029d174d554(orignl) != "object") orignl = {};
    if ($48055557806f998e$export$bf9fb029d174d554(dfault) != "object") dfault = {};
    for(var k in dfault){
        if (!dfault.hasOwnProperty(k)) continue;
        if (typeof orignl[k] == "undefined") orignl[k] = dfault[k];
        else if ($48055557806f998e$export$bf9fb029d174d554(orignl[k]) == "object") $48055557806f998e$export$8b58be045bf06082(orignl[k], dfault[k]);
    }
    return orignl;
}
function $48055557806f998e$export$c69521134f103c95(surface) {
    var direction = "";
    surface.addEventListener("touchmove", function(evnt) {
        direction = "";
        if (evnt.movementY > 0) direction = "down";
        else if (evnt.movementY < 0) direction = "up";
    });
    return {
        get: function get() {
            return direction;
        }
    };
}
function $48055557806f998e$export$bf9fb029d174d554(variable) {
    return ({}).toString.call(variable).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $48055557806f998e$export$536caabe1a98b576(element, option, dfault) {
    if (typeof option == "function") {
        var value = option.call(element);
        if (typeof value != "undefined") return value;
    }
    if ((option === null || typeof option == "function" || typeof option == "undefined") && typeof dfault != "undefined") return dfault;
    return option;
}
function $48055557806f998e$export$a214e5a3a7081ff1(element, func, duration) {
    var _ended = false, _fn = function _fn1(evnt) {
        if (typeof evnt !== "undefined") {
            if (evnt.target !== element) return;
        }
        if (!_ended) {
            element.removeEventListener("transitionend", _fn);
            element.removeEventListener("webkitTransitionEnd", _fn);
            func.call(element);
        }
        _ended = true;
    };
    element.addEventListener("transitionend", _fn);
    element.addEventListener("webkitTransitionEnd", _fn);
    setTimeout(_fn, duration * 1.1);
}
function $48055557806f998e$export$8b15d37bc3f197d4() {
    return "mm-" + $48055557806f998e$var$__id++;
}
var $48055557806f998e$var$__id = 0;
function $48055557806f998e$export$77c7ff3a98df843b(id) {
    if (id.slice(0, 3) == "mm-") return id.slice(3);
    return id;
}


var $9154f0701a0acf98$var$translations = {};
function $9154f0701a0acf98$export$e16d8520af44a096(text, language) {
    if (typeof $9154f0701a0acf98$var$translations[language] == "undefined") $9154f0701a0acf98$var$translations[language] = {};
    (0, $48055557806f998e$export$8b58be045bf06082)($9154f0701a0acf98$var$translations[language], text);
}
function $9154f0701a0acf98$export$3988ae62b71be9a3(text, language) {
    if (typeof language == "string" && typeof $9154f0701a0acf98$var$translations[language] != "undefined") return $9154f0701a0acf98$var$translations[language][text] || text;
    return text;
}
function $9154f0701a0acf98$export$84bf76cd7afc7469(language) {
    return $9154f0701a0acf98$var$translations;
}


var $4f6b63854c48f83a$export$2e2bcd8739ae039 = {
    Menu: "Menu"
};


var $dd2bf57ed26d6083$export$2e2bcd8739ae039 = {
    Menu: "\u0645\u0646\u0648"
};


var $84de7325a410b1f3$export$2e2bcd8739ae039 = {
    Menu: "Men\xfc"
};


var $1a5e31455b5fe055$export$2e2bcd8739ae039 = {
    Menu: "\u041C\u0435\u043D\u044E"
};


function $9ec3ac8f0ed0dafd$export$2e2bcd8739ae039() {
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $4f6b63854c48f83a$export$2e2bcd8739ae039), "nl");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $dd2bf57ed26d6083$export$2e2bcd8739ae039), "fa");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $84de7325a410b1f3$export$2e2bcd8739ae039), "de");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $1a5e31455b5fe055$export$2e2bcd8739ae039), "ru");
}


/**
 * Create an element with classname.
 *
 * @param 	{string}		selector	The nodeName and classnames for the element to create.
 * @return	{HTMLElement}				The created element.
 */ function $5e687dcee2dc17d2$export$185802fd694ee1f5(selector) {
    var args = selector.split(".");
    var elem = document.createElement(args.shift());
    //  IE11:
    args.forEach(function(classname) {
        elem.classList.add(classname);
    });
    //  Better browsers:
    // elem.classList.add(...args);
    return elem;
}
function $5e687dcee2dc17d2$export$71aa6c912b956294(element, filter) {
    return Array.prototype.slice.call(element.querySelectorAll(filter));
}
function $5e687dcee2dc17d2$export$bacb5cc5a11aef16(element, filter) {
    var children = Array.prototype.slice.call(element.children);
    return filter ? children.filter(function(child) {
        return child.matches(filter);
    }) : children;
}
function $5e687dcee2dc17d2$export$6f093cfa640b7166(element) {
    return Array.prototype.slice.call(element.childNodes).filter(function(child) {
        return child.nodeType == 3;
    }).map(function(child) {
        return child.textContent;
    }).join(" ");
}
function $5e687dcee2dc17d2$export$7901f6cd558b9a93(element, filter) {
    /** Array of preceding elements that match the selector. */ var parents = [];
    /** Array of preceding elements that match the selector. */ var parent = element.parentElement;
    while(parent){
        parents.push(parent);
        parent = parent.parentElement;
    }
    return filter ? parents.filter(function(parent) {
        return parent.matches(filter);
    }) : parents;
}
function $5e687dcee2dc17d2$export$5a01ccd45552d0b4(element, filter) {
    /** Array of previous siblings that match the selector. */ var previous = [];
    /** Current element in the loop */ var current = element.previousElementSibling;
    while(current){
        if (!filter || current.matches(filter)) previous.push(current);
        current = current.previousElementSibling;
    }
    return previous;
}
function $5e687dcee2dc17d2$export$cc800923e997bb8(element, direction) {
    return element.getBoundingClientRect()[direction] + document.body[direction === "left" ? "scrollLeft" : "scrollTop"];
}
function $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems) {
    return listitems.filter(function(listitem) {
        return !listitem.matches(".mm-hidden");
    });
}
function $5e687dcee2dc17d2$export$f6486d4f577dfcc4(listitems) {
    var anchors = [];
    $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems).forEach(function(listitem) {
        anchors.push.apply(anchors, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, "a.mm-listitem__text"));
    });
    return anchors.filter(function(anchor) {
        return !anchor.matches(".mm-btn_next");
    });
}
function $5e687dcee2dc17d2$export$9604f4b73fb157f3(element, oldClass, newClass) {
    if (element.matches("." + oldClass)) {
        element.classList.remove(oldClass);
        element.classList.add(newClass);
    }
}



/** Collection of callback functions for media querys. */ var $fb351eed9e08732b$var$listeners = {};
function $fb351eed9e08732b$export$e16d8520af44a096(query, yes, no) {
    if (typeof query == "number") query = "(min-width: " + query + "px)";
    $fb351eed9e08732b$var$listeners[query] = $fb351eed9e08732b$var$listeners[query] || [];
    $fb351eed9e08732b$var$listeners[query].push({
        yes: yes,
        no: no
    });
}
function $fb351eed9e08732b$export$3db5d71bdb2d5499() {
    var _loop_1 = function _loop_1(query) {
        var mqlist = window.matchMedia(query);
        $fb351eed9e08732b$export$46ff36df9b99bc25(query, mqlist);
        mqlist.onchange = function(evnt) {
            $fb351eed9e08732b$export$46ff36df9b99bc25(query, mqlist);
        };
    };
    for(var query in $fb351eed9e08732b$var$listeners)_loop_1(query);
}
function $fb351eed9e08732b$export$46ff36df9b99bc25(query, mqlist) {
    var fn = mqlist.matches ? "yes" : "no";
    for(var m = 0; m < $fb351eed9e08732b$var$listeners[query].length; m++)$fb351eed9e08732b$var$listeners[query][m][fn]();
}



//  Add the translations.
(0, $9ec3ac8f0ed0dafd$export$2e2bcd8739ae039)();
/**
 * Class for a mobile menu.
 */ var $a52e6e9520ba942b$var$Mmenu = /** @class */ function() {
    /**
     * Create a mobile menu.
     * @param {HTMLElement|string} 	menu						The menu node.
     * @param {object} 				[options=Mmenu.options]		Options for the menu.
     * @param {object} 				[configs=Mmenu.configs]		Configuration options for the menu.
     */ function Mmenu(menu, options, configs) {
        //	Extend options and configuration from defaults.
        this.opts = (0, $48055557806f998e$export$8b58be045bf06082)(options, Mmenu.options);
        this.conf = (0, $48055557806f998e$export$8b58be045bf06082)(configs, Mmenu.configs);
        //	Methods to expose in the API.
        this._api = [
            "bind",
            "initPanel",
            "initListview",
            "openPanel",
            "closePanel",
            "closeAllPanels",
            "setSelected"
        ];
        //	Storage objects for nodes, variables, hooks and click handlers.
        this.node = {};
        this.vars = {};
        this.hook = {};
        this.clck = [];
        //	Get menu node from string or element.
        this.node.menu = typeof menu == "string" ? document.querySelector(menu) : menu;
        if (typeof this._deprecatedWarnings == "function") this._deprecatedWarnings();
        this._initWrappers();
        this._initAddons();
        this._initExtensions();
        this._initHooks();
        this._initAPI();
        this._initMenu();
        this._initPanels();
        this._initOpened();
        this._initAnchors();
        $fb351eed9e08732b$export$3db5d71bdb2d5499();
        return this;
    }
    /**
     * Open a panel.
     * @param {HTMLElement} panel				Panel to open.
     * @param {boolean}		[animation=true]	Whether or not to open the panel with an animation.
     */ Mmenu.prototype.openPanel = function(panel, animation) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("openPanel:before", [
            panel
        ]);
        //	Find panel.
        if (!panel) return;
        if (!panel.matches(".mm-panel")) panel = panel.closest(".mm-panel");
        if (!panel) return;
        //	/Find panel.
        if (typeof animation != "boolean") animation = true;
        //	Open a "vertical" panel.
        if (panel.parentElement.matches(".mm-listitem_vertical")) {
            //	Open current and all vertical parent panels.
            $5e687dcee2dc17d2$export$7901f6cd558b9a93(panel, ".mm-listitem_vertical").forEach(function(listitem) {
                listitem.classList.add("mm-listitem_opened");
                $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, ".mm-panel").forEach(function(panel) {
                    panel.classList.remove("mm-hidden");
                });
            });
            //	Open first non-vertical parent panel.
            var parents = $5e687dcee2dc17d2$export$7901f6cd558b9a93(panel, ".mm-panel").filter(function(panel) {
                return !panel.parentElement.matches(".mm-listitem_vertical");
            });
            this.trigger("openPanel:start", [
                panel
            ]);
            if (parents.length) this.openPanel(parents[0]);
            this.trigger("openPanel:finish", [
                panel
            ]);
        //	Open a "horizontal" panel.
        } else {
            if (panel.matches(".mm-panel_opened")) return;
            var panels = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel"), current_1 = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel_opened")[0];
            //	Close all child panels.
            panels.filter(function(parent) {
                return parent !== panel;
            }).forEach(function(parent) {
                parent.classList.remove("mm-panel_opened-parent");
            });
            //	Open all parent panels.
            var parent_1 = panel["mmParent"];
            while(parent_1){
                parent_1 = parent_1.closest(".mm-panel");
                if (parent_1) {
                    if (!parent_1.parentElement.matches(".mm-listitem_vertical")) parent_1.classList.add("mm-panel_opened-parent");
                    parent_1 = parent_1["mmParent"];
                }
            }
            //	Add classes for animation.
            panels.forEach(function(panel) {
                panel.classList.remove("mm-panel_highest");
            });
            panels.filter(function(hidden) {
                return hidden !== current_1;
            }).filter(function(hidden) {
                return hidden !== panel;
            }).forEach(function(hidden) {
                hidden.classList.add("mm-hidden");
            });
            panel.classList.remove("mm-hidden");
            /**	Start opening the panel. */ var openPanelStart_1 = function openPanelStart_1() {
                if (current_1) current_1.classList.remove("mm-panel_opened");
                panel.classList.add("mm-panel_opened");
                if (panel.matches(".mm-panel_opened-parent")) {
                    if (current_1) current_1.classList.add("mm-panel_highest");
                    panel.classList.remove("mm-panel_opened-parent");
                } else {
                    if (current_1) current_1.classList.add("mm-panel_opened-parent");
                    panel.classList.add("mm-panel_highest");
                }
                //	Invoke "start" hook.
                _this.trigger("openPanel:start", [
                    panel
                ]);
            };
            /**	Finish opening the panel. */ var openPanelFinish_1 = function openPanelFinish_1() {
                if (current_1) {
                    current_1.classList.remove("mm-panel_highest");
                    current_1.classList.add("mm-hidden");
                }
                panel.classList.remove("mm-panel_highest");
                //	Invoke "finish" hook.
                _this.trigger("openPanel:finish", [
                    panel
                ]);
            };
            if (animation && !panel.matches(".mm-panel_noanimation")) //	Without the timeout the animation will not work because the element had display: none;
            setTimeout(function() {
                //	Callback
                (0, $48055557806f998e$export$a214e5a3a7081ff1)(panel, function() {
                    openPanelFinish_1();
                }, _this.conf.transitionDuration);
                openPanelStart_1();
            }, this.conf.openingInterval);
            else {
                openPanelStart_1();
                openPanelFinish_1();
            }
        }
        //	Invoke "after" hook.
        this.trigger("openPanel:after", [
            panel
        ]);
    };
    /**
     * Close a panel.
     * @param {HTMLElement} panel Panel to close.
     */ Mmenu.prototype.closePanel = function(panel) {
        //	Invoke "before" hook.
        this.trigger("closePanel:before", [
            panel
        ]);
        var li = panel.parentElement;
        //	Only works for "vertical" panels.
        if (li.matches(".mm-listitem_vertical")) {
            li.classList.remove("mm-listitem_opened");
            panel.classList.add("mm-hidden");
            //	Invoke main hook.
            this.trigger("closePanel", [
                panel
            ]);
        }
        //	Invoke "after" hook.
        this.trigger("closePanel:after", [
            panel
        ]);
    };
    /**
     * Close all opened panels.
     * @param {HTMLElement} panel Panel to open after closing all other panels.
     */ Mmenu.prototype.closeAllPanels = function(panel) {
        //	Invoke "before" hook.
        this.trigger("closeAllPanels:before");
        //	Close all "vertical" panels.
        var listitems = this.node.pnls.querySelectorAll(".mm-listitem");
        listitems.forEach(function(listitem) {
            listitem.classList.remove("mm-listitem_selected");
            listitem.classList.remove("mm-listitem_opened");
        });
        //	Close all "horizontal" panels.
        var panels = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel"), opened = panel ? panel : panels[0];
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel").forEach(function(panel) {
            if (panel !== opened) {
                panel.classList.remove("mm-panel_opened");
                panel.classList.remove("mm-panel_opened-parent");
                panel.classList.remove("mm-panel_highest");
                panel.classList.add("mm-hidden");
            }
        });
        //	Open first panel.
        this.openPanel(opened, false);
        //	Invoke "after" hook.
        this.trigger("closeAllPanels:after");
    };
    /**
     * Toggle a panel opened/closed.
     * @param {HTMLElement} panel Panel to open or close.
     */ Mmenu.prototype.togglePanel = function(panel) {
        var listitem = panel.parentElement;
        //	Only works for "vertical" panels.
        if (listitem.matches(".mm-listitem_vertical")) this[listitem.matches(".mm-listitem_opened") ? "closePanel" : "openPanel"](panel);
    };
    /**
     * Display a listitem as being "selected".
     * @param {HTMLElement} listitem Listitem to mark.
     */ Mmenu.prototype.setSelected = function(listitem) {
        //	Invoke "before" hook.
        this.trigger("setSelected:before", [
            listitem
        ]);
        //	First, remove the selected class from all listitems.
        $5e687dcee2dc17d2$export$71aa6c912b956294(this.node.menu, ".mm-listitem_selected").forEach(function(li) {
            li.classList.remove("mm-listitem_selected");
        });
        //	Next, add the selected class to the provided listitem.
        listitem.classList.add("mm-listitem_selected");
        //	Invoke "after" hook.
        this.trigger("setSelected:after", [
            listitem
        ]);
    };
    /**
     * Bind functions to a hook (subscriber).
     * @param {string} 		hook The hook.
     * @param {function} 	func The function.
     */ Mmenu.prototype.bind = function(hook, func) {
        //	Create an array for the hook if it does not yet excist.
        this.hook[hook] = this.hook[hook] || [];
        //	Push the function to the array.
        this.hook[hook].push(func);
    };
    /**
     * Invoke the functions bound to a hook (publisher).
     * @param {string} 	hook  	The hook.
     * @param {array}	[args] 	Arguments for the function.
     */ Mmenu.prototype.trigger = function(hook, args) {
        if (this.hook[hook]) for(var h = 0, l = this.hook[hook].length; h < l; h++)this.hook[hook][h].apply(this, args);
    };
    /**
     * Create the API.
     */ Mmenu.prototype._initAPI = function() {
        var _this = this;
        //	We need this=that because:
        //	1) the "arguments" object can not be referenced in an arrow function in ES3 and ES5.
        var that = this;
        this.API = {};
        this._api.forEach(function(fn) {
            _this.API[fn] = function() {
                var re = that[fn].apply(that, arguments); // 1)
                return typeof re == "undefined" ? that.API : re;
            };
        });
        //	Store the API in the HTML node for external usage.
        this.node.menu["mmApi"] = this.API;
    };
    /**
     * Bind the hooks specified in the options (publisher).
     */ Mmenu.prototype._initHooks = function() {
        for(var hook in this.opts.hooks)this.bind(hook, this.opts.hooks[hook]);
    };
    /**
     * Initialize the wrappers specified in the options.
     */ Mmenu.prototype._initWrappers = function() {
        //	Invoke "before" hook.
        this.trigger("initWrappers:before");
        for(var w = 0; w < this.opts.wrappers.length; w++){
            var wrpr = Mmenu.wrappers[this.opts.wrappers[w]];
            if (typeof wrpr == "function") wrpr.call(this);
        }
        //	Invoke "after" hook.
        this.trigger("initWrappers:after");
    };
    /**
     * Initialize all available add-ons.
     */ Mmenu.prototype._initAddons = function() {
        //	Invoke "before" hook.
        this.trigger("initAddons:before");
        for(var addon in Mmenu.addons)Mmenu.addons[addon].call(this);
        //	Invoke "after" hook.
        this.trigger("initAddons:after");
    };
    /**
     * Initialize the extensions specified in the options.
     */ Mmenu.prototype._initExtensions = function() {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initExtensions:before");
        //	Convert array to object with array.
        if ((0, $48055557806f998e$export$bf9fb029d174d554)(this.opts.extensions) == "array") this.opts.extensions = {
            all: this.opts.extensions
        };
        //	Loop over object.
        Object.keys(this.opts.extensions).forEach(function(query) {
            var classnames = _this.opts.extensions[query].map(function(extension) {
                return "mm-menu_" + extension;
            });
            if (classnames.length) $fb351eed9e08732b$export$e16d8520af44a096(query, function() {
                //  IE11:
                classnames.forEach(function(classname) {
                    _this.node.menu.classList.add(classname);
                });
            //  Better browsers:
            // this.node.menu.classList.add(...classnames);
            }, function() {
                //  IE11:
                classnames.forEach(function(classname) {
                    _this.node.menu.classList.remove(classname);
                });
            //  Better browsers:
            // this.node.menu.classList.remove(...classnames);
            });
        });
        //	Invoke "after" hook.
        this.trigger("initExtensions:after");
    };
    /**
     * Initialize the menu.
     */ Mmenu.prototype._initMenu = function() {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initMenu:before");
        //	Add class to the wrapper.
        this.node.wrpr = this.node.wrpr || this.node.menu.parentElement;
        this.node.wrpr.classList.add("mm-wrapper");
        //	Add an ID to the menu if it does not yet have one.
        this.node.menu.id = this.node.menu.id || (0, $48055557806f998e$export$8b15d37bc3f197d4)();
        //	Wrap the panels in a node.
        var panels = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-panels");
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.menu).forEach(function(panel) {
            if (_this.conf.panelNodetype.indexOf(panel.nodeName.toLowerCase()) > -1) panels.append(panel);
        });
        this.node.menu.append(panels);
        this.node.pnls = panels;
        //	Add class to the menu.
        this.node.menu.classList.add("mm-menu");
        //	Invoke "after" hook.
        this.trigger("initMenu:after");
    };
    /**
     * Initialize panels.
     */ Mmenu.prototype._initPanels = function() {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initPanels:before");
        //	Open / close panels.
        this.clck.push(function(anchor, args) {
            if (args.inMenu) {
                var href = anchor.getAttribute("href");
                if (href && href.length > 1 && href.slice(0, 1) == "#") try {
                    var panel = $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.menu, href)[0];
                    if (panel && panel.matches(".mm-panel")) {
                        if (anchor.parentElement.matches(".mm-listitem_vertical")) _this.togglePanel(panel);
                        else _this.openPanel(panel);
                        return true;
                    }
                } catch (err) {}
            }
        });
        /** The panels to initiate */ var panels = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls);
        panels.forEach(function(panel) {
            _this.initPanel(panel);
        });
        //	Invoke "after" hook.
        this.trigger("initPanels:after");
    };
    /**
     * Initialize a single panel and its children.
     * @param {HTMLElement} panel The panel to initialize.
     */ Mmenu.prototype.initPanel = function(panel) {
        var _this = this;
        /** Query selector for possible node-types for panels. */ var panelNodetype = this.conf.panelNodetype.join(", ");
        if (panel.matches(panelNodetype)) {
            //  Only once
            if (!panel.matches(".mm-panel")) panel = this._initPanel(panel);
            if (panel) {
                /** The sub panels. */ var children_1 = [];
                //	Find panel > panel
                children_1.push.apply(children_1, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, "." + this.conf.classNames.panel));
                //	Find panel listitem > panel
                $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-listview").forEach(function(listview) {
                    $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview, ".mm-listitem").forEach(function(listitem) {
                        children_1.push.apply(children_1, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, panelNodetype));
                    });
                });
                //  Initiate subpanel(s).
                children_1.forEach(function(child) {
                    _this.initPanel(child);
                });
            }
        }
    };
    /**
     * Initialize a single panel.
     * @param  {HTMLElement} 		panel 	Panel to initialize.
     * @return {HTMLElement|null} 			Initialized panel.
     */ Mmenu.prototype._initPanel = function(panel) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initPanel:before", [
            panel
        ]);
        //	Refactor panel classnames
        $5e687dcee2dc17d2$export$9604f4b73fb157f3(panel, this.conf.classNames.panel, "mm-panel");
        $5e687dcee2dc17d2$export$9604f4b73fb157f3(panel, this.conf.classNames.nopanel, "mm-nopanel");
        $5e687dcee2dc17d2$export$9604f4b73fb157f3(panel, this.conf.classNames.inset, "mm-listview_inset");
        if (panel.matches(".mm-listview_inset")) panel.classList.add("mm-nopanel");
        //	Stop if not supposed to be a panel.
        if (panel.matches(".mm-nopanel")) return null;
        /** The original ID on the node. */ var id = panel.id || (0, $48055557806f998e$export$8b15d37bc3f197d4)();
        //  Vertical panel.
        var vertical = panel.matches("." + this.conf.classNames.vertical) || !this.opts.slidingSubmenus;
        panel.classList.remove(this.conf.classNames.vertical);
        //	Wrap UL/OL in DIV
        if (panel.matches("ul, ol")) {
            panel.removeAttribute("id");
            /** The panel. */ var wrapper = $5e687dcee2dc17d2$export$185802fd694ee1f5("div");
            //	Wrap the listview in the panel.
            panel.before(wrapper);
            wrapper.append(panel);
            panel = wrapper;
        }
        panel.id = id;
        panel.classList.add("mm-panel");
        panel.classList.add("mm-hidden");
        /** The parent listitem. */ var parent = [
            panel.parentElement
        ].filter(function(listitem) {
            return listitem.matches("li");
        })[0];
        if (vertical) {
            if (parent) parent.classList.add("mm-listitem_vertical");
        } else this.node.pnls.append(panel);
        if (parent) {
            //	Store parent/child relation.
            parent["mmChild"] = panel;
            panel["mmParent"] = parent;
            //	Add open link to parent listitem
            if (parent && parent.matches(".mm-listitem")) {
                if (!$5e687dcee2dc17d2$export$bacb5cc5a11aef16(parent, ".mm-btn").length) {
                    /** The text node. */ var item = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(parent, ".mm-listitem__text")[0];
                    if (item) {
                        /** The open link. */ var button = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_next.mm-listitem__btn");
                        button.setAttribute("href", "#" + panel.id);
                        //  If the item has no link,
                        //      Replace the item with the open link.
                        if (item.matches("span")) {
                            button.classList.add("mm-listitem__text");
                            button.innerHTML = item.innerHTML;
                            parent.insertBefore(button, item.nextElementSibling);
                            item.remove();
                        } else parent.insertBefore(button, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(parent, ".mm-panel")[0]);
                    }
                }
            }
        }
        this._initNavbar(panel);
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, "ul, ol").forEach(function(listview) {
            _this.initListview(listview);
        });
        //	Invoke "after" hook.
        this.trigger("initPanel:after", [
            panel
        ]);
        return panel;
    };
    /**
     * Initialize a navbar.
     * @param {HTMLElement} panel Panel for the navbar.
     */ Mmenu.prototype._initNavbar = function(panel) {
        //	Invoke "before" hook.
        this.trigger("initNavbar:before", [
            panel
        ]);
        //	Only one navbar per panel.
        if ($5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar").length) return;
        /** The parent listitem. */ var parentListitem = null;
        /** The parent panel. */ var parentPanel = null;
        //  The parent panel was specified in the data-mm-parent attribute.
        if (panel.getAttribute("data-mm-parent")) parentPanel = $5e687dcee2dc17d2$export$71aa6c912b956294(this.node.pnls, panel.getAttribute("data-mm-parent"))[0];
        else {
            parentListitem = panel["mmParent"];
            if (parentListitem) parentPanel = parentListitem.closest(".mm-panel");
        }
        //  No navbar needed for vertical submenus.
        if (parentListitem && parentListitem.matches(".mm-listitem_vertical")) return;
        /** The navbar element. */ var navbar = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-navbar");
        //  Hide navbar if specified in options.
        if (!this.opts.navbar.add) navbar.classList.add("mm-hidden");
        else if (this.opts.navbar.sticky) navbar.classList.add("mm-navbar_sticky");
        //  Add the back button.
        if (parentPanel) {
            /** The back button. */ var prev = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_prev.mm-navbar__btn");
            prev.setAttribute("href", "#" + parentPanel.id);
            navbar.append(prev);
        }
        /** The anchor that opens the panel. */ var opener = null;
        //  The anchor is in a listitem.
        if (parentListitem) opener = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(parentListitem, ".mm-listitem__text")[0];
        else if (parentPanel) opener = $5e687dcee2dc17d2$export$71aa6c912b956294(parentPanel, 'a[href="#' + panel.id + '"]')[0];
        //  Add the title.
        var title = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-navbar__title");
        var titleText = $5e687dcee2dc17d2$export$185802fd694ee1f5("span");
        title.append(titleText);
        titleText.innerHTML = // panel.dataset.mmTitle || // IE10 has no dataset :(
        panel.getAttribute("data-mm-title") || (opener ? opener.textContent : "") || this.i18n(this.opts.navbar.title) || this.i18n("Menu");
        switch(this.opts.navbar.titleLink){
            case "anchor":
                if (opener) title.setAttribute("href", opener.getAttribute("href"));
                break;
            case "parent":
                if (parentPanel) title.setAttribute("href", "#" + parentPanel.id);
                break;
        }
        navbar.append(title);
        panel.prepend(navbar);
        //	Invoke "after" hook.
        this.trigger("initNavbar:after", [
            panel
        ]);
    };
    /**
     * Initialize a listview.
     * @param {HTMLElement} listview Listview to initialize.
     */ Mmenu.prototype.initListview = function(listview) {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initListview:before", [
            listview
        ]);
        $5e687dcee2dc17d2$export$9604f4b73fb157f3(listview, this.conf.classNames.nolistview, "mm-nolistview");
        if (!listview.matches(".mm-nolistview")) {
            listview.classList.add("mm-listview");
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview).forEach(function(listitem) {
                listitem.classList.add("mm-listitem");
                $5e687dcee2dc17d2$export$9604f4b73fb157f3(listitem, _this.conf.classNames.selected, "mm-listitem_selected");
                $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, "a, span").forEach(function(item) {
                    if (!item.matches(".mm-btn")) item.classList.add("mm-listitem__text");
                });
            });
        }
        //	Invoke "after" hook.
        this.trigger("initListview:after", [
            listview
        ]);
    };
    /**
     * Find and open the correct panel after creating the menu.
     */ Mmenu.prototype._initOpened = function() {
        //	Invoke "before" hook.
        this.trigger("initOpened:before");
        /** The selected listitem(s). */ var listitems = this.node.pnls.querySelectorAll(".mm-listitem_selected");
        /** The last selected listitem. */ var lastitem = null;
        //	Deselect the listitems.
        listitems.forEach(function(listitem) {
            lastitem = listitem;
            listitem.classList.remove("mm-listitem_selected");
        });
        //	Re-select the last listitem.
        if (lastitem) lastitem.classList.add("mm-listitem_selected");
        /**	The current opened panel. */ var current = lastitem ? lastitem.closest(".mm-panel") : $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel")[0];
        //	Open the current opened panel.
        this.openPanel(current, false);
        //	Invoke "after" hook.
        this.trigger("initOpened:after");
    };
    /**
     * Initialize anchors in / for the menu.
     */ Mmenu.prototype._initAnchors = function() {
        var _this = this;
        //	Invoke "before" hook.
        this.trigger("initAnchors:before");
        document.addEventListener("click", function(evnt) {
            /** The clicked element. */ var target = evnt.target.closest("a[href]");
            if (!target) return;
            /** Arguments passed to the bound methods. */ var args = {
                inMenu: target.closest(".mm-menu") === _this.node.menu,
                inListview: target.matches(".mm-listitem > a"),
                toExternal: target.matches('[rel="external"]') || target.matches('[target="_blank"]')
            };
            var onClick = {
                close: null,
                setSelected: null,
                preventDefault: target.getAttribute("href").slice(0, 1) == "#"
            };
            //	Find hooked behavior.
            for(var c = 0; c < _this.clck.length; c++){
                var click = _this.clck[c].call(_this, target, args);
                if (click) {
                    if (typeof click == "boolean") {
                        evnt.preventDefault();
                        return;
                    }
                    if ((0, $48055557806f998e$export$bf9fb029d174d554)(click) == "object") onClick = (0, $48055557806f998e$export$8b58be045bf06082)(click, onClick);
                }
            }
            //	Default behavior for anchors in lists.
            if (args.inMenu && args.inListview && !args.toExternal) {
                //	Set selected item, Default: true
                if ((0, $48055557806f998e$export$536caabe1a98b576)(target, _this.opts.onClick.setSelected, onClick.setSelected)) _this.setSelected(target.parentElement);
                //	Prevent default / don't follow link. Default: false.
                if ((0, $48055557806f998e$export$536caabe1a98b576)(target, _this.opts.onClick.preventDefault, onClick.preventDefault)) evnt.preventDefault();
                //	Close menu. Default: false
                if ((0, $48055557806f998e$export$536caabe1a98b576)(target, _this.opts.onClick.close, onClick.close)) {
                    if (_this.opts.offCanvas && typeof _this.close == "function") _this.close();
                }
            }
        }, true);
        //	Invoke "after" hook.
        this.trigger("initAnchors:after");
    };
    /**
     * Get the translation for a text.
     * @param  {string} text 	Text to translate.
     * @return {string}			The translated text.
     */ Mmenu.prototype.i18n = function(text) {
        return $9154f0701a0acf98$export$3988ae62b71be9a3(text, this.conf.language);
    };
    /**	Plugin version. */ Mmenu.version = (0, $705b1bb7572e1f39$export$2e2bcd8739ae039);
    /**	Default options for menus. */ Mmenu.options = (0, $17aff3062705e314$export$2e2bcd8739ae039);
    /**	Default configuration for menus. */ Mmenu.configs = (0, $fa45e5db20850c20$export$2e2bcd8739ae039);
    /**	Available add-ons for the plugin. */ Mmenu.addons = {};
    /** Available wrappers for the plugin. */ Mmenu.wrappers = {};
    /**	Globally used HTML elements. */ Mmenu.node = {};
    /** Globally used variables. */ Mmenu.vars = {};
    return Mmenu;
}();
var $a52e6e9520ba942b$export$2e2bcd8739ae039 = $a52e6e9520ba942b$var$Mmenu;



var $d45fb80fa91cca9f$var$options = {
    blockUI: true,
    moveBackground: true
};
var $d45fb80fa91cca9f$export$2e2bcd8739ae039 = $d45fb80fa91cca9f$var$options;
function $d45fb80fa91cca9f$export$4f8b0ef91d76ca33(options) {
    if (typeof options != "object") options = {};
    return options;
}


var $7cea99ba6c407592$var$configs = {
    clone: false,
    menu: {
        insertMethod: "prepend",
        insertSelector: "body"
    },
    page: {
        nodetype: "div",
        selector: null,
        noSelector: []
    }
};
var $7cea99ba6c407592$export$2e2bcd8739ae039 = $7cea99ba6c407592$var$configs;



/**
 * Make the first letter in a word uppercase.
 * @param {string} word The word.
 */ function $b6b8b66b6d279982$var$ucFirst(word) {
    if (!word) return "";
    return word.charAt(0).toUpperCase() + word.slice(1);
}
function $b6b8b66b6d279982$export$af631764ddc44097(element, evnt, handler) {
    //  Extract the event name and space from the event (the event can include a namespace (click.foo)).
    var evntParts = evnt.split(".");
    evnt = "mmEvent" + $b6b8b66b6d279982$var$ucFirst(evntParts[0]) + $b6b8b66b6d279982$var$ucFirst(evntParts[1]);
    element[evnt] = element[evnt] || [];
    element[evnt].push(handler);
    element.addEventListener(evntParts[0], handler);
}
function $b6b8b66b6d279982$export$8c8705df4a2dcec9(element, evnt) {
    //  Extract the event name and space from the event (the event can include a namespace (click.foo)).
    var evntParts = evnt.split(".");
    evnt = "mmEvent" + $b6b8b66b6d279982$var$ucFirst(evntParts[0]) + $b6b8b66b6d279982$var$ucFirst(evntParts[1]);
    (element[evnt] || []).forEach(function(handler) {
        element.removeEventListener(evntParts[0], handler);
    });
}
function $b6b8b66b6d279982$export$e614dc9140f7ae71(element, evnt, options) {
    var evntParts = evnt.split(".");
    evnt = "mmEvent" + $b6b8b66b6d279982$var$ucFirst(evntParts[0]) + $b6b8b66b6d279982$var$ucFirst(evntParts[1]);
    (element[evnt] || []).forEach(function(handler) {
        handler(options || {});
    });
}



//  Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.offCanvas = (0, $d45fb80fa91cca9f$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.offCanvas = (0, $7cea99ba6c407592$export$2e2bcd8739ae039);
function $a0a535b30841e529$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$options = (0, $d45fb80fa91cca9f$export$4f8b0ef91d76ca33)(this.opts.offCanvas);
    this.opts.offCanvas = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.offCanvas);
    var _$configs = this.conf.offCanvas;
    //	Add methods to the API.
    this._api.push("open", "close", "setPage");
    //	Setup the menu.
    this.vars.opened = false;
    //	Add off-canvas behavior.
    this.bind("initMenu:before", function() {
        //	Clone if needed.
        if (_$configs.clone) {
            //	Clone the original menu and store it.
            _this.node.menu = _this.node.menu.cloneNode(true);
            //	Prefix all ID's in the cloned menu.
            if (_this.node.menu.id) _this.node.menu.id = "mm-" + _this.node.menu.id;
            $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.menu, "[id]").forEach(function(elem) {
                elem.id = "mm-" + elem.id;
            });
        }
        _this.node.wrpr = document.body;
        //	Prepend to the <body>
        document.querySelector(_$configs.menu.insertSelector)[_$configs.menu.insertMethod](_this.node.menu);
    });
    this.bind("initMenu:after", function() {
        //	Setup the UI blocker.
        $a0a535b30841e529$var$initBlocker.call(_this);
        //	Setup the page.
        _this.setPage((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page);
        //	Setup window events.
        $a0a535b30841e529$var$initWindow.call(_this);
        //	Setup the menu.
        _this.node.menu.classList.add("mm-menu_offcanvas");
        //	Open if url hash equals menu id (usefull when user clicks the hamburger icon before the menu is created)
        var hash = window.location.hash;
        if (hash) {
            var id = (0, $48055557806f998e$export$77c7ff3a98df843b)(_this.node.menu.id);
            if (id && id == hash.slice(1)) setTimeout(function() {
                _this.open();
            }, 1000);
        }
    });
    //	Sync the blocker to target the page.
    this.bind("setPage:after", function(page) {
        if ((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck) $5e687dcee2dc17d2$export$bacb5cc5a11aef16((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck, "a").forEach(function(anchor) {
            anchor.setAttribute("href", "#" + page.id);
        });
    });
    //	Add screenreader / aria support
    this.bind("open:start:sr-aria", function() {
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(_this.node.menu, "hidden", false);
    });
    this.bind("close:finish:sr-aria", function() {
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(_this.node.menu, "hidden", true);
    });
    this.bind("initMenu:after:sr-aria", function() {
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(_this.node.menu, "hidden", true);
    });
    //	Add screenreader / text support
    this.bind("initBlocker:after:sr-text", function() {
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck, "a").forEach(function(anchor) {
            anchor.innerHTML = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_text(_this.i18n(_this.conf.screenReader.text.closeMenu));
        });
    });
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor
    this.clck.push(function(anchor, args) {
        //	Open menu if the clicked anchor links to the menu
        var id = (0, $48055557806f998e$export$77c7ff3a98df843b)(_this.node.menu.id);
        if (id) {
            if (anchor.matches('[href="#' + id + '"]')) {
                //	Opening this menu from within this menu
                //		-> Open menu
                if (args.inMenu) {
                    _this.open();
                    return true;
                }
                //	Opening this menu from within a second menu
                //		-> Close the second menu before opening this menu
                var menu = anchor.closest(".mm-menu");
                if (menu) {
                    var api = menu["mmApi"];
                    if (api && api.close) {
                        api.close();
                        (0, $48055557806f998e$export$a214e5a3a7081ff1)(menu, function() {
                            _this.open();
                        }, _this.conf.transitionDuration);
                        return true;
                    }
                }
                //	Opening this menu
                _this.open();
                return true;
            }
        }
        //	Close menu
        id = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page.id;
        if (id) {
            if (anchor.matches('[href="#' + id + '"]')) {
                _this.close();
                return true;
            }
        }
        return;
    });
}
/**
 * Open the menu.
 */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype.open = function() {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger("open:before");
    if (this.vars.opened) return;
    this._openSetup();
    //	Without the timeout, the animation won't work because the menu had display: none;
    setTimeout(function() {
        _this._openStart();
    }, this.conf.openingInterval);
    //	Invoke "after" hook.
    this.trigger("open:after");
};
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype._openSetup = function() {
    var _this = this;
    var _$options = this.opts.offCanvas;
    //	Close other menus
    this.closeAllOthers();
    //	Store style and position
    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page["mmStyle"] = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page.getAttribute("style") || "";
    //	Trigger window-resize to measure height
    $b6b8b66b6d279982$export$e614dc9140f7ae71(window, "resize.page", {
        force: true
    });
    var clsn = [
        "mm-wrapper_opened"
    ];
    //	Add options
    if (_$options.blockUI) clsn.push("mm-wrapper_blocking");
    if (_$options.blockUI == "modal") clsn.push("mm-wrapper_modal");
    if (_$options.moveBackground) clsn.push("mm-wrapper_background");
    //  IE11:
    clsn.forEach(function(classname) {
        _this.node.wrpr.classList.add(classname);
    });
    //  Better browsers:
    // this.node.wrpr.classList.add(...clsn);
    //	Open
    //	Without the timeout, the animation won't work because the menu had display: none;
    setTimeout(function() {
        _this.vars.opened = true;
    }, this.conf.openingInterval);
    this.node.menu.classList.add("mm-menu_opened");
};
/**
 * Finish opening the menu.
 */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype._openStart = function() {
    var _this = this;
    //	Callback when the page finishes opening.
    (0, $48055557806f998e$export$a214e5a3a7081ff1)((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page, function() {
        _this.trigger("open:finish");
    }, this.conf.transitionDuration);
    //	Opening
    this.trigger("open:start");
    this.node.wrpr.classList.add("mm-wrapper_opening");
};
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype.close = function() {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger("close:before");
    if (!this.vars.opened) return;
    //	Callback when the page finishes closing.
    (0, $48055557806f998e$export$a214e5a3a7081ff1)((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page, function() {
        _this.node.menu.classList.remove("mm-menu_opened");
        var classnames = [
            "mm-wrapper_opened",
            "mm-wrapper_blocking",
            "mm-wrapper_modal",
            "mm-wrapper_background"
        ];
        //  IE11:
        classnames.forEach(function(classname) {
            _this.node.wrpr.classList.remove(classname);
        });
        //  Better browsers:
        // this.node.wrpr.classList.remove(...classnames);
        //	Restore style and position
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page.setAttribute("style", (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page["mmStyle"]);
        _this.vars.opened = false;
        _this.trigger("close:finish");
    }, this.conf.transitionDuration);
    //	Closing
    this.trigger("close:start");
    this.node.wrpr.classList.remove("mm-wrapper_opening");
    //	Invoke "after" hook.
    this.trigger("close:after");
};
/**
 * Close all other menus.
 */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype.closeAllOthers = function() {
    var _this = this;
    $5e687dcee2dc17d2$export$71aa6c912b956294(document.body, ".mm-menu_offcanvas").forEach(function(menu) {
        if (menu !== _this.node.menu) {
            var api = menu["mmApi"];
            if (api && api.close) api.close();
        }
    });
};
/**
 * Set the "page" node.
 *
 * @param {HTMLElement} page Element to set as the page.
 */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype.setPage = function(page) {
    //	Invoke "before" hook.
    this.trigger("setPage:before", [
        page
    ]);
    var _$configs = this.conf.offCanvas;
    //	If no page was specified, find it.
    if (!page) {
        /** Array of elements that are / could be "the page". */ var pages = typeof _$configs.page.selector == "string" ? $5e687dcee2dc17d2$export$71aa6c912b956294(document.body, _$configs.page.selector) : $5e687dcee2dc17d2$export$bacb5cc5a11aef16(document.body, _$configs.page.nodetype);
        //	Filter out elements that are absolutely not "the page".
        pages = pages.filter(function(page) {
            return !page.matches(".mm-menu, .mm-wrapper__blocker");
        });
        //	Filter out elements that are configured to not be "the page".
        if (_$configs.page.noSelector.length) pages = pages.filter(function(page) {
            return !page.matches(_$configs.page.noSelector.join(", "));
        });
        //	Wrap multiple pages in a single element.
        if (pages.length > 1) {
            var wrapper_1 = $5e687dcee2dc17d2$export$185802fd694ee1f5("div");
            pages[0].before(wrapper_1);
            pages.forEach(function(page) {
                wrapper_1.append(page);
            });
            pages = [
                wrapper_1
            ];
        }
        page = pages[0];
    }
    page.classList.add("mm-page");
    page.classList.add("mm-slideout");
    page.id = page.id || (0, $48055557806f998e$export$8b15d37bc3f197d4)();
    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page = page;
    //	Invoke "after" hook.
    this.trigger("setPage:after", [
        page
    ]);
};
/**
 * Initialize the window.
 */ var $a0a535b30841e529$var$initWindow = function initWindow() {
    var _this = this;
    //	Prevent tabbing
    //	Because when tabbing outside the menu, the element that gains focus will be centered on the screen.
    //	In other words: The menu would move out of view.
    $b6b8b66b6d279982$export$8c8705df4a2dcec9(document.body, "keydown.tabguard");
    $b6b8b66b6d279982$export$af631764ddc44097(document.body, "keydown.tabguard", function(evnt) {
        if (evnt.keyCode == 9) {
            if (_this.node.wrpr.matches(".mm-wrapper_opened")) evnt.preventDefault();
        }
    });
};
/**
 * Initialize "blocker" node
 */ var $a0a535b30841e529$var$initBlocker = function initBlocker() {
    var _this = this;
    //	Invoke "before" hook.
    this.trigger("initBlocker:before");
    var _$options = this.opts.offCanvas, _$configs = this.conf.offCanvas;
    if (!_$options.blockUI) return;
    //	Create the blocker node.
    if (!(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck) {
        var blck = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-wrapper__blocker.mm-slideout");
        blck.innerHTML = "<a></a>";
        //	Append the blocker node to the body.
        document.querySelector(_$configs.menu.insertSelector).append(blck);
        //	Store the blocker node.
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck = blck;
    }
    //	Close the menu when
    //		1) clicking,
    //		2) touching or
    //		3) dragging the blocker node.
    var closeMenu = function closeMenu(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
        if (!_this.node.wrpr.matches(".mm-wrapper_modal")) _this.close();
    };
    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck.addEventListener("mousedown", closeMenu); // 1
    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck.addEventListener("touchstart", closeMenu); // 2
    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck.addEventListener("touchmove", closeMenu); // 3
    //	Invoke "after" hook.
    this.trigger("initBlocker:after");
};



var $523aa2d8abe188cd$var$options = {
    aria: true,
    text: true
};
var $523aa2d8abe188cd$export$2e2bcd8739ae039 = $523aa2d8abe188cd$var$options;
function $523aa2d8abe188cd$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        aria: options,
        text: options
    };
    if (typeof options != "object") options = {};
    return options;
}


var $caabe12ee77e4816$var$configs = {
    text: {
        closeMenu: "Close menu",
        closeSubmenu: "Close submenu",
        openSubmenu: "Open submenu",
        toggleSubmenu: "Toggle submenu"
    }
};
var $caabe12ee77e4816$export$2e2bcd8739ae039 = $caabe12ee77e4816$var$configs;



var $0646a703a7a7dc2f$export$2e2bcd8739ae039 = {
    "Close menu": "Menu sluiten",
    "Close submenu": "Submenu sluiten",
    "Open submenu": "Submenu openen",
    "Toggle submenu": "Submenu wisselen"
};


var $42c6bf568b11ea7e$export$2e2bcd8739ae039 = {
    "Close menu": "\u0628\u0633\u062A\u0646 \u0645\u0646\u0648",
    "Close submenu": "\u0628\u0633\u062A\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    "Open submenu": "\u0628\u0627\u0632\u06A9\u0631\u062F\u0646 \u0632\u06CC\u0631\u0645\u0646\u0648",
    "Toggle submenu": "\u0633\u0648\u06CC\u06CC\u0686 \u0632\u06CC\u0631\u0645\u0646\u0648"
};


var $9cbfcdc12bc2f242$export$2e2bcd8739ae039 = {
    "Close menu": "Men\xfc schlie\xdfen",
    "Close submenu": "Untermen\xfc schlie\xdfen",
    "Open submenu": "Untermen\xfc \xf6ffnen",
    "Toggle submenu": "Untermen\xfc wechseln"
};


var $7fa3b40334a66fb8$export$2e2bcd8739ae039 = {
    "Close menu": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043C\u0435\u043D\u044E",
    "Close submenu": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    "Open submenu": "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E",
    "Toggle submenu": "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043F\u043E\u0434\u043C\u0435\u043D\u044E"
};


function $8112da669a874aff$export$2e2bcd8739ae039() {
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $0646a703a7a7dc2f$export$2e2bcd8739ae039), "nl");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $42c6bf568b11ea7e$export$2e2bcd8739ae039), "fa");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $9cbfcdc12bc2f242$export$2e2bcd8739ae039), "de");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $7fa3b40334a66fb8$export$2e2bcd8739ae039), "ru");
}




//  Add the translations.
(0, $8112da669a874aff$export$2e2bcd8739ae039)();
//  Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.screenReader = (0, $523aa2d8abe188cd$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.screenReader = (0, $caabe12ee77e4816$export$2e2bcd8739ae039);
function $6abcb35fa0e94821$export$2e2bcd8739ae039() {
    var _this = this;
    //	Extend options.
    var _$options = (0, $523aa2d8abe188cd$export$4f8b0ef91d76ca33)(this.opts.screenReader);
    this.opts.screenReader = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.screenReader);
    //	Extend configs.
    var _$configs = this.conf.screenReader;
    //	Add Aria-* attributes
    if (_$options.aria) {
        //	Add screenreader / aria hooks for add-ons
        //	In orde to keep this list short, only extend hooks that are actually used by other add-ons.
        this.bind("initAddons:after", function() {
            _this.bind("initMenu:after", function() {
                this.trigger("initMenu:after:sr-aria", [].slice.call(arguments));
            });
            _this.bind("initNavbar:after", function() {
                this.trigger("initNavbar:after:sr-aria", [].slice.call(arguments));
            });
            _this.bind("openPanel:start", function() {
                this.trigger("openPanel:start:sr-aria", [].slice.call(arguments));
            });
            _this.bind("close:start", function() {
                this.trigger("close:start:sr-aria", [].slice.call(arguments));
            });
            _this.bind("close:finish", function() {
                this.trigger("close:finish:sr-aria", [].slice.call(arguments));
            });
            _this.bind("open:start", function() {
                this.trigger("open:start:sr-aria", [].slice.call(arguments));
            });
            _this.bind("initOpened:after", function() {
                this.trigger("initOpened:after:sr-aria", [].slice.call(arguments));
            });
        });
        //	Update aria-hidden for hidden / visible listitems
        this.bind("updateListview", function() {
            _this.node.pnls.querySelectorAll(".mm-listitem").forEach(function(listitem) {
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(listitem, "hidden", listitem.matches(".mm-hidden"));
            });
        });
        //	Update aria-hidden for the panels when opening and closing a panel.
        this.bind("openPanel:start", function(panel) {
            /** Panels that should be considered "hidden". */ var hidden = $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.pnls, ".mm-panel").filter(function(hide) {
                return hide !== panel;
            }).filter(function(hide) {
                return !hide.parentElement.matches(".mm-panel");
            });
            /** Panels that should be considered "visible". */ var visible = [
                panel
            ];
            $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem_vertical .mm-listitem_opened").forEach(function(listitem) {
                visible.push.apply(visible, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, ".mm-panel"));
            });
            //	Set the panels to be considered "hidden" or "visible".
            hidden.forEach(function(panel) {
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(panel, "hidden", true);
            });
            visible.forEach(function(panel) {
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(panel, "hidden", false);
            });
        });
        this.bind("closePanel", function(panel) {
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(panel, "hidden", true);
        });
        //	Add aria-haspopup and aria-owns to prev- and next buttons.
        this.bind("initPanel:after", function(panel) {
            $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-btn").forEach(function(button) {
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(button, "haspopup", true);
                var href = button.getAttribute("href");
                if (href) (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(button, "owns", href.replace("#", ""));
            });
        });
        //	Add aria-hidden for navbars in panels.
        this.bind("initNavbar:after", function(panel) {
            /** The navbar in the panel. */ var navbar = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0];
            /** Whether or not the navbar should be considered "hidden". */ var hidden = navbar.matches(".mm-hidden");
            //	Set the navbar to be considered "hidden" or "visible".
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(navbar, "hidden", hidden);
        });
        //	Text
        if (_$options.text) //	Add aria-hidden to titles in navbars
        {
            if (this.opts.navbar.titleLink == "parent") this.bind("initNavbar:after", function(panel) {
                /** The navbar in the panel. */ var navbar = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0];
                /** Whether or not the navbar should be considered "hidden". */ var hidden = navbar.querySelector(".mm-btn_prev") ? true : false;
                //	Set the navbar-title to be considered "hidden" or "visible".
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria($5e687dcee2dc17d2$export$71aa6c912b956294(navbar, ".mm-navbar__title")[0], "hidden", hidden);
            });
        }
    }
    //	Add screenreader text
    if (_$options.text) {
        //	Add screenreader / text hooks for add-ons
        //	In orde to keep this list short, only extend hooks that are actually used by other add-ons.
        this.bind("initAddons:after", function() {
            _this.bind("setPage:after", function() {
                this.trigger("setPage:after:sr-text", [].slice.call(arguments));
            });
            _this.bind("initBlocker:after", function() {
                this.trigger("initBlocker:after:sr-text", [].slice.call(arguments));
            });
        });
        //	Add text to the prev-buttons.
        this.bind("initNavbar:after", function(panel) {
            var navbar = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0];
            if (navbar) {
                var button = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(navbar, ".mm-btn_prev")[0];
                if (button) button.innerHTML = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_text(_this.i18n(_$configs.text.closeSubmenu));
            }
        });
        //	Add text to the next-buttons.
        this.bind("initListview:after", function(listview) {
            var parent = listview.closest(".mm-panel")["mmParent"];
            if (parent) {
                var next = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(parent, ".mm-btn_next")[0];
                if (next) {
                    var text = _this.i18n(_$configs.text[next.parentElement.matches(".mm-listitem_vertical") ? "toggleSubmenu" : "openSubmenu"]);
                    next.innerHTML += (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_text(text);
                }
            }
        });
    }
}
//	Methods
(function() {
    var attr = function attr(element, attr, value) {
        element[attr] = value;
        if (value) element.setAttribute(attr, value.toString());
        else element.removeAttribute(attr);
    };
    /**
     * Add aria (property and) attribute to a HTML element.
     *
     * @param {HTMLElement} 	element	The node to add the attribute to.
     * @param {string}			name	The (non-aria-prefixed) attribute name.
     * @param {string|boolean}	value	The attribute value.
     */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria = function(element, name, value) {
        attr(element, "aria-" + name, value);
    };
    /**
     * Add role attribute to a HTML element.
     *
     * @param {HTMLElement}		element	The node to add the attribute to.
     * @param {string|boolean}	value	The attribute value.
     */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_role = function(element, value) {
        attr(element, "role", value);
    };
    /**
     * Wrap a text in a screen-reader-only node.
     *
     * @param 	{string} text	The text to wrap.
     * @return	{string}		The wrapped text.
     */ (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_text = function(text) {
        return '<span class="mm-sronly">' + text + "</span>";
    };
})();



var $cc5a3485534080dd$var$options = {
    fix: true
};
var $cc5a3485534080dd$export$2e2bcd8739ae039 = $cc5a3485534080dd$var$options;
function $cc5a3485534080dd$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        fix: options
    };
    if (typeof options != "object") options = {};
    return options;
}



/** Whether or not touch gestures are supported by the browser. */ var $2b1d8945f5aabd11$export$d0b7ea69ab6056df = "ontouchstart" in window || (navigator.msMaxTouchPoints ? true : false) || false;



//  Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.scrollBugFix = (0, $cc5a3485534080dd$export$2e2bcd8739ae039);
function $b754b876423d6500$export$2e2bcd8739ae039() {
    var _this = this;
    //	The scrollBugFix add-on fixes a scrolling bug
    //		1) on touch devices
    //		2) in an off-canvas menu
    //		3) that -when opened- blocks the UI from interaction
    if (!$2b1d8945f5aabd11$export$d0b7ea69ab6056df || // 1
    !this.opts.offCanvas || // 2
    !this.opts.offCanvas.blockUI // 3
    ) return;
    //	Extend options.
    var _$options = (0, $cc5a3485534080dd$export$4f8b0ef91d76ca33)(this.opts.scrollBugFix);
    this.opts.scrollBugFix = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.scrollBugFix);
    if (!_$options.fix) return;
    var touchDir = (0, $48055557806f998e$export$c69521134f103c95)(this.node.menu);
    /**
     * Prevent an event from doing its default and stop its propagation.
     * @param {ScrollBehavior} evnt The event to stop.
     */ function stop(evnt) {
        evnt.preventDefault();
        evnt.stopPropagation();
    }
    //  Prevent the page from scrolling when scrolling in the menu.
    this.node.menu.addEventListener("scroll", stop, {
        //  Make sure to tell the browser the event will be prevented.
        passive: false
    });
    //  Prevent the page from scrolling when dragging in the menu.
    this.node.menu.addEventListener("touchmove", function(evnt) {
        var panel = evnt.target.closest(".mm-panel");
        if (panel) {
            //  When dragging a non-scrollable panel,
            //      we can simple preventDefault and stopPropagation.
            if (panel.scrollHeight === panel.offsetHeight) stop(evnt);
            else if (//  When scrolled up and dragging down
            panel.scrollTop == 0 && touchDir.get() == "down" || //  When scrolled down and dragging up
            panel.scrollHeight == panel.scrollTop + panel.offsetHeight && touchDir.get() == "up") stop(evnt);
        //  When dragging anything other than a panel.
        } else stop(evnt);
    }, {
        //  Make sure to tell the browser the event can be prevented.
        passive: false
    });
    //  Some small additional improvements
    //	Scroll the current opened panel to the top when opening the menu.
    this.bind("open:start", function() {
        var panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
        if (panel) panel.scrollTop = 0;
    });
    //	Fix issue after device rotation change.
    window.addEventListener("orientationchange", function(evnt) {
        var panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
        if (panel) {
            panel.scrollTop = 0;
            //	Apparently, changing the overflow-scrolling property triggers some event :)
            panel.style["-webkit-overflow-scrolling"] = "auto";
            panel.style["-webkit-overflow-scrolling"] = "touch";
        }
    });
}



var $ca9c32ad898575d1$var$opts = {
    height: "default"
};
var $ca9c32ad898575d1$export$2e2bcd8739ae039 = $ca9c32ad898575d1$var$opts;
function $ca9c32ad898575d1$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean" && options) options = {
        height: "auto"
    };
    if (typeof options == "string") options = {
        height: options
    };
    if (typeof options != "object") options = {};
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.autoHeight = (0, $ca9c32ad898575d1$export$2e2bcd8739ae039);
function $cbadd89cefd74af9$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $ca9c32ad898575d1$export$4f8b0ef91d76ca33)(this.opts.autoHeight);
    this.opts.autoHeight = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.autoHeight);
    if (_$options.height != "auto" && _$options.height != "highest") return;
    var setHeight = function() {
        var getCurrent = function getCurrent() {
            var panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
            if (panel) panel = measurablePanel(panel);
            //	Fallback, just to be sure we have a panel.
            if (!panel) panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel")[0];
            return panel.scrollHeight;
        };
        var getHighest = function getHighest() {
            var highest = 0;
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel").forEach(function(panel) {
                panel = measurablePanel(panel);
                highest = Math.max(highest, panel.scrollHeight);
            });
            return highest;
        };
        var measurablePanel = function measurablePanel(panel) {
            //	If it's a vertically expanding panel...
            if (panel.parentElement.matches(".mm-listitem_vertical")) //	...find the first parent panel that isn't.
            panel = $5e687dcee2dc17d2$export$7901f6cd558b9a93(panel, ".mm-panel").filter(function(panel) {
                return !panel.parentElement.matches(".mm-listitem_vertical");
            })[0];
            return panel;
        };
        return function() {
            if (_this.opts.offCanvas && !_this.vars.opened) return;
            var _hgh = 0;
            var _dif = _this.node.menu.offsetHeight - _this.node.pnls.offsetHeight;
            //	The "measuring" classname undoes some CSS to be able to measure the height.
            _this.node.menu.classList.add("mm-menu_autoheight-measuring");
            //	Measure the height.
            if (_$options.height == "auto") _hgh = getCurrent();
            else if (_$options.height == "highest") _hgh = getHighest();
            //	Set the height.
            _this.node.menu.style.height = _hgh + _dif + "px";
            //	Remove the "measuring" classname.
            _this.node.menu.classList.remove("mm-menu_autoheight-measuring");
        };
    }();
    //	Add the autoheight class to the menu.
    this.bind("initMenu:after", function() {
        _this.node.menu.classList.add("mm-menu_autoheight");
    });
    if (this.opts.offCanvas) //	Measure the height when opening the off-canvas menu.
    this.bind("open:start", setHeight);
    if (_$options.height == "highest") //	Measure the height when initiating panels.
    this.bind("initPanels:after", setHeight);
    if (_$options.height == "auto") {
        //	Measure the height when updating listviews.
        this.bind("updateListview", setHeight);
        //	Measure the height when opening a panel.
        this.bind("openPanel:start", setHeight);
    }
}



var $fe81dd971f9b0155$var$options = {
    close: false,
    open: false
};
var $fe81dd971f9b0155$export$2e2bcd8739ae039 = $fe81dd971f9b0155$var$options;
function $fe81dd971f9b0155$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        close: options
    };
    if (typeof options != "object") options = {};
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.backButton = (0, $fe81dd971f9b0155$export$2e2bcd8739ae039);
function $2dababb2dc8e13ee$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$options = (0, $fe81dd971f9b0155$export$4f8b0ef91d76ca33)(this.opts.backButton);
    this.opts.backButton = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.backButton);
    var _menu = "#" + this.node.menu.id;
    //	Close menu
    if (_$options.close) {
        var states = [];
        var setStates = function setStates() {
            states = [
                _menu
            ];
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened, .mm-panel_opened-parent").forEach(function(panel) {
                states.push("#" + panel.id);
            });
        };
        this.bind("open:finish", function() {
            history.pushState(null, document.title, _menu);
        });
        this.bind("open:finish", setStates);
        this.bind("openPanel:finish", setStates);
        this.bind("close:finish", function() {
            states = [];
            history.back();
            history.pushState(null, document.title, location.pathname + location.search);
        });
        window.addEventListener("popstate", function(evnt) {
            if (_this.vars.opened) {
                if (states.length) {
                    states = states.slice(0, -1);
                    var hash = states[states.length - 1];
                    if (hash == _menu) _this.close();
                    else {
                        _this.openPanel(_this.node.menu.querySelector(hash));
                        history.pushState(null, document.title, _menu);
                    }
                }
            }
        });
    }
    if (_$options.open) window.addEventListener("popstate", function(evnt) {
        if (!_this.vars.opened && location.hash == _menu) _this.open();
    });
}



var $de007715962b8959$var$options = {
    add: false,
    visible: {
        min: 1,
        max: 3
    }
};
var $de007715962b8959$export$2e2bcd8739ae039 = $de007715962b8959$var$options;
function $de007715962b8959$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options
    };
    if (typeof options == "number") options = {
        add: true,
        visible: options
    };
    if (typeof options != "object") options = {};
    if (typeof options.visible == "number") options.visible = {
        min: options.visible,
        max: options.visible
    };
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.columns = (0, $de007715962b8959$export$2e2bcd8739ae039);
function $3db3d1a106c5c582$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $de007715962b8959$export$4f8b0ef91d76ca33)(this.opts.columns);
    this.opts.columns = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.columns);
    //	Add the columns
    if (_$options.add) {
        _$options.visible.min = Math.max(1, Math.min(6, _$options.visible.min));
        _$options.visible.max = Math.max(_$options.visible.min, Math.min(6, _$options.visible.max));
        /** Columns related clasnames for the menu. */ var colm = [];
        /** Columns related clasnames for the panels. */ var colp = [];
        /** Classnames to remove from panels in favor of showing columns. */ var rmvc = [
            "mm-panel_opened",
            "mm-panel_opened-parent",
            "mm-panel_highest"
        ];
        for(var i = 0; i <= _$options.visible.max; i++){
            colm.push("mm-menu_columns-" + i);
            colp.push("mm-panel_columns-" + i);
        }
        rmvc.push.apply(rmvc, colp);
        //	Close all later opened panels
        this.bind("openPanel:before", function(panel) {
            /** The parent panel. */ var parent;
            if (panel) parent = panel["mmParent"];
            if (!parent) return;
            parent = parent.closest(".mm-panel");
            if (!parent) return;
            var classname = parent.className;
            if (!classname.length) return;
            classname = classname.split("mm-panel_columns-")[1];
            if (!classname) return;
            var colnr = parseInt(classname.split(" ")[0], 10) + 1;
            while(colnr > 0){
                panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_columns-" + colnr)[0];
                if (panel) {
                    colnr++;
                    panel.classList.add("mm-hidden");
                    //  IE11:
                    rmvc.forEach(function(classname) {
                        panel.classList.remove(classname);
                    });
                //  Better browsers:
                // panel.classList.remove(...rmvc);
                } else {
                    colnr = -1;
                    break;
                }
            }
        });
        this.bind("openPanel:start", function(panel) {
            var columns = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened-parent").length;
            if (!panel.matches(".mm-panel_opened-parent")) columns++;
            columns = Math.min(_$options.visible.max, Math.max(_$options.visible.min, columns));
            //  IE11:
            colm.forEach(function(classname) {
                _this.node.menu.classList.remove(classname);
            });
            //  Better browsers:
            // this.node.menu.classList.remove(...colm);
            _this.node.menu.classList.add("mm-menu_columns-" + columns);
            var panels = [];
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel").forEach(function(panel) {
                //  IE11:
                colp.forEach(function(classname) {
                    panel.classList.remove(classname);
                });
                //  Better browsers:
                // panel.classList.remove(...colp);
                if (panel.matches(".mm-panel_opened-parent")) panels.push(panel);
            });
            panels.push(panel);
            panels.slice(-_$options.visible.max).forEach(function(panel, p) {
                panel.classList.add("mm-panel_columns-" + p);
            });
        });
    }
}



var $2debf5fbb91fac4b$var$options = {
    add: false,
    addTo: "panels",
    count: false
};
var $2debf5fbb91fac4b$export$2e2bcd8739ae039 = $2debf5fbb91fac4b$var$options;
function $2debf5fbb91fac4b$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options,
        addTo: "panels",
        count: options
    };
    if (typeof options != "object") options = {};
    if (options.addTo == "panels") options.addTo = ".mm-listview";
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.counters = (0, $2debf5fbb91fac4b$export$2e2bcd8739ae039);
//	Add the classnames.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.classNames.counters = {
    counter: "Counter"
};
function $240c27dcfcf1ee33$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $2debf5fbb91fac4b$export$4f8b0ef91d76ca33)(this.opts.counters);
    this.opts.counters = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.counters);
    //	Refactor counter class
    this.bind("initListview:after", function(listview) {
        var cntrclss = _this.conf.classNames.counters.counter, counters = $5e687dcee2dc17d2$export$71aa6c912b956294(listview, "." + cntrclss);
        counters.forEach(function(counter) {
            $5e687dcee2dc17d2$export$9604f4b73fb157f3(counter, cntrclss, "mm-counter");
        });
    });
    //	Add the counters after a listview is initiated.
    if (_$options.add) this.bind("initListview:after", function(listview) {
        if (!listview.matches(_$options.addTo)) return;
        var parent = listview.closest(".mm-panel")["mmParent"];
        if (parent) //	Check if no counter already excists.
        {
            if (!$5e687dcee2dc17d2$export$71aa6c912b956294(parent, ".mm-counter").length) {
                var btn = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(parent, ".mm-btn")[0];
                if (btn) btn.prepend($5e687dcee2dc17d2$export$185802fd694ee1f5("span.mm-counter"));
            }
        }
    });
    if (_$options.count) {
        var count = function count(listview) {
            var panels = listview ? [
                listview.closest(".mm-panel")
            ] : $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel");
            panels.forEach(function(panel) {
                var parent = panel["mmParent"];
                if (!parent) return;
                var counter = $5e687dcee2dc17d2$export$71aa6c912b956294(parent, ".mm-counter")[0];
                if (!counter) return;
                var listitems = [];
                $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-listview").forEach(function(listview) {
                    listitems.push.apply(listitems, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview));
                });
                counter.innerHTML = $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems).length.toString();
            });
        };
        this.bind("initListview:after", count);
        this.bind("updateListview", count);
    }
}



var $3d777b47311d541e$var$options = {
    add: false,
    addTo: "panels"
};
var $3d777b47311d541e$export$2e2bcd8739ae039 = $3d777b47311d541e$var$options;
function $3d777b47311d541e$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options
    };
    if (typeof options != "object") options = {};
    if (options.addTo == "panels") options.addTo = ".mm-listview";
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.dividers = (0, $3d777b47311d541e$export$2e2bcd8739ae039);
//  Add the classnames.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.classNames.divider = "Divider";
function $0c7774ebe80a1831$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $3d777b47311d541e$export$4f8b0ef91d76ca33)(this.opts.dividers);
    this.opts.dividers = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.dividers);
    //	Refactor divider classname
    this.bind("initListview:after", function(listview) {
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview).forEach(function(listitem) {
            $5e687dcee2dc17d2$export$9604f4b73fb157f3(listitem, _this.conf.classNames.divider, "mm-divider");
            if (listitem.matches(".mm-divider")) listitem.classList.remove("mm-listitem");
        });
    });
    //	Add dividers
    if (_$options.add) this.bind("initListview:after", function(listview) {
        if (!listview.matches(_$options.addTo)) return;
        $5e687dcee2dc17d2$export$71aa6c912b956294(listview, ".mm-divider").forEach(function(divider) {
            divider.remove();
        });
        var lastletter = "", listitems = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview);
        $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems).forEach(function(listitem) {
            var letter = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, ".mm-listitem__text")[0].textContent.trim().toLowerCase()[0];
            if (letter.length && letter != lastletter) {
                lastletter = letter;
                var divider = $5e687dcee2dc17d2$export$185802fd694ee1f5("li.mm-divider");
                divider.textContent = letter;
                listview.insertBefore(divider, listitem);
            }
        });
    });
}



var $ae515b7b83877d94$var$options = {
    open: false,
    node: null
};
var $ae515b7b83877d94$export$2e2bcd8739ae039 = $ae515b7b83877d94$var$options;
function $ae515b7b83877d94$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        open: options
    };
    if (typeof options != "object") options = {};
    return options;
}


/** Whether or not touch gestures are supported by the browser. */ var $d6485b28ad66c28f$export$d0b7ea69ab6056df = "ontouchstart" in window || (navigator.msMaxTouchPoints ? true : false) || false;


/** How far from the sides the gesture can start. */ var $f98a9e0adfbad3d9$export$bb3edc44842b5f2e = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $f98a9e0adfbad3d9$export$7813f63a0471b9e3 = {
    start: 15,
    swipe: 15
};


/** Names of the possible directions. */ var $d01c6a9d8bc044a6$export$855631ebe65de9d8 = {
    x: [
        "Right",
        "Left"
    ],
    y: [
        "Down",
        "Up"
    ]
};
var $d01c6a9d8bc044a6$export$ca000e230c0caa3e = {
    inactive: 0,
    watching: 1,
    dragging: 2
};


/**
 * Calculate a distance from a percentage.
 * @param  {string|number}   position   The percentage (e.g. "75%").
 * @param  {number}          size       The available width or height in pixels.
 * @return {number}                     The calculated distance.
 */ var $db682c2bfb96e72f$export$69030955a69ceae3 = function percentage2number(position, size) {
    if (typeof position == "string") {
        if (position.slice(-1) == "%") {
            position = parseInt(position.slice(0, -1), 10);
            position = size * (position / 100);
        }
    }
    return position;
};



var $fa471599f13239d1$var$DragEvents = /** @class */ function() {
    /**
     * Create the gestures.
     * @param {HTMLElement} surface     The surface for the gesture.
     * @param {object}      area        Restriction where on the surface the gesture can be started.
     * @param {object}      treshold    Treshold for the gestures.
     */ function DragEvents(surface, area, treshold) {
        this.surface = surface;
        this.area = (0, $48055557806f998e$export$8b58be045bf06082)(area, $f98a9e0adfbad3d9$export$bb3edc44842b5f2e);
        this.treshold = (0, $48055557806f998e$export$8b58be045bf06082)(treshold, $f98a9e0adfbad3d9$export$7813f63a0471b9e3);
        //	Set the mouse/touch events.
        if (!this.surface["mmHasDragEvents"]) {
            this.surface.addEventListener($d6485b28ad66c28f$export$d0b7ea69ab6056df ? "touchstart" : "mousedown", this.start.bind(this));
            this.surface.addEventListener($d6485b28ad66c28f$export$d0b7ea69ab6056df ? "touchend" : "mouseup", this.stop.bind(this));
            this.surface.addEventListener($d6485b28ad66c28f$export$d0b7ea69ab6056df ? "touchleave" : "mouseleave", this.stop.bind(this));
            this.surface.addEventListener($d6485b28ad66c28f$export$d0b7ea69ab6056df ? "touchmove" : "mousemove", this.move.bind(this));
        }
        this.surface["mmHasDragEvents"] = true;
    }
    /**
     * Starting the touch gesture.
     * @param {Event} event The touch event.
     */ DragEvents.prototype.start = function(event) {
        this.currentPosition = {
            x: event.touches ? event.touches[0].pageX : event.pageX || 0,
            y: event.touches ? event.touches[0].pageY : event.pageY || 0
        };
        /** The widht of the surface. */ var width = this.surface.clientWidth;
        /** The height of the surface. */ var height = this.surface.clientHeight;
        //  Check if the gesture started below the area.top.
        var top = (0, $db682c2bfb96e72f$export$69030955a69ceae3)(this.area.top, height);
        if (typeof top == "number") {
            if (this.currentPosition.y < top) return;
        }
        //  Check if the gesture started before the area.right.
        var right = (0, $db682c2bfb96e72f$export$69030955a69ceae3)(this.area.right, width);
        if (typeof right == "number") {
            right = width - right;
            if (this.currentPosition.x > right) return;
        }
        //  Check if the gesture started above the area.bottom.
        var bottom = (0, $db682c2bfb96e72f$export$69030955a69ceae3)(this.area.bottom, height);
        if (typeof bottom == "number") {
            bottom = height - bottom;
            if (this.currentPosition.y > bottom) return;
        }
        //  Check if the gesture started after the area.left.
        var left = (0, $db682c2bfb96e72f$export$69030955a69ceae3)(this.area.left, width);
        if (typeof left == "number") {
            if (this.currentPosition.x < left) return;
        }
        //	Store the start x- and y-position.
        this.startPosition = {
            x: this.currentPosition.x,
            y: this.currentPosition.y
        };
        //	Set the state of the gesture to "watching".
        this.state = $d01c6a9d8bc044a6$export$ca000e230c0caa3e.watching;
    };
    /**
     * Stopping the touch gesture.
     * @param {Event} event The touch event.
     */ DragEvents.prototype.stop = function(event) {
        //	Dispatch the "dragEnd" events.
        if (this.state == $d01c6a9d8bc044a6$export$ca000e230c0caa3e.dragging) {
            /** The direction. */ var dragDirection = this._dragDirection();
            /** The event information. */ var detail = this._eventDetail(dragDirection);
            this._dispatchEvents("drag*End", detail);
            //	Dispatch the "swipe" events.
            if (Math.abs(this.movement[this.axis]) > this.treshold.swipe) {
                /** The direction. */ var swipeDirection = this._swipeDirection();
                detail.direction = swipeDirection;
                this._dispatchEvents("swipe*", detail);
            }
        }
        //	Set the state of the gesture to "inactive".
        this.state = $d01c6a9d8bc044a6$export$ca000e230c0caa3e.inactive;
    };
    /**
     * Doing the touch gesture.
     * @param {Event} event The touch event.
     */ DragEvents.prototype.move = function(event) {
        switch(this.state){
            case $d01c6a9d8bc044a6$export$ca000e230c0caa3e.watching:
            case $d01c6a9d8bc044a6$export$ca000e230c0caa3e.dragging:
                var position = {
                    x: event.changedTouches ? event.touches[0].pageX : event.pageX || 0,
                    y: event.changedTouches ? event.touches[0].pageY : event.pageY || 0
                };
                this.movement = {
                    x: position.x - this.currentPosition.x,
                    y: position.y - this.currentPosition.y
                };
                this.distance = {
                    x: position.x - this.startPosition.x,
                    y: position.y - this.startPosition.y
                };
                this.currentPosition = {
                    x: position.x,
                    y: position.y
                };
                this.axis = Math.abs(this.distance.x) > Math.abs(this.distance.y) ? "x" : "y";
                /** The direction. */ var dragDirection = this._dragDirection();
                /** The event information. */ var detail = this._eventDetail(dragDirection);
                //	Watching for the gesture to go past the treshold.
                if (this.state == $d01c6a9d8bc044a6$export$ca000e230c0caa3e.watching) {
                    if (Math.abs(this.distance[this.axis]) > this.treshold.start) {
                        this._dispatchEvents("drag*Start", detail);
                        //	Set the state of the gesture to "inactive".
                        this.state = $d01c6a9d8bc044a6$export$ca000e230c0caa3e.dragging;
                    }
                }
                //	Dispatch the "drag" events.
                if (this.state == $d01c6a9d8bc044a6$export$ca000e230c0caa3e.dragging) this._dispatchEvents("drag*Move", detail);
                break;
        }
    };
    /**
     * Get the event details.
     * @param {string}  direction   Direction for the event (up, right, down, left).
     * @return {object}             The event details.
     */ DragEvents.prototype._eventDetail = function(direction) {
        var distX = this.distance.x;
        var distY = this.distance.y;
        if (this.axis == "x") distX -= distX > 0 ? this.treshold.start : 0 - this.treshold.start;
        if (this.axis == "y") distY -= distY > 0 ? this.treshold.start : 0 - this.treshold.start;
        return {
            axis: this.axis,
            direction: direction,
            movementX: this.movement.x,
            movementY: this.movement.y,
            distanceX: distX,
            distanceY: distY
        };
    };
    /**
     * Dispatch the events
     * @param {string} eventName    The name for the events to dispatch.
     * @param {object} detail       The event details.
     */ DragEvents.prototype._dispatchEvents = function(eventName, detail) {
        /** General event, e.g. "drag" */ var event = new CustomEvent(eventName.replace("*", ""), {
            detail: detail
        });
        this.surface.dispatchEvent(event);
        /** Axis event, e.g. "dragX" */ var axis = new CustomEvent(eventName.replace("*", this.axis.toUpperCase()), {
            detail: detail
        });
        this.surface.dispatchEvent(axis);
        /** Direction event, e.g. "dragLeft" */ var direction = new CustomEvent(eventName.replace("*", detail.direction), {
            detail: detail
        });
        this.surface.dispatchEvent(direction);
    };
    /**
     * Get the dragging direction.
     * @return {string} The direction in which the user is dragging.
     */ DragEvents.prototype._dragDirection = function() {
        return $d01c6a9d8bc044a6$export$855631ebe65de9d8[this.axis][this.distance[this.axis] > 0 ? 0 : 1];
    };
    /**
     * Get the dragging direction.
     * @return {string} The direction in which the user is dragging.
     */ DragEvents.prototype._swipeDirection = function() {
        return $d01c6a9d8bc044a6$export$855631ebe65de9d8[this.axis][this.movement[this.axis] > 0 ? 0 : 1];
    };
    return DragEvents;
}();
var $fa471599f13239d1$export$2e2bcd8739ae039 = $fa471599f13239d1$var$DragEvents;





/** Instance of the DragEvents class. */ var $92cc95adcae1e98e$var$dragInstance = null;
/** THe node that can be dragged. */ var $92cc95adcae1e98e$var$dragNode = null;
/** How far the page (or menu) can be dragged. */ var $92cc95adcae1e98e$var$maxDistance = 0;
function $92cc95adcae1e98e$export$2e2bcd8739ae039(page) {
    var _this = this;
    /** Variables that vary for each menu position (top, right, bottom, left. front, back). */ var vars = {};
    /** Whether or not the page or menu is actually being moved. */ var moving = false;
    /**
     * Add the dragging events.
     */ var addEvents = function addEvents() {
        if ($92cc95adcae1e98e$var$dragNode) {
            //  Prepare the page or menu to be moved.
            $b6b8b66b6d279982$export$af631764ddc44097($92cc95adcae1e98e$var$dragNode, "dragStart", function(evnt) {
                if (evnt["detail"].direction == vars.direction) {
                    moving = true;
                    //  Class prevents interaction with the page.
                    _this.node.wrpr.classList.add("mm-wrapper_dragging");
                    //  Prepare the menu to be opened.
                    _this._openSetup();
                    _this.trigger("open:start");
                    //  Get the maximum distance to move out the page or menu.
                    $92cc95adcae1e98e$var$maxDistance = _this.node.menu[vars.axis == "x" ? "clientWidth" : "clientHeight"];
                }
            });
            //  Move the page or menu when dragging.
            $b6b8b66b6d279982$export$af631764ddc44097($92cc95adcae1e98e$var$dragNode, "dragMove", function(evnt) {
                if (evnt["detail"].axis == vars.axis) {
                    if (moving) {
                        var distance = evnt["detail"]["distance" + vars.axis.toUpperCase()];
                        switch(vars.position){
                            case "right":
                            case "bottom":
                                distance = Math.min(Math.max(distance, -$92cc95adcae1e98e$var$maxDistance), 0);
                                break;
                            default:
                                distance = Math.max(Math.min(distance, $92cc95adcae1e98e$var$maxDistance), 0);
                        }
                        //  Deviate for position front (the menu starts out of view).
                        if (vars.zposition == "front") switch(vars.position){
                            case "right":
                            case "bottom":
                                distance += $92cc95adcae1e98e$var$maxDistance;
                                break;
                            default:
                                distance -= $92cc95adcae1e98e$var$maxDistance;
                                break;
                        }
                        vars.slideOutNodes.forEach(function(node) {
                            node.style["transform"] = "translate" + vars.axis.toUpperCase() + "(" + distance + "px)";
                        });
                    }
                }
            });
            //  Stop the page or menu from being moved.
            $b6b8b66b6d279982$export$af631764ddc44097($92cc95adcae1e98e$var$dragNode, "dragEnd", function(evnt) {
                if (evnt["detail"].axis == vars.axis) {
                    if (moving) {
                        moving = false;
                        _this.node.wrpr.classList.remove("mm-wrapper_dragging");
                        vars.slideOutNodes.forEach(function(node) {
                            node.style["transform"] = "";
                        });
                        //  Determine if the menu should open or close.
                        var open_1 = Math.abs(evnt["detail"]["distance" + vars.axis.toUpperCase()]) >= $92cc95adcae1e98e$var$maxDistance * 0.75;
                        if (!open_1) {
                            var movement = evnt["detail"]["movement" + vars.axis.toUpperCase()];
                            switch(vars.position){
                                case "right":
                                case "bottom":
                                    open_1 = movement <= 0;
                                    break;
                                default:
                                    open_1 = movement >= 0;
                                    break;
                            }
                        }
                        if (open_1) _this._openStart();
                        else _this.close();
                    }
                }
            });
        }
    };
    /**
     * Remove the dragging events.
     */ var removeEvents = function removeEvents() {
        if ($92cc95adcae1e98e$var$dragNode) {
            $b6b8b66b6d279982$export$8c8705df4a2dcec9($92cc95adcae1e98e$var$dragNode, "dragStart");
            $b6b8b66b6d279982$export$8c8705df4a2dcec9($92cc95adcae1e98e$var$dragNode, "dragMove");
            $b6b8b66b6d279982$export$8c8705df4a2dcec9($92cc95adcae1e98e$var$dragNode, "dragEnd");
        }
    };
    var addMatchMedia = function addMatchMedia() {
        var queries = Object.keys(_this.opts.extensions);
        if (queries.length) {
            //  A media query that'll match if any of the other media query matches:
            //    set the defaults if it doesn't match.
            $fb351eed9e08732b$export$e16d8520af44a096(queries.join(", "), function() {}, function() {
                vars = $92cc95adcae1e98e$var$getPositionVars(vars, [], _this.node.menu);
            });
            //  The other media queries.
            queries.forEach(function(query) {
                $fb351eed9e08732b$export$e16d8520af44a096(query, function() {
                    vars = $92cc95adcae1e98e$var$getPositionVars(vars, _this.opts.extensions[query], _this.node.menu);
                }, function() {});
            });
        //  No extensions, just use the defaults.
        } else vars = $92cc95adcae1e98e$var$getPositionVars(vars, [], _this.node.menu);
    };
    //  Remove events from previous "page"
    removeEvents();
    //  Store new "page"
    $92cc95adcae1e98e$var$dragNode = page;
    //  Initialize the drag events.
    $92cc95adcae1e98e$var$dragInstance = new (0, $fa471599f13239d1$export$2e2bcd8739ae039)($92cc95adcae1e98e$var$dragNode);
    addMatchMedia();
    addMatchMedia = function addMatchMedia() {};
    addEvents();
}
var $92cc95adcae1e98e$var$getPositionVars = function getPositionVars(vars, extensions, menu) {
    //  Default position and z-position.
    vars.position = "left";
    vars.zposition = "back";
    //  Find position.
    [
        "right",
        "top",
        "bottom"
    ].forEach(function(pos) {
        if (extensions.indexOf("position-" + pos) > -1) vars.position = pos;
    });
    //  Find z-position.
    [
        "front",
        "top",
        "bottom"
    ].forEach(function(pos) {
        if (extensions.indexOf("position-" + pos) > -1) vars.zposition = "front";
    });
    //  Set the area where the dragging can start.
    $92cc95adcae1e98e$var$dragInstance.area = {
        top: vars.position == "bottom" ? "75%" : 0,
        right: vars.position == "left" ? "75%" : 0,
        bottom: vars.position == "top" ? "75%" : 0,
        left: vars.position == "right" ? "75%" : 0
    };
    //  What side of the menu to measure (width or height).
    //  What axis to drag the menu along (x or y).
    switch(vars.position){
        case "top":
        case "bottom":
            vars.axis = "y";
            break;
        default:
            vars.axis = "x";
    }
    //  What direction to drag in.
    switch(vars.position){
        case "top":
            vars.direction = "Down";
            break;
        case "right":
            vars.direction = "Left";
            break;
        case "bottom":
            vars.direction = "Up";
            break;
        default:
            vars.direction = "Right";
    }
    //  What nodes to slide out while dragging.
    switch(vars.zposition){
        case "front":
            vars.slideOutNodes = [
                menu
            ];
            break;
        default:
            vars.slideOutNodes = $5e687dcee2dc17d2$export$71aa6c912b956294(document.body, ".mm-slideout");
    }
    return vars;
};



//	Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.drag = (0, $ae515b7b83877d94$export$2e2bcd8739ae039);
function $8d62d64bc0b4a6e7$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$options = (0, $ae515b7b83877d94$export$4f8b0ef91d76ca33)(this.opts.drag);
    this.opts.drag = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.drag);
    //	Drag open the menu
    if (_$options.open) this.bind("setPage:after", function(page) {
        (0, $92cc95adcae1e98e$export$2e2bcd8739ae039).call(_this, _$options.node || page);
    });
}



var $664a9d2983dcb79f$var$options = {
    drop: false,
    fitViewport: true,
    event: "click",
    position: {},
    tip: true
};
var $664a9d2983dcb79f$export$2e2bcd8739ae039 = $664a9d2983dcb79f$var$options;
function $664a9d2983dcb79f$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean" && options) options = {
        drop: options
    };
    if (typeof options != "object") options = {};
    if (typeof options.position == "string") options.position = {
        of: options.position
    };
    return options;
}


var $1476547c36831ce6$var$configs = {
    offset: {
        button: {
            x: -5,
            y: 5
        },
        viewport: {
            x: 20,
            y: 20
        }
    },
    height: {
        max: 880
    },
    width: {
        max: 440
    }
};
var $1476547c36831ce6$export$2e2bcd8739ae039 = $1476547c36831ce6$var$configs;




//	Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.dropdown = (0, $664a9d2983dcb79f$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.dropdown = (0, $1476547c36831ce6$export$2e2bcd8739ae039);
function $d11b60a790ec772c$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$options = (0, $664a9d2983dcb79f$export$4f8b0ef91d76ca33)(this.opts.dropdown);
    this.opts.dropdown = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.dropdown);
    var _$configs = this.conf.dropdown;
    if (!_$options.drop) return;
    var button;
    this.bind("initMenu:after", function() {
        _this.node.menu.classList.add("mm-menu_dropdown");
        if (typeof _$options.position.of != "string") {
            var id = (0, $48055557806f998e$export$77c7ff3a98df843b)(_this.node.menu.id);
            if (id) _$options.position.of = '[href="#' + id + '"]';
        }
        if (typeof _$options.position.of != "string") return;
        //	Get the button to put the menu next to
        button = $5e687dcee2dc17d2$export$71aa6c912b956294(document.body, _$options.position.of)[0];
        //	Emulate hover effect
        var events = _$options.event.split(" ");
        if (events.length == 1) events[1] = events[0];
        if (events[0] == "hover") button.addEventListener("mouseenter", function() {
            _this.open();
        }, {
            passive: true
        });
        if (events[1] == "hover") _this.node.menu.addEventListener("mouseleave", function() {
            _this.close();
        }, {
            passive: true
        });
    });
    //	Add/remove classname and style when opening/closing the menu
    this.bind("open:start", function() {
        _this.node.menu["mmStyle"] = _this.node.menu.getAttribute("style");
        _this.node.wrpr.classList.add("mm-wrapper_dropdown");
    });
    this.bind("close:finish", function() {
        _this.node.menu.setAttribute("style", _this.node.menu["mmStyle"]);
        _this.node.wrpr.classList.remove("mm-wrapper_dropdown");
    });
    /**
     * Find the position (x, y) and sizes (width, height) for the menu.
     *
     * @param  {string} dir The direction to measure ("x" for horizontal, "y" for vertical)
     * @param  {object} obj The object where (previously) measured values are stored.
     * @return {object}		The object where measered values are stored.
     */ var getPosition = function getPosition(dir, obj) {
        var css = obj[0], cls = obj[1];
        var _outerSize = dir == "x" ? "offsetWidth" : "offsetHeight", _startPos = dir == "x" ? "left" : "top", _stopPos = dir == "x" ? "right" : "bottom", _size = dir == "x" ? "width" : "height", _winSize = dir == "x" ? "innerWidth" : "innerHeight", _maxSize = dir == "x" ? "maxWidth" : "maxHeight", _position = null;
        var startPos = $5e687dcee2dc17d2$export$cc800923e997bb8(button, _startPos), stopPos = startPos + button[_outerSize], windowSize = window[_winSize];
        /** Offset for the menu relative to the button. */ var offs = _$configs.offset.button[dir] + _$configs.offset.viewport[dir];
        //	Position set in option
        if (_$options.position[dir]) switch(_$options.position[dir]){
            case "left":
            case "bottom":
                _position = "after";
                break;
            case "right":
            case "top":
                _position = "before";
                break;
        }
        //	Position not set in option, find most space
        if (_position === null) _position = startPos + (stopPos - startPos) / 2 < windowSize / 2 ? "after" : "before";
        //	Set position and max
        var val, max;
        if (_position == "after") {
            val = dir == "x" ? startPos : stopPos;
            max = windowSize - (val + offs);
            css[_startPos] = val + _$configs.offset.button[dir] + "px";
            css[_stopPos] = "auto";
            if (_$options.tip) cls.push("mm-menu_tip-" + (dir == "x" ? "left" : "top"));
        } else {
            val = dir == "x" ? stopPos : startPos;
            max = val - offs;
            css[_stopPos] = "calc( 100% - " + (val - _$configs.offset.button[dir]) + "px )";
            css[_startPos] = "auto";
            if (_$options.tip) cls.push("mm-menu_tip-" + (dir == "x" ? "right" : "bottom"));
        }
        if (_$options.fitViewport) css[_maxSize] = Math.min(_$configs[_size].max, max) + "px";
        return [
            css,
            cls
        ];
    };
    function position() {
        var _this = this;
        if (!this.vars.opened) return;
        this.node.menu.setAttribute("style", this.node.menu["mmStyle"]);
        var obj = [
            {},
            []
        ];
        obj = getPosition.call(this, "y", obj);
        obj = getPosition.call(this, "x", obj);
        for(var s in obj[0])this.node.menu.style[s] = obj[0][s];
        if (_$options.tip) {
            var classnames = [
                "mm-menu_tip-left",
                "mm-menu_tip-right",
                "mm-menu_tip-top",
                "mm-menu_tip-bottom"
            ];
            //  IE11:
            classnames.forEach(function(classname) {
                _this.node.menu.classList.remove(classname);
            });
            obj[1].forEach(function(classname) {
                _this.node.menu.classList.add(classname);
            });
        //  Better browsers:
        // this.node.menu.classList.remove(...classnames);
        // this.node.menu.classList.add(...obj[1]);
        }
    }
    this.bind("open:start", position);
    window.addEventListener("resize", function(evnt) {
        position.call(_this);
    }, {
        passive: true
    });
    if (!this.opts.offCanvas.blockUI) window.addEventListener("scroll", function(evnt) {
        position.call(_this);
    }, {
        passive: true
    });
}



var $67d228f98e6fcd1a$var$configs = {
    insertMethod: "append",
    insertSelector: "body"
};
var $67d228f98e6fcd1a$export$2e2bcd8739ae039 = $67d228f98e6fcd1a$var$configs;



//	Add the configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.fixedElements = (0, $67d228f98e6fcd1a$export$2e2bcd8739ae039);
//	Add the classnames.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.classNames.fixedElements = {
    fixed: "Fixed"
};
function $30885eefb7af0c40$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$configs = this.conf.fixedElements;
    var _fixd, fixed, wrppr;
    this.bind("setPage:after", function(page) {
        _fixd = _this.conf.classNames.fixedElements.fixed;
        wrppr = $5e687dcee2dc17d2$export$71aa6c912b956294(document, _$configs.insertSelector)[0];
        fixed = $5e687dcee2dc17d2$export$71aa6c912b956294(page, "." + _fixd);
        fixed.forEach(function(fxd) {
            $5e687dcee2dc17d2$export$9604f4b73fb157f3(fxd, _fixd, "mm-slideout");
            wrppr[_$configs.insertMethod](fxd);
        });
    });
}




var $faa8ad607c0c9033$var$options = {
    use: false,
    top: [],
    bottom: [],
    position: "left",
    type: "default"
};
var $faa8ad607c0c9033$export$2e2bcd8739ae039 = $faa8ad607c0c9033$var$options;
function $faa8ad607c0c9033$export$4f8b0ef91d76ca33(options) {
    if ((0, $48055557806f998e$export$bf9fb029d174d554)(options) == "array") options = {
        use: true,
        top: options
    };
    if ((0, $48055557806f998e$export$bf9fb029d174d554)(options) != "object") options = {};
    if (typeof options.use == "undefined") options.use = true;
    if (typeof options.use == "boolean" && options.use) options.use = true;
    return options;
}





//  Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.iconbar = (0, $faa8ad607c0c9033$export$2e2bcd8739ae039);
function $36a88457ae069f4f$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $faa8ad607c0c9033$export$4f8b0ef91d76ca33)(this.opts.iconbar);
    this.opts.iconbar = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.iconbar);
    if (!_$options.use) return;
    var iconbar;
    [
        "top",
        "bottom"
    ].forEach(function(position, n) {
        var ctnt = _$options[position];
        //	Extend shorthand options
        if ((0, $48055557806f998e$export$bf9fb029d174d554)(ctnt) != "array") ctnt = [
            ctnt
        ];
        //	Create node
        var part = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-iconbar__" + position);
        //	Add content
        for(var c = 0, l = ctnt.length; c < l; c++)if (typeof ctnt[c] == "string") part.innerHTML += ctnt[c];
        else part.append(ctnt[c]);
        if (part.children.length) {
            if (!iconbar) iconbar = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-iconbar");
            iconbar.append(part);
        }
    });
    //	Add to menu
    if (iconbar) {
        //	Add the iconbar.
        this.bind("initMenu:after", function() {
            _this.node.menu.prepend(iconbar);
        });
        //	En-/disable the iconbar.
        var classname_1 = "mm-menu_iconbar-" + _$options.position;
        var enable = function enable() {
            _this.node.menu.classList.add(classname_1);
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(iconbar, "hidden", false);
        };
        var disable = function disable() {
            _this.node.menu.classList.remove(classname_1);
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(iconbar, "hidden", true);
        };
        if (typeof _$options.use == "boolean") this.bind("initMenu:after", enable);
        else $fb351eed9e08732b$export$e16d8520af44a096(_$options.use, enable, disable);
        //	Tabs
        if (_$options.type == "tabs") {
            iconbar.classList.add("mm-iconbar_tabs");
            iconbar.addEventListener("click", function(evnt) {
                var anchor = evnt.target;
                if (!anchor.matches("a")) return;
                if (anchor.matches(".mm-iconbar__tab_selected")) {
                    evnt.stopImmediatePropagation();
                    return;
                }
                try {
                    var panel = _this.node.menu.querySelector(anchor.getAttribute("href"))[0];
                    if (panel && panel.matches(".mm-panel")) {
                        evnt.preventDefault();
                        evnt.stopImmediatePropagation();
                        _this.openPanel(panel, false);
                    }
                } catch (err) {}
            });
            var selectTab_1 = function selectTab_11(panel) {
                $5e687dcee2dc17d2$export$71aa6c912b956294(iconbar, "a").forEach(function(anchor) {
                    anchor.classList.remove("mm-iconbar__tab_selected");
                });
                var anchor = $5e687dcee2dc17d2$export$71aa6c912b956294(iconbar, '[href="#' + panel.id + '"]')[0];
                if (anchor) anchor.classList.add("mm-iconbar__tab_selected");
                else {
                    var parent_1 = panel["mmParent"];
                    if (parent_1) selectTab_1(parent_1.closest(".mm-panel"));
                }
            };
            this.bind("openPanel:start", selectTab_1);
        }
    }
}



var $5a6e147855245fd3$var$options = {
    add: false,
    blockPanel: true,
    hideDivider: false,
    hideNavbar: true,
    visible: 3
};
var $5a6e147855245fd3$export$2e2bcd8739ae039 = $5a6e147855245fd3$var$options;
function $5a6e147855245fd3$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options
    };
    if (typeof options == "number" || typeof options == "string") options = {
        add: true,
        visible: options
    };
    if (typeof options != "object") options = {};
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.iconPanels = (0, $5a6e147855245fd3$export$2e2bcd8739ae039);
function $a3a915025e8cc237$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $5a6e147855245fd3$export$4f8b0ef91d76ca33)(this.opts.iconPanels);
    this.opts.iconPanels = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.iconPanels);
    var keepFirst = false;
    if (_$options.visible == "first") {
        keepFirst = true;
        _$options.visible = 1;
    }
    _$options.visible = Math.min(3, Math.max(1, _$options.visible));
    _$options.visible++;
    //	Add the iconpanels
    if (_$options.add) {
        this.bind("initMenu:after", function() {
            var classnames = [
                "mm-menu_iconpanel"
            ];
            if (_$options.hideNavbar) classnames.push("mm-menu_hidenavbar");
            if (_$options.hideDivider) classnames.push("mm-menu_hidedivider");
            //  IE11:
            classnames.forEach(function(classname) {
                _this.node.menu.classList.add(classname);
            });
        //  Better browsers:
        // this.node.menu.classList.add(...classnames);
        });
        var classnames_1 = [];
        if (!keepFirst) for(var i = 0; i <= _$options.visible; i++)classnames_1.push("mm-panel_iconpanel-" + i);
        this.bind("openPanel:start", function(panel) {
            var panels = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel");
            panel = panel || panels[0];
            if (panel.parentElement.matches(".mm-listitem_vertical")) return;
            if (keepFirst) panels.forEach(function(panel, p) {
                panel.classList[p == 0 ? "add" : "remove"]("mm-panel_iconpanel-first");
            });
            else {
                //	Remove the "iconpanel" classnames from all panels.
                panels.forEach(function(panel) {
                    //  IE11:
                    classnames_1.forEach(function(classname) {
                        panel.classList.remove(classname);
                    });
                //  Better browsers:
                // panel.classList.remove(...classnames);
                });
                //	Filter out panels that are not opened.
                panels = panels.filter(function(panel) {
                    return panel.matches(".mm-panel_opened-parent");
                });
                //	Add the current panel to the list.
                var panelAdded_1 = false;
                panels.forEach(function(elem) {
                    if (panel === elem) panelAdded_1 = true;
                });
                if (!panelAdded_1) panels.push(panel);
                //	Remove the "hidden" classname from all opened panels.
                panels.forEach(function(panel) {
                    panel.classList.remove("mm-hidden");
                });
                //	Slice the opened panels to the max visible amount.
                panels = panels.slice(-_$options.visible);
                //	Add the "iconpanel" classnames.
                panels.forEach(function(panel, p) {
                    panel.classList.add("mm-panel_iconpanel-" + p);
                });
            }
        });
        this.bind("initPanel:after", function(panel) {
            if (_$options.blockPanel && !panel.parentElement.matches(".mm-listitem_vertical") && !$5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-panel__blocker")[0]) {
                var blocker = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-panel__blocker");
                blocker.setAttribute("href", "#" + panel.closest(".mm-panel").id);
                panel.prepend(blocker);
            }
        });
    }
}



var $6bae9ec2d39d55fb$var$options = {
    enable: false,
    enhance: false
};
var $6bae9ec2d39d55fb$export$2e2bcd8739ae039 = $6bae9ec2d39d55fb$var$options;
function $6bae9ec2d39d55fb$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean" || typeof options == "string") options = {
        enable: options
    };
    if (typeof options != "object") options = {};
    return options;
}






//  Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.keyboardNavigation = (0, $6bae9ec2d39d55fb$export$2e2bcd8739ae039);
function $3e54e096cbf91271$export$2e2bcd8739ae039() {
    var _this = this;
    //	Keyboard navigation on touchscreens opens the virtual keyboard :/
    //	Lets prevent that.
    if ($2b1d8945f5aabd11$export$d0b7ea69ab6056df) return;
    var _$options = (0, $6bae9ec2d39d55fb$export$4f8b0ef91d76ca33)(this.opts.keyboardNavigation);
    this.opts.keyboardNavigation = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.keyboardNavigation);
    //	Enable keyboard navigation
    if (_$options.enable) {
        var menuStart_1 = $5e687dcee2dc17d2$export$185802fd694ee1f5("button.mm-tabstart.mm-sronly"), menuEnd_1 = $5e687dcee2dc17d2$export$185802fd694ee1f5("button.mm-tabend.mm-sronly"), blockerEnd_1 = $5e687dcee2dc17d2$export$185802fd694ee1f5("button.mm-tabend.mm-sronly");
        this.bind("initMenu:after", function() {
            if (_$options.enhance) _this.node.menu.classList.add("mm-menu_keyboardfocus");
            $3e54e096cbf91271$var$initWindow.call(_this, _$options.enhance);
        });
        this.bind("initOpened:before", function() {
            _this.node.menu.prepend(menuStart_1);
            _this.node.menu.append(menuEnd_1);
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.menu, ".mm-navbars-top, .mm-navbars-bottom").forEach(function(navbars) {
                navbars.querySelectorAll(".mm-navbar__title").forEach(function(title) {
                    title.setAttribute("tabindex", "-1");
                });
            });
        });
        this.bind("initBlocker:after", function() {
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck.append(blockerEnd_1);
            $5e687dcee2dc17d2$export$bacb5cc5a11aef16((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck, "a")[0].classList.add("mm-tabstart");
        });
        var focusable_1 = "input, select, textarea, button, label, a[href]";
        var setFocus = function setFocus(panel) {
            panel = panel || $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
            var focus = null;
            //	Focus already is on an element in a navbar in this menu.
            var navbar = document.activeElement.closest(".mm-navbar");
            if (navbar) {
                if (navbar.closest(".mm-menu") == _this.node.menu) return;
            }
            //	Set the focus to the first focusable element by default.
            if (_$options.enable == "default") {
                //	First visible anchor in a listview in the current panel.
                focus = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listview a[href]:not(.mm-hidden)")[0];
                //	First focusable and visible element in the current panel.
                if (!focus) focus = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, focusable_1 + ":not(.mm-hidden)")[0];
                //	First focusable and visible element in a navbar.
                if (!focus) {
                    var elements_1 = [];
                    $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.menu, ".mm-navbars_top, .mm-navbars_bottom").forEach(function(navbar) {
                        elements_1.push.apply(elements_1, $5e687dcee2dc17d2$export$71aa6c912b956294(navbar, focusable_1 + ":not(.mm-hidden)"));
                    });
                    focus = elements_1[0];
                }
            }
            //	Default.
            if (!focus) focus = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.menu, ".mm-tabstart")[0];
            if (focus) focus.focus();
        };
        this.bind("open:finish", setFocus);
        this.bind("openPanel:finish", setFocus);
        //	Add screenreader / aria support.
        this.bind("initOpened:after:sr-aria", function() {
            [
                _this.node.menu,
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck
            ].forEach(function(element) {
                $5e687dcee2dc17d2$export$bacb5cc5a11aef16(element, ".mm-tabstart, .mm-tabend").forEach(function(tabber) {
                    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(tabber, "hidden", true);
                    (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_role(tabber, "presentation");
                });
            });
        });
    }
}
/**
 * Initialize the window for keyboard navigation.
 * @param {boolean} enhance - Whether or not to also rich enhance the keyboard behavior.
 **/ var $3e54e096cbf91271$var$initWindow = function initWindow(enhance) {
    var _this = this;
    //	Re-enable tabbing in general
    $b6b8b66b6d279982$export$8c8705df4a2dcec9(document.body, "keydown.tabguard");
    //	Intersept the target when tabbing.
    $b6b8b66b6d279982$export$8c8705df4a2dcec9(document.body, "focusin.tabguard");
    $b6b8b66b6d279982$export$af631764ddc44097(document.body, "focusin.tabguard", function(evnt) {
        if (_this.node.wrpr.matches(".mm-wrapper_opened")) {
            var target = evnt.target;
            if (target.matches(".mm-tabend")) {
                var next = void 0;
                //	Jump from menu to blocker.
                if (target.parentElement.matches(".mm-menu")) {
                    if ((0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck) next = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.blck;
                }
                //	Jump to opened menu.
                if (target.parentElement.matches(".mm-wrapper__blocker")) next = $5e687dcee2dc17d2$export$71aa6c912b956294(document.body, ".mm-menu_offcanvas.mm-menu_opened")[0];
                //	If no available element found, stay in current element.
                if (!next) next = target.parentElement;
                if (next) $5e687dcee2dc17d2$export$bacb5cc5a11aef16(next, ".mm-tabstart")[0].focus();
            }
        }
    });
    //	Add Additional keyboard behavior.
    $b6b8b66b6d279982$export$8c8705df4a2dcec9(document.body, "keydown.navigate");
    $b6b8b66b6d279982$export$af631764ddc44097(document.body, "keydown.navigate", function(evnt) {
        var target = evnt.target;
        var menu = target.closest(".mm-menu");
        if (menu) {
            var api = menu["mmApi"];
            if (!target.matches("input, textarea")) switch(evnt.keyCode){
                //	press enter to toggle and check
                case 13:
                    if (target.matches(".mm-toggle") || target.matches(".mm-check")) target.dispatchEvent(new Event("click"));
                    break;
                //	prevent spacebar or arrows from scrolling the page
                case 32:
                case 37:
                case 38:
                case 39:
                case 40:
                    evnt.preventDefault();
                    break;
            }
            if (enhance) {
                //	special case for input
                if (target.matches("input")) switch(evnt.keyCode){
                    //	empty searchfield with esc
                    case 27:
                        target.value = "";
                        break;
                }
                else {
                    var api_1 = menu["mmApi"];
                    switch(evnt.keyCode){
                        //	close submenu with backspace
                        case 8:
                            var parent_1 = $5e687dcee2dc17d2$export$71aa6c912b956294(menu, ".mm-panel_opened")[0]["mmParent"];
                            if (parent_1) api_1.openPanel(parent_1.closest(".mm-panel"));
                            break;
                        //	close menu with esc
                        case 27:
                            if (menu.matches(".mm-menu_offcanvas")) api_1.close();
                            break;
                    }
                }
            }
        }
    });
};



var $8c2a7321c3ab03d3$var$options = {
    load: false
};
var $8c2a7321c3ab03d3$export$2e2bcd8739ae039 = $8c2a7321c3ab03d3$var$options;
function $8c2a7321c3ab03d3$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        load: options
    };
    if (typeof options != "object") options = {};
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.lazySubmenus = (0, $8c2a7321c3ab03d3$export$2e2bcd8739ae039);
function $2f7fbf753a8803c4$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $8c2a7321c3ab03d3$export$4f8b0ef91d76ca33)(this.opts.lazySubmenus);
    this.opts.lazySubmenus = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.lazySubmenus);
    if (_$options.load) {
        //	Prevent all sub panels from being initialized.
        this.bind("initMenu:after", function() {
            var panels = [];
            //	Find all potential subpanels.
            $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.pnls, "li").forEach(function(listitem) {
                panels.push.apply(panels, $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, _this.conf.panelNodetype.join(", ")));
            });
            //	Filter out all non-panels and add the lazyload classes
            panels.filter(function(panel) {
                return !panel.matches(".mm-listview_inset");
            }).filter(function(panel) {
                return !panel.matches(".mm-nolistview");
            }).filter(function(panel) {
                return !panel.matches(".mm-nopanel");
            }).forEach(function(panel) {
                var classnames = [
                    "mm-panel_lazysubmenu",
                    "mm-nolistview",
                    "mm-nopanel"
                ];
                //  IE11:
                classnames.forEach(function(classname) {
                    panel.classList.add(classname);
                });
            //  Better browsers:
            // panel.classList.add(...classnames);
            });
        });
        //	Prepare current and one level sub panels for initPanels
        this.bind("initPanels:before", function() {
            var panels = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, _this.conf.panelNodetype.join(", "));
            panels.forEach(function(panel) {
                var filter = ".mm-panel_lazysubmenu", children = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, filter);
                if (panel.matches(filter)) children.unshift(panel);
                children.filter(function(child) {
                    return !child.matches(".mm-panel_lazysubmenu .mm-panel_lazysubmenu");
                }).forEach(function(child) {
                    var classnames = [
                        "mm-panel_lazysubmenu",
                        "mm-nolistview",
                        "mm-nopanel"
                    ];
                    //  IE11:
                    classnames.forEach(function(classname) {
                        child.classList.remove(classname);
                    });
                //  Better browsers:
                // child.classList.remove(...classnames);
                });
            });
        });
        //	initPanels for the default opened panel
        this.bind("initOpened:before", function() {
            var panels = [];
            $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.pnls, "." + _this.conf.classNames.selected).forEach(function(listitem) {
                panels.push.apply(panels, $5e687dcee2dc17d2$export$7901f6cd558b9a93(listitem, ".mm-panel_lazysubmenu"));
            });
            if (panels.length) {
                panels.forEach(function(panel) {
                    var classnames = [
                        "mm-panel_lazysubmenu",
                        "mm-nolistview",
                        "mm-nopanel"
                    ];
                    //  IE11:
                    classnames.forEach(function(classname) {
                        panel.classList.remove(classname);
                    });
                //  Better browsers:
                // panel.classList.remove(...classnames);
                });
                _this.initPanel(panels[panels.length - 1]);
            }
        });
        //	initPanels for current- and sub panels before openPanel
        this.bind("openPanel:before", function(panel) {
            var filter = ".mm-panel_lazysubmenu", panels = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, filter);
            if (panel.matches(filter)) panels.unshift(panel);
            panels = panels.filter(function(panel) {
                return !panel.matches(".mm-panel_lazysubmenu .mm-panel_lazysubmenu");
            });
            panels.forEach(function(panel) {
                _this.initPanel(panel);
            });
        });
    }
}



var $20b62a8524c73433$var$options = [];
var $20b62a8524c73433$export$2e2bcd8739ae039 = $20b62a8524c73433$var$options;
function $20b62a8524c73433$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean" && options) options = {};
    if (typeof options != "object") options = {};
    if (typeof options.content == "undefined") options.content = [
        "prev",
        "title"
    ];
    if (!(options.content instanceof Array)) options.content = [
        options.content
    ];
    if (typeof options.use == "undefined") options.use = true;
    if (typeof options.use == "boolean" && options.use) options.use = true;
    return options;
}


var $ae455031a623ff07$var$configs = {
    breadcrumbs: {
        separator: "/",
        removeFirst: false
    }
};
var $ae455031a623ff07$export$2e2bcd8739ae039 = $ae455031a623ff07$var$configs;






function $b9e5c2298c220b9c$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    //	Add content
    var breadcrumbs = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-navbar__breadcrumbs");
    navbar.append(breadcrumbs);
    this.bind("initNavbar:after", function(panel) {
        if (panel.querySelector(".mm-navbar__breadcrumbs")) return;
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0].classList.add("mm-hidden");
        var crumbs = [], breadcrumbs = $5e687dcee2dc17d2$export$185802fd694ee1f5("span.mm-navbar__breadcrumbs"), current = panel, first = true;
        while(current){
            current = current.closest(".mm-panel");
            if (!current.parentElement.matches(".mm-listitem_vertical")) {
                var title = $5e687dcee2dc17d2$export$71aa6c912b956294(current, ".mm-navbar__title span")[0];
                if (title) {
                    var text = title.textContent;
                    if (text.length) crumbs.unshift(first ? "<span>" + text + "</span>" : '<a href="#' + current.id + '">' + text + "</a>");
                }
                first = false;
            }
            current = current["mmParent"];
        }
        if (_this.conf.navbars.breadcrumbs.removeFirst) crumbs.shift();
        breadcrumbs.innerHTML = crumbs.join('<span class="mm-separator">' + _this.conf.navbars.breadcrumbs.separator + "</span>");
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0].append(breadcrumbs);
    });
    //	Update for to opened panel
    this.bind("openPanel:start", function(panel) {
        var crumbs = panel.querySelector(".mm-navbar__breadcrumbs");
        breadcrumbs.innerHTML = crumbs ? crumbs.innerHTML : "";
    });
    //	Add screenreader / aria support
    this.bind("initNavbar:after:sr-aria", function(panel) {
        $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-breadcrumbs a").forEach(function(anchor) {
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(anchor, "owns", anchor.getAttribute("href").slice(1));
        });
    });
}




function $123b02287a39fdc8$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    //	Add content
    var close = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_close.mm-navbar__btn");
    navbar.append(close);
    //	Update to page node
    this.bind("setPage:after", function(page) {
        close.setAttribute("href", "#" + page.id);
    });
    //	Add screenreader / text support
    this.bind("setPage:after:sr-text", function() {
        close.innerHTML = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_text(_this.i18n(_this.conf.screenReader.text.closeMenu));
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(close, "owns", close.getAttribute("href").slice(1));
    });
}




function $5da7abf599aa2deb$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    //	Add content.
    var prev = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_prev.mm-navbar__btn");
    navbar.append(prev);
    this.bind("initNavbar:after", function(panel) {
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(panel, ".mm-navbar")[0].classList.add("mm-hidden");
    });
    //	Update to opened panel.
    var org;
    var _url, _txt;
    this.bind("openPanel:start", function(panel) {
        if (panel.parentElement.matches(".mm-listitem_vertical")) return;
        org = panel.querySelector("." + _this.conf.classNames.navbars.panelPrev);
        if (!org) org = panel.querySelector(".mm-navbar__btn.mm-btn_prev");
        _url = org ? org.getAttribute("href") : "";
        _txt = org ? org.innerHTML : "";
        if (_url) prev.setAttribute("href", _url);
        else prev.removeAttribute("href");
        prev.classList[_url || _txt ? "remove" : "add"]("mm-hidden");
        prev.innerHTML = _txt;
    });
    //	Add screenreader / aria support
    this.bind("initNavbar:after:sr-aria", function(panel) {
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(panel.querySelector(".mm-navbar"), "hidden", true);
    });
    this.bind("openPanel:start:sr-aria", function(panel) {
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(prev, "hidden", prev.matches(".mm-hidden"));
        (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(prev, "owns", (prev.getAttribute("href") || "").slice(1));
    });
}




function $8051281e3bf2ff52$export$2e2bcd8739ae039(navbar) {
    if ((0, $48055557806f998e$export$bf9fb029d174d554)(this.opts.searchfield) != "object") this.opts.searchfield = {};
    var searchfield = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-navbar__searchfield");
    navbar.append(searchfield);
    this.opts.searchfield.add = true;
    this.opts.searchfield.addTo = [
        searchfield
    ];
}




function $ba74cd362dbf4132$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    //	Add content to the navbar.
    var title = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-navbar__title");
    var titleText = $5e687dcee2dc17d2$export$185802fd694ee1f5("span");
    title.append(titleText);
    navbar.append(title);
    //	Update the title to the opened panel.
    var _url, _txt;
    var original;
    this.bind("openPanel:start", function(panel) {
        //	Do nothing in a vertically expanding panel.
        if (panel.parentElement.matches(".mm-listitem_vertical")) return;
        //	Find the original title in the opened panel.
        original = panel.querySelector("." + _this.conf.classNames.navbars.panelTitle);
        if (!original) original = panel.querySelector(".mm-navbar__title span");
        //	Get the URL for the title.
        _url = original && original.closest("a") ? original.closest("a").getAttribute("href") : "";
        if (_url) title.setAttribute("href", _url);
        else title.removeAttribute("href");
        //	Get the text for the title.
        _txt = original ? original.innerHTML : "";
        titleText.innerHTML = _txt;
    });
    //	Add screenreader / aria support
    var prev;
    this.bind("openPanel:start:sr-aria", function(panel) {
        if (_this.opts.screenReader.text) {
            if (!prev) {
                var navbars = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.menu, ".mm-navbars_top, .mm-navbars_bottom");
                navbars.forEach(function(navbar) {
                    var btn = navbar.querySelector(".mm-btn_prev");
                    if (btn) prev = btn;
                });
            }
            if (prev) {
                var hidden = true;
                if (_this.opts.navbar.titleLink == "parent") hidden = !prev.matches(".mm-hidden");
                (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(title, "hidden", hidden);
            }
        }
    });
}



function $90a74b8939fac8c8$export$2e2bcd8739ae039(navbar) {
    var _this = this;
    navbar.classList.add("mm-navbar_tabs");
    navbar.parentElement.classList.add("mm-navbars_has-tabs");
    var anchors = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(navbar, "a");
    navbar.addEventListener("click", function(evnt) {
        var anchor = evnt.target;
        if (!anchor.matches("a")) return;
        if (anchor.matches(".mm-navbar__tab_selected")) {
            evnt.stopImmediatePropagation();
            return;
        }
        try {
            _this.openPanel(_this.node.menu.querySelector(anchor.getAttribute("href")), false);
            evnt.stopImmediatePropagation();
        } catch (err) {}
    });
    function selectTab(panel) {
        anchors.forEach(function(anchor) {
            anchor.classList.remove("mm-navbar__tab_selected");
        });
        var anchor = anchors.filter(function(anchor) {
            return anchor.matches('[href="#' + panel.id + '"]');
        })[0];
        if (anchor) anchor.classList.add("mm-navbar__tab_selected");
        else {
            var parent = panel["mmParent"];
            if (parent) selectTab.call(this, parent.closest(".mm-panel"));
        }
    }
    this.bind("openPanel:start", selectTab);
}


//  Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.navbars = (0, $20b62a8524c73433$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.navbars = (0, $ae455031a623ff07$export$2e2bcd8739ae039);
//  Add the classnames.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.classNames.navbars = {
    panelPrev: "Prev",
    panelTitle: "Title"
};
$0eafda1bd3a2b4cc$export$2e2bcd8739ae039.navbarContents = {
    breadcrumbs: (0, $b9e5c2298c220b9c$export$2e2bcd8739ae039),
    close: (0, $123b02287a39fdc8$export$2e2bcd8739ae039),
    prev: (0, $5da7abf599aa2deb$export$2e2bcd8739ae039),
    searchfield: (0, $8051281e3bf2ff52$export$2e2bcd8739ae039),
    title: (0, $ba74cd362dbf4132$export$2e2bcd8739ae039)
};
$0eafda1bd3a2b4cc$export$2e2bcd8739ae039.navbarTypes = {
    tabs: (0, $90a74b8939fac8c8$export$2e2bcd8739ae039)
};
function $0eafda1bd3a2b4cc$export$2e2bcd8739ae039() {
    var _this = this;
    var navs = this.opts.navbars;
    if (typeof navs == "undefined") return;
    if (!(navs instanceof Array)) navs = [
        navs
    ];
    var navbars = {};
    if (!navs.length) return;
    navs.forEach(function(options) {
        options = (0, $20b62a8524c73433$export$4f8b0ef91d76ca33)(options);
        if (!options.use) return false;
        //	Create the navbar element.
        var navbar = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-navbar");
        //	Get the position for the navbar.
        var position = options.position;
        //	Restrict the position to either "bottom" or "top" (default).
        if (position !== "bottom") position = "top";
        //	Create the wrapper for the navbar position.
        if (!navbars[position]) navbars[position] = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-navbars_" + position);
        navbars[position].append(navbar);
        //	Add content to the navbar.
        for(var c = 0, l = options.content.length; c < l; c++){
            var ctnt = options.content[c];
            //	The content is a string.
            if (typeof ctnt == "string") {
                var func = $0eafda1bd3a2b4cc$export$2e2bcd8739ae039.navbarContents[ctnt];
                //	The content refers to one of the navbar-presets ("prev", "title", etc).
                if (typeof func == "function") //	Call the preset function.
                func.call(_this, navbar);
                else {
                    //	Add the HTML.
                    //  Wrap the HTML in a single node
                    var node = $5e687dcee2dc17d2$export$185802fd694ee1f5("span");
                    node.innerHTML = ctnt;
                    //  If there was only a single node, use that.
                    var children = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(node);
                    if (children.length == 1) node = children[0];
                    navbar.append(node);
                }
            //	The content is not a string, it must be an element.
            } else navbar.append(ctnt);
        }
        //	The type option is set.
        if (typeof options.type == "string") {
            //	The function refers to one of the navbar-presets ("tabs").
            var func = $0eafda1bd3a2b4cc$export$2e2bcd8739ae039.navbarTypes[options.type];
            if (typeof func == "function") //	Call the preset function.
            func.call(_this, navbar);
        }
        //	En-/disable the navbar.
        var enable = function enable() {
            navbar.classList.remove("mm-hidden");
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(navbar, "hidden", false);
        };
        var disable = function disable() {
            navbar.classList.add("mm-hidden");
            (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).sr_aria(navbar, "hidden", true);
        };
        if (typeof options.use != "boolean") $fb351eed9e08732b$export$e16d8520af44a096(options.use, enable, disable);
    });
    //	Add to menu.
    this.bind("initMenu:after", function() {
        for(var position in navbars)_this.node.menu[position == "bottom" ? "append" : "prepend"](navbars[position]);
    });
}



var $b307a3ff3c07900a$var$options = {
    scroll: false,
    update: false
};
var $b307a3ff3c07900a$export$2e2bcd8739ae039 = $b307a3ff3c07900a$var$options;
function $b307a3ff3c07900a$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        scroll: options
    };
    if (typeof options != "object") options = {};
    return options;
}


var $02dd7e236f0ae979$var$configs = {
    scrollOffset: 0,
    updateOffset: 50
};
var $02dd7e236f0ae979$export$2e2bcd8739ae039 = $02dd7e236f0ae979$var$configs;




//	Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.pageScroll = (0, $b307a3ff3c07900a$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.pageScroll = (0, $02dd7e236f0ae979$export$2e2bcd8739ae039);
function $dac43d641308dd12$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $b307a3ff3c07900a$export$4f8b0ef91d76ca33)(this.opts.pageScroll);
    this.opts.pageScroll = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.pageScroll);
    var _$configs = this.conf.pageScroll;
    /** The currently "active" section */ var section;
    function scrollTo() {
        if (section) // section.scrollIntoView({ behavior: 'smooth' });
        window.scrollTo({
            top: section.getBoundingClientRect().top + document.scrollingElement.scrollTop - _$configs.scrollOffset,
            behavior: "smooth"
        });
        section = null;
    }
    function anchorInPage(href) {
        try {
            if (href != "#" && href.slice(0, 1) == "#") return (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).node.page.querySelector(href);
            return null;
        } catch (err) {
            return null;
        }
    }
    //	Scroll to section after clicking menu item.
    if (_$options.scroll) this.bind("close:finish", function() {
        scrollTo();
    });
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor.
    if (this.opts.offCanvas && _$options.scroll) this.clck.push(function(anchor, args) {
        section = null;
        //	Don't continue if the clicked anchor is not in the menu.
        if (!args.inMenu) return;
        //	Don't continue if the targeted section is not on the page.
        var href = anchor.getAttribute("href");
        section = anchorInPage(href);
        if (!section) return;
        //	If the sidebar add-on is "expanded"...
        if (_this.node.menu.matches(".mm-menu_sidebar-expanded") && _this.node.wrpr.matches(".mm-wrapper_sidebar-expanded")) //	... scroll the page to the section.
        scrollTo();
        else //	... close the menu.
        return {
            close: true
        };
    });
    //	Update selected menu item after scrolling.
    if (_$options.update) {
        var scts_1 = [];
        this.bind("initListview:after", function(listview) {
            var listitems = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview, ".mm-listitem");
            $5e687dcee2dc17d2$export$f6486d4f577dfcc4(listitems).forEach(function(anchor) {
                var href = anchor.getAttribute("href");
                var section = anchorInPage(href);
                if (section) scts_1.unshift(section);
            });
        });
        var _selected_1 = -1;
        window.addEventListener("scroll", function(evnt) {
            var scrollTop = window.scrollY;
            for(var s = 0; s < scts_1.length; s++)if (scts_1[s].offsetTop < scrollTop + _$configs.updateOffset) {
                if (_selected_1 !== s) {
                    _selected_1 = s;
                    var panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
                    var listitems = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem");
                    var anchors = $5e687dcee2dc17d2$export$f6486d4f577dfcc4(listitems);
                    anchors = anchors.filter(function(anchor) {
                        return anchor.matches('[href="#' + scts_1[s].id + '"]');
                    });
                    if (anchors.length) _this.setSelected(anchors[0].parentElement);
                }
                break;
            }
        });
    }
}



var $f0b5d048b0b62a0f$var$options = {
    add: false,
    addTo: "panels",
    cancel: false,
    noResults: "No results found.",
    placeholder: "Search",
    panel: {
        add: false,
        dividers: true,
        fx: "none",
        id: null,
        splash: null,
        title: "Search"
    },
    search: true,
    showTextItems: false,
    showSubPanels: true
};
var $f0b5d048b0b62a0f$export$2e2bcd8739ae039 = $f0b5d048b0b62a0f$var$options;
function $f0b5d048b0b62a0f$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options
    };
    if (typeof options != "object") options = {};
    if (typeof options.panel == "boolean") options.panel = {
        add: options.panel
    };
    if (typeof options.panel != "object") options.panel = {};
    //	Extend logical options.
    if (options.addTo == "panel") options.panel.add = true;
    if (options.panel.add) {
        options.showSubPanels = false;
        if (options.panel.splash) options.cancel = true;
    }
    return options;
}


var $e9e32dbf08324644$var$configs = {
    clear: false,
    form: false,
    input: false,
    submit: false
};
var $e9e32dbf08324644$export$2e2bcd8739ae039 = $e9e32dbf08324644$var$configs;



var $a5aebacfbf3bfac1$export$2e2bcd8739ae039 = {
    Search: "Zoeken",
    "No results found.": "Geen resultaten gevonden.",
    cancel: "annuleren"
};


var $af08ce97f62f2c06$export$2e2bcd8739ae039 = {
    Search: "\u062C\u0633\u062A\u062C\u0648",
    "No results found.": "\u0646\u062A\u06CC\u062C\u0647\u200C\u0627\u06CC \u06CC\u0627\u0641\u062A \u0646\u0634\u062F.",
    cancel: "\u0627\u0646\u0635\u0631\u0627\u0641"
};


var $1ec613341024d70a$export$2e2bcd8739ae039 = {
    Search: "Suche",
    "No results found.": "Keine Ergebnisse gefunden.",
    cancel: "beenden"
};


var $c4047a8706db27fb$export$2e2bcd8739ae039 = {
    Search: "\u041D\u0430\u0439\u0442\u0438",
    "No results found.": "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E.",
    cancel: "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"
};


function $93b014738e593b32$export$2e2bcd8739ae039() {
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $a5aebacfbf3bfac1$export$2e2bcd8739ae039), "nl");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $af08ce97f62f2c06$export$2e2bcd8739ae039), "fa");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $1ec613341024d70a$export$2e2bcd8739ae039), "de");
    (0, $9154f0701a0acf98$export$e16d8520af44a096)((0, $c4047a8706db27fb$export$2e2bcd8739ae039), "ru");
}





//  Add the translations.
(0, $93b014738e593b32$export$2e2bcd8739ae039)();
//  Add the options and configs.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.searchfield = (0, $f0b5d048b0b62a0f$export$2e2bcd8739ae039);
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.searchfield = (0, $e9e32dbf08324644$export$2e2bcd8739ae039);
function $f26083bf834e4db6$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $f0b5d048b0b62a0f$export$4f8b0ef91d76ca33)(this.opts.searchfield);
    this.opts.searchfield = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.searchfield);
    var _$configs = this.conf.searchfield;
    if (!_$options.add) return;
    //	Blur searchfield
    this.bind("close:start", function() {
        $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.menu, ".mm-searchfield").forEach(function(input) {
            input.blur();
        });
    });
    this.bind("initPanel:after", function(panel) {
        var searchpanel = null;
        //	Add the search panel
        if (_$options.panel.add) searchpanel = $f26083bf834e4db6$var$initSearchPanel.call(_this);
        //	Add the searchfield
        var addTo = null;
        switch(_$options.addTo){
            case "panels":
                addTo = [
                    panel
                ];
                break;
            case "panel":
                addTo = [
                    searchpanel
                ];
                break;
            default:
                if (typeof _$options.addTo == "string") addTo = $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.menu, _$options.addTo);
                else if ((0, $48055557806f998e$export$bf9fb029d174d554)(_$options.addTo) == "array") addTo = _$options.addTo;
                break;
        }
        addTo.forEach(function(form) {
            form = $f26083bf834e4db6$var$initSearchfield.call(_this, form);
            if (_$options.search && form) $f26083bf834e4db6$var$initSearching.call(_this, form);
        });
        //	Add the no-results message
        if (_$options.noResults) $f26083bf834e4db6$var$initNoResultsMsg.call(_this, _$options.panel.add ? searchpanel : panel);
    });
    //	Add click behavior.
    //	Prevents default behavior when clicking an anchor
    this.clck.push(function(anchor, args) {
        if (args.inMenu) {
            if (anchor.matches(".mm-searchfield__btn")) {
                //	Clicking the clear button
                if (anchor.matches(".mm-btn_close")) {
                    var form = anchor.closest(".mm-searchfield"), input = $5e687dcee2dc17d2$export$71aa6c912b956294(form, "input")[0];
                    input.value = "";
                    _this.search(input);
                    return true;
                }
                //	Clicking the submit button
                if (anchor.matches(".mm-btn_next")) {
                    var form = anchor.closest("form");
                    if (form) form.submit();
                    return true;
                }
            }
        }
    });
}
var $f26083bf834e4db6$var$initSearchPanel = function initSearchPanel() {
    var _$options = this.opts.searchfield, _$configs = this.conf.searchfield;
    var searchpanel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel_search")[0];
    //	Only once
    if (searchpanel) return searchpanel;
    searchpanel = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-panel.mm-panel_search.mm-hidden");
    if (_$options.panel.id) searchpanel.id = _$options.panel.id;
    if (_$options.panel.title) searchpanel.setAttribute("data-mm-title", _$options.panel.title);
    var listview = $5e687dcee2dc17d2$export$185802fd694ee1f5("ul");
    searchpanel.append(listview);
    this.node.pnls.append(searchpanel);
    this.initListview(listview);
    this._initNavbar(searchpanel);
    switch(_$options.panel.fx){
        case false:
            break;
        case "none":
            searchpanel.classList.add("mm-panel_noanimation");
            break;
        default:
            searchpanel.classList.add("mm-panel_fx-" + _$options.panel.fx);
            break;
    }
    //	Add splash content
    if (_$options.panel.splash) {
        var splash = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-panel__content");
        splash.innerHTML = _$options.panel.splash;
        searchpanel.append(splash);
    }
    searchpanel.classList.add("mm-panel");
    searchpanel.classList.add("mm-hidden");
    this.node.pnls.append(searchpanel);
    return searchpanel;
};
var $f26083bf834e4db6$var$initSearchfield = function initSearchfield(wrapper) {
    var _$options = this.opts.searchfield, _$configs = this.conf.searchfield;
    //	No searchfield in vertical submenus
    if (wrapper.parentElement.matches(".mm-listitem_vertical")) return null;
    //	Only one searchfield per panel
    var form = $5e687dcee2dc17d2$export$71aa6c912b956294(wrapper, ".mm-searchfield")[0];
    if (form) return form;
    function addAttributes(element, attr) {
        if (attr) for(var a in attr)element.setAttribute(a, attr[a]);
    }
    var form = $5e687dcee2dc17d2$export$185802fd694ee1f5((_$configs.form ? "form" : "div") + ".mm-searchfield"), field = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-searchfield__input"), input = $5e687dcee2dc17d2$export$185802fd694ee1f5("input");
    input.type = "text";
    input.autocomplete = "off";
    input.placeholder = this.i18n(_$options.placeholder);
    field.append(input);
    form.append(field);
    wrapper.prepend(form);
    //	Add attributes to the input
    addAttributes(input, _$configs.input);
    //	Add the clear button
    if (_$configs.clear) {
        var anchor = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_close.mm-searchfield__btn");
        anchor.setAttribute("href", "#");
        field.append(anchor);
    }
    //	Add attributes and submit to the form
    addAttributes(form, _$configs.form);
    if (_$configs.form && _$configs.submit && !_$configs.clear) {
        var anchor = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-btn.mm-btn_next.mm-searchfield__btn");
        anchor.setAttribute("href", "#");
        field.append(anchor);
    }
    if (_$options.cancel) {
        var anchor = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-searchfield__cancel");
        anchor.setAttribute("href", "#");
        anchor.textContent = this.i18n("cancel");
        form.append(anchor);
    }
    return form;
};
var $f26083bf834e4db6$var$initSearching = function initSearching(form) {
    var _this = this;
    var _$options = this.opts.searchfield, _$configs = this.conf.searchfield;
    var data = {};
    //	In the searchpanel.
    if (form.closest(".mm-panel_search")) {
        data.panels = $5e687dcee2dc17d2$export$71aa6c912b956294(this.node.pnls, ".mm-panel");
        data.noresults = [
            form.closest(".mm-panel")
        ];
    //	In a panel
    } else if (form.closest(".mm-panel")) {
        data.panels = [
            form.closest(".mm-panel")
        ];
        data.noresults = data.panels;
    //	Not in a panel, global
    } else {
        data.panels = $5e687dcee2dc17d2$export$71aa6c912b956294(this.node.pnls, ".mm-panel");
        data.noresults = [
            this.node.menu
        ];
    }
    //	Filter out vertical submenus
    data.panels = data.panels.filter(function(panel) {
        return !panel.parentElement.matches(".mm-listitem_vertical");
    });
    //	Filter out search panel
    data.panels = data.panels.filter(function(panel) {
        return !panel.matches(".mm-panel_search");
    });
    //  Find listitems and dividers.
    data.listitems = [];
    data.dividers = [];
    data.panels.forEach(function(panel) {
        var _a, _b;
        (_a = data.listitems).push.apply(_a, $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem"));
        (_b = data.dividers).push.apply(_b, $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-divider"));
    });
    var searchpanel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel_search")[0], input = $5e687dcee2dc17d2$export$71aa6c912b956294(form, "input")[0], cancel = $5e687dcee2dc17d2$export$71aa6c912b956294(form, ".mm-searchfield__cancel")[0];
    input["mmSearchfield"] = data;
    //	Open the splash panel when focussing the input.
    if (_$options.panel.add && _$options.panel.splash) {
        $b6b8b66b6d279982$export$8c8705df4a2dcec9(input, "focus.splash");
        $b6b8b66b6d279982$export$af631764ddc44097(input, "focus.splash", function(evnt) {
            _this.openPanel(searchpanel);
        });
    }
    if (_$options.cancel) {
        //	Show the cancel button when focussing the input.
        $b6b8b66b6d279982$export$8c8705df4a2dcec9(input, "focus.cancel");
        $b6b8b66b6d279982$export$af631764ddc44097(input, "focus.cancel", function(evnt) {
            cancel.classList.add("mm-searchfield__cancel-active");
        });
        //	Close the splash panel when clicking the cancel button.
        $b6b8b66b6d279982$export$8c8705df4a2dcec9(cancel, "click.splash");
        $b6b8b66b6d279982$export$af631764ddc44097(cancel, "click.splash", function(evnt) {
            evnt.preventDefault();
            cancel.classList.remove("mm-searchfield__cancel-active");
            if (searchpanel.matches(".mm-panel_opened")) {
                var parents = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened-parent");
                if (parents.length) _this.openPanel(parents[parents.length - 1]);
            }
        });
    }
    //	Focus the input in the searchpanel when opening the searchpanel.
    if (_$options.panel.add && _$options.addTo == "panel") this.bind("openPanel:finish", function(panel) {
        if (panel === searchpanel) input.focus();
    });
    //	Search while typing.
    $b6b8b66b6d279982$export$8c8705df4a2dcec9(input, "input.search");
    $b6b8b66b6d279982$export$af631764ddc44097(input, "input.search", function(evnt) {
        switch(evnt.keyCode){
            case 9:
            case 16:
            case 17:
            case 18:
            case 37:
            case 38:
            case 39:
            case 40:
                break;
            default:
                _this.search(input);
                break;
        }
    });
    //	Search initially.
    this.search(input);
};
var $f26083bf834e4db6$var$initNoResultsMsg = function initNoResultsMsg(wrapper) {
    if (!wrapper) return;
    var _$options = this.opts.searchfield, _$configs = this.conf.searchfield;
    //	Not in a panel
    if (!wrapper.closest(".mm-panel")) wrapper = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel")[0];
    //	Only once
    if ($5e687dcee2dc17d2$export$bacb5cc5a11aef16(wrapper, ".mm-panel__noresultsmsg").length) return;
    //	Add no-results message
    var message = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-panel__noresultsmsg.mm-hidden");
    message.innerHTML = this.i18n(_$options.noResults);
    wrapper.append(message);
};
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).prototype.search = function(input, query) {
    var _this = this;
    var _a;
    var _$options = this.opts.searchfield, _$configs = this.conf.searchfield;
    query = query || "" + input.value;
    query = query.toLowerCase().trim();
    var data = input["mmSearchfield"];
    var form = input.closest(".mm-searchfield"), buttons = $5e687dcee2dc17d2$export$71aa6c912b956294(form, ".mm-btn"), searchpanel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel_search")[0];
    /** The panels. */ var panels = data.panels;
    /** The "no results" messages in a cloned array. */ var noresults = data.noresults;
    /** The listitems in a cloned array. */ var listitems = data.listitems;
    /** Tje dividers in a cloned array. */ var dividers = data.dividers;
    //	Reset previous results
    listitems.forEach(function(listitem) {
        listitem.classList.remove("mm-listitem_nosubitems");
        listitem.classList.remove("mm-listitem_onlysubitems");
        listitem.classList.remove("mm-hidden");
    });
    if (searchpanel) $5e687dcee2dc17d2$export$bacb5cc5a11aef16(searchpanel, ".mm-listview")[0].innerHTML = "";
    panels.forEach(function(panel) {
        panel.scrollTop = 0;
    });
    //	Search
    if (query.length) {
        //	Initially hide all dividers.
        dividers.forEach(function(divider) {
            divider.classList.add("mm-hidden");
        });
        //	Hide listitems that do not match.
        listitems.forEach(function(listitem) {
            var text = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listitem, ".mm-listitem__text")[0];
            var add = false;
            //  The listitem should be shown if:
            //          1) The text matches the query and
            //          2a) The text is a open-button and
            //          2b) the option showSubPanels is set to true.
            //      or  3a) The text is not an anchor and
            //          3b) the option showTextItems is set to true.
            //      or  4)  The text is an anchor.
            //  1
            if (text && $5e687dcee2dc17d2$export$6f093cfa640b7166(text).toLowerCase().indexOf(query) > -1) {
                //  2a
                if (text.matches(".mm-listitem__btn")) //  2b
                {
                    if (_$options.showSubPanels) add = true;
                } else if (!text.matches("a")) //  3b
                {
                    if (_$options.showTextItems) add = true;
                } else add = true;
            }
            if (!add) listitem.classList.add("mm-hidden");
        });
        /** Whether or not the query yielded results. */ var hasResults = listitems.filter(function(listitem) {
            return !listitem.matches(".mm-hidden");
        }).length;
        //	Show all mached listitems in the search panel
        if (_$options.panel.add) {
            //	Clone all matched listitems into the search panel
            var allitems_1 = [];
            panels.forEach(function(panel) {
                var listitems = $5e687dcee2dc17d2$export$72ac92c27fa3be94($5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem"));
                listitems = listitems.filter(function(listitem) {
                    return !listitem.matches(".mm-hidden");
                });
                if (listitems.length) {
                    //  Add a divider to indicate in what panel the listitems were.
                    if (_$options.panel.dividers) {
                        var divider = $5e687dcee2dc17d2$export$185802fd694ee1f5("li.mm-divider");
                        var title = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-navbar__title")[0];
                        if (title) {
                            divider.innerHTML = title.innerHTML;
                            allitems_1.push(divider);
                        }
                    }
                    listitems.forEach(function(listitem) {
                        allitems_1.push(listitem.cloneNode(true));
                    });
                }
            });
            //	Remove toggles and checks.
            allitems_1.forEach(function(listitem) {
                listitem.querySelectorAll(".mm-toggle, .mm-check").forEach(function(element) {
                    element.remove();
                });
            });
            //	Add to the search panel.
            (_a = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(searchpanel, ".mm-listview")[0]).append.apply(_a, allitems_1);
            //	Open the search panel.
            this.openPanel(searchpanel);
        } else {
            //	Also show listitems in sub-panels for matched listitems
            if (_$options.showSubPanels) panels.forEach(function(panel) {
                var listitems = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem");
                $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems).forEach(function(listitem) {
                    var child = listitem["mmChild"];
                    if (child) $5e687dcee2dc17d2$export$71aa6c912b956294(child, ".mm-listitem").forEach(function(listitem) {
                        listitem.classList.remove("mm-hidden");
                    });
                });
            });
            //	Update parent for sub-panel
            //  .reverse() mutates the original array, therefor we "clone" it first using [...panels].
            panels.slice().reverse().forEach(function(panel, p) {
                var parent = panel["mmParent"];
                if (parent) {
                    //	The current panel has mached listitems
                    var listitems_1 = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem");
                    if ($5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems_1).length) {
                        //	Show parent
                        if (parent.matches(".mm-hidden")) parent.classList.remove("mm-hidden");
                        parent.classList.add("mm-listitem_onlysubitems");
                    } else if (!input.closest(".mm-panel")) {
                        if (panel.matches(".mm-panel_opened") || panel.matches(".mm-panel_opened-parent")) //	Compensate the timeout for the opening animation
                        setTimeout(function() {
                            _this.openPanel(parent.closest(".mm-panel"));
                        }, (p + 1) * (_this.conf.openingInterval * 1.5));
                        parent.classList.add("mm-listitem_nosubitems");
                    }
                }
            });
            //	Show first preceeding divider of parent
            panels.forEach(function(panel) {
                var listitems = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-listitem");
                $5e687dcee2dc17d2$export$72ac92c27fa3be94(listitems).forEach(function(listitem) {
                    var divider = $5e687dcee2dc17d2$export$5a01ccd45552d0b4(listitem, ".mm-divider")[0];
                    if (divider) divider.classList.remove("mm-hidden");
                });
            });
        }
        //	Show submit / clear button
        buttons.forEach(function(button) {
            return button.classList.remove("mm-hidden");
        });
        //	Show/hide no results message
        noresults.forEach(function(wrapper) {
            $5e687dcee2dc17d2$export$71aa6c912b956294(wrapper, ".mm-panel__noresultsmsg").forEach(function(message) {
                return message.classList[hasResults ? "add" : "remove"]("mm-hidden");
            });
        });
        if (_$options.panel.add) {
            //	Hide splash
            if (_$options.panel.splash) $5e687dcee2dc17d2$export$71aa6c912b956294(searchpanel, ".mm-panel__content").forEach(function(splash) {
                return splash.classList.add("mm-hidden");
            });
            //	Re-show original listitems when in search panel
            listitems.forEach(function(listitem) {
                return listitem.classList.remove("mm-hidden");
            });
            dividers.forEach(function(divider) {
                return divider.classList.remove("mm-hidden");
            });
        }
    //	Don't search
    } else {
        //	Show all items
        listitems.forEach(function(listitem) {
            return listitem.classList.remove("mm-hidden");
        });
        dividers.forEach(function(divider) {
            return divider.classList.remove("mm-hidden");
        });
        //	Hide submit / clear button
        buttons.forEach(function(button) {
            return button.classList.add("mm-hidden");
        });
        //	Hide no results message
        noresults.forEach(function(wrapper) {
            $5e687dcee2dc17d2$export$71aa6c912b956294(wrapper, ".mm-panel__noresultsmsg").forEach(function(message) {
                return message.classList.add("mm-hidden");
            });
        });
        if (_$options.panel.add) {
            //	Show splash
            if (_$options.panel.splash) $5e687dcee2dc17d2$export$71aa6c912b956294(searchpanel, ".mm-panel__content").forEach(function(splash) {
                return splash.classList.remove("mm-hidden");
            });
            else if (!input.closest(".mm-panel_search")) {
                var opened = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.pnls, ".mm-panel_opened-parent");
                this.openPanel(opened.slice(-1)[0]);
            }
        }
    }
    //	Update for other addons
    this.trigger("updateListview");
};



var $aa96e7cfa49a078c$var$options = {
    add: false,
    addTo: "panels"
};
var $aa96e7cfa49a078c$export$2e2bcd8739ae039 = $aa96e7cfa49a078c$var$options;
function $aa96e7cfa49a078c$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        add: options
    };
    if (typeof options != "object") options = {};
    return options;
}





//  Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.sectionIndexer = (0, $aa96e7cfa49a078c$export$2e2bcd8739ae039);
function $983e266f04e40489$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $aa96e7cfa49a078c$export$4f8b0ef91d76ca33)(this.opts.sectionIndexer);
    this.opts.sectionIndexer = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.sectionIndexer);
    if (!_$options.add) return;
    this.bind("initPanels:after", function() {
        //	Add the indexer, only if it does not allready excists
        if (!_this.node.indx) {
            var buttons_1 = "";
            "abcdefghijklmnopqrstuvwxyz".split("").forEach(function(letter) {
                buttons_1 += '<a href="#">' + letter + "</a>";
            });
            var indexer = $5e687dcee2dc17d2$export$185802fd694ee1f5("div.mm-sectionindexer");
            indexer.innerHTML = buttons_1;
            _this.node.pnls.prepend(indexer);
            _this.node.indx = indexer;
            //	Prevent default behavior when clicking an anchor
            _this.node.indx.addEventListener("click", function(evnt) {
                var anchor = evnt.target;
                if (anchor.matches("a")) evnt.preventDefault();
            });
            //	Scroll onMouseOver / onTouchStart
            var mouseOverEvent = function mouseOverEvent(evnt) {
                if (!evnt.target.matches("a")) return;
                var letter = evnt.target.textContent, panel = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.pnls, ".mm-panel_opened")[0];
                var newTop = -1, oldTop = panel.scrollTop;
                panel.scrollTop = 0;
                $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-divider").filter(function(divider) {
                    return !divider.matches(".mm-hidden");
                }).forEach(function(divider) {
                    if (newTop < 0 && letter == divider.textContent.trim().slice(0, 1).toLowerCase()) newTop = divider.offsetTop;
                });
                panel.scrollTop = newTop > -1 ? newTop : oldTop;
            };
            if ($2b1d8945f5aabd11$export$d0b7ea69ab6056df) {
                _this.node.indx.addEventListener("touchstart", mouseOverEvent);
                _this.node.indx.addEventListener("touchmove", mouseOverEvent);
            } else _this.node.indx.addEventListener("mouseover", mouseOverEvent);
        }
        //	Show or hide the indexer
        _this.bind("openPanel:start", function(panel) {
            var active = $5e687dcee2dc17d2$export$71aa6c912b956294(panel, ".mm-divider").filter(function(divider) {
                return !divider.matches(".mm-hidden");
            }).length;
            _this.node.indx.classList[active ? "add" : "remove"]("mm-sectionindexer_active");
        });
    });
}



var $69de0c4329757208$var$options = {
    current: true,
    hover: false,
    parent: false
};
var $69de0c4329757208$export$2e2bcd8739ae039 = $69de0c4329757208$var$options;
function $69de0c4329757208$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "boolean") options = {
        hover: options,
        parent: options
    };
    if (typeof options != "object") options = {};
    return options;
}




//	Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.setSelected = (0, $69de0c4329757208$export$2e2bcd8739ae039);
function $8cf08b163cad4d69$export$2e2bcd8739ae039() {
    var _this = this;
    var _$options = (0, $69de0c4329757208$export$4f8b0ef91d76ca33)(this.opts.setSelected);
    this.opts.setSelected = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.setSelected);
    //	Find current by URL
    if (_$options.current == "detect") {
        var findCurrent_1 = function findCurrent_11(url) {
            url = url.split("?")[0].split("#")[0];
            var anchor = _this.node.menu.querySelector('a[href="' + url + '"], a[href="' + url + '/"]');
            if (anchor) _this.setSelected(anchor.parentElement);
            else {
                var arr = url.split("/").slice(0, -1);
                if (arr.length) findCurrent_1(arr.join("/"));
            }
        };
        this.bind("initMenu:after", function() {
            findCurrent_1.call(_this, window.location.href);
        });
    //	Remove current selected item
    } else if (!_$options.current) this.bind("initListview:after", function(listview) {
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(listview, ".mm-listitem_selected").forEach(function(listitem) {
            listitem.classList.remove("mm-listitem_selected");
        });
    });
    //	Add :hover effect on items
    if (_$options.hover) this.bind("initMenu:after", function() {
        _this.node.menu.classList.add("mm-menu_selected-hover");
    });
    //	Set parent item selected for submenus
    if (_$options.parent) {
        this.bind("openPanel:finish", function(panel) {
            //	Remove all
            $5e687dcee2dc17d2$export$71aa6c912b956294(_this.node.pnls, ".mm-listitem_selected-parent").forEach(function(listitem) {
                listitem.classList.remove("mm-listitem_selected-parent");
            });
            //	Move up the DOM tree
            var parent = panel["mmParent"];
            while(parent){
                if (!parent.matches(".mm-listitem_vertical")) parent.classList.add("mm-listitem_selected-parent");
                parent = parent.closest(".mm-panel");
                parent = parent["mmParent"];
            }
        });
        this.bind("initMenu:after", function() {
            _this.node.menu.classList.add("mm-menu_selected-parent");
        });
    }
}



var $3871966c4acb727c$var$options = {
    collapsed: {
        use: false,
        blockMenu: true,
        hideDivider: false,
        hideNavbar: true
    },
    expanded: {
        use: false,
        initial: "open"
    }
};
var $3871966c4acb727c$export$2e2bcd8739ae039 = $3871966c4acb727c$var$options;
function $3871966c4acb727c$export$4f8b0ef91d76ca33(options) {
    if (typeof options == "string" || typeof options == "boolean" && options || typeof options == "number") options = {
        expanded: options
    };
    if (typeof options != "object") options = {};
    //	Extend collapsed shorthand options.
    if (typeof options.collapsed == "boolean" && options.collapsed) options.collapsed = {
        use: true
    };
    if (typeof options.collapsed == "string" || typeof options.collapsed == "number") options.collapsed = {
        use: options.collapsed
    };
    if (typeof options.collapsed != "object") options.collapsed = {};
    //	Extend expanded shorthand options.
    if (typeof options.expanded == "boolean" && options.expanded) options.expanded = {
        use: true
    };
    if (typeof options.expanded == "string" || typeof options.expanded == "number") options.expanded = {
        use: options.expanded
    };
    if (typeof options.expanded != "object") options.expanded = {};
    return options;
}





//  Add the options.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.sidebar = (0, $3871966c4acb727c$export$2e2bcd8739ae039);
function $872185c2f35c9c22$export$2e2bcd8739ae039() {
    var _this = this;
    if (!this.opts.offCanvas) return;
    var _$options = (0, $3871966c4acb727c$export$4f8b0ef91d76ca33)(this.opts.sidebar);
    this.opts.sidebar = (0, $48055557806f998e$export$8b58be045bf06082)(_$options, (0, $a52e6e9520ba942b$export$2e2bcd8739ae039).options.sidebar);
    //	Collapsed
    if (_$options.collapsed.use) {
        //	Make the menu collapsable.
        this.bind("initMenu:after", function() {
            _this.node.menu.classList.add("mm-menu_sidebar-collapsed");
            if (_$options.collapsed.blockMenu && _this.opts.offCanvas && !$5e687dcee2dc17d2$export$bacb5cc5a11aef16(_this.node.menu, ".mm-menu__blocker")[0]) {
                var anchor = $5e687dcee2dc17d2$export$185802fd694ee1f5("a.mm-menu__blocker");
                anchor.setAttribute("href", "#" + _this.node.menu.id);
                _this.node.menu.prepend(anchor);
            }
            if (_$options.collapsed.hideNavbar) _this.node.menu.classList.add("mm-menu_hidenavbar");
            if (_$options.collapsed.hideDivider) _this.node.menu.classList.add("mm-menu_hidedivider");
        });
        //	En-/disable the collapsed sidebar.
        var enable = function enable() {
            _this.node.wrpr.classList.add("mm-wrapper_sidebar-collapsed");
        };
        var disable = function disable() {
            _this.node.wrpr.classList.remove("mm-wrapper_sidebar-collapsed");
        };
        if (typeof _$options.collapsed.use == "boolean") this.bind("initMenu:after", enable);
        else $fb351eed9e08732b$export$e16d8520af44a096(_$options.collapsed.use, enable, disable);
    }
    //	Expanded
    if (_$options.expanded.use) {
        //	Make the menu expandable
        this.bind("initMenu:after", function() {
            _this.node.menu.classList.add("mm-menu_sidebar-expanded");
        });
        //	En-/disable the expanded sidebar.
        var enable = function enable() {
            _this.node.wrpr.classList.add("mm-wrapper_sidebar-expanded");
            if (!_this.node.wrpr.matches(".mm-wrapper_sidebar-closed")) _this.open();
        };
        var disable = function disable() {
            _this.node.wrpr.classList.remove("mm-wrapper_sidebar-expanded");
            _this.close();
        };
        if (typeof _$options.expanded.use == "boolean") this.bind("initMenu:after", enable);
        else $fb351eed9e08732b$export$e16d8520af44a096(_$options.expanded.use, enable, disable);
        //  Manually en-/disable the expanded sidebar (open / close the menu)
        this.bind("close:start", function() {
            if (_this.node.wrpr.matches(".mm-wrapper_sidebar-expanded")) {
                _this.node.wrpr.classList.add("mm-wrapper_sidebar-closed");
                if (_$options.expanded.initial == "remember") window.localStorage.setItem("mmenuExpandedState", "closed");
            }
        });
        this.bind("open:start", function() {
            if (_this.node.wrpr.matches(".mm-wrapper_sidebar-expanded")) {
                _this.node.wrpr.classList.remove("mm-wrapper_sidebar-closed");
                if (_$options.expanded.initial == "remember") window.localStorage.setItem("mmenuExpandedState", "open");
            }
        });
        //  Set the initial state
        var initialState = _$options.expanded.initial;
        if (_$options.expanded.initial == "remember") {
            var state = window.localStorage.getItem("mmenuExpandedState");
            switch(state){
                case "open":
                case "closed":
                    initialState = state;
                    break;
            }
        }
        if (initialState == "closed") this.bind("initMenu:after", function() {
            _this.node.wrpr.classList.add("mm-wrapper_sidebar-closed");
        });
        //	Add click behavior.
        //	Prevents default behavior when clicking an anchor
        this.clck.push(function(anchor, args) {
            if (args.inMenu && args.inListview) {
                if (_this.node.wrpr.matches(".mm-wrapper_sidebar-expanded")) return {
                    close: _$options.expanded.initial == "closed"
                };
            }
        });
    }
}




//	Add the classnames.
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).configs.classNames.toggles = {
    toggle: "Toggle",
    check: "Check"
};
function $a56e3181da1cfb13$export$2e2bcd8739ae039() {
    var _this = this;
    this.bind("initPanel:after", function(panel) {
        //	Refactor toggle classes
        $5e687dcee2dc17d2$export$71aa6c912b956294(panel, "input").forEach(function(input) {
            $5e687dcee2dc17d2$export$9604f4b73fb157f3(input, _this.conf.classNames.toggles.toggle, "mm-toggle");
            $5e687dcee2dc17d2$export$9604f4b73fb157f3(input, _this.conf.classNames.toggles.check, "mm-check");
        });
    });
}


function $975cb02ad25a4ba0$export$2e2bcd8739ae039() {
    this.opts.onClick = {
        close: true,
        preventDefault: false,
        setSelected: true
    };
}



function $91aee51088e94ae0$export$2e2bcd8739ae039() {
    var _this = this;
    //	Create the menu
    if (this.node.menu.matches(".navbar-collapse")) {
        //	No need for cloning the menu...
        if (this.conf.offCanvas) this.conf.offCanvas.clone = false;
        //	... We'll create a new menu
        var nav = $5e687dcee2dc17d2$export$185802fd694ee1f5("nav"), panel = $5e687dcee2dc17d2$export$185802fd694ee1f5("div");
        nav.append(panel);
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(this.node.menu).forEach(function(child) {
            switch(true){
                case child.matches(".navbar-nav"):
                    panel.append(cloneNav(child));
                    break;
                case child.matches(".dropdown-menu"):
                    panel.append(cloneDropdown(child));
                    break;
                case child.matches(".form-inline"):
                    _this.conf.searchfield.form = {
                        action: child.getAttribute("action") || null,
                        method: child.getAttribute("method") || null
                    };
                    _this.conf.searchfield.input = {
                        name: child.querySelector("input").getAttribute("name") || null
                    };
                    _this.conf.searchfield.clear = false;
                    _this.conf.searchfield.submit = true;
                    break;
                default:
                    panel.append(child.cloneNode(true));
                    break;
            }
        });
        //	Set the menu
        this.bind("initMenu:before", function() {
            document.body.prepend(nav);
            _this.node.menu = nav;
        });
        //	Hijack the toggler.
        var parent_1 = this.node.menu.parentElement;
        if (parent_1) {
            var toggler = parent_1.querySelector(".navbar-toggler");
            if (toggler) {
                toggler.removeAttribute("data-target");
                // delete toggler.dataset.target; // IE10 has no dataset :(
                toggler.removeAttribute("aria-controls");
                //	Remove all bound events.
                toggler.outerHTML = toggler.outerHTML;
                toggler = parent_1.querySelector(".navbar-toggler");
                //  Open the menu on-click.
                toggler.addEventListener("click", function(evnt) {
                    evnt.preventDefault();
                    evnt.stopImmediatePropagation();
                    _this[_this.vars.opened ? "close" : "open"]();
                });
            }
        }
    }
    function cloneLink(anchor) {
        var link = $5e687dcee2dc17d2$export$185802fd694ee1f5(anchor.matches("a") ? "a" : "span");
        //	Copy attributes
        var attr = [
            "href",
            "title",
            "target"
        ];
        for(var a = 0; a < attr.length; a++)if (typeof anchor.getAttribute(attr[a]) != "undefined") link.setAttribute(attr[a], anchor.getAttribute(attr[a]));
        //	Copy contents
        link.innerHTML = anchor.innerHTML;
        //	Remove Screen reader text.
        $5e687dcee2dc17d2$export$71aa6c912b956294(link, ".sr-only").forEach(function(sro) {
            sro.remove();
        });
        return link;
    }
    function cloneDropdown(dropdown) {
        var list = $5e687dcee2dc17d2$export$185802fd694ee1f5("ul");
        $5e687dcee2dc17d2$export$bacb5cc5a11aef16(dropdown).forEach(function(anchor) {
            var item = $5e687dcee2dc17d2$export$185802fd694ee1f5("li");
            if (anchor.matches(".dropdown-divider")) item.classList.add("Divider");
            else if (anchor.matches(".dropdown-item")) item.append(cloneLink(anchor));
            list.append(item);
        });
        return list;
    }
    function cloneNav(nav) {
        var list = $5e687dcee2dc17d2$export$185802fd694ee1f5("ul");
        $5e687dcee2dc17d2$export$71aa6c912b956294(nav, ".nav-item").forEach(function(anchor) {
            var item = $5e687dcee2dc17d2$export$185802fd694ee1f5("li");
            if (anchor.matches(".active")) item.classList.add("Selected");
            if (!anchor.matches(".nav-link")) {
                var dropdown = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(anchor, ".dropdown-menu")[0];
                if (dropdown) item.append(cloneDropdown(dropdown));
                anchor = $5e687dcee2dc17d2$export$bacb5cc5a11aef16(anchor, ".nav-link")[0];
            }
            item.prepend(cloneLink(anchor));
            list.append(item);
        });
        return list;
    }
}


function $be1407f949f19630$export$2e2bcd8739ae039() {
    this.conf.offCanvas.page.noSelector.push("#olark");
}


function $dea2bdb6c1b677c5$export$2e2bcd8739ae039() {
    var classnames;
    document.addEventListener("turbolinks:before-visit", function(evnt) {
        classnames = document.querySelector(".mm-wrapper").className.split(" ").filter(function(name) {
            return /mm-/.test(name);
        });
    });
    document.addEventListener("turbolinks:load", function(evnt) {
        if (typeof classnames === "undefined") return;
        document.querySelector(".mm-wrapper").className = classnames;
    });
}


function $69c8b8db19f6f253$export$2e2bcd8739ae039() {
    this.conf.classNames.selected = "current-menu-item";
    var wpadminbar = document.getElementById("wpadminbar");
    if (wpadminbar) {
        wpadminbar.style.position = "fixed";
        wpadminbar.classList.add("mm-slideout");
    }
}


(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).addons = {
    //	Core add-ons
    offcanvas: (0, $a0a535b30841e529$export$2e2bcd8739ae039),
    screenReader: (0, $6abcb35fa0e94821$export$2e2bcd8739ae039),
    scrollBugFix: (0, $b754b876423d6500$export$2e2bcd8739ae039),
    //	Add-ons
    autoHeight: (0, $cbadd89cefd74af9$export$2e2bcd8739ae039),
    backButton: (0, $2dababb2dc8e13ee$export$2e2bcd8739ae039),
    columns: (0, $3db3d1a106c5c582$export$2e2bcd8739ae039),
    counters: (0, $240c27dcfcf1ee33$export$2e2bcd8739ae039),
    dividers: (0, $0c7774ebe80a1831$export$2e2bcd8739ae039),
    drag: (0, $8d62d64bc0b4a6e7$export$2e2bcd8739ae039),
    dropdown: (0, $d11b60a790ec772c$export$2e2bcd8739ae039),
    fixedElements: (0, $30885eefb7af0c40$export$2e2bcd8739ae039),
    iconbar: (0, $36a88457ae069f4f$export$2e2bcd8739ae039),
    iconPanels: (0, $a3a915025e8cc237$export$2e2bcd8739ae039),
    keyboardNavigation: (0, $3e54e096cbf91271$export$2e2bcd8739ae039),
    lazySubmenus: (0, $2f7fbf753a8803c4$export$2e2bcd8739ae039),
    navbars: (0, $0eafda1bd3a2b4cc$export$2e2bcd8739ae039),
    pageScroll: (0, $dac43d641308dd12$export$2e2bcd8739ae039),
    searchfield: (0, $f26083bf834e4db6$export$2e2bcd8739ae039),
    sectionIndexer: (0, $983e266f04e40489$export$2e2bcd8739ae039),
    setSelected: (0, $8cf08b163cad4d69$export$2e2bcd8739ae039),
    sidebar: (0, $872185c2f35c9c22$export$2e2bcd8739ae039),
    toggles: (0, $a56e3181da1cfb13$export$2e2bcd8739ae039)
};
//	Wrappers
(0, $a52e6e9520ba942b$export$2e2bcd8739ae039).wrappers = {
    angular: (0, $975cb02ad25a4ba0$export$2e2bcd8739ae039),
    bootstrap: (0, $91aee51088e94ae0$export$2e2bcd8739ae039),
    olark: (0, $be1407f949f19630$export$2e2bcd8739ae039),
    turbolinks: (0, $dea2bdb6c1b677c5$export$2e2bcd8739ae039),
    wordpress: (0, $69c8b8db19f6f253$export$2e2bcd8739ae039)
};
var //  Export module
$2b03e485f202f715$export$2e2bcd8739ae039 = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039);
//	Global namespace
if (window) window.Mmenu = (0, $a52e6e9520ba942b$export$2e2bcd8739ae039);
//	jQuery plugin
(function($) {
    if ($) $.fn.mmenu = function(options, configs) {
        var $result = $();
        this.each(function(e, element) {
            //	Don't proceed if the element already is a mmenu.
            if (element.mmApi) return;
            var menu = new (0, $a52e6e9520ba942b$export$2e2bcd8739ae039)(element, options, configs), $menu = $(menu.node.menu);
            //	Store the API for backward compat.
            $menu.data("mmenu", menu.API);
            $result = $result.add($menu);
        });
        return $result;
    };
})(window.jQuery || window.Zepto || null);


window.$ = window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)));
document.addEventListener("DOMContentLoaded", function() {
    if (document.querySelector("#my-menu")) {
        /* mobile */ new Mmenu("#my-menu", {
            /* searchfield : {
                    placeholder   : "Bitte Suchbegriff eingeben..."
                }, */ navbars: [
                {
                    position: "top",
                    content: [
                        "<a class='menulogo' href='/'></a>",
                        /* "searchfield", */ "close"
                    ]
                }
            ],
            extensions: [
                /* "fullscreen",
                    "popup" */ "position-front",
                "position-right"
            ],
            setSelected: {
                parent: true
            }
        });
        /* desktop */ new Mmenu("#my-menu-desktop", {
            columns: {
                add: true,
                visible: {
                    max: 1,
                    min: 1
                }
            },
            /* searchfield : {
                    placeholder   : "Bitte Suchbegriff eingeben..."
                }, */ navbars: [
                {
                    position: "top",
                    content: [
                        "<a class='menulogo' href='/'></a>",
                        /* "searchfield", */ "close"
                    ]
                }
            ],
            extensions: [
                /* "fullscreen",
                    "popup" */ "position-front",
                "position-right"
            ],
            setSelected: {
                parent: true
            }
        });
    }
    $8bcd4e9b91b37cf9$var$mmenuSwitcher();
});
function $8bcd4e9b91b37cf9$var$mmenuSwitcher() {
    if ($(this).width() < 1400) $("div.mainmenu > a.item.mm-menubtn").attr("href", "#my-menu");
    else $("div.mainmenu > a.item.mm-menubtn").attr("href", "#my-menu-desktop");
}
$(window).on("resize", $8bcd4e9b91b37cf9$var$mmenuSwitcher);



var $4w9fm = parcelRequire("4w9fm");
(0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(document).ready(function() {
    function docountdown() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".fig").each(function() {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").indexOf(",") > 0) {
                var decimals = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").length - 1 - (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").indexOf(",");
                (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-decimals", decimals);
                (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig", (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").replace(",", ""));
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").indexOf(".") > 0) {
                (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).addClass("thousandSep");
                (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig", (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).attr("data-fig").replace(".", ""));
            }
            function filterSeperators(fig, count) {
                if (fig.hasClass("thousandSep")) {
                    if (Math.floor(count.countNum / 1000) == 0) fig.text(Math.floor(count.countNum % 1000));
                    else {
                        var to3places = Math.floor(count.countNum % 1000);
                        if (to3places < 10) to3places = "00" + to3places;
                        else if (to3places < 100) to3places = "0" + to3places;
                        fig.text(Math.floor(count.countNum / 1000) + "." + to3places);
                    }
                } else if (fig.attr("data-decimals") != undefined) {
                    var decimals = parseInt(fig.attr("data-decimals"));
                    fig.text(Math.floor(count.countNum / Math.pow(10, decimals)) + "," + Math.floor(count.countNum % Math.pow(10, decimals)));
                } else fig.text(Math.floor(count.countNum));
            }
            if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm))).isNumeric((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).html()) && !(0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this).closest(".fig").closest(".count").hasClass("done")) {
                var $this = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this);
                var countTo = parseInt($this.attr("data-fig"));
                var offset = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(window).scrollTop() + (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(window).height() / 1.2;
                if ($this.offset().top <= offset && !$this.closest(".count").hasClass("anim")) {
                    $this.closest(".count").addClass("anim");
                    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))({
                        countNum: 0
                    }).animate({
                        countNum: countTo
                    }, {
                        duration: 3000,
                        easing: "linear",
                        step: function step() {
                            filterSeperators($this, this);
                        },
                        complete: function complete() {
                            filterSeperators($this, this);
                            $this.closest(".count").removeClass("anim");
                            $this.closest(".fig").closest(".count").addClass("done");
                        }
                    });
                }
            }
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".fig").length) {
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(window).on("scroll", function() {
            docountdown();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(window).on("load", function() {
            docountdown();
        });
    }
});


parcelRequire("4w9fm");
var $84cf196c66595ac8$exports = {};

/*!
 * Bootstrap-select v1.13.18 (https://developer.snapappointments.com/bootstrap-select)
 *
 * Copyright 2012-2020 SnapAppointments, LLC
 * Licensed under MIT (https://github.com/snapappointments/bootstrap-select/blob/master/LICENSE)
 */ (function(root, factory) {
    if (root === undefined && window !== undefined) root = window;
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module unless amdModuleId is set
    define([
        "jquery"
    ], function(a0) {
        return factory(a0);
    });
    else if (0, $84cf196c66595ac8$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $84cf196c66595ac8$exports = factory((parcelRequire("4w9fm")));
    else factory(root["jQuery"]);
})($84cf196c66595ac8$exports, function(jQuery) {
    (function($) {
        "use strict";
        var DISALLOWED_ATTRIBUTES = [
            "sanitize",
            "whiteList",
            "sanitizeFn"
        ];
        var uriAttrs = [
            "background",
            "cite",
            "href",
            "itemtype",
            "longdesc",
            "poster",
            "src",
            "xlink:href"
        ];
        var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
        var DefaultWhitelist = {
            // Global attributes allowed on any supplied element below.
            "*": [
                "class",
                "dir",
                "id",
                "lang",
                "role",
                "tabindex",
                "style",
                ARIA_ATTRIBUTE_PATTERN
            ],
            a: [
                "target",
                "href",
                "title",
                "rel"
            ],
            area: [],
            b: [],
            br: [],
            col: [],
            code: [],
            div: [],
            em: [],
            hr: [],
            h1: [],
            h2: [],
            h3: [],
            h4: [],
            h5: [],
            h6: [],
            i: [],
            img: [
                "src",
                "alt",
                "title",
                "width",
                "height"
            ],
            li: [],
            ol: [],
            p: [],
            pre: [],
            s: [],
            small: [],
            span: [],
            sub: [],
            sup: [],
            strong: [],
            u: [],
            ul: []
        };
        /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
        /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */ var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;
        function allowedAttribute(attr, allowedAttributeList) {
            var attrName = attr.nodeName.toLowerCase();
            if ($.inArray(attrName, allowedAttributeList) !== -1) {
                if ($.inArray(attrName, uriAttrs) !== -1) return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
                return true;
            }
            var regExp = $(allowedAttributeList).filter(function(index, value) {
                return value instanceof RegExp;
            });
            // Check if a regular expression validates the attribute.
            for(var i = 0, l = regExp.length; i < l; i++){
                if (attrName.match(regExp[i])) return true;
            }
            return false;
        }
        function sanitizeHtml(unsafeElements, whiteList, sanitizeFn) {
            if (sanitizeFn && typeof sanitizeFn === "function") return sanitizeFn(unsafeElements);
            var whitelistKeys = Object.keys(whiteList);
            for(var i = 0, len = unsafeElements.length; i < len; i++){
                var elements = unsafeElements[i].querySelectorAll("*");
                for(var j = 0, len2 = elements.length; j < len2; j++){
                    var el = elements[j];
                    var elName = el.nodeName.toLowerCase();
                    if (whitelistKeys.indexOf(elName) === -1) {
                        el.parentNode.removeChild(el);
                        continue;
                    }
                    var attributeList = [].slice.call(el.attributes);
                    var whitelistedAttributes = [].concat(whiteList["*"] || [], whiteList[elName] || []);
                    for(var k = 0, len3 = attributeList.length; k < len3; k++){
                        var attr = attributeList[k];
                        if (!allowedAttribute(attr, whitelistedAttributes)) el.removeAttribute(attr.nodeName);
                    }
                }
            }
        }
        // Polyfill for browsers with no classList support
        // Remove in v2
        if (!("classList" in document.createElement("_"))) (function(view) {
            if (!("Element" in view)) return;
            var classListProp = "classList", protoProp = "prototype", elemCtrProto = view.Element[protoProp], objCtr = Object, classListGetter = function classListGetter() {
                var $elem = $(this);
                return {
                    add: function add(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.addClass(classes);
                    },
                    remove: function remove(classes) {
                        classes = Array.prototype.slice.call(arguments).join(" ");
                        return $elem.removeClass(classes);
                    },
                    toggle: function toggle(classes, force) {
                        return $elem.toggleClass(classes, force);
                    },
                    contains: function contains(classes) {
                        return $elem.hasClass(classes);
                    }
                };
            };
            if (objCtr.defineProperty) {
                var classListPropDesc = {
                    get: classListGetter,
                    enumerable: true,
                    configurable: true
                };
                try {
                    objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                } catch (ex) {
                    // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                    // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                    if (ex.number === undefined || ex.number === -2146823252) {
                        classListPropDesc.enumerable = false;
                        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                    }
                }
            } else if (objCtr[protoProp].__defineGetter__) elemCtrProto.__defineGetter__(classListProp, classListGetter);
        })(window);
        var testElement = document.createElement("_");
        testElement.classList.add("c1", "c2");
        if (!testElement.classList.contains("c2")) {
            var _add = DOMTokenList.prototype.add, _remove = DOMTokenList.prototype.remove;
            DOMTokenList.prototype.add = function() {
                Array.prototype.forEach.call(arguments, _add.bind(this));
            };
            DOMTokenList.prototype.remove = function() {
                Array.prototype.forEach.call(arguments, _remove.bind(this));
            };
        }
        testElement.classList.toggle("c3", false);
        // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
        // support the second argument.
        if (testElement.classList.contains("c3")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
                if (1 in arguments && !this.contains(token) === !force) return force;
                else return _toggle.call(this, token);
            };
        }
        testElement = null;
        // shallow array comparison
        function isEqual(array1, array2) {
            return array1.length === array2.length && array1.every(function(element, index) {
                return element === array2[index];
            });
        }
        // <editor-fold desc="Shims">
        if (!String.prototype.startsWith) (function() {
            "use strict"; // needed to support `apply`/`call` with `undefined`/`null`
            var defineProperty = function() {
                // IE 8 only supports `Object.defineProperty` on DOM elements
                try {
                    var object = {};
                    var $defineProperty = Object.defineProperty;
                    var result = $defineProperty(object, object, object) && $defineProperty;
                } catch (error) {}
                return result;
            }();
            var toString = {}.toString;
            var startsWith = function startsWith(search) {
                if (this == null) throw new TypeError();
                var string = String(this);
                if (search && toString.call(search) == "[object RegExp]") throw new TypeError();
                var stringLength = string.length;
                var searchString = String(search);
                var searchLength = searchString.length;
                var position = arguments.length > 1 ? arguments[1] : undefined;
                // `ToInteger`
                var pos = position ? Number(position) : 0;
                if (pos != pos) pos = 0;
                var start = Math.min(Math.max(pos, 0), stringLength);
                // Avoid the `indexOf` call if no match is possible
                if (searchLength + start > stringLength) return false;
                var index = -1;
                while(++index < searchLength){
                    if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) return false;
                }
                return true;
            };
            if (defineProperty) defineProperty(String.prototype, "startsWith", {
                value: startsWith,
                configurable: true,
                writable: true
            });
            else String.prototype.startsWith = startsWith;
        })();
        if (!Object.keys) Object.keys = function(o, k, r // result array
        ) {
            // initialize object and result
            r = [];
            // iterate over object keys
            for(k in o)// fill result array with non-prototypical keys
            r.hasOwnProperty.call(o, k) && r.push(k);
            // return result
            return r;
        };
        if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty("selectedOptions")) Object.defineProperty(HTMLSelectElement.prototype, "selectedOptions", {
            get: function get() {
                return this.querySelectorAll(":checked");
            }
        });
        function getSelectedOptions(select, ignoreDisabled) {
            var selectedOptions = select.selectedOptions, options = [], opt;
            if (ignoreDisabled) {
                for(var i = 0, len = selectedOptions.length; i < len; i++){
                    opt = selectedOptions[i];
                    if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) options.push(opt);
                }
                return options;
            }
            return selectedOptions;
        }
        // much faster than $.val()
        function getSelectValues(select, selectedOptions) {
            var value = [], options = selectedOptions || select.selectedOptions, opt;
            for(var i = 0, len = options.length; i < len; i++){
                opt = options[i];
                if (!(opt.disabled || opt.parentNode.tagName === "OPTGROUP" && opt.parentNode.disabled)) value.push(opt.value);
            }
            if (!select.multiple) return !value.length ? null : value[0];
            return value;
        }
        // set data-selected on select element if the value has been programmatically selected
        // prior to initialization of bootstrap-select
        // * consider removing or replacing an alternative method *
        var valHooks = {
            useDefault: false,
            _set: $.valHooks.select.set
        };
        $.valHooks.select.set = function(elem, value) {
            if (value && !valHooks.useDefault) $(elem).data("selected", true);
            return valHooks._set.apply(this, arguments);
        };
        var changedArguments = null;
        var EventIsSupported = function() {
            try {
                new Event("change");
                return true;
            } catch (e) {
                return false;
            }
        }();
        $.fn.triggerNative = function(eventName) {
            var el = this[0], event;
            if (el.dispatchEvent) {
                if (EventIsSupported) // For modern browsers
                event = new Event(eventName, {
                    bubbles: true
                });
                else {
                    // For IE since it doesn't support Event constructor
                    event = document.createEvent("Event");
                    event.initEvent(eventName, true, false);
                }
                el.dispatchEvent(event);
            } else if (el.fireEvent) {
                event = document.createEventObject();
                event.eventType = eventName;
                el.fireEvent("on" + eventName, event);
            } else // fall back to jQuery.trigger
            this.trigger(eventName);
        };
        // </editor-fold>
        function stringSearch(li, searchString, method, normalize) {
            var stringTypes = [
                "display",
                "subtext",
                "tokens"
            ], searchSuccess = false;
            for(var i = 0; i < stringTypes.length; i++){
                var stringType = stringTypes[i], string = li[stringType];
                if (string) {
                    string = string.toString();
                    // Strip HTML tags. This isn't perfect, but it's much faster than any other method
                    if (stringType === "display") string = string.replace(/<[^>]+>/g, "");
                    if (normalize) string = normalizeToBase(string);
                    string = string.toUpperCase();
                    if (method === "contains") searchSuccess = string.indexOf(searchString) >= 0;
                    else searchSuccess = string.startsWith(searchString);
                    if (searchSuccess) break;
                }
            }
            return searchSuccess;
        }
        function toInteger(value) {
            return parseInt(value, 10) || 0;
        }
        // Borrowed from Lodash (_.deburr)
        /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
            // Latin-1 Supplement block.
            "\xc0": "A",
            "\xc1": "A",
            "\xc2": "A",
            "\xc3": "A",
            "\xc4": "A",
            "\xc5": "A",
            "\xe0": "a",
            "\xe1": "a",
            "\xe2": "a",
            "\xe3": "a",
            "\xe4": "a",
            "\xe5": "a",
            "\xc7": "C",
            "\xe7": "c",
            "\xd0": "D",
            "\xf0": "d",
            "\xc8": "E",
            "\xc9": "E",
            "\xca": "E",
            "\xcb": "E",
            "\xe8": "e",
            "\xe9": "e",
            "\xea": "e",
            "\xeb": "e",
            "\xcc": "I",
            "\xcd": "I",
            "\xce": "I",
            "\xcf": "I",
            "\xec": "i",
            "\xed": "i",
            "\xee": "i",
            "\xef": "i",
            "\xd1": "N",
            "\xf1": "n",
            "\xd2": "O",
            "\xd3": "O",
            "\xd4": "O",
            "\xd5": "O",
            "\xd6": "O",
            "\xd8": "O",
            "\xf2": "o",
            "\xf3": "o",
            "\xf4": "o",
            "\xf5": "o",
            "\xf6": "o",
            "\xf8": "o",
            "\xd9": "U",
            "\xda": "U",
            "\xdb": "U",
            "\xdc": "U",
            "\xf9": "u",
            "\xfa": "u",
            "\xfb": "u",
            "\xfc": "u",
            "\xdd": "Y",
            "\xfd": "y",
            "\xff": "y",
            "\xc6": "Ae",
            "\xe6": "ae",
            "\xde": "Th",
            "\xfe": "th",
            "\xdf": "ss",
            // Latin Extended-A block.
            \u0100: "A",
            \u0102: "A",
            \u0104: "A",
            \u0101: "a",
            \u0103: "a",
            \u0105: "a",
            \u0106: "C",
            \u0108: "C",
            \u010A: "C",
            \u010C: "C",
            \u0107: "c",
            \u0109: "c",
            \u010B: "c",
            \u010D: "c",
            \u010E: "D",
            \u0110: "D",
            \u010F: "d",
            \u0111: "d",
            \u0112: "E",
            \u0114: "E",
            \u0116: "E",
            \u0118: "E",
            \u011A: "E",
            \u0113: "e",
            \u0115: "e",
            \u0117: "e",
            \u0119: "e",
            \u011B: "e",
            \u011C: "G",
            \u011E: "G",
            \u0120: "G",
            \u0122: "G",
            \u011D: "g",
            \u011F: "g",
            \u0121: "g",
            \u0123: "g",
            \u0124: "H",
            \u0126: "H",
            \u0125: "h",
            \u0127: "h",
            \u0128: "I",
            \u012A: "I",
            \u012C: "I",
            \u012E: "I",
            \u0130: "I",
            \u0129: "i",
            \u012B: "i",
            \u012D: "i",
            \u012F: "i",
            \u0131: "i",
            \u0134: "J",
            \u0135: "j",
            \u0136: "K",
            \u0137: "k",
            \u0138: "k",
            \u0139: "L",
            \u013B: "L",
            \u013D: "L",
            \u013F: "L",
            \u0141: "L",
            \u013A: "l",
            \u013C: "l",
            \u013E: "l",
            \u0140: "l",
            \u0142: "l",
            \u0143: "N",
            \u0145: "N",
            \u0147: "N",
            \u014A: "N",
            \u0144: "n",
            \u0146: "n",
            \u0148: "n",
            \u014B: "n",
            \u014C: "O",
            \u014E: "O",
            \u0150: "O",
            \u014D: "o",
            \u014F: "o",
            \u0151: "o",
            \u0154: "R",
            \u0156: "R",
            \u0158: "R",
            \u0155: "r",
            \u0157: "r",
            \u0159: "r",
            \u015A: "S",
            \u015C: "S",
            \u015E: "S",
            \u0160: "S",
            \u015B: "s",
            \u015D: "s",
            \u015F: "s",
            \u0161: "s",
            \u0162: "T",
            \u0164: "T",
            \u0166: "T",
            \u0163: "t",
            \u0165: "t",
            \u0167: "t",
            \u0168: "U",
            \u016A: "U",
            \u016C: "U",
            \u016E: "U",
            \u0170: "U",
            \u0172: "U",
            \u0169: "u",
            \u016B: "u",
            \u016D: "u",
            \u016F: "u",
            \u0171: "u",
            \u0173: "u",
            \u0174: "W",
            \u0175: "w",
            \u0176: "Y",
            \u0177: "y",
            \u0178: "Y",
            \u0179: "Z",
            \u017B: "Z",
            \u017D: "Z",
            \u017A: "z",
            \u017C: "z",
            \u017E: "z",
            \u0132: "IJ",
            \u0133: "ij",
            \u0152: "Oe",
            \u0153: "oe",
            \u0149: "'n",
            \u017F: "s"
        };
        /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
        /** Used to compose unicode character classes. */ var rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboMarksExtendedRange = "\\u1ab0-\\u1aff", rsComboMarksSupplementRange = "\\u1dc0-\\u1dff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;
        /** Used to compose unicode capture groups. */ var rsCombo = "[" + rsComboRange + "]";
        /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
        function deburrLetter(key) {
            return deburredLetters[key];
        }
        function normalizeToBase(string) {
            string = string.toString();
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        // List of HTML entities for escaping.
        var escapeMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#x27;",
            "`": "&#x60;"
        };
        // Functions for escaping and unescaping strings to/from HTML interpolation.
        var createEscaper = function createEscaper(map) {
            var escaper = function escaper(match) {
                return map[match];
            };
            // Regexes for identifying a key that needs to be escaped.
            var source = "(?:" + Object.keys(map).join("|") + ")";
            var testRegexp = RegExp(source);
            var replaceRegexp = RegExp(source, "g");
            return function(string) {
                string = string == null ? "" : "" + string;
                return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
            };
        };
        var htmlEscape = createEscaper(escapeMap);
        /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var keyCodeMap = {
            32: " ",
            48: "0",
            49: "1",
            50: "2",
            51: "3",
            52: "4",
            53: "5",
            54: "6",
            55: "7",
            56: "8",
            57: "9",
            59: ";",
            65: "A",
            66: "B",
            67: "C",
            68: "D",
            69: "E",
            70: "F",
            71: "G",
            72: "H",
            73: "I",
            74: "J",
            75: "K",
            76: "L",
            77: "M",
            78: "N",
            79: "O",
            80: "P",
            81: "Q",
            82: "R",
            83: "S",
            84: "T",
            85: "U",
            86: "V",
            87: "W",
            88: "X",
            89: "Y",
            90: "Z",
            96: "0",
            97: "1",
            98: "2",
            99: "3",
            100: "4",
            101: "5",
            102: "6",
            103: "7",
            104: "8",
            105: "9"
        };
        var keyCodes = {
            ESCAPE: 27,
            ENTER: 13,
            SPACE: 32,
            TAB: 9,
            ARROW_UP: 38,
            ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
        };
        var version = {
            success: false,
            major: "3"
        };
        try {
            version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
            version.major = version.full[0];
            version.success = true;
        } catch (err) {
        // do nothing
        }
        var selectId = 0;
        var EVENT_KEY = ".bs.select";
        var classNames = {
            DISABLED: "disabled",
            DIVIDER: "divider",
            SHOW: "open",
            DROPUP: "dropup",
            MENU: "dropdown-menu",
            MENURIGHT: "dropdown-menu-right",
            MENULEFT: "dropdown-menu-left",
            // to-do: replace with more advanced template/customization options
            BUTTONCLASS: "btn-default",
            POPOVERHEADER: "popover-title",
            ICONBASE: "glyphicon",
            TICKICON: "glyphicon-ok"
        };
        var Selector = {
            MENU: "." + classNames.MENU
        };
        var elementTemplates = {
            div: document.createElement("div"),
            span: document.createElement("span"),
            i: document.createElement("i"),
            subtext: document.createElement("small"),
            a: document.createElement("a"),
            li: document.createElement("li"),
            whitespace: document.createTextNode("\xa0"),
            fragment: document.createDocumentFragment()
        };
        elementTemplates.noResults = elementTemplates.li.cloneNode(false);
        elementTemplates.noResults.className = "no-results";
        elementTemplates.a.setAttribute("role", "option");
        elementTemplates.a.className = "dropdown-item";
        elementTemplates.subtext.className = "text-muted";
        elementTemplates.text = elementTemplates.span.cloneNode(false);
        elementTemplates.text.className = "text";
        elementTemplates.checkMark = elementTemplates.span.cloneNode(false);
        var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + "|" + keyCodes.ARROW_DOWN);
        var REGEXP_TAB_OR_ESCAPE = new RegExp("^" + keyCodes.TAB + "$|" + keyCodes.ESCAPE);
        var generateOption = {
            li: function li(content, classes, optgroup) {
                var li = elementTemplates.li.cloneNode(false);
                if (content) {
                    if (content.nodeType === 1 || content.nodeType === 11) li.appendChild(content);
                    else li.innerHTML = content;
                }
                if (typeof classes !== "undefined" && classes !== "") li.className = classes;
                if (typeof optgroup !== "undefined" && optgroup !== null) li.classList.add("optgroup-" + optgroup);
                return li;
            },
            a: function a(text, classes, inline) {
                var a = elementTemplates.a.cloneNode(true);
                if (text) {
                    if (text.nodeType === 11) a.appendChild(text);
                    else a.insertAdjacentHTML("beforeend", text);
                }
                if (typeof classes !== "undefined" && classes !== "") a.classList.add.apply(a.classList, classes.split(/\s+/));
                if (inline) a.setAttribute("style", inline);
                return a;
            },
            text: function text(options, useFragment) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                if (options.content) textElement.innerHTML = options.content;
                else {
                    textElement.textContent = options.text;
                    if (options.icon) {
                        var whitespace = elementTemplates.whitespace.cloneNode(false);
                        // need to use <i> for icons in the button to prevent a breaking change
                        // note: switch to span in next major release
                        iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
                        iconElement.className = this.options.iconBase + " " + options.icon;
                        elementTemplates.fragment.appendChild(iconElement);
                        elementTemplates.fragment.appendChild(whitespace);
                    }
                    if (options.subtext) {
                        subtextElement = elementTemplates.subtext.cloneNode(false);
                        subtextElement.textContent = options.subtext;
                        textElement.appendChild(subtextElement);
                    }
                }
                if (useFragment === true) while(textElement.childNodes.length > 0)elementTemplates.fragment.appendChild(textElement.childNodes[0]);
                else elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            },
            label: function label(options) {
                var textElement = elementTemplates.text.cloneNode(false), subtextElement, iconElement;
                textElement.innerHTML = options.display;
                if (options.icon) {
                    var whitespace = elementTemplates.whitespace.cloneNode(false);
                    iconElement = elementTemplates.span.cloneNode(false);
                    iconElement.className = this.options.iconBase + " " + options.icon;
                    elementTemplates.fragment.appendChild(iconElement);
                    elementTemplates.fragment.appendChild(whitespace);
                }
                if (options.subtext) {
                    subtextElement = elementTemplates.subtext.cloneNode(false);
                    subtextElement.textContent = options.subtext;
                    textElement.appendChild(subtextElement);
                }
                elementTemplates.fragment.appendChild(textElement);
                return elementTemplates.fragment;
            }
        };
        function showNoResults(searchMatch, searchValue) {
            if (!searchMatch.length) {
                elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace("{0}", '"' + htmlEscape(searchValue) + '"');
                this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
            }
        }
        var Selectpicker = function Selectpicker1(element, options) {
            var that = this;
            // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
            if (!valHooks.useDefault) {
                $.valHooks.select.set = valHooks._set;
                valHooks.useDefault = true;
            }
            this.$element = $(element);
            this.$newElement = null;
            this.$button = null;
            this.$menu = null;
            this.options = options;
            this.selectpicker = {
                main: {},
                search: {},
                current: {},
                view: {},
                isSearching: false,
                keydown: {
                    keyHistory: "",
                    resetKeyHistory: {
                        start: function start() {
                            return setTimeout(function() {
                                that.selectpicker.keydown.keyHistory = "";
                            }, 800);
                        }
                    }
                }
            };
            this.sizeInfo = {};
            // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
            // data-attribute)
            if (this.options.title === null) this.options.title = this.$element.attr("title");
            // Format window padding
            var winPad = this.options.windowPadding;
            if (typeof winPad === "number") this.options.windowPadding = [
                winPad,
                winPad,
                winPad,
                winPad
            ];
            // Expose public methods
            this.val = Selectpicker.prototype.val;
            this.render = Selectpicker.prototype.render;
            this.refresh = Selectpicker.prototype.refresh;
            this.setStyle = Selectpicker.prototype.setStyle;
            this.selectAll = Selectpicker.prototype.selectAll;
            this.deselectAll = Selectpicker.prototype.deselectAll;
            this.destroy = Selectpicker.prototype.destroy;
            this.remove = Selectpicker.prototype.remove;
            this.show = Selectpicker.prototype.show;
            this.hide = Selectpicker.prototype.hide;
            this.init();
        };
        Selectpicker.VERSION = "1.13.18";
        // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
        Selectpicker.DEFAULTS = {
            noneSelectedText: "Nothing selected",
            noneResultsText: "No results matched {0}",
            countSelectedText: function countSelectedText(numSelected, numTotal) {
                return numSelected == 1 ? "{0} item selected" : "{0} items selected";
            },
            maxOptionsText: function maxOptionsText(numAll, numGroup) {
                return [
                    numAll == 1 ? "Limit reached ({n} item max)" : "Limit reached ({n} items max)",
                    numGroup == 1 ? "Group limit reached ({n} item max)" : "Group limit reached ({n} items max)"
                ];
            },
            selectAllText: "Select All",
            deselectAllText: "Deselect All",
            doneButton: false,
            doneButtonText: "Close",
            multipleSeparator: ", ",
            styleBase: "btn",
            style: classNames.BUTTONCLASS,
            size: "auto",
            title: null,
            selectedTextFormat: "values",
            width: false,
            container: false,
            hideDisabled: false,
            showSubtext: false,
            showIcon: true,
            showContent: true,
            dropupAuto: true,
            header: false,
            liveSearch: false,
            liveSearchPlaceholder: null,
            liveSearchNormalize: false,
            liveSearchStyle: "contains",
            actionsBox: false,
            iconBase: classNames.ICONBASE,
            tickIcon: classNames.TICKICON,
            showTick: false,
            template: {
                caret: '<span class="caret"></span>'
            },
            maxOptions: false,
            mobile: false,
            selectOnTab: false,
            dropdownAlignRight: false,
            windowPadding: 0,
            virtualScroll: 600,
            display: false,
            sanitize: true,
            sanitizeFn: null,
            whiteList: DefaultWhitelist
        };
        Selectpicker.prototype = {
            constructor: Selectpicker,
            init: function init() {
                var that = this, id = this.$element.attr("id"), element = this.$element[0], form = element.form;
                selectId++;
                this.selectId = "bs-select-" + selectId;
                element.classList.add("bs-select-hidden");
                this.multiple = this.$element.prop("multiple");
                this.autofocus = this.$element.prop("autofocus");
                if (element.classList.contains("show-tick")) this.options.showTick = true;
                this.$newElement = this.createDropdown();
                this.buildData();
                this.$element.after(this.$newElement).prependTo(this.$newElement);
                // ensure select is associated with form element if it got unlinked after moving it inside newElement
                if (form && element.form === null) {
                    if (!form.id) form.id = "form-" + this.selectId;
                    element.setAttribute("form", form.id);
                }
                this.$button = this.$newElement.children("button");
                this.$menu = this.$newElement.children(Selector.MENU);
                this.$menuInner = this.$menu.children(".inner");
                this.$searchbox = this.$menu.find("input");
                element.classList.remove("bs-select-hidden");
                if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);
                if (typeof id !== "undefined") this.$button.attr("data-id", id);
                this.checkDisabled();
                this.clickListener();
                if (this.options.liveSearch) {
                    this.liveSearchListener();
                    this.focusedParent = this.$searchbox[0];
                } else this.focusedParent = this.$menuInner[0];
                this.setStyle();
                this.render();
                this.setWidth();
                if (this.options.container) this.selectPosition();
                else this.$element.on("hide" + EVENT_KEY, function() {
                    if (that.isVirtual()) {
                        // empty menu on close
                        var menuInner = that.$menuInner[0], emptyMenu = menuInner.firstChild.cloneNode(false);
                        // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
                        menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                        menuInner.scrollTop = 0;
                    }
                });
                this.$menu.data("this", this);
                this.$newElement.data("this", this);
                if (this.options.mobile) this.mobile();
                this.$newElement.on({
                    "hide.bs.dropdown": function(e) {
                        that.$element.trigger("hide" + EVENT_KEY, e);
                    },
                    "hidden.bs.dropdown": function(e) {
                        that.$element.trigger("hidden" + EVENT_KEY, e);
                    },
                    "show.bs.dropdown": function(e) {
                        that.$element.trigger("show" + EVENT_KEY, e);
                    },
                    "shown.bs.dropdown": function(e) {
                        that.$element.trigger("shown" + EVENT_KEY, e);
                    }
                });
                if (element.hasAttribute("required")) this.$element.on("invalid" + EVENT_KEY, function() {
                    that.$button[0].classList.add("bs-invalid");
                    that.$element.on("shown" + EVENT_KEY + ".invalid", function() {
                        that.$element.val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
                        .off("shown" + EVENT_KEY + ".invalid");
                    }).on("rendered" + EVENT_KEY, function() {
                        // if select is no longer invalid, remove the bs-invalid class
                        if (this.validity.valid) that.$button[0].classList.remove("bs-invalid");
                        that.$element.off("rendered" + EVENT_KEY);
                    });
                    that.$button.on("blur" + EVENT_KEY, function() {
                        that.$element.trigger("focus").trigger("blur");
                        that.$button.off("blur" + EVENT_KEY);
                    });
                });
                setTimeout(function() {
                    that.buildList();
                    that.$element.trigger("loaded" + EVENT_KEY);
                });
            },
            createDropdown: function createDropdown() {
                // Options
                // If we are multiple or showTick option is set, then add the show-tick class
                var showTick = this.multiple || this.options.showTick ? " show-tick" : "", multiselectable = this.multiple ? ' aria-multiselectable="true"' : "", inputGroup = "", autofocus = this.autofocus ? " autofocus" : "";
                if (version.major < 4 && this.$element.parent().hasClass("input-group")) inputGroup = " input-group-btn";
                // Elements
                var drop, header = "", searchbox = "", actionsbox = "", donebutton = "";
                if (this.options.header) header = '<div class="' + classNames.POPOVERHEADER + '">' + '<button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + "</div>";
                if (this.options.liveSearch) searchbox = '<div class="bs-searchbox"><input type="search" class="form-control" autocomplete="off"' + (this.options.liveSearchPlaceholder === null ? "" : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' + "</div>";
                if (this.multiple && this.options.actionsBox) actionsbox = '<div class="bs-actionsbox"><div class="btn-group btn-group-sm btn-block"><button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' + this.options.selectAllText + "</button>" + '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' + this.options.deselectAllText + "</button>" + "</div>" + "</div>";
                if (this.multiple && this.options.doneButton) donebutton = '<div class="bs-donebutton"><div class="btn-group btn-block"><button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' + this.options.doneButtonText + "</button>" + "</div>" + "</div>";
                drop = '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' + '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === "static" ? 'data-display="static"' : "") + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' + '<div class="filter-option">' + '<div class="filter-option-inner">' + '<div class="filter-option-inner-inner"></div>' + "</div> " + "</div>" + (version.major === "4" ? "" : '<span class="bs-caret">' + this.options.template.caret + "</span>") + "</button>" + '<div class="' + classNames.MENU + " " + (version.major === "4" ? "" : classNames.SHOW) + '">' + header + searchbox + actionsbox + '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + ">" + '<ul class="' + classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "") + '" role="presentation">' + "</ul>" + "</div>" + donebutton + "</div>" + "</div>";
                return $(drop);
            },
            setPositionData: function setPositionData() {
                this.selectpicker.view.canHighlight = [];
                this.selectpicker.view.size = 0;
                this.selectpicker.view.firstHighlightIndex = false;
                for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var li = this.selectpicker.current.data[i], canHighlight = true;
                    if (li.type === "divider") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dividerHeight;
                    } else if (li.type === "optgroup-label") {
                        canHighlight = false;
                        li.height = this.sizeInfo.dropdownHeaderHeight;
                    } else li.height = this.sizeInfo.liHeight;
                    if (li.disabled) canHighlight = false;
                    this.selectpicker.view.canHighlight.push(canHighlight);
                    if (canHighlight) {
                        this.selectpicker.view.size++;
                        li.posinset = this.selectpicker.view.size;
                        if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
                    }
                    li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
                }
            },
            isVirtual: function isVirtual() {
                return this.options.virtualScroll !== false && this.selectpicker.main.elements.length >= this.options.virtualScroll || this.options.virtualScroll === true;
            },
            createView: function createView(isSearching, setSize, refresh) {
                var that = this, scrollTop = 0, active = [], selected, prevActive;
                this.selectpicker.isSearching = isSearching;
                this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;
                this.setPositionData();
                if (setSize) {
                    if (refresh) scrollTop = this.$menuInner[0].scrollTop;
                    else if (!that.multiple) {
                        var element = that.$element[0], selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                        if (typeof selectedIndex === "number" && that.options.size !== false) {
                            var selectedData = that.selectpicker.main.data[selectedIndex], position = selectedData && selectedData.position;
                            if (position) scrollTop = position - (that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2;
                        }
                    }
                }
                scroll(scrollTop, true);
                this.$menuInner.off("scroll.createView").on("scroll.createView", function(e, updateValue) {
                    if (!that.noScroll) scroll(this.scrollTop, updateValue);
                    that.noScroll = false;
                });
                function scroll(scrollTop, init) {
                    var size = that.selectpicker.current.elements.length, chunks = [], chunkSize, chunkCount, firstChunk, lastChunk, currentChunk, prevPositions, positionIsDifferent, previousElements, menuIsDifferent = true, isVirtual = that.isVirtual();
                    that.selectpicker.view.scrollTop = scrollTop;
                    chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
                    chunkCount = Math.round(size / chunkSize) || 1; // number of chunks
                    for(var i = 0; i < chunkCount; i++){
                        var endOfChunk = (i + 1) * chunkSize;
                        if (i === chunkCount - 1) endOfChunk = size;
                        chunks[i] = [
                            i * chunkSize + (!i ? 0 : 1),
                            endOfChunk
                        ];
                        if (!size) break;
                        if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) currentChunk = i;
                    }
                    if (currentChunk === undefined) currentChunk = 0;
                    prevPositions = [
                        that.selectpicker.view.position0,
                        that.selectpicker.view.position1
                    ];
                    // always display previous, current, and next chunks
                    firstChunk = Math.max(0, currentChunk - 1);
                    lastChunk = Math.min(chunkCount - 1, currentChunk + 1);
                    that.selectpicker.view.position0 = isVirtual === false ? 0 : Math.max(0, chunks[firstChunk][0]) || 0;
                    that.selectpicker.view.position1 = isVirtual === false ? size : Math.min(size, chunks[lastChunk][1]) || 0;
                    positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;
                    if (that.activeIndex !== undefined) {
                        prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
                        active = that.selectpicker.main.elements[that.activeIndex];
                        selected = that.selectpicker.main.elements[that.selectedIndex];
                        if (init) {
                            if (that.activeIndex !== that.selectedIndex) that.defocusItem(active);
                            that.activeIndex = undefined;
                        }
                        if (that.activeIndex && that.activeIndex !== that.selectedIndex) that.defocusItem(selected);
                    }
                    if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) that.defocusItem(prevActive);
                    if (init || positionIsDifferent) {
                        previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];
                        if (isVirtual === false) that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
                        else that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
                        that.setOptionStatus();
                        // if searching, check to make sure the list has actually been updated before updating DOM
                        // this prevents unnecessary repaints
                        if (isSearching || isVirtual === false && init) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);
                        // if virtual scroll is disabled and not searching,
                        // menu should never need to be updated more than once
                        if ((init || isVirtual === true) && menuIsDifferent) {
                            var menuInner = that.$menuInner[0], menuFragment = document.createDocumentFragment(), emptyMenu = menuInner.firstChild.cloneNode(false), marginTop, marginBottom, elements = that.selectpicker.view.visibleElements, toSanitize = [];
                            // replace the existing UL with an empty one - this is faster than $.empty()
                            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
                            for(var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++){
                                var element = elements[i], elText, elementData;
                                if (that.options.sanitize) {
                                    elText = element.lastChild;
                                    if (elText) {
                                        elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];
                                        if (elementData && elementData.content && !elementData.sanitized) {
                                            toSanitize.push(elText);
                                            elementData.sanitized = true;
                                        }
                                    }
                                }
                                menuFragment.appendChild(element);
                            }
                            if (that.options.sanitize && toSanitize.length) sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
                            if (isVirtual === true) {
                                marginTop = that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position;
                                marginBottom = that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position;
                                menuInner.firstChild.style.marginTop = marginTop + "px";
                                menuInner.firstChild.style.marginBottom = marginBottom + "px";
                            } else {
                                menuInner.firstChild.style.marginTop = 0;
                                menuInner.firstChild.style.marginBottom = 0;
                            }
                            menuInner.firstChild.appendChild(menuFragment);
                            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
                            // switch to ResizeObserver with increased browser support
                            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
                                var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;
                                if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
                                    // set to 0 to get actual width of menu
                                    that.$menu[0].style.minWidth = 0;
                                    var actualMenuWidth = menuInner.firstChild.offsetWidth;
                                    if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
                                        that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
                                        menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + "px";
                                    }
                                    // reset to default CSS styling
                                    that.$menu[0].style.minWidth = "";
                                }
                            }
                        }
                    }
                    that.prevActiveIndex = that.activeIndex;
                    if (!that.options.liveSearch) that.$menuInner.trigger("focus");
                    else if (isSearching && init) {
                        var index = 0, newActive;
                        if (!that.selectpicker.view.canHighlight[index]) index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
                        newActive = that.selectpicker.view.visibleElements[index];
                        that.defocusItem(that.selectpicker.view.currentActive);
                        that.activeIndex = (that.selectpicker.current.data[index] || {}).index;
                        that.focusItem(newActive);
                    }
                }
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + ".createView").on("resize" + EVENT_KEY + "." + this.selectId + ".createView", function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) scroll(that.$menuInner[0].scrollTop);
                });
            },
            focusItem: function focusItem(li, liData, noStyle) {
                if (li) {
                    liData = liData || this.selectpicker.main.data[this.activeIndex];
                    var a = li.firstChild;
                    if (a) {
                        a.setAttribute("aria-setsize", this.selectpicker.view.size);
                        a.setAttribute("aria-posinset", liData.posinset);
                        if (noStyle !== true) {
                            this.focusedParent.setAttribute("aria-activedescendant", a.id);
                            li.classList.add("active");
                            a.classList.add("active");
                        }
                    }
                }
            },
            defocusItem: function defocusItem(li) {
                if (li) {
                    li.classList.remove("active");
                    if (li.firstChild) li.firstChild.classList.remove("active");
                }
            },
            setPlaceholder: function setPlaceholder() {
                var that = this, updateIndex = false;
                if (this.options.title && !this.multiple) {
                    if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement("option");
                    // this option doesn't create a new <li> element, but does add a new option at the start,
                    // so startIndex should increase to prevent having to check every option for the bs-title-option class
                    updateIndex = true;
                    var element = this.$element[0], selectTitleOption = false, titleNotAppended = !this.selectpicker.view.titleOption.parentNode, selectedIndex = element.selectedIndex, selectedOption = element.options[selectedIndex], navigation = window.performance && window.performance.getEntriesByType("navigation"), // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
                    isNotBackForward = navigation && navigation.length ? navigation[0].type !== "back_forward" : window.performance.navigation.type !== 2;
                    if (titleNotAppended) {
                        // Use native JS to prepend option (faster)
                        this.selectpicker.view.titleOption.className = "bs-title-option";
                        this.selectpicker.view.titleOption.value = "";
                        // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
                        // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
                        // if so, the select will have the data-selected attribute
                        selectTitleOption = !selectedOption || selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data("selected") === undefined;
                    }
                    if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
                    // Set selected *after* appending to select,
                    // otherwise the option doesn't get selected in IE
                    // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
                    if (selectTitleOption && isNotBackForward) element.selectedIndex = 0;
                    else if (document.readyState !== "complete") // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
                    // wait for that value to be set, then run render again
                    window.addEventListener("pageshow", function() {
                        if (that.selectpicker.view.displayedValue !== element.value) that.render();
                    });
                }
                return updateIndex;
            },
            buildData: function buildData() {
                var optionSelector = ':not([hidden]):not([data-hidden="true"])', mainData = [], optID = 0, startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop
                if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                var selectOptions = this.$element[0].querySelectorAll("select > *" + optionSelector);
                function addDivider(config) {
                    var previousData = mainData[mainData.length - 1];
                    // ensure optgroup doesn't create back-to-back dividers
                    if (previousData && previousData.type === "divider" && (previousData.optID || config.optID)) return;
                    config = config || {};
                    config.type = "divider";
                    mainData.push(config);
                }
                function addOption(option, config) {
                    config = config || {};
                    config.divider = option.getAttribute("data-divider") === "true";
                    if (config.divider) addDivider({
                        optID: config.optID
                    });
                    else {
                        var liIndex = mainData.length, cssText = option.style.cssText, inlineStyle = cssText ? htmlEscape(cssText) : "", optionClass = (option.className || "") + (config.optgroupClass || "");
                        if (config.optID) optionClass = "opt " + optionClass;
                        config.optionClass = optionClass.trim();
                        config.inlineStyle = inlineStyle;
                        config.text = option.textContent;
                        config.content = option.getAttribute("data-content");
                        config.tokens = option.getAttribute("data-tokens");
                        config.subtext = option.getAttribute("data-subtext");
                        config.icon = option.getAttribute("data-icon");
                        option.liIndex = liIndex;
                        config.display = config.content || config.text;
                        config.type = "option";
                        config.index = liIndex;
                        config.option = option;
                        config.selected = !!option.selected;
                        config.disabled = config.disabled || !!option.disabled;
                        mainData.push(config);
                    }
                }
                function addOptgroup(index, selectOptions) {
                    var optgroup = selectOptions[index], // skip placeholder option
                    previous = index - 1 < startIndex ? false : selectOptions[index - 1], next = selectOptions[index + 1], options = optgroup.querySelectorAll("option" + optionSelector);
                    if (!options.length) return;
                    var config = {
                        display: htmlEscape(optgroup.label),
                        subtext: optgroup.getAttribute("data-subtext"),
                        icon: optgroup.getAttribute("data-icon"),
                        type: "optgroup-label",
                        optgroupClass: " " + (optgroup.className || "")
                    }, headerIndex, lastIndex;
                    optID++;
                    if (previous) addDivider({
                        optID: optID
                    });
                    config.optID = optID;
                    mainData.push(config);
                    for(var j = 0, len = options.length; j < len; j++){
                        var option = options[j];
                        if (j === 0) {
                            headerIndex = mainData.length - 1;
                            lastIndex = headerIndex + len;
                        }
                        addOption(option, {
                            headerIndex: headerIndex,
                            lastIndex: lastIndex,
                            optID: config.optID,
                            optgroupClass: config.optgroupClass,
                            disabled: optgroup.disabled
                        });
                    }
                    if (next) addDivider({
                        optID: optID
                    });
                }
                for(var len = selectOptions.length, i = startIndex; i < len; i++){
                    var item = selectOptions[i];
                    if (item.tagName !== "OPTGROUP") addOption(item, {});
                    else addOptgroup(i, selectOptions);
                }
                this.selectpicker.main.data = this.selectpicker.current.data = mainData;
            },
            buildList: function buildList() {
                var that = this, selectData = this.selectpicker.main.data, mainElements = [], widestOptionLength = 0;
                if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
                    elementTemplates.checkMark.className = this.options.iconBase + " " + that.options.tickIcon + " check-mark";
                    elementTemplates.a.appendChild(elementTemplates.checkMark);
                }
                function buildElement(item) {
                    var liElement, combinedLength = 0;
                    switch(item.type){
                        case "divider":
                            liElement = generateOption.li(false, classNames.DIVIDER, item.optID ? item.optID + "div" : undefined);
                            break;
                        case "option":
                            liElement = generateOption.li(generateOption.a(generateOption.text.call(that, item), item.optionClass, item.inlineStyle), "", item.optID);
                            if (liElement.firstChild) liElement.firstChild.id = that.selectId + "-" + item.index;
                            break;
                        case "optgroup-label":
                            liElement = generateOption.li(generateOption.label.call(that, item), "dropdown-header" + item.optgroupClass, item.optID);
                            break;
                    }
                    item.element = liElement;
                    mainElements.push(liElement);
                    // count the number of characters in the option - not perfect, but should work in most cases
                    if (item.display) combinedLength += item.display.length;
                    if (item.subtext) combinedLength += item.subtext.length;
                    // if there is an icon, ensure this option's width is checked
                    if (item.icon) combinedLength += 1;
                    if (combinedLength > widestOptionLength) {
                        widestOptionLength = combinedLength;
                        // guess which option is the widest
                        // use this when calculating menu width
                        // not perfect, but it's fast, and the width will be updating accordingly when scrolling
                        that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
                    }
                }
                for(var len = selectData.length, i = 0; i < len; i++){
                    var item = selectData[i];
                    buildElement(item);
                }
                this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
            },
            findLis: function findLis() {
                return this.$menuInner.find(".inner > li");
            },
            render: function render() {
                var that = this, element = this.$element[0], // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
                placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0, selectedOptions = getSelectedOptions(element, this.options.hideDisabled), selectedCount = selectedOptions.length, button = this.$button[0], buttonInner = button.querySelector(".filter-option-inner-inner"), multipleSeparator = document.createTextNode(this.options.multipleSeparator), titleFragment = elementTemplates.fragment.cloneNode(false), showCount, countMax, hasContent = false;
                button.classList.toggle("bs-placeholder", that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));
                if (!that.multiple && selectedOptions.length === 1) that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
                if (this.options.selectedTextFormat === "static") titleFragment = generateOption.text.call(this, {
                    text: this.options.title
                }, true);
                else {
                    showCount = this.multiple && this.options.selectedTextFormat.indexOf("count") !== -1 && selectedCount > 1;
                    // determine if the number of selected options will be shown (showCount === true)
                    if (showCount) {
                        countMax = this.options.selectedTextFormat.split(">");
                        showCount = countMax.length > 1 && selectedCount > countMax[1] || countMax.length === 1 && selectedCount >= 2;
                    }
                    // only loop through all selected options if the count won't be shown
                    if (showCount === false) {
                        if (!placeholderSelected) {
                            for(var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++){
                                if (selectedIndex < 50) {
                                    var option = selectedOptions[selectedIndex], thisData = this.selectpicker.main.data[option.liIndex], titleOptions = {};
                                    if (this.multiple && selectedIndex > 0) titleFragment.appendChild(multipleSeparator.cloneNode(false));
                                    if (option.title) titleOptions.text = option.title;
                                    else if (thisData) {
                                        if (thisData.content && that.options.showContent) {
                                            titleOptions.content = thisData.content.toString();
                                            hasContent = true;
                                        } else {
                                            if (that.options.showIcon) titleOptions.icon = thisData.icon;
                                            if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = " " + thisData.subtext;
                                            titleOptions.text = option.textContent.trim();
                                        }
                                    }
                                    titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
                                } else break;
                            }
                            // add ellipsis
                            if (selectedCount > 49) titleFragment.appendChild(document.createTextNode("..."));
                        }
                    } else {
                        var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
                        if (this.options.hideDisabled) optionSelector += ":not(:disabled)";
                        // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
                        var totalCount = this.$element[0].querySelectorAll("select > option" + optionSelector + ", optgroup" + optionSelector + " option" + optionSelector).length, tr8nText = typeof this.options.countSelectedText === "function" ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;
                        titleFragment = generateOption.text.call(this, {
                            text: tr8nText.replace("{0}", selectedCount.toString()).replace("{1}", totalCount.toString())
                        }, true);
                    }
                }
                if (this.options.title == undefined) // use .attr to ensure undefined is returned if title attribute is not set
                this.options.title = this.$element.attr("title");
                // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
                if (!titleFragment.childNodes.length) titleFragment = generateOption.text.call(this, {
                    text: typeof this.options.title !== "undefined" ? this.options.title : this.options.noneSelectedText
                }, true);
                // strip all HTML tags and trim the result, then unescape any escaped tags
                button.title = titleFragment.textContent.replace(/<[^>]*>?/g, "").trim();
                if (this.options.sanitize && hasContent) sanitizeHtml([
                    titleFragment
                ], that.options.whiteList, that.options.sanitizeFn);
                buttonInner.innerHTML = "";
                buttonInner.appendChild(titleFragment);
                if (version.major < 4 && this.$newElement[0].classList.contains("bs3-has-addon")) {
                    var filterExpand = button.querySelector(".filter-expand"), clone = buttonInner.cloneNode(true);
                    clone.className = "filter-expand";
                    if (filterExpand) button.replaceChild(clone, filterExpand);
                    else button.appendChild(clone);
                }
                this.$element.trigger("rendered" + EVENT_KEY);
            },
            /**
     * @param [style]
     * @param [status]
     */ setStyle: function setStyle(newStyle, status) {
                var button = this.$button[0], newElement = this.$newElement[0], style = this.options.style.trim(), buttonClass;
                if (this.$element.attr("class")) this.$newElement.addClass(this.$element.attr("class").replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ""));
                if (version.major < 4) {
                    newElement.classList.add("bs3");
                    if (newElement.parentNode.classList && newElement.parentNode.classList.contains("input-group") && (newElement.previousElementSibling || newElement.nextElementSibling) && (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains("input-group-addon")) newElement.classList.add("bs3-has-addon");
                }
                if (newStyle) buttonClass = newStyle.trim();
                else buttonClass = style;
                if (status == "add") {
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                } else if (status == "remove") {
                    if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(" "));
                } else {
                    if (style) button.classList.remove.apply(button.classList, style.split(" "));
                    if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(" "));
                }
            },
            liHeight: function liHeight(refresh) {
                if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;
                var newElement = elementTemplates.div.cloneNode(false), menu = elementTemplates.div.cloneNode(false), menuInner = elementTemplates.div.cloneNode(false), menuInnerInner = document.createElement("ul"), divider = elementTemplates.li.cloneNode(false), dropdownHeader = elementTemplates.li.cloneNode(false), li, a = elementTemplates.a.cloneNode(false), text = elementTemplates.span.cloneNode(false), header = this.options.header && this.$menu.find("." + classNames.POPOVERHEADER).length > 0 ? this.$menu.find("." + classNames.POPOVERHEADER)[0].cloneNode(true) : null, search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null, actions = this.options.actionsBox && this.multiple && this.$menu.find(".bs-actionsbox").length > 0 ? this.$menu.find(".bs-actionsbox")[0].cloneNode(true) : null, doneButton = this.options.doneButton && this.multiple && this.$menu.find(".bs-donebutton").length > 0 ? this.$menu.find(".bs-donebutton")[0].cloneNode(true) : null, firstOption = this.$element.find("option")[0];
                this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;
                text.className = "text";
                a.className = "dropdown-item " + (firstOption ? firstOption.className : "");
                newElement.className = this.$menu[0].parentNode.className + " " + classNames.SHOW;
                newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
                if (this.options.width === "auto") menu.style.minWidth = 0;
                menu.className = classNames.MENU + " " + classNames.SHOW;
                menuInner.className = "inner " + classNames.SHOW;
                menuInnerInner.className = classNames.MENU + " inner " + (version.major === "4" ? classNames.SHOW : "");
                divider.className = classNames.DIVIDER;
                dropdownHeader.className = "dropdown-header";
                text.appendChild(document.createTextNode("\u200B"));
                if (this.selectpicker.current.data.length) for(var i = 0; i < this.selectpicker.current.data.length; i++){
                    var data = this.selectpicker.current.data[i];
                    if (data.type === "option") {
                        li = data.element;
                        break;
                    }
                }
                else {
                    li = elementTemplates.li.cloneNode(false);
                    a.appendChild(text);
                    li.appendChild(a);
                }
                dropdownHeader.appendChild(text.cloneNode(true));
                if (this.selectpicker.view.widestOption) menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
                menuInnerInner.appendChild(li);
                menuInnerInner.appendChild(divider);
                menuInnerInner.appendChild(dropdownHeader);
                if (header) menu.appendChild(header);
                if (search) {
                    var input = document.createElement("input");
                    search.className = "bs-searchbox";
                    input.className = "form-control";
                    search.appendChild(input);
                    menu.appendChild(search);
                }
                if (actions) menu.appendChild(actions);
                menuInner.appendChild(menuInnerInner);
                menu.appendChild(menuInner);
                if (doneButton) menu.appendChild(doneButton);
                newElement.appendChild(menu);
                document.body.appendChild(newElement);
                var liHeight = li.offsetHeight, dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0, headerHeight = header ? header.offsetHeight : 0, searchHeight = search ? search.offsetHeight : 0, actionsHeight = actions ? actions.offsetHeight : 0, doneButtonHeight = doneButton ? doneButton.offsetHeight : 0, dividerHeight = $(divider).outerHeight(true), // fall back to jQuery if getComputedStyle is not supported
                menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false, menuWidth = menu.offsetWidth, $menu = menuStyle ? null : $(menu), menuPadding = {
                    vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css("paddingTop")) + toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css("paddingBottom")) + toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css("borderTopWidth")) + toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css("borderBottomWidth")),
                    horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css("paddingLeft")) + toInteger(menuStyle ? menuStyle.paddingRight : $menu.css("paddingRight")) + toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css("borderLeftWidth")) + toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css("borderRightWidth"))
                }, menuExtras = {
                    vert: menuPadding.vert + toInteger(menuStyle ? menuStyle.marginTop : $menu.css("marginTop")) + toInteger(menuStyle ? menuStyle.marginBottom : $menu.css("marginBottom")) + 2,
                    horiz: menuPadding.horiz + toInteger(menuStyle ? menuStyle.marginLeft : $menu.css("marginLeft")) + toInteger(menuStyle ? menuStyle.marginRight : $menu.css("marginRight")) + 2
                }, scrollBarWidth;
                menuInner.style.overflowY = "scroll";
                scrollBarWidth = menu.offsetWidth - menuWidth;
                document.body.removeChild(newElement);
                this.sizeInfo.liHeight = liHeight;
                this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
                this.sizeInfo.headerHeight = headerHeight;
                this.sizeInfo.searchHeight = searchHeight;
                this.sizeInfo.actionsHeight = actionsHeight;
                this.sizeInfo.doneButtonHeight = doneButtonHeight;
                this.sizeInfo.dividerHeight = dividerHeight;
                this.sizeInfo.menuPadding = menuPadding;
                this.sizeInfo.menuExtras = menuExtras;
                this.sizeInfo.menuWidth = menuWidth;
                this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
                this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
                this.sizeInfo.scrollBarWidth = scrollBarWidth;
                this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;
                this.setPositionData();
            },
            getSelectPosition: function getSelectPosition() {
                var that = this, $window = $(window), pos = that.$newElement.offset(), $container = $(that.options.container), containerPos;
                if (that.options.container && $container.length && !$container.is("body")) {
                    containerPos = $container.offset();
                    containerPos.top += parseInt($container.css("borderTopWidth"));
                    containerPos.left += parseInt($container.css("borderLeftWidth"));
                } else containerPos = {
                    top: 0,
                    left: 0
                };
                var winPad = that.options.windowPadding;
                this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
                this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
                this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
                this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
                this.sizeInfo.selectOffsetTop -= winPad[0];
                this.sizeInfo.selectOffsetLeft -= winPad[3];
            },
            setMenuSize: function setMenuSize(isAuto) {
                this.getSelectPosition();
                var selectWidth = this.sizeInfo.selectWidth, liHeight = this.sizeInfo.liHeight, headerHeight = this.sizeInfo.headerHeight, searchHeight = this.sizeInfo.searchHeight, actionsHeight = this.sizeInfo.actionsHeight, doneButtonHeight = this.sizeInfo.doneButtonHeight, divHeight = this.sizeInfo.dividerHeight, menuPadding = this.sizeInfo.menuPadding, menuInnerHeight, menuHeight, divLength = 0, minHeight, _minHeight, maxHeight, menuInnerMinHeight, estimate, isDropup;
                if (this.options.dropupAuto) {
                    // Get the estimated height of the menu without scrollbars.
                    // This is useful for smaller menus, where there might be plenty of room
                    // below the button without setting dropup, but we can't know
                    // the exact height of the menu until createView is called later
                    estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;
                    isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;
                    // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
                    if (this.selectpicker.isSearching === true) isDropup = this.selectpicker.dropup;
                    this.$newElement.toggleClass(classNames.DROPUP, isDropup);
                    this.selectpicker.dropup = isDropup;
                }
                if (this.options.size === "auto") {
                    _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
                    menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
                    minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);
                    if (this.$newElement.hasClass(classNames.DROPUP)) menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
                    maxHeight = menuHeight;
                    menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
                } else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) {
                    for(var i = 0; i < this.options.size; i++)if (this.selectpicker.current.data[i].type === "divider") divLength++;
                    menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
                    menuInnerHeight = menuHeight - menuPadding.vert;
                    maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
                    minHeight = menuInnerMinHeight = "";
                }
                this.$menu.css({
                    "max-height": maxHeight + "px",
                    overflow: "hidden",
                    "min-height": minHeight + "px"
                });
                this.$menuInner.css({
                    "max-height": menuInnerHeight + "px",
                    "overflow-y": "auto",
                    "min-height": menuInnerMinHeight + "px"
                });
                // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
                this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);
                if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
                    this.sizeInfo.hasScrollBar = true;
                    this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
                }
                if (this.options.dropdownAlignRight === "auto") this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.sizeInfo.totalMenuWidth - selectWidth);
                if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
            },
            setSize: function setSize(refresh) {
                this.liHeight(refresh);
                if (this.options.header) this.$menu.css("padding-top", 0);
                if (this.options.size !== false) {
                    var that = this, $window = $(window);
                    this.setMenuSize();
                    if (this.options.liveSearch) this.$searchbox.off("input.setMenuSize propertychange.setMenuSize").on("input.setMenuSize propertychange.setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    if (this.options.size === "auto") $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize").on("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize", function() {
                        return that.setMenuSize();
                    });
                    else if (this.options.size && this.options.size != "auto" && this.selectpicker.current.elements.length > this.options.size) $window.off("resize" + EVENT_KEY + "." + this.selectId + ".setMenuSize" + " scroll" + EVENT_KEY + "." + this.selectId + ".setMenuSize");
                }
                this.createView(false, true, refresh);
            },
            setWidth: function setWidth() {
                var that = this;
                if (this.options.width === "auto") requestAnimationFrame(function() {
                    that.$menu.css("min-width", "0");
                    that.$element.on("loaded" + EVENT_KEY, function() {
                        that.liHeight();
                        that.setMenuSize();
                        // Get correct width if element is hidden
                        var $selectClone = that.$newElement.clone().appendTo("body"), btnWidth = $selectClone.css("width", "auto").children("button").outerWidth();
                        $selectClone.remove();
                        // Set width to whatever's larger, button title or longest option
                        that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
                        that.$newElement.css("width", that.sizeInfo.selectWidth + "px");
                    });
                });
                else if (this.options.width === "fit") {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "").addClass("fit-width");
                } else if (this.options.width) {
                    // Remove inline min-width so width can be changed from 'auto'
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", this.options.width);
                } else {
                    // Remove inline min-width/width so width can be changed
                    this.$menu.css("min-width", "");
                    this.$newElement.css("width", "");
                }
                // Remove fit-width class if width is changed programmatically
                if (this.$newElement.hasClass("fit-width") && this.options.width !== "fit") this.$newElement[0].classList.remove("fit-width");
            },
            selectPosition: function selectPosition() {
                this.$bsContainer = $('<div class="bs-container" />');
                var that = this, $container = $(this.options.container), pos, containerPos, actualHeight, getPlacement = function getPlacement($element) {
                    var containerPosition = {}, // fall back to dropdown's default display setting if display is not manually set
                    display = that.options.display || // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
                    ($.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display : false);
                    that.$bsContainer.addClass($element.attr("class").replace(/form-control|fit-width/gi, "")).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
                    pos = $element.offset();
                    if (!$container.is("body")) {
                        containerPos = $container.offset();
                        containerPos.top += parseInt($container.css("borderTopWidth")) - $container.scrollTop();
                        containerPos.left += parseInt($container.css("borderLeftWidth")) - $container.scrollLeft();
                    } else containerPos = {
                        top: 0,
                        left: 0
                    };
                    actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;
                    // Bootstrap 4+ uses Popper for menu positioning
                    if (version.major < 4 || display === "static") {
                        containerPosition.top = pos.top - containerPos.top + actualHeight;
                        containerPosition.left = pos.left - containerPos.left;
                    }
                    containerPosition.width = $element[0].offsetWidth;
                    that.$bsContainer.css(containerPosition);
                };
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (that.isDisabled()) return;
                    getPlacement(that.$newElement);
                    that.$bsContainer.appendTo(that.options.container).toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW)).append(that.$menu);
                });
                $(window).off("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId).on("resize" + EVENT_KEY + "." + this.selectId + " scroll" + EVENT_KEY + "." + this.selectId, function() {
                    var isActive = that.$newElement.hasClass(classNames.SHOW);
                    if (isActive) getPlacement(that.$newElement);
                });
                this.$element.on("hide" + EVENT_KEY, function() {
                    that.$menu.data("height", that.$menu.height());
                    that.$bsContainer.detach();
                });
            },
            setOptionStatus: function setOptionStatus(selectedOnly) {
                var that = this;
                that.noScroll = false;
                if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) for(var i = 0; i < that.selectpicker.view.visibleElements.length; i++){
                    var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0], option = liData.option;
                    if (option) {
                        if (selectedOnly !== true) that.setDisabled(liData.index, liData.disabled);
                        that.setSelected(liData.index, option.selected);
                    }
                }
            },
            /**
     * @param {number} index - the index of the option that is being changed
     * @param {boolean} selected - true if the option is being selected, false if being deselected
     */ setSelected: function setSelected(index, selected) {
                var li = this.selectpicker.main.elements[index], liData = this.selectpicker.main.data[index], activeIndexIsSet = this.activeIndex !== undefined, thisIsActive = this.activeIndex === index, prevActive, a, // if current option is already active
                // OR
                // if the current option is being selected, it's NOT multiple, and
                // activeIndex is undefined:
                //  - when the menu is first being opened, OR
                //  - after a search has been performed, OR
                //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
                keepActive = thisIsActive || selected && !this.multiple && !activeIndexIsSet;
                liData.selected = selected;
                a = li.firstChild;
                if (selected) this.selectedIndex = index;
                li.classList.toggle("selected", selected);
                if (keepActive) {
                    this.focusItem(li, liData);
                    this.selectpicker.view.currentActive = li;
                    this.activeIndex = index;
                } else this.defocusItem(li);
                if (a) {
                    a.classList.toggle("selected", selected);
                    if (selected) a.setAttribute("aria-selected", true);
                    else if (this.multiple) a.setAttribute("aria-selected", false);
                    else a.removeAttribute("aria-selected");
                }
                if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
                    prevActive = this.selectpicker.main.elements[this.prevActiveIndex];
                    this.defocusItem(prevActive);
                }
            },
            /**
     * @param {number} index - the index of the option that is being disabled
     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
     */ setDisabled: function setDisabled(index, disabled) {
                var li = this.selectpicker.main.elements[index], a;
                this.selectpicker.main.data[index].disabled = disabled;
                a = li.firstChild;
                li.classList.toggle(classNames.DISABLED, disabled);
                if (a) {
                    if (version.major === "4") a.classList.toggle(classNames.DISABLED, disabled);
                    if (disabled) {
                        a.setAttribute("aria-disabled", disabled);
                        a.setAttribute("tabindex", -1);
                    } else {
                        a.removeAttribute("aria-disabled");
                        a.setAttribute("tabindex", 0);
                    }
                }
            },
            isDisabled: function isDisabled() {
                return this.$element[0].disabled;
            },
            checkDisabled: function checkDisabled() {
                if (this.isDisabled()) {
                    this.$newElement[0].classList.add(classNames.DISABLED);
                    this.$button.addClass(classNames.DISABLED).attr("aria-disabled", true);
                } else if (this.$button[0].classList.contains(classNames.DISABLED)) {
                    this.$newElement[0].classList.remove(classNames.DISABLED);
                    this.$button.removeClass(classNames.DISABLED).attr("aria-disabled", false);
                }
            },
            clickListener: function clickListener() {
                var that = this, $document = $(document);
                $document.data("spaceSelect", false);
                this.$button.on("keyup", function(e) {
                    if (/(32)/.test(e.keyCode.toString(10)) && $document.data("spaceSelect")) {
                        e.preventDefault();
                        $document.data("spaceSelect", false);
                    }
                });
                this.$newElement.on("show.bs.dropdown", function() {
                    if (version.major > 3 && !that.dropdown) {
                        that.dropdown = that.$button.data("bs.dropdown");
                        that.dropdown._menu = that.$menu[0];
                    }
                });
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!that.$newElement.hasClass(classNames.SHOW)) that.setSize();
                });
                function setFocus() {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$menuInner.trigger("focus");
                }
                function checkPopperExists() {
                    if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) setFocus();
                    else requestAnimationFrame(checkPopperExists);
                }
                this.$element.on("shown" + EVENT_KEY, function() {
                    if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
                    if (version.major > 3) requestAnimationFrame(checkPopperExists);
                    else setFocus();
                });
                // ensure posinset and setsize are correct before selecting an option via a click
                this.$menuInner.on("mouseenter", "li a", function(e) {
                    var hoverLi = this.parentElement, position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi), hoverData = that.selectpicker.current.data[index + position0];
                    that.focusItem(hoverLi, hoverData, true);
                });
                this.$menuInner.on("click", "li a", function(e, retainActive) {
                    var $this = $(this), element = that.$element[0], position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0, clickedData = that.selectpicker.current.data[$this.parent().index() + position0], clickedIndex = clickedData.index, prevValue = getSelectValues(element), prevIndex = element.selectedIndex, prevOption = element.options[prevIndex], triggerChange = true;
                    // Don't close on multi choice menu
                    if (that.multiple && that.options.maxOptions !== 1) e.stopPropagation();
                    e.preventDefault();
                    // Don't run if the select is disabled
                    if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
                        var option = clickedData.option, $option = $(option), state = option.selected, $optgroup = $option.parent("optgroup"), $optgroupOptions = $optgroup.find("option"), maxOptions = that.options.maxOptions, maxOptionsGrp = $optgroup.data("maxOptions") || false;
                        if (clickedIndex === that.activeIndex) retainActive = true;
                        if (!retainActive) {
                            that.prevActiveIndex = that.activeIndex;
                            that.activeIndex = undefined;
                        }
                        if (!that.multiple) {
                            if (prevOption) prevOption.selected = false;
                            option.selected = true;
                            that.setSelected(clickedIndex, true);
                        } else {
                            option.selected = !state;
                            that.setSelected(clickedIndex, !state);
                            that.focusedParent.focus();
                            if (maxOptions !== false || maxOptionsGrp !== false) {
                                var maxReached = maxOptions < getSelectedOptions(element).length, maxReachedGrp = maxOptionsGrp < $optgroup.find("option:selected").length;
                                if (maxOptions && maxReached || maxOptionsGrp && maxReachedGrp) {
                                    if (maxOptions && maxOptions == 1) {
                                        element.selectedIndex = -1;
                                        option.selected = true;
                                        that.setOptionStatus(true);
                                    } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                                        for(var i = 0; i < $optgroupOptions.length; i++){
                                            var _option = $optgroupOptions[i];
                                            _option.selected = false;
                                            that.setSelected(_option.liIndex, false);
                                        }
                                        option.selected = true;
                                        that.setSelected(clickedIndex, true);
                                    } else {
                                        var maxOptionsText = typeof that.options.maxOptionsText === "string" ? [
                                            that.options.maxOptionsText,
                                            that.options.maxOptionsText
                                        ] : that.options.maxOptionsText, maxOptionsArr = typeof maxOptionsText === "function" ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText, maxTxt = maxOptionsArr[0].replace("{n}", maxOptions), maxTxtGrp = maxOptionsArr[1].replace("{n}", maxOptionsGrp), $notify = $('<div class="notify"></div>');
                                        // If {var} is set in array, replace it
                                        /** @deprecated */ if (maxOptionsArr[2]) {
                                            maxTxt = maxTxt.replace("{var}", maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                                            maxTxtGrp = maxTxtGrp.replace("{var}", maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                                        }
                                        option.selected = false;
                                        that.$menu.append($notify);
                                        if (maxOptions && maxReached) {
                                            $notify.append($("<div>" + maxTxt + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReached" + EVENT_KEY);
                                        }
                                        if (maxOptionsGrp && maxReachedGrp) {
                                            $notify.append($("<div>" + maxTxtGrp + "</div>"));
                                            triggerChange = false;
                                            that.$element.trigger("maxReachedGrp" + EVENT_KEY);
                                        }
                                        setTimeout(function() {
                                            that.setSelected(clickedIndex, false);
                                        }, 10);
                                        $notify[0].classList.add("fadeOut");
                                        setTimeout(function() {
                                            $notify.remove();
                                        }, 1050);
                                    }
                                }
                            }
                        }
                        if (!that.multiple || that.multiple && that.options.maxOptions === 1) that.$button.trigger("focus");
                        else if (that.options.liveSearch) that.$searchbox.trigger("focus");
                        // Trigger select 'change'
                        if (triggerChange) {
                            if (that.multiple || prevIndex !== element.selectedIndex) {
                                // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
                                changedArguments = [
                                    option.index,
                                    $option.prop("selected"),
                                    prevValue
                                ];
                                that.$element.triggerNative("change");
                            }
                        }
                    }
                });
                this.$menu.on("click", "li." + classNames.DISABLED + " a, ." + classNames.POPOVERHEADER + ", ." + classNames.POPOVERHEADER + " :not(.close)", function(e) {
                    if (e.currentTarget == this) {
                        e.preventDefault();
                        e.stopPropagation();
                        if (that.options.liveSearch && !$(e.target).hasClass("close")) that.$searchbox.trigger("focus");
                        else that.$button.trigger("focus");
                    }
                });
                this.$menuInner.on("click", ".divider, .dropdown-header", function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                });
                this.$menu.on("click", "." + classNames.POPOVERHEADER + " .close", function() {
                    that.$button.trigger("click");
                });
                this.$searchbox.on("click", function(e) {
                    e.stopPropagation();
                });
                this.$menu.on("click", ".actions-btn", function(e) {
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else that.$button.trigger("focus");
                    e.preventDefault();
                    e.stopPropagation();
                    if ($(this).hasClass("bs-select-all")) that.selectAll();
                    else that.deselectAll();
                });
                this.$button.on("focus" + EVENT_KEY, function(e) {
                    var tabindex = that.$element[0].getAttribute("tabindex");
                    // only change when button is actually focused
                    if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
                        this.setAttribute("tabindex", tabindex);
                        // set element's tabindex to -1 to allow for reverse tabbing
                        that.$element[0].setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = tabindex;
                    }
                }).on("blur" + EVENT_KEY, function(e) {
                    // revert everything to original tabindex
                    if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
                        that.$element[0].setAttribute("tabindex", that.selectpicker.view.tabindex);
                        this.setAttribute("tabindex", -1);
                        that.selectpicker.view.tabindex = undefined;
                    }
                });
                this.$element.on("change" + EVENT_KEY, function() {
                    that.render();
                    that.$element.trigger("changed" + EVENT_KEY, changedArguments);
                    changedArguments = null;
                }).on("focus" + EVENT_KEY, function() {
                    if (!that.options.mobile) that.$button[0].focus();
                });
            },
            liveSearchListener: function liveSearchListener() {
                var that = this;
                this.$button.on("click.bs.dropdown.data-api", function() {
                    if (!!that.$searchbox.val()) {
                        that.$searchbox.val("");
                        that.selectpicker.search.previousValue = undefined;
                    }
                });
                this.$searchbox.on("click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api", function(e) {
                    e.stopPropagation();
                });
                this.$searchbox.on("input propertychange", function() {
                    var searchValue = that.$searchbox[0].value;
                    that.selectpicker.search.elements = [];
                    that.selectpicker.search.data = [];
                    if (searchValue) {
                        var i, searchMatch = [], q = searchValue.toUpperCase(), cache = {}, cacheArr = [], searchStyle = that._searchStyle(), normalizeSearch = that.options.liveSearchNormalize;
                        if (normalizeSearch) q = normalizeToBase(q);
                        for(var i = 0; i < that.selectpicker.main.data.length; i++){
                            var li = that.selectpicker.main.data[i];
                            if (!cache[i]) cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
                            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
                                if (li.headerIndex > 0) {
                                    cache[li.headerIndex - 1] = true;
                                    cacheArr.push(li.headerIndex - 1);
                                }
                                cache[li.headerIndex] = true;
                                cacheArr.push(li.headerIndex);
                                cache[li.lastIndex + 1] = true;
                            }
                            if (cache[i] && li.type !== "optgroup-label") cacheArr.push(i);
                        }
                        for(var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++){
                            var index = cacheArr[i], prevIndex = cacheArr[i - 1], li = that.selectpicker.main.data[index], liPrev = that.selectpicker.main.data[prevIndex];
                            if (li.type !== "divider" || li.type === "divider" && liPrev && liPrev.type !== "divider" && cacheLen - 1 !== i) {
                                that.selectpicker.search.data.push(li);
                                searchMatch.push(that.selectpicker.main.elements[index]);
                            }
                        }
                        that.activeIndex = undefined;
                        that.noScroll = true;
                        that.$menuInner.scrollTop(0);
                        that.selectpicker.search.elements = searchMatch;
                        that.createView(true);
                        showNoResults.call(that, searchMatch, searchValue);
                    } else if (that.selectpicker.search.previousValue) {
                        that.$menuInner.scrollTop(0);
                        that.createView(false);
                    }
                    that.selectpicker.search.previousValue = searchValue;
                });
            },
            _searchStyle: function _searchStyle() {
                return this.options.liveSearchStyle || "contains";
            },
            val: function val(value) {
                var element = this.$element[0];
                if (typeof value !== "undefined") {
                    var prevValue = getSelectValues(element);
                    changedArguments = [
                        null,
                        null,
                        prevValue
                    ];
                    this.$element.val(value).trigger("changed" + EVENT_KEY, changedArguments);
                    if (this.$newElement.hasClass(classNames.SHOW)) {
                        if (this.multiple) this.setOptionStatus(true);
                        else {
                            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;
                            if (typeof liSelectedIndex === "number") {
                                this.setSelected(this.selectedIndex, false);
                                this.setSelected(liSelectedIndex, true);
                            }
                        }
                    }
                    this.render();
                    changedArguments = null;
                    return this.$element;
                } else return this.$element.val();
            },
            changeAll: function changeAll(status) {
                if (!this.multiple) return;
                if (typeof status === "undefined") status = true;
                var element = this.$element[0], previousSelected = 0, currentSelected = 0, prevValue = getSelectValues(element);
                element.classList.add("bs-select-hidden");
                for(var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++){
                    var liData = data[i], option = liData.option;
                    if (option && !liData.disabled && liData.type !== "divider") {
                        if (liData.selected) previousSelected++;
                        option.selected = status;
                        if (status === true) currentSelected++;
                    }
                }
                element.classList.remove("bs-select-hidden");
                if (previousSelected === currentSelected) return;
                this.setOptionStatus();
                changedArguments = [
                    null,
                    null,
                    prevValue
                ];
                this.$element.triggerNative("change");
            },
            selectAll: function selectAll() {
                return this.changeAll(true);
            },
            deselectAll: function deselectAll() {
                return this.changeAll(false);
            },
            toggle: function toggle(e) {
                e = e || window.event;
                if (e) e.stopPropagation();
                this.$button.trigger("click.bs.dropdown.data-api");
            },
            keydown: function keydown(e) {
                var $this = $(this), isToggle = $this.hasClass("dropdown-toggle"), $parent = isToggle ? $this.closest(".dropdown") : $this.closest(Selector.MENU), that = $parent.data("this"), $items = that.findLis(), index, isActive, liActive, activeLi, offset, updateScroll = false, downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab, isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab, scrollTop = that.$menuInner[0].scrollTop, isVirtual = that.isVirtual(), position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;
                // do nothing if a function key is pressed
                if (e.which >= 112 && e.which <= 123) return;
                isActive = that.$newElement.hasClass(classNames.SHOW);
                if (!isActive && (isArrowKey || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90)) {
                    that.$button.trigger("click.bs.dropdown.data-api");
                    if (that.options.liveSearch) {
                        that.$searchbox.trigger("focus");
                        return;
                    }
                }
                if (e.which === keyCodes.ESCAPE && isActive) {
                    e.preventDefault();
                    that.$button.trigger("click.bs.dropdown.data-api").trigger("focus");
                }
                if (isArrowKey) {
                    if (!$items.length) return;
                    liActive = that.selectpicker.main.elements[that.activeIndex];
                    index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;
                    if (index !== -1) that.defocusItem(liActive);
                    if (e.which === keyCodes.ARROW_UP) {
                        if (index !== -1) index--;
                        if (index + position0 < 0) index += $items.length;
                        if (!that.selectpicker.view.canHighlight[index + position0]) {
                            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
                            if (index === -1) index = $items.length - 1;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        index++;
                        if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;
                        if (!that.selectpicker.view.canHighlight[index + position0]) index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
                    }
                    e.preventDefault();
                    var liActiveIndex = position0 + index;
                    if (e.which === keyCodes.ARROW_UP) {
                        // scroll to bottom and highlight last option
                        if (position0 === 0 && index === $items.length - 1) {
                            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;
                            liActiveIndex = that.selectpicker.current.elements.length - 1;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - activeLi.height;
                            updateScroll = offset < scrollTop;
                        }
                    } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
                        // scroll to top and highlight first option
                        if (index === that.selectpicker.view.firstHighlightIndex) {
                            that.$menuInner[0].scrollTop = 0;
                            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
                        } else {
                            activeLi = that.selectpicker.current.data[liActiveIndex];
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            updateScroll = offset > scrollTop;
                        }
                    }
                    liActive = that.selectpicker.current.elements[liActiveIndex];
                    that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;
                    that.focusItem(liActive);
                    that.selectpicker.view.currentActive = liActive;
                    if (updateScroll) that.$menuInner[0].scrollTop = offset;
                    if (that.options.liveSearch) that.$searchbox.trigger("focus");
                    else $this.trigger("focus");
                } else if (!$this.is("input") && !REGEXP_TAB_OR_ESCAPE.test(e.which) || e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory) {
                    var searchMatch, matches = [], keyHistory;
                    e.preventDefault();
                    that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];
                    if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
                    that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();
                    keyHistory = that.selectpicker.keydown.keyHistory;
                    // if all letters are the same, set keyHistory to just the first character when searching
                    if (/^(.)\1+$/.test(keyHistory)) keyHistory = keyHistory.charAt(0);
                    // find matches
                    for(var i = 0; i < that.selectpicker.current.data.length; i++){
                        var li = that.selectpicker.current.data[i], hasMatch;
                        hasMatch = stringSearch(li, keyHistory, "startsWith", true);
                        if (hasMatch && that.selectpicker.view.canHighlight[i]) matches.push(li.index);
                    }
                    if (matches.length) {
                        var matchIndex = 0;
                        $items.removeClass("active").find("a").removeClass("active");
                        // either only one key has been pressed or they are all the same key
                        if (keyHistory.length === 1) {
                            matchIndex = matches.indexOf(that.activeIndex);
                            if (matchIndex === -1 || matchIndex === matches.length - 1) matchIndex = 0;
                            else matchIndex++;
                        }
                        searchMatch = matches[matchIndex];
                        activeLi = that.selectpicker.main.data[searchMatch];
                        if (scrollTop - activeLi.position > 0) {
                            offset = activeLi.position - activeLi.height;
                            updateScroll = true;
                        } else {
                            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
                            // if the option is already visible at the current scroll position, just keep it the same
                            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
                        }
                        liActive = that.selectpicker.main.elements[searchMatch];
                        that.activeIndex = matches[matchIndex];
                        that.focusItem(liActive);
                        if (liActive) liActive.firstChild.focus();
                        if (updateScroll) that.$menuInner[0].scrollTop = offset;
                        $this.trigger("focus");
                    }
                }
                // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
                if (isActive && (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory || e.which === keyCodes.ENTER || e.which === keyCodes.TAB && that.options.selectOnTab)) {
                    if (e.which !== keyCodes.SPACE) e.preventDefault();
                    if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
                        that.$menuInner.find(".active a").trigger("click", true); // retain active class
                        $this.trigger("focus");
                        if (!that.options.liveSearch) {
                            // Prevent screen from scrolling if the user hits the spacebar
                            e.preventDefault();
                            // Fixes spacebar selection of dropdown items in FF & IE
                            $(document).data("spaceSelect", true);
                        }
                    }
                }
            },
            mobile: function mobile() {
                // ensure mobile is set to true if mobile function is called after init
                this.options.mobile = true;
                this.$element[0].classList.add("mobile-device");
            },
            refresh: function refresh() {
                // update options if data attributes have been changed
                var config = $.extend({}, this.options, this.$element.data());
                this.options = config;
                this.checkDisabled();
                this.buildData();
                this.setStyle();
                this.render();
                this.buildList();
                this.setWidth();
                this.setSize(true);
                this.$element.trigger("refreshed" + EVENT_KEY);
            },
            hide: function hide() {
                this.$newElement.hide();
            },
            show: function show() {
                this.$newElement.show();
            },
            remove: function remove() {
                this.$newElement.remove();
                this.$element.remove();
            },
            destroy: function destroy() {
                this.$newElement.before(this.$element).remove();
                if (this.$bsContainer) this.$bsContainer.remove();
                else this.$menu.remove();
                if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
                this.$element.off(EVENT_KEY).removeData("selectpicker").removeClass("bs-select-hidden selectpicker");
                $(window).off(EVENT_KEY + "." + this.selectId);
            }
        };
        // SELECTPICKER PLUGIN DEFINITION
        // ==============================
        function Plugin(option) {
            // get the args of the outer function..
            var args = arguments;
            // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
            // to get lost/corrupted in android 2.3 and IE9 #715 #775
            var _option = option;
            [].shift.apply(args);
            // if the version was not set successfully
            if (!version.success) {
                // try to retreive it again
                try {
                    version.full = ($.fn.dropdown.Constructor.VERSION || "").split(" ")[0].split(".");
                } catch (err) {
                    // fall back to use BootstrapVersion if set
                    if (Selectpicker.BootstrapVersion) version.full = Selectpicker.BootstrapVersion.split(" ")[0].split(".");
                    else {
                        version.full = [
                            version.major,
                            "0",
                            "0"
                        ];
                        console.warn("There was an issue retrieving Bootstrap's version. Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.", err);
                    }
                }
                version.major = version.full[0];
                version.success = true;
            }
            if (version.major === "4") {
                // some defaults need to be changed if using Bootstrap 4
                // check to see if they have already been manually changed before forcing them to update
                var toUpdate = [];
                if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({
                    name: "style",
                    className: "BUTTONCLASS"
                });
                if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({
                    name: "iconBase",
                    className: "ICONBASE"
                });
                if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({
                    name: "tickIcon",
                    className: "TICKICON"
                });
                classNames.DIVIDER = "dropdown-divider";
                classNames.SHOW = "show";
                classNames.BUTTONCLASS = "btn-light";
                classNames.POPOVERHEADER = "popover-header";
                classNames.ICONBASE = "";
                classNames.TICKICON = "bs-ok-default";
                for(var i = 0; i < toUpdate.length; i++){
                    var option = toUpdate[i];
                    Selectpicker.DEFAULTS[option.name] = classNames[option.className];
                }
            }
            var value;
            var chain = this.each(function() {
                var $this = $(this);
                if ($this.is("select")) {
                    var data = $this.data("selectpicker"), options = typeof _option == "object" && _option;
                    if (!data) {
                        var dataAttributes = $this.data();
                        for(var dataAttr in dataAttributes)if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) delete dataAttributes[dataAttr];
                        var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
                        config.template = $.extend({}, Selectpicker.DEFAULTS.template, $.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}, dataAttributes.template, options.template);
                        $this.data("selectpicker", data = new Selectpicker(this, config));
                    } else if (options) {
                        for(var i in options)if (Object.prototype.hasOwnProperty.call(options, i)) data.options[i] = options[i];
                    }
                    if (typeof _option == "string") {
                        if (data[_option] instanceof Function) value = data[_option].apply(data, args);
                        else value = data.options[_option];
                    }
                }
            });
            if (typeof value !== "undefined") // noinspection JSUnusedAssignment
            return value;
            else return chain;
        }
        var old = $.fn.selectpicker;
        $.fn.selectpicker = Plugin;
        $.fn.selectpicker.Constructor = Selectpicker;
        // SELECTPICKER NO CONFLICT
        // ========================
        $.fn.selectpicker.noConflict = function() {
            $.fn.selectpicker = old;
            return this;
        };
        // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
        function keydownHandler() {
            if ($.fn.dropdown) {
                // wait to define until function is called in case Bootstrap isn't loaded yet
                var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
                return bootstrapKeydown.apply(this, arguments);
            }
        }
        $(document).off("keydown.bs.dropdown.data-api").on("keydown.bs.dropdown.data-api", ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler).on("keydown.bs.dropdown.data-api", ":not(.bootstrap-select) > .dropdown-menu", keydownHandler).on("keydown" + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown).on("focusin.modal", '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function(e) {
            e.stopPropagation();
        });
        // SELECTPICKER DATA-API
        // =====================
        $(window).on("load" + EVENT_KEY + ".data-api", function() {
            $(".selectpicker").each(function() {
                var $selectpicker = $(this);
                Plugin.call($selectpicker, $selectpicker.data());
            });
        });
    })(jQuery);
});




parcelRequire("4w9fm");
/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ "use strict";
var $56302cec4a14ff9a$exports = {};
"use strict";
var $131460ececef5983$exports = {};
"use strict";
var $605c5cd9c3aed513$exports = {};
"use strict";
var $605c5cd9c3aed513$var$check = function check(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$605c5cd9c3aed513$exports = // eslint-disable-next-line es/no-global-this -- safe
$605c5cd9c3aed513$var$check(typeof globalThis == "object" && globalThis) || $605c5cd9c3aed513$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$605c5cd9c3aed513$var$check(typeof self == "object" && self) || $605c5cd9c3aed513$var$check(typeof $parcel$global == "object" && $parcel$global) || $605c5cd9c3aed513$var$check(typeof $605c5cd9c3aed513$exports == "object" && $605c5cd9c3aed513$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $ad8a2fa7f3a3a6cd$exports = {};
"use strict";
var $8617ba4766246a37$exports = {};
"use strict";
var $5bff024010083d10$exports = {};
"use strict";
$5bff024010083d10$exports = false;



var $12dd487eba75164c$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $12dd487eba75164c$var$defineProperty = Object.defineProperty;
$12dd487eba75164c$exports = function(key, value) {
    try {
        $12dd487eba75164c$var$defineProperty($605c5cd9c3aed513$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $605c5cd9c3aed513$exports[key] = value;
    }
    return value;
};


var $8617ba4766246a37$var$SHARED = "__core-js_shared__";
var $8617ba4766246a37$var$store = $8617ba4766246a37$exports = $605c5cd9c3aed513$exports[$8617ba4766246a37$var$SHARED] || $12dd487eba75164c$exports($8617ba4766246a37$var$SHARED, {});
($8617ba4766246a37$var$store.versions || ($8617ba4766246a37$var$store.versions = [])).push({
    version: "3.36.1",
    mode: $5bff024010083d10$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$ad8a2fa7f3a3a6cd$exports = function(key, value) {
    return $8617ba4766246a37$exports[key] || ($8617ba4766246a37$exports[key] = value || {});
};


var $f54d86fb147e81a3$exports = {};
"use strict";
var $cc682aa152788262$exports = {};
"use strict";
var $0b224d9c80aa3e60$exports = {};
"use strict";
var $3c2ab9b4ea4760df$exports = {};
"use strict";
$3c2ab9b4ea4760df$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


$0b224d9c80aa3e60$exports = !$3c2ab9b4ea4760df$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $cc682aa152788262$var$FunctionPrototype = Function.prototype;
var $cc682aa152788262$var$call = $cc682aa152788262$var$FunctionPrototype.call;
var $cc682aa152788262$var$uncurryThisWithBind = $0b224d9c80aa3e60$exports && $cc682aa152788262$var$FunctionPrototype.bind.bind($cc682aa152788262$var$call, $cc682aa152788262$var$call);
$cc682aa152788262$exports = $0b224d9c80aa3e60$exports ? $cc682aa152788262$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $cc682aa152788262$var$call.apply(fn, arguments);
    };
};


var $e2a51ca67adb8a11$exports = {};
"use strict";
var $845f3e9d2f4f3629$exports = {};
"use strict";
var $50fb4e8da6ee0e0a$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$50fb4e8da6ee0e0a$exports = function(it) {
    return it === null || it === undefined;
};


var $845f3e9d2f4f3629$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$845f3e9d2f4f3629$exports = function(it) {
    if ($50fb4e8da6ee0e0a$exports(it)) throw new $845f3e9d2f4f3629$var$$TypeError("Can't call method on " + it);
    return it;
};


var $e2a51ca67adb8a11$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$e2a51ca67adb8a11$exports = function(argument) {
    return $e2a51ca67adb8a11$var$$Object($845f3e9d2f4f3629$exports(argument));
};


var $f54d86fb147e81a3$var$hasOwnProperty = $cc682aa152788262$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$f54d86fb147e81a3$exports = Object.hasOwn || function hasOwn(it, key) {
    return $f54d86fb147e81a3$var$hasOwnProperty($e2a51ca67adb8a11$exports(it), key);
};


var $ca2a6c13ba9e533d$exports = {};
"use strict";

var $ca2a6c13ba9e533d$var$id = 0;
var $ca2a6c13ba9e533d$var$postfix = Math.random();
var $ca2a6c13ba9e533d$var$toString = $cc682aa152788262$exports(1.0.toString);
$ca2a6c13ba9e533d$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $ca2a6c13ba9e533d$var$toString(++$ca2a6c13ba9e533d$var$id + $ca2a6c13ba9e533d$var$postfix, 36);
};


var $8d29e0d618aacb82$exports = {};
"use strict";
var $d9b80d2e05132a69$exports = {};
"use strict";

var $686b1407410517c1$exports = {};
"use strict";
$686b1407410517c1$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $d9b80d2e05132a69$var$process = $605c5cd9c3aed513$exports.process;
var $d9b80d2e05132a69$var$Deno = $605c5cd9c3aed513$exports.Deno;
var $d9b80d2e05132a69$var$versions = $d9b80d2e05132a69$var$process && $d9b80d2e05132a69$var$process.versions || $d9b80d2e05132a69$var$Deno && $d9b80d2e05132a69$var$Deno.version;
var $d9b80d2e05132a69$var$v8 = $d9b80d2e05132a69$var$versions && $d9b80d2e05132a69$var$versions.v8;
var $d9b80d2e05132a69$var$match, $d9b80d2e05132a69$var$version;
if ($d9b80d2e05132a69$var$v8) {
    $d9b80d2e05132a69$var$match = $d9b80d2e05132a69$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $d9b80d2e05132a69$var$version = $d9b80d2e05132a69$var$match[0] > 0 && $d9b80d2e05132a69$var$match[0] < 4 ? 1 : +($d9b80d2e05132a69$var$match[0] + $d9b80d2e05132a69$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$d9b80d2e05132a69$var$version && $686b1407410517c1$exports) {
    $d9b80d2e05132a69$var$match = $686b1407410517c1$exports.match(/Edge\/(\d+)/);
    if (!$d9b80d2e05132a69$var$match || $d9b80d2e05132a69$var$match[1] >= 74) {
        $d9b80d2e05132a69$var$match = $686b1407410517c1$exports.match(/Chrome\/(\d+)/);
        if ($d9b80d2e05132a69$var$match) $d9b80d2e05132a69$var$version = +$d9b80d2e05132a69$var$match[1];
    }
}
$d9b80d2e05132a69$exports = $d9b80d2e05132a69$var$version;




var $8d29e0d618aacb82$var$$String = $605c5cd9c3aed513$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$8d29e0d618aacb82$exports = !!Object.getOwnPropertySymbols && !$3c2ab9b4ea4760df$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$8d29e0d618aacb82$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $d9b80d2e05132a69$exports && $d9b80d2e05132a69$exports < 41;
});


var $46bbccb4ffc713b8$exports = {};

var $3J8Kb = parcelRequire("3J8Kb");
"use strict";

$46bbccb4ffc713b8$exports = $8d29e0d618aacb82$exports && !Symbol.sham && (0, $3J8Kb._)(Symbol.iterator) == "symbol";


var $131460ececef5983$var$Symbol = $605c5cd9c3aed513$exports.Symbol;
var $131460ececef5983$var$WellKnownSymbolsStore = $ad8a2fa7f3a3a6cd$exports("wks");
var $131460ececef5983$var$createWellKnownSymbol = $46bbccb4ffc713b8$exports ? $131460ececef5983$var$Symbol["for"] || $131460ececef5983$var$Symbol : $131460ececef5983$var$Symbol && $131460ececef5983$var$Symbol.withoutSetter || $ca2a6c13ba9e533d$exports;
$131460ececef5983$exports = function(name) {
    if (!$f54d86fb147e81a3$exports($131460ececef5983$var$WellKnownSymbolsStore, name)) $131460ececef5983$var$WellKnownSymbolsStore[name] = $8d29e0d618aacb82$exports && $f54d86fb147e81a3$exports($131460ececef5983$var$Symbol, name) ? $131460ececef5983$var$Symbol[name] : $131460ececef5983$var$createWellKnownSymbol("Symbol." + name);
    return $131460ececef5983$var$WellKnownSymbolsStore[name];
};


var $56302cec4a14ff9a$var$TO_STRING_TAG = $131460ececef5983$exports("toStringTag");
var $56302cec4a14ff9a$var$test = {};
$56302cec4a14ff9a$var$test[$56302cec4a14ff9a$var$TO_STRING_TAG] = "z";
$56302cec4a14ff9a$exports = String($56302cec4a14ff9a$var$test) === "[object z]";


var $c9272b287f1d50a0$exports = {};
"use strict";
var $999204e0caa7c0da$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $999204e0caa7c0da$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$999204e0caa7c0da$exports = typeof $999204e0caa7c0da$var$documentAll == "undefined" && $999204e0caa7c0da$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $999204e0caa7c0da$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $324f102fb15ae006$export$2d1720544b23b823;
"use strict";
var $2708db8aa4e8f4d2$exports = {};
"use strict";

// Detect IE8's incomplete defineProperty implementation
$2708db8aa4e8f4d2$exports = !$3c2ab9b4ea4760df$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function get() {
            return 7;
        }
    })[1] !== 7;
});


var $4ddf1d1933f327b4$exports = {};
"use strict";


var $1b51fc38223748c6$exports = {};
"use strict";

var $843e5056f67bf37c$exports = {};
"use strict";

$843e5056f67bf37c$exports = function(it) {
    return typeof it == "object" ? it !== null : $999204e0caa7c0da$exports(it);
};


var $1b51fc38223748c6$var$document = $605c5cd9c3aed513$exports.document;
// typeof document.createElement is 'object' in old IE
var $1b51fc38223748c6$var$EXISTS = $843e5056f67bf37c$exports($1b51fc38223748c6$var$document) && $843e5056f67bf37c$exports($1b51fc38223748c6$var$document.createElement);
$1b51fc38223748c6$exports = function(it) {
    return $1b51fc38223748c6$var$EXISTS ? $1b51fc38223748c6$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$4ddf1d1933f327b4$exports = !$2708db8aa4e8f4d2$exports && !$3c2ab9b4ea4760df$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($1b51fc38223748c6$exports("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a !== 7;
});


var $0f93f7afb263258e$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$0f93f7afb263258e$exports = $2708db8aa4e8f4d2$exports && $3c2ab9b4ea4760df$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $2d779c9560717a35$exports = {};
"use strict";

var $2d779c9560717a35$var$$String = String;
var $2d779c9560717a35$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$2d779c9560717a35$exports = function(argument) {
    if ($843e5056f67bf37c$exports(argument)) return argument;
    throw new $2d779c9560717a35$var$$TypeError($2d779c9560717a35$var$$String(argument) + " is not an object");
};


var $3fab48cb13316330$exports = {};
"use strict";
var $dbe4f9377b7cab9d$exports = {};
"use strict";
var $a34142376931cf1e$exports = {};
"use strict";

var $a34142376931cf1e$var$call = Function.prototype.call;
$a34142376931cf1e$exports = $0b224d9c80aa3e60$exports ? $a34142376931cf1e$var$call.bind($a34142376931cf1e$var$call) : function() {
    return $a34142376931cf1e$var$call.apply($a34142376931cf1e$var$call, arguments);
};



var $38cb3ef47463acf7$exports = {};

var $3J8Kb = parcelRequire("3J8Kb");
"use strict";
var $cae17ea3610e12cc$exports = {};
"use strict";


var $cae17ea3610e12cc$var$aFunction = function aFunction(argument) {
    return $999204e0caa7c0da$exports(argument) ? argument : undefined;
};
$cae17ea3610e12cc$exports = function(namespace, method) {
    return arguments.length < 2 ? $cae17ea3610e12cc$var$aFunction($605c5cd9c3aed513$exports[namespace]) : $605c5cd9c3aed513$exports[namespace] && $605c5cd9c3aed513$exports[namespace][method];
};



var $1101a6759fe6d6c0$exports = {};
"use strict";

$1101a6759fe6d6c0$exports = $cc682aa152788262$exports({}.isPrototypeOf);



var $38cb3ef47463acf7$var$$Object = Object;
$38cb3ef47463acf7$exports = $46bbccb4ffc713b8$exports ? function(it) {
    return (typeof it === "undefined" ? "undefined" : (0, $3J8Kb._)(it)) == "symbol";
} : function(it) {
    var $Symbol = $cae17ea3610e12cc$exports("Symbol");
    return $999204e0caa7c0da$exports($Symbol) && $1101a6759fe6d6c0$exports($Symbol.prototype, $38cb3ef47463acf7$var$$Object(it));
};


var $a76fffc2ea20877e$exports = {};
"use strict";
var $936bc4e7e1b39b6f$exports = {};
"use strict";

var $a9ce0b3d37830bdf$exports = {};
"use strict";
var $a9ce0b3d37830bdf$var$$String = String;
$a9ce0b3d37830bdf$exports = function(argument) {
    try {
        return $a9ce0b3d37830bdf$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $936bc4e7e1b39b6f$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$936bc4e7e1b39b6f$exports = function(argument) {
    if ($999204e0caa7c0da$exports(argument)) return argument;
    throw new $936bc4e7e1b39b6f$var$$TypeError($a9ce0b3d37830bdf$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$a76fffc2ea20877e$exports = function(V, P) {
    var func = V[P];
    return $50fb4e8da6ee0e0a$exports(func) ? undefined : $936bc4e7e1b39b6f$exports(func);
};


var $511e4fd57330548e$exports = {};
"use strict";



var $511e4fd57330548e$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$511e4fd57330548e$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $999204e0caa7c0da$exports(fn = input.toString) && !$843e5056f67bf37c$exports(val = $a34142376931cf1e$exports(fn, input))) return val;
    if ($999204e0caa7c0da$exports(fn = input.valueOf) && !$843e5056f67bf37c$exports(val = $a34142376931cf1e$exports(fn, input))) return val;
    if (pref !== "string" && $999204e0caa7c0da$exports(fn = input.toString) && !$843e5056f67bf37c$exports(val = $a34142376931cf1e$exports(fn, input))) return val;
    throw new $511e4fd57330548e$var$$TypeError("Can't convert object to primitive value");
};



var $dbe4f9377b7cab9d$var$$TypeError = TypeError;
var $dbe4f9377b7cab9d$var$TO_PRIMITIVE = $131460ececef5983$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$dbe4f9377b7cab9d$exports = function(input, pref) {
    if (!$843e5056f67bf37c$exports(input) || $38cb3ef47463acf7$exports(input)) return input;
    var exoticToPrim = $a76fffc2ea20877e$exports(input, $dbe4f9377b7cab9d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $a34142376931cf1e$exports(exoticToPrim, input, pref);
        if (!$843e5056f67bf37c$exports(result) || $38cb3ef47463acf7$exports(result)) return result;
        throw new $dbe4f9377b7cab9d$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $511e4fd57330548e$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$3fab48cb13316330$exports = function(argument) {
    var key = $dbe4f9377b7cab9d$exports(argument, "string");
    return $38cb3ef47463acf7$exports(key) ? key : key + "";
};


var $324f102fb15ae006$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $324f102fb15ae006$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $324f102fb15ae006$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $324f102fb15ae006$var$ENUMERABLE = "enumerable";
var $324f102fb15ae006$var$CONFIGURABLE = "configurable";
var $324f102fb15ae006$var$WRITABLE = "writable";
$324f102fb15ae006$export$2d1720544b23b823 = $2708db8aa4e8f4d2$exports ? $0f93f7afb263258e$exports ? function defineProperty(O, P, Attributes) {
    $2d779c9560717a35$exports(O);
    P = $3fab48cb13316330$exports(P);
    $2d779c9560717a35$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $324f102fb15ae006$var$WRITABLE in Attributes && !Attributes[$324f102fb15ae006$var$WRITABLE]) {
        var current = $324f102fb15ae006$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$324f102fb15ae006$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $324f102fb15ae006$var$CONFIGURABLE in Attributes ? Attributes[$324f102fb15ae006$var$CONFIGURABLE] : current[$324f102fb15ae006$var$CONFIGURABLE],
                enumerable: $324f102fb15ae006$var$ENUMERABLE in Attributes ? Attributes[$324f102fb15ae006$var$ENUMERABLE] : current[$324f102fb15ae006$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $324f102fb15ae006$var$$defineProperty(O, P, Attributes);
} : $324f102fb15ae006$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $2d779c9560717a35$exports(O);
    P = $3fab48cb13316330$exports(P);
    $2d779c9560717a35$exports(Attributes);
    if ($4ddf1d1933f327b4$exports) try {
        return $324f102fb15ae006$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $324f102fb15ae006$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $8327a6fa4d840a5c$exports = {};
"use strict";





var $2356260dee87883e$exports = {};
"use strict";


var $2356260dee87883e$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $2356260dee87883e$var$getDescriptor = $2708db8aa4e8f4d2$exports && Object.getOwnPropertyDescriptor;
var $2356260dee87883e$var$EXISTS = $f54d86fb147e81a3$exports($2356260dee87883e$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $2356260dee87883e$var$PROPER = $2356260dee87883e$var$EXISTS && (function something() {}).name === "something";
var $2356260dee87883e$var$CONFIGURABLE = $2356260dee87883e$var$EXISTS && (!$2708db8aa4e8f4d2$exports || $2708db8aa4e8f4d2$exports && $2356260dee87883e$var$getDescriptor($2356260dee87883e$var$FunctionPrototype, "name").configurable);
$2356260dee87883e$exports = {
    EXISTS: $2356260dee87883e$var$EXISTS,
    PROPER: $2356260dee87883e$var$PROPER,
    CONFIGURABLE: $2356260dee87883e$var$CONFIGURABLE
};


var $8327a6fa4d840a5c$require$CONFIGURABLE_FUNCTION_NAME = $2356260dee87883e$exports.CONFIGURABLE;
var $2590fb86c79fb443$exports = {};
"use strict";



var $2590fb86c79fb443$var$functionToString = $cc682aa152788262$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$999204e0caa7c0da$exports($8617ba4766246a37$exports.inspectSource)) $8617ba4766246a37$exports.inspectSource = function(it) {
    return $2590fb86c79fb443$var$functionToString(it);
};
$2590fb86c79fb443$exports = $8617ba4766246a37$exports.inspectSource;


var $8c7995ce54ba35ed$exports = {};
"use strict";
var $96b33fd05a185b6e$exports = {};
"use strict";


var $96b33fd05a185b6e$var$WeakMap = $605c5cd9c3aed513$exports.WeakMap;
$96b33fd05a185b6e$exports = $999204e0caa7c0da$exports($96b33fd05a185b6e$var$WeakMap) && /native code/.test(String($96b33fd05a185b6e$var$WeakMap));




var $d4687f5727b08995$exports = {};
"use strict";


var $eda28ded52679ffb$exports = {};
"use strict";
$eda28ded52679ffb$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$d4687f5727b08995$exports = $2708db8aa4e8f4d2$exports ? function(object, key, value) {
    return $324f102fb15ae006$export$2d1720544b23b823(object, key, $eda28ded52679ffb$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $4b15c5cd71f344f1$exports = {};
"use strict";


var $4b15c5cd71f344f1$var$keys = $ad8a2fa7f3a3a6cd$exports("keys");
$4b15c5cd71f344f1$exports = function(key) {
    return $4b15c5cd71f344f1$var$keys[key] || ($4b15c5cd71f344f1$var$keys[key] = $ca2a6c13ba9e533d$exports(key));
};


var $fd3671a46f760b77$exports = {};
"use strict";
$fd3671a46f760b77$exports = {};


var $8c7995ce54ba35ed$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $8c7995ce54ba35ed$var$TypeError = $605c5cd9c3aed513$exports.TypeError;
var $8c7995ce54ba35ed$var$WeakMap = $605c5cd9c3aed513$exports.WeakMap;
var $8c7995ce54ba35ed$var$set, $8c7995ce54ba35ed$var$get, $8c7995ce54ba35ed$var$has;
var $8c7995ce54ba35ed$var$enforce = function enforce(it) {
    return $8c7995ce54ba35ed$var$has(it) ? $8c7995ce54ba35ed$var$get(it) : $8c7995ce54ba35ed$var$set(it, {});
};
var $8c7995ce54ba35ed$var$getterFor = function getterFor(TYPE) {
    return function(it) {
        var state;
        if (!$843e5056f67bf37c$exports(it) || (state = $8c7995ce54ba35ed$var$get(it)).type !== TYPE) throw new $8c7995ce54ba35ed$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($96b33fd05a185b6e$exports || $8617ba4766246a37$exports.state) {
    var $8c7995ce54ba35ed$var$store = $8617ba4766246a37$exports.state || ($8617ba4766246a37$exports.state = new $8c7995ce54ba35ed$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $8c7995ce54ba35ed$var$store.get = $8c7995ce54ba35ed$var$store.get;
    $8c7995ce54ba35ed$var$store.has = $8c7995ce54ba35ed$var$store.has;
    $8c7995ce54ba35ed$var$store.set = $8c7995ce54ba35ed$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $8c7995ce54ba35ed$var$set = function set(it, metadata) {
        if ($8c7995ce54ba35ed$var$store.has(it)) throw new $8c7995ce54ba35ed$var$TypeError($8c7995ce54ba35ed$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $8c7995ce54ba35ed$var$store.set(it, metadata);
        return metadata;
    };
    $8c7995ce54ba35ed$var$get = function get(it) {
        return $8c7995ce54ba35ed$var$store.get(it) || {};
    };
    $8c7995ce54ba35ed$var$has = function has(it) {
        return $8c7995ce54ba35ed$var$store.has(it);
    };
} else {
    var $8c7995ce54ba35ed$var$STATE = $4b15c5cd71f344f1$exports("state");
    $fd3671a46f760b77$exports[$8c7995ce54ba35ed$var$STATE] = true;
    $8c7995ce54ba35ed$var$set = function set(it, metadata) {
        if ($f54d86fb147e81a3$exports(it, $8c7995ce54ba35ed$var$STATE)) throw new $8c7995ce54ba35ed$var$TypeError($8c7995ce54ba35ed$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $d4687f5727b08995$exports(it, $8c7995ce54ba35ed$var$STATE, metadata);
        return metadata;
    };
    $8c7995ce54ba35ed$var$get = function get(it) {
        return $f54d86fb147e81a3$exports(it, $8c7995ce54ba35ed$var$STATE) ? it[$8c7995ce54ba35ed$var$STATE] : {};
    };
    $8c7995ce54ba35ed$var$has = function has(it) {
        return $f54d86fb147e81a3$exports(it, $8c7995ce54ba35ed$var$STATE);
    };
}
$8c7995ce54ba35ed$exports = {
    set: $8c7995ce54ba35ed$var$set,
    get: $8c7995ce54ba35ed$var$get,
    has: $8c7995ce54ba35ed$var$has,
    enforce: $8c7995ce54ba35ed$var$enforce,
    getterFor: $8c7995ce54ba35ed$var$getterFor
};


var $8327a6fa4d840a5c$var$enforceInternalState = $8c7995ce54ba35ed$exports.enforce;
var $8327a6fa4d840a5c$var$getInternalState = $8c7995ce54ba35ed$exports.get;
var $8327a6fa4d840a5c$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $8327a6fa4d840a5c$var$defineProperty = Object.defineProperty;
var $8327a6fa4d840a5c$var$stringSlice = $cc682aa152788262$exports("".slice);
var $8327a6fa4d840a5c$var$replace = $cc682aa152788262$exports("".replace);
var $8327a6fa4d840a5c$var$join = $cc682aa152788262$exports([].join);
var $8327a6fa4d840a5c$var$CONFIGURABLE_LENGTH = $2708db8aa4e8f4d2$exports && !$3c2ab9b4ea4760df$exports(function() {
    return $8327a6fa4d840a5c$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $8327a6fa4d840a5c$var$TEMPLATE = String(String).split("String");
var $8327a6fa4d840a5c$var$makeBuiltIn = $8327a6fa4d840a5c$exports = function makeBuiltIn(value, name, options) {
    if ($8327a6fa4d840a5c$var$stringSlice($8327a6fa4d840a5c$var$$String(name), 0, 7) === "Symbol(") name = "[" + $8327a6fa4d840a5c$var$replace($8327a6fa4d840a5c$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$f54d86fb147e81a3$exports(value, "name") || $8327a6fa4d840a5c$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($2708db8aa4e8f4d2$exports) $8327a6fa4d840a5c$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($8327a6fa4d840a5c$var$CONFIGURABLE_LENGTH && options && $f54d86fb147e81a3$exports(options, "arity") && value.length !== options.arity) $8327a6fa4d840a5c$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $f54d86fb147e81a3$exports(options, "constructor") && options.constructor) {
            if ($2708db8aa4e8f4d2$exports) $8327a6fa4d840a5c$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $8327a6fa4d840a5c$var$enforceInternalState(value);
    if (!$f54d86fb147e81a3$exports(state, "source")) state.source = $8327a6fa4d840a5c$var$join($8327a6fa4d840a5c$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $8327a6fa4d840a5c$var$makeBuiltIn(function toString() {
    return $999204e0caa7c0da$exports(this) && $8327a6fa4d840a5c$var$getInternalState(this).source || $2590fb86c79fb443$exports(this);
}, "toString");



$c9272b287f1d50a0$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($999204e0caa7c0da$exports(value)) $8327a6fa4d840a5c$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $12dd487eba75164c$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $324f102fb15ae006$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};


var $227d0a55929b8f15$exports = {};
"use strict";

var $0348a0c2acd6d4c4$exports = {};
"use strict";


var $6d78dcf79704944a$exports = {};
"use strict";

var $6d78dcf79704944a$var$toString = $cc682aa152788262$exports({}.toString);
var $6d78dcf79704944a$var$stringSlice = $cc682aa152788262$exports("".slice);
$6d78dcf79704944a$exports = function(it) {
    return $6d78dcf79704944a$var$stringSlice($6d78dcf79704944a$var$toString(it), 8, -1);
};



var $0348a0c2acd6d4c4$var$TO_STRING_TAG = $131460ececef5983$exports("toStringTag");
var $0348a0c2acd6d4c4$var$$Object = Object;
// ES3 wrong here
var $0348a0c2acd6d4c4$var$CORRECT_ARGUMENTS = $6d78dcf79704944a$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $0348a0c2acd6d4c4$var$tryGet = function tryGet(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$0348a0c2acd6d4c4$exports = $56302cec4a14ff9a$exports ? $6d78dcf79704944a$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $0348a0c2acd6d4c4$var$tryGet(O = $0348a0c2acd6d4c4$var$$Object(it), $0348a0c2acd6d4c4$var$TO_STRING_TAG)) == "string" ? tag : $0348a0c2acd6d4c4$var$CORRECT_ARGUMENTS ? $6d78dcf79704944a$exports(O) : (result = $6d78dcf79704944a$exports(O)) === "Object" && $999204e0caa7c0da$exports(O.callee) ? "Arguments" : result;
};


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$227d0a55929b8f15$exports = $56302cec4a14ff9a$exports ? ({}).toString : function toString() {
    return "[object " + $0348a0c2acd6d4c4$exports(this) + "]";
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$56302cec4a14ff9a$exports) $c9272b287f1d50a0$exports(Object.prototype, "toString", $227d0a55929b8f15$exports, {
    unsafe: true
});


"use strict";

var $641c2b904096fda5$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$641c2b904096fda5$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $e097927bd9e0dd3a$exports = {};
"use strict";

var $e097927bd9e0dd3a$var$classList = $1b51fc38223748c6$exports("span").classList;
var $e097927bd9e0dd3a$var$DOMTokenListPrototype = $e097927bd9e0dd3a$var$classList && $e097927bd9e0dd3a$var$classList.constructor && $e097927bd9e0dd3a$var$classList.constructor.prototype;
$e097927bd9e0dd3a$exports = $e097927bd9e0dd3a$var$DOMTokenListPrototype === Object.prototype ? undefined : $e097927bd9e0dd3a$var$DOMTokenListPrototype;


var $c55ebe9f2c33b9b5$exports = {};
"use strict";
var $cfd9d595464d1cfe$exports = {};
"use strict";
var $7a45353897a24c5c$exports = {};
"use strict";
var $6f254d5357cc1670$exports = {};
"use strict";


$6f254d5357cc1670$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($6d78dcf79704944a$exports(fn) === "Function") return $cc682aa152788262$exports(fn);
};




var $7a45353897a24c5c$var$bind = $6f254d5357cc1670$exports($6f254d5357cc1670$exports.bind);
// optional / simple context binding
$7a45353897a24c5c$exports = function(fn, that) {
    $936bc4e7e1b39b6f$exports(fn);
    return that === undefined ? fn : $0b224d9c80aa3e60$exports ? $7a45353897a24c5c$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};



var $130c954dcf883841$exports = {};
"use strict";



var $130c954dcf883841$var$$Object = Object;
var $130c954dcf883841$var$split = $cc682aa152788262$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$130c954dcf883841$exports = $3c2ab9b4ea4760df$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$130c954dcf883841$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6d78dcf79704944a$exports(it) === "String" ? $130c954dcf883841$var$split(it, "") : $130c954dcf883841$var$$Object(it);
} : $130c954dcf883841$var$$Object;



var $e7355fbb94fc5d58$exports = {};
"use strict";
var $22380859140abb43$exports = {};
"use strict";
var $b9228c0f0dfd3d8a$exports = {};
"use strict";
var $38e03c4432c85462$exports = {};
"use strict";
var $38e03c4432c85462$var$ceil = Math.ceil;
var $38e03c4432c85462$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$38e03c4432c85462$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $38e03c4432c85462$var$floor : $38e03c4432c85462$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$b9228c0f0dfd3d8a$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $38e03c4432c85462$exports(number);
};


var $22380859140abb43$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$22380859140abb43$exports = function(argument) {
    var len = $b9228c0f0dfd3d8a$exports(argument);
    return len > 0 ? $22380859140abb43$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$e7355fbb94fc5d58$exports = function(obj) {
    return $22380859140abb43$exports(obj.length);
};


var $bdd5f6a79f8bda97$exports = {};
"use strict";
var $0ce459c3d685b47b$exports = {};
"use strict";
var $e9f2689e91d30e24$exports = {};
"use strict";

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$e9f2689e91d30e24$exports = Array.isArray || function isArray(argument) {
    return $6d78dcf79704944a$exports(argument) === "Array";
};


var $6180903db96e7c28$exports = {};
"use strict";






var $6180903db96e7c28$var$noop = function noop() {};
var $6180903db96e7c28$var$construct = $cae17ea3610e12cc$exports("Reflect", "construct");
var $6180903db96e7c28$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $6180903db96e7c28$var$exec = $cc682aa152788262$exports($6180903db96e7c28$var$constructorRegExp.exec);
var $6180903db96e7c28$var$INCORRECT_TO_STRING = !$6180903db96e7c28$var$constructorRegExp.test($6180903db96e7c28$var$noop);
var $6180903db96e7c28$var$isConstructorModern = function isConstructor(argument) {
    if (!$999204e0caa7c0da$exports(argument)) return false;
    try {
        $6180903db96e7c28$var$construct($6180903db96e7c28$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $6180903db96e7c28$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$999204e0caa7c0da$exports(argument)) return false;
    switch($0348a0c2acd6d4c4$exports(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $6180903db96e7c28$var$INCORRECT_TO_STRING || !!$6180903db96e7c28$var$exec($6180903db96e7c28$var$constructorRegExp, $2590fb86c79fb443$exports(argument));
    } catch (error) {
        return true;
    }
};
$6180903db96e7c28$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$6180903db96e7c28$exports = !$6180903db96e7c28$var$construct || $3c2ab9b4ea4760df$exports(function() {
    var called;
    return $6180903db96e7c28$var$isConstructorModern($6180903db96e7c28$var$isConstructorModern.call) || !$6180903db96e7c28$var$isConstructorModern(Object) || !$6180903db96e7c28$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $6180903db96e7c28$var$isConstructorLegacy : $6180903db96e7c28$var$isConstructorModern;




var $0ce459c3d685b47b$var$SPECIES = $131460ececef5983$exports("species");
var $0ce459c3d685b47b$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$0ce459c3d685b47b$exports = function(originalArray) {
    var C;
    if ($e9f2689e91d30e24$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($6180903db96e7c28$exports(C) && (C === $0ce459c3d685b47b$var$$Array || $e9f2689e91d30e24$exports(C.prototype))) C = undefined;
        else if ($843e5056f67bf37c$exports(C)) {
            C = C[$0ce459c3d685b47b$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $0ce459c3d685b47b$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$bdd5f6a79f8bda97$exports = function(originalArray, length) {
    return new ($0ce459c3d685b47b$exports(originalArray))(length === 0 ? 0 : length);
};


var $cfd9d595464d1cfe$var$push = $cc682aa152788262$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $cfd9d595464d1cfe$var$createMethod = function createMethod(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $e2a51ca67adb8a11$exports($this);
        var self = $130c954dcf883841$exports(O);
        var length = $e7355fbb94fc5d58$exports(self);
        var boundFunction = $7a45353897a24c5c$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $bdd5f6a79f8bda97$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $cfd9d595464d1cfe$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $cfd9d595464d1cfe$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$cfd9d595464d1cfe$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $cfd9d595464d1cfe$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $cfd9d595464d1cfe$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $cfd9d595464d1cfe$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $cfd9d595464d1cfe$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $cfd9d595464d1cfe$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $cfd9d595464d1cfe$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $cfd9d595464d1cfe$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $cfd9d595464d1cfe$var$createMethod(7)
};


var $c55ebe9f2c33b9b5$require$$forEach = $cfd9d595464d1cfe$exports.forEach;
var $2b4b1483b339e862$exports = {};
"use strict";

$2b4b1483b339e862$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $3c2ab9b4ea4760df$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};


var $c55ebe9f2c33b9b5$var$STRICT_METHOD = $2b4b1483b339e862$exports("forEach");
// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
$c55ebe9f2c33b9b5$exports = !$c55ebe9f2c33b9b5$var$STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
    return $c55ebe9f2c33b9b5$require$$forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;



var $6c2e0971a4649982$var$handlePrototype = function handlePrototype(CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype && CollectionPrototype.forEach !== $c55ebe9f2c33b9b5$exports) try {
        $d4687f5727b08995$exports(CollectionPrototype, "forEach", $c55ebe9f2c33b9b5$exports);
    } catch (error) {
        CollectionPrototype.forEach = $c55ebe9f2c33b9b5$exports;
    }
};
for(var $6c2e0971a4649982$var$COLLECTION_NAME in $641c2b904096fda5$exports)if ($641c2b904096fda5$exports[$6c2e0971a4649982$var$COLLECTION_NAME]) $6c2e0971a4649982$var$handlePrototype($605c5cd9c3aed513$exports[$6c2e0971a4649982$var$COLLECTION_NAME] && $605c5cd9c3aed513$exports[$6c2e0971a4649982$var$COLLECTION_NAME].prototype);
$6c2e0971a4649982$var$handlePrototype($e097927bd9e0dd3a$exports);


var $67316715b856f0c7$exports = {};
var $67316715b856f0c7$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$67316715b856f0c7$exports = $67316715b856f0c7$var$canUseDOM;


"use strict";
var $6341b48e77c95e91$exports = {};

var $3J8Kb = parcelRequire("3J8Kb");
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $a4826332e4dbc169$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $c31f9153ca9c50d7$export$2d1720544b23b823;
"use strict";
var $c31f9153ca9c50d7$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $c31f9153ca9c50d7$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $c31f9153ca9c50d7$var$NASHORN_BUG = $c31f9153ca9c50d7$var$getOwnPropertyDescriptor && !$c31f9153ca9c50d7$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$c31f9153ca9c50d7$export$2d1720544b23b823 = $c31f9153ca9c50d7$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $c31f9153ca9c50d7$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $c31f9153ca9c50d7$var$$propertyIsEnumerable;



var $e2ddf11d05308d2c$exports = {};
"use strict";


$e2ddf11d05308d2c$exports = function(it) {
    return $130c954dcf883841$exports($845f3e9d2f4f3629$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $a4826332e4dbc169$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$a4826332e4dbc169$export$2d1720544b23b823 = $2708db8aa4e8f4d2$exports ? $a4826332e4dbc169$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $e2ddf11d05308d2c$exports(O);
    P = $3fab48cb13316330$exports(P);
    if ($4ddf1d1933f327b4$exports) try {
        return $a4826332e4dbc169$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($f54d86fb147e81a3$exports(O, P)) return $eda28ded52679ffb$exports(!$a34142376931cf1e$exports($c31f9153ca9c50d7$export$2d1720544b23b823, O, P), O[P]);
};


var $6341b48e77c95e91$require$getOwnPropertyDescriptor = $a4826332e4dbc169$export$2d1720544b23b823;



var $b9385fb5827130da$exports = {};
"use strict";

var $23acf49e07b14cd5$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $9c72f18da8c8234d$export$2d1720544b23b823;
"use strict";
var $ce53f9f12b58993c$exports = {};
"use strict";



var $e50fde61bc27e418$exports = {};
"use strict";

var $c613fa7788798eb2$exports = {};
"use strict";

var $c613fa7788798eb2$var$max = Math.max;
var $c613fa7788798eb2$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$c613fa7788798eb2$exports = function(index, length) {
    var integer = $b9228c0f0dfd3d8a$exports(index);
    return integer < 0 ? $c613fa7788798eb2$var$max(integer + length, 0) : $c613fa7788798eb2$var$min(integer, length);
};



// `Array.prototype.{ indexOf, includes }` methods implementation
var $e50fde61bc27e418$var$createMethod = function createMethod(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $e2ddf11d05308d2c$exports($this);
        var length = $e7355fbb94fc5d58$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $c613fa7788798eb2$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$e50fde61bc27e418$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $e50fde61bc27e418$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $e50fde61bc27e418$var$createMethod(false)
};


var $ce53f9f12b58993c$require$indexOf = $e50fde61bc27e418$exports.indexOf;

var $ce53f9f12b58993c$var$push = $cc682aa152788262$exports([].push);
$ce53f9f12b58993c$exports = function(object, names) {
    var O = $e2ddf11d05308d2c$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$f54d86fb147e81a3$exports($fd3671a46f760b77$exports, key) && $f54d86fb147e81a3$exports(O, key) && $ce53f9f12b58993c$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($f54d86fb147e81a3$exports(O, key = names[i++])) ~$ce53f9f12b58993c$require$indexOf(result, key) || $ce53f9f12b58993c$var$push(result, key);
    return result;
};


var $09c580bad628c1e7$exports = {};
"use strict";
// IE8- don't enum bug keys
$09c580bad628c1e7$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $9c72f18da8c8234d$var$hiddenKeys = $09c580bad628c1e7$exports.concat("length", "prototype");
$9c72f18da8c8234d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $ce53f9f12b58993c$exports(O, $9c72f18da8c8234d$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $123df831a5495aa0$export$2d1720544b23b823;
"use strict";
$123df831a5495aa0$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $23acf49e07b14cd5$var$concat = $cc682aa152788262$exports([].concat);
// all object keys, includes non-enumerable and symbols
$23acf49e07b14cd5$exports = $cae17ea3610e12cc$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $9c72f18da8c8234d$export$2d1720544b23b823($2d779c9560717a35$exports(it));
    var getOwnPropertySymbols = $123df831a5495aa0$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $23acf49e07b14cd5$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$b9385fb5827130da$exports = function(target, source, exceptions) {
    var keys = $23acf49e07b14cd5$exports(source);
    var defineProperty = $324f102fb15ae006$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $a4826332e4dbc169$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$f54d86fb147e81a3$exports(target, key) && !(exceptions && $f54d86fb147e81a3$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $20b751cdc07e213d$exports = {};
"use strict";


var $20b751cdc07e213d$var$replacement = /#|\.prototype\./;
var $20b751cdc07e213d$var$isForced = function isForced(feature, detection) {
    var value = $20b751cdc07e213d$var$data[$20b751cdc07e213d$var$normalize(feature)];
    return value === $20b751cdc07e213d$var$POLYFILL ? true : value === $20b751cdc07e213d$var$NATIVE ? false : $999204e0caa7c0da$exports(detection) ? $3c2ab9b4ea4760df$exports(detection) : !!detection;
};
var $20b751cdc07e213d$var$normalize = $20b751cdc07e213d$var$isForced.normalize = function normalize(string) {
    return String(string).replace($20b751cdc07e213d$var$replacement, ".").toLowerCase();
};
var $20b751cdc07e213d$var$data = $20b751cdc07e213d$var$isForced.data = {};
var $20b751cdc07e213d$var$NATIVE = $20b751cdc07e213d$var$isForced.NATIVE = "N";
var $20b751cdc07e213d$var$POLYFILL = $20b751cdc07e213d$var$isForced.POLYFILL = "P";
$20b751cdc07e213d$exports = $20b751cdc07e213d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $6341b48e77c95e91$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $605c5cd9c3aed513$exports;
    else if (STATIC) target = $605c5cd9c3aed513$exports[TARGET] || $12dd487eba75164c$exports(TARGET, {});
    else target = $605c5cd9c3aed513$exports[TARGET] && $605c5cd9c3aed513$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $6341b48e77c95e91$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $20b751cdc07e213d$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if ((typeof sourceProperty === "undefined" ? "undefined" : (0, $3J8Kb._)(sourceProperty)) == (typeof targetProperty === "undefined" ? "undefined" : (0, $3J8Kb._)(targetProperty))) continue;
            $b9385fb5827130da$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $d4687f5727b08995$exports(sourceProperty, "sham", true);
        $c9272b287f1d50a0$exports(target, key, sourceProperty, options);
    }
};


var $e5dd0090ce354116$exports = {};
"use strict";



var $8184f16f0ff2a2de$exports = {};
"use strict";

var $8184f16f0ff2a2de$var$$String = String;
$8184f16f0ff2a2de$exports = function(argument) {
    if ($0348a0c2acd6d4c4$exports(argument) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return $8184f16f0ff2a2de$var$$String(argument);
};


var $873265696b616d3c$exports = {};
"use strict";



var $80ce80abea41b899$exports = {};
"use strict";
// a string of all valid unicode whitespaces
$80ce80abea41b899$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $873265696b616d3c$var$replace = $cc682aa152788262$exports("".replace);
var $873265696b616d3c$var$ltrim = RegExp("^[" + $80ce80abea41b899$exports + "]+");
var $873265696b616d3c$var$rtrim = RegExp("(^|[^" + $80ce80abea41b899$exports + "])[" + $80ce80abea41b899$exports + "]+$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $873265696b616d3c$var$createMethod = function createMethod(TYPE) {
    return function($this) {
        var string = $8184f16f0ff2a2de$exports($845f3e9d2f4f3629$exports($this));
        if (TYPE & 1) string = $873265696b616d3c$var$replace(string, $873265696b616d3c$var$ltrim, "");
        if (TYPE & 2) string = $873265696b616d3c$var$replace(string, $873265696b616d3c$var$rtrim, "$1");
        return string;
    };
};
$873265696b616d3c$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $873265696b616d3c$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $873265696b616d3c$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $873265696b616d3c$var$createMethod(3)
};


var $e5dd0090ce354116$require$trim = $873265696b616d3c$exports.trim;

var $e5dd0090ce354116$var$$parseInt = $605c5cd9c3aed513$exports.parseInt;
var $e5dd0090ce354116$var$Symbol = $605c5cd9c3aed513$exports.Symbol;
var $e5dd0090ce354116$var$ITERATOR = $e5dd0090ce354116$var$Symbol && $e5dd0090ce354116$var$Symbol.iterator;
var $e5dd0090ce354116$var$hex = /^[+-]?0x/i;
var $e5dd0090ce354116$var$exec = $cc682aa152788262$exports($e5dd0090ce354116$var$hex.exec);
var $e5dd0090ce354116$var$FORCED = $e5dd0090ce354116$var$$parseInt($80ce80abea41b899$exports + "08") !== 8 || $e5dd0090ce354116$var$$parseInt($80ce80abea41b899$exports + "0x16") !== 22 || $e5dd0090ce354116$var$ITERATOR && !$3c2ab9b4ea4760df$exports(function() {
    $e5dd0090ce354116$var$$parseInt(Object($e5dd0090ce354116$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$e5dd0090ce354116$exports = $e5dd0090ce354116$var$FORCED ? function parseInt(string, radix) {
    var S = $e5dd0090ce354116$require$trim($8184f16f0ff2a2de$exports(string));
    return $e5dd0090ce354116$var$$parseInt(S, radix >>> 0 || ($e5dd0090ce354116$var$exec($e5dd0090ce354116$var$hex, S) ? 16 : 10));
} : $e5dd0090ce354116$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$6341b48e77c95e91$exports({
    global: true,
    forced: parseInt !== $e5dd0090ce354116$exports
}, {
    parseInt: $e5dd0090ce354116$exports
});


"use strict";

var $7f38325527305c50$exports = {};
"use strict";




var $e850e862aa0a3ce2$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$e850e862aa0a3ce2$exports = Object.keys || function keys(O) {
    return $ce53f9f12b58993c$exports(O, $09c580bad628c1e7$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $7f38325527305c50$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $7f38325527305c50$var$defineProperty = Object.defineProperty;
var $7f38325527305c50$var$concat = $cc682aa152788262$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$7f38325527305c50$exports = !$7f38325527305c50$var$$assign || $3c2ab9b4ea4760df$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($2708db8aa4e8f4d2$exports && $7f38325527305c50$var$$assign({
        b: 1
    }, $7f38325527305c50$var$$assign($7f38325527305c50$var$defineProperty({}, "a", {
        enumerable: true,
        get: function get() {
            $7f38325527305c50$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol("assign detection");
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $7f38325527305c50$var$$assign({}, A)[symbol] !== 7 || $e850e862aa0a3ce2$exports($7f38325527305c50$var$$assign({}, B)).join("") !== alphabet;
}) ? function assign(target, source) {
    var T = $e2a51ca67adb8a11$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $123df831a5495aa0$export$2d1720544b23b823;
    var propertyIsEnumerable = $c31f9153ca9c50d7$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $130c954dcf883841$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $7f38325527305c50$var$concat($e850e862aa0a3ce2$exports(S), getOwnPropertySymbols(S)) : $e850e862aa0a3ce2$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2708db8aa4e8f4d2$exports || $a34142376931cf1e$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $7f38325527305c50$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$6341b48e77c95e91$exports({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $7f38325527305c50$exports
}, {
    assign: $7f38325527305c50$exports
});


"use strict";


var $b825b43eba267fe0$require$$filter = $cfd9d595464d1cfe$exports.filter;
var $d3f47c6466d06346$exports = {};
"use strict";



var $d3f47c6466d06346$var$SPECIES = $131460ececef5983$exports("species");
$d3f47c6466d06346$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $d9b80d2e05132a69$exports >= 51 || !$3c2ab9b4ea4760df$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$d3f47c6466d06346$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $b825b43eba267fe0$var$HAS_SPECIES_SUPPORT = $d3f47c6466d06346$exports("filter");
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$6341b48e77c95e91$exports({
    target: "Array",
    proto: true,
    forced: !$b825b43eba267fe0$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $b825b43eba267fe0$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


var $e20e87ec735d26e0$exports = {};
"use strict";

var $64732281c22b91b5$exports = {};
"use strict";

var $6d22990bd5a876d2$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $a47aaa5c3275228a$export$2d1720544b23b823;
"use strict";






$a47aaa5c3275228a$export$2d1720544b23b823 = $2708db8aa4e8f4d2$exports && !$0f93f7afb263258e$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $2d779c9560717a35$exports(O);
    var props = $e2ddf11d05308d2c$exports(Properties);
    var keys = $e850e862aa0a3ce2$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$324f102fb15ae006$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $0b9a4b788f424ae0$exports = {};
"use strict";

$0b9a4b788f424ae0$exports = $cae17ea3610e12cc$exports("document", "documentElement");




var $6d22990bd5a876d2$var$GT = ">";
var $6d22990bd5a876d2$var$LT = "<";
var $6d22990bd5a876d2$var$PROTOTYPE = "prototype";
var $6d22990bd5a876d2$var$SCRIPT = "script";
var $6d22990bd5a876d2$var$IE_PROTO = $4b15c5cd71f344f1$exports("IE_PROTO");
var $6d22990bd5a876d2$var$EmptyConstructor = function EmptyConstructor() {};
var $6d22990bd5a876d2$var$scriptTag = function scriptTag(content) {
    return $6d22990bd5a876d2$var$LT + $6d22990bd5a876d2$var$SCRIPT + $6d22990bd5a876d2$var$GT + content + $6d22990bd5a876d2$var$LT + "/" + $6d22990bd5a876d2$var$SCRIPT + $6d22990bd5a876d2$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $6d22990bd5a876d2$var$NullProtoObjectViaActiveX = function NullProtoObjectViaActiveX(activeXDocument) {
    activeXDocument.write($6d22990bd5a876d2$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6d22990bd5a876d2$var$NullProtoObjectViaIFrame = function NullProtoObjectViaIFrame() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $1b51fc38223748c6$exports("iframe");
    var JS = "java" + $6d22990bd5a876d2$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $0b9a4b788f424ae0$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($6d22990bd5a876d2$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $6d22990bd5a876d2$var$activeXDocument;
var $6d22990bd5a876d2$var$NullProtoObject = function NullProtoObject1() {
    try {
        $6d22990bd5a876d2$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $6d22990bd5a876d2$var$NullProtoObject = typeof document != "undefined" ? document.domain && $6d22990bd5a876d2$var$activeXDocument ? $6d22990bd5a876d2$var$NullProtoObjectViaActiveX($6d22990bd5a876d2$var$activeXDocument) // old IE
     : $6d22990bd5a876d2$var$NullProtoObjectViaIFrame() : $6d22990bd5a876d2$var$NullProtoObjectViaActiveX($6d22990bd5a876d2$var$activeXDocument); // WSH
    var length = $09c580bad628c1e7$exports.length;
    while(length--)delete $6d22990bd5a876d2$var$NullProtoObject[$6d22990bd5a876d2$var$PROTOTYPE][$09c580bad628c1e7$exports[length]];
    return $6d22990bd5a876d2$var$NullProtoObject();
};
$fd3671a46f760b77$exports[$6d22990bd5a876d2$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$6d22990bd5a876d2$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6d22990bd5a876d2$var$EmptyConstructor[$6d22990bd5a876d2$var$PROTOTYPE] = $2d779c9560717a35$exports(O);
        result = new $6d22990bd5a876d2$var$EmptyConstructor();
        $6d22990bd5a876d2$var$EmptyConstructor[$6d22990bd5a876d2$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6d22990bd5a876d2$var$IE_PROTO] = O;
    } else result = $6d22990bd5a876d2$var$NullProtoObject();
    return Properties === undefined ? result : $a47aaa5c3275228a$export$2d1720544b23b823(result, Properties);
};



var $64732281c22b91b5$require$defineProperty = $324f102fb15ae006$export$2d1720544b23b823;
var $64732281c22b91b5$var$UNSCOPABLES = $131460ececef5983$exports("unscopables");
var $64732281c22b91b5$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($64732281c22b91b5$var$ArrayPrototype[$64732281c22b91b5$var$UNSCOPABLES] === undefined) $64732281c22b91b5$require$defineProperty($64732281c22b91b5$var$ArrayPrototype, $64732281c22b91b5$var$UNSCOPABLES, {
    configurable: true,
    value: $6d22990bd5a876d2$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$64732281c22b91b5$exports = function(key) {
    $64732281c22b91b5$var$ArrayPrototype[$64732281c22b91b5$var$UNSCOPABLES][key] = true;
};


var $7ab5974c8ad6de09$exports = {};
"use strict";
$7ab5974c8ad6de09$exports = {};




var $e20e87ec735d26e0$require$defineProperty = $324f102fb15ae006$export$2d1720544b23b823;
var $98058249e997ad30$exports = {};
"use strict";





var $2228c168f99c143f$exports = {};
"use strict";
var $5baaed153d3b1050$exports = {};
"use strict";




var $d966c71609246683$exports = {};
"use strict";




var $e850f2cd0d4ce1c5$exports = {};
"use strict";

$e850f2cd0d4ce1c5$exports = !$3c2ab9b4ea4760df$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $d966c71609246683$var$IE_PROTO = $4b15c5cd71f344f1$exports("IE_PROTO");
var $d966c71609246683$var$$Object = Object;
var $d966c71609246683$var$ObjectPrototype = $d966c71609246683$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$d966c71609246683$exports = $e850f2cd0d4ce1c5$exports ? $d966c71609246683$var$$Object.getPrototypeOf : function(O) {
    var object = $e2a51ca67adb8a11$exports(O);
    if ($f54d86fb147e81a3$exports(object, $d966c71609246683$var$IE_PROTO)) return object[$d966c71609246683$var$IE_PROTO];
    var constructor = object.constructor;
    if ($999204e0caa7c0da$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $d966c71609246683$var$$Object ? $d966c71609246683$var$ObjectPrototype : null;
};





var $5baaed153d3b1050$var$ITERATOR = $131460ececef5983$exports("iterator");
var $5baaed153d3b1050$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5baaed153d3b1050$var$IteratorPrototype, $5baaed153d3b1050$var$PrototypeOfArrayIteratorPrototype, $5baaed153d3b1050$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $5baaed153d3b1050$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5baaed153d3b1050$var$arrayIterator)) $5baaed153d3b1050$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $5baaed153d3b1050$var$PrototypeOfArrayIteratorPrototype = $d966c71609246683$exports($d966c71609246683$exports($5baaed153d3b1050$var$arrayIterator));
        if ($5baaed153d3b1050$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5baaed153d3b1050$var$IteratorPrototype = $5baaed153d3b1050$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5baaed153d3b1050$var$NEW_ITERATOR_PROTOTYPE = !$843e5056f67bf37c$exports($5baaed153d3b1050$var$IteratorPrototype) || $3c2ab9b4ea4760df$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5baaed153d3b1050$var$IteratorPrototype[$5baaed153d3b1050$var$ITERATOR].call(test) !== test;
});
if ($5baaed153d3b1050$var$NEW_ITERATOR_PROTOTYPE) $5baaed153d3b1050$var$IteratorPrototype = {};
else if ($5bff024010083d10$exports) $5baaed153d3b1050$var$IteratorPrototype = $6d22990bd5a876d2$exports($5baaed153d3b1050$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$999204e0caa7c0da$exports($5baaed153d3b1050$var$IteratorPrototype[$5baaed153d3b1050$var$ITERATOR])) $c9272b287f1d50a0$exports($5baaed153d3b1050$var$IteratorPrototype, $5baaed153d3b1050$var$ITERATOR, function() {
    return this;
});
$5baaed153d3b1050$exports = {
    IteratorPrototype: $5baaed153d3b1050$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $5baaed153d3b1050$var$BUGGY_SAFARI_ITERATORS
};


var $2228c168f99c143f$require$IteratorPrototype = $5baaed153d3b1050$exports.IteratorPrototype;


var $709128e4e81623f2$exports = {};
"use strict";

var $709128e4e81623f2$require$defineProperty = $324f102fb15ae006$export$2d1720544b23b823;


var $709128e4e81623f2$var$TO_STRING_TAG = $131460ececef5983$exports("toStringTag");
$709128e4e81623f2$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$f54d86fb147e81a3$exports(target, $709128e4e81623f2$var$TO_STRING_TAG)) $709128e4e81623f2$require$defineProperty(target, $709128e4e81623f2$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $2228c168f99c143f$var$returnThis = function returnThis() {
    return this;
};
$2228c168f99c143f$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $6d22990bd5a876d2$exports($2228c168f99c143f$require$IteratorPrototype, {
        next: $eda28ded52679ffb$exports(+!ENUMERABLE_NEXT, next)
    });
    $709128e4e81623f2$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $7ab5974c8ad6de09$exports[TO_STRING_TAG] = $2228c168f99c143f$var$returnThis;
    return IteratorConstructor;
};



var $d96f80f3c6c6c6e0$exports = {};
"use strict";
var $836c1a9d67a05f24$exports = {};
"use strict";


$836c1a9d67a05f24$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $cc682aa152788262$exports($936bc4e7e1b39b6f$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $351973eb0b68ea60$exports = {};
"use strict";
var $4d452333edb74048$exports = {};
"use strict";

$4d452333edb74048$exports = function(argument) {
    return $843e5056f67bf37c$exports(argument) || argument === null;
};


var $351973eb0b68ea60$var$$String = String;
var $351973eb0b68ea60$var$$TypeError = TypeError;
$351973eb0b68ea60$exports = function(argument) {
    if ($4d452333edb74048$exports(argument)) return argument;
    throw new $351973eb0b68ea60$var$$TypeError("Can't set " + $351973eb0b68ea60$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$d96f80f3c6c6c6e0$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $836c1a9d67a05f24$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $845f3e9d2f4f3629$exports(O);
        $351973eb0b68ea60$exports(proto);
        if (!$843e5056f67bf37c$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $98058249e997ad30$var$PROPER_FUNCTION_NAME = $2356260dee87883e$exports.PROPER;
var $98058249e997ad30$var$CONFIGURABLE_FUNCTION_NAME = $2356260dee87883e$exports.CONFIGURABLE;
var $98058249e997ad30$var$IteratorPrototype = $5baaed153d3b1050$exports.IteratorPrototype;
var $98058249e997ad30$var$BUGGY_SAFARI_ITERATORS = $5baaed153d3b1050$exports.BUGGY_SAFARI_ITERATORS;
var $98058249e997ad30$var$ITERATOR = $131460ececef5983$exports("iterator");
var $98058249e997ad30$var$KEYS = "keys";
var $98058249e997ad30$var$VALUES = "values";
var $98058249e997ad30$var$ENTRIES = "entries";
var $98058249e997ad30$var$returnThis = function returnThis() {
    return this;
};
$98058249e997ad30$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2228c168f99c143f$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function getIterationMethod(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$98058249e997ad30$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $98058249e997ad30$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $98058249e997ad30$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $98058249e997ad30$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$98058249e997ad30$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$98058249e997ad30$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $d966c71609246683$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$5bff024010083d10$exports && $d966c71609246683$exports(CurrentIteratorPrototype) !== $98058249e997ad30$var$IteratorPrototype) {
                if ($d96f80f3c6c6c6e0$exports) $d96f80f3c6c6c6e0$exports(CurrentIteratorPrototype, $98058249e997ad30$var$IteratorPrototype);
                else if (!$999204e0caa7c0da$exports(CurrentIteratorPrototype[$98058249e997ad30$var$ITERATOR])) $c9272b287f1d50a0$exports(CurrentIteratorPrototype, $98058249e997ad30$var$ITERATOR, $98058249e997ad30$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $709128e4e81623f2$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($5bff024010083d10$exports) $7ab5974c8ad6de09$exports[TO_STRING_TAG] = $98058249e997ad30$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($98058249e997ad30$var$PROPER_FUNCTION_NAME && DEFAULT === $98058249e997ad30$var$VALUES && nativeIterator && nativeIterator.name !== $98058249e997ad30$var$VALUES) {
        if (!$5bff024010083d10$exports && $98058249e997ad30$var$CONFIGURABLE_FUNCTION_NAME) $d4687f5727b08995$exports(IterablePrototype, "name", $98058249e997ad30$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $a34142376931cf1e$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($98058249e997ad30$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($98058249e997ad30$var$KEYS),
            entries: getIterationMethod($98058249e997ad30$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($98058249e997ad30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $c9272b287f1d50a0$exports(IterablePrototype, KEY, methods[KEY]);
        } else $6341b48e77c95e91$exports({
            target: NAME,
            proto: true,
            forced: $98058249e997ad30$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$5bff024010083d10$exports || FORCED) && IterablePrototype[$98058249e997ad30$var$ITERATOR] !== defaultIterator) $c9272b287f1d50a0$exports(IterablePrototype, $98058249e997ad30$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $7ab5974c8ad6de09$exports[NAME] = defaultIterator;
    return methods;
};


var $d4d5662e9d66c792$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$d4d5662e9d66c792$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $e20e87ec735d26e0$var$ARRAY_ITERATOR = "Array Iterator";
var $e20e87ec735d26e0$var$setInternalState = $8c7995ce54ba35ed$exports.set;
var $e20e87ec735d26e0$var$getInternalState = $8c7995ce54ba35ed$exports.getterFor($e20e87ec735d26e0$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$e20e87ec735d26e0$exports = $98058249e997ad30$exports(Array, "Array", function(iterated, kind) {
    $e20e87ec735d26e0$var$setInternalState(this, {
        type: $e20e87ec735d26e0$var$ARRAY_ITERATOR,
        target: $e2ddf11d05308d2c$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $e20e87ec735d26e0$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $d4d5662e9d66c792$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $d4d5662e9d66c792$exports(index, false);
        case "values":
            return $d4d5662e9d66c792$exports(target[index], false);
    }
    return $d4d5662e9d66c792$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $e20e87ec735d26e0$var$values = $7ab5974c8ad6de09$exports.Arguments = $7ab5974c8ad6de09$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$64732281c22b91b5$exports("keys");
$64732281c22b91b5$exports("values");
$64732281c22b91b5$exports("entries");
// V8 ~ Chrome 45- bug
if (!$5bff024010083d10$exports && $2708db8aa4e8f4d2$exports && $e20e87ec735d26e0$var$values.name !== "values") try {
    $e20e87ec735d26e0$require$defineProperty($e20e87ec735d26e0$var$values, "name", {
        value: "values"
    });
} catch (error) {}


"use strict";
var $843797b2b79f64a9$exports = {};
"use strict";




var $843797b2b79f64a9$var$charAt = $cc682aa152788262$exports("".charAt);
var $843797b2b79f64a9$var$charCodeAt = $cc682aa152788262$exports("".charCodeAt);
var $843797b2b79f64a9$var$stringSlice = $cc682aa152788262$exports("".slice);
var $843797b2b79f64a9$var$createMethod = function createMethod(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $8184f16f0ff2a2de$exports($845f3e9d2f4f3629$exports($this));
        var position = $b9228c0f0dfd3d8a$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $843797b2b79f64a9$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $843797b2b79f64a9$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $843797b2b79f64a9$var$charAt(S, position) : first : CONVERT_TO_STRING ? $843797b2b79f64a9$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$843797b2b79f64a9$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $843797b2b79f64a9$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $843797b2b79f64a9$var$createMethod(true)
};


var $6dbf7b6b6b246ec9$require$charAt = $843797b2b79f64a9$exports.charAt;




var $6dbf7b6b6b246ec9$var$STRING_ITERATOR = "String Iterator";
var $6dbf7b6b6b246ec9$var$setInternalState = $8c7995ce54ba35ed$exports.set;
var $6dbf7b6b6b246ec9$var$getInternalState = $8c7995ce54ba35ed$exports.getterFor($6dbf7b6b6b246ec9$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$98058249e997ad30$exports(String, "String", function(iterated) {
    $6dbf7b6b6b246ec9$var$setInternalState(this, {
        type: $6dbf7b6b6b246ec9$var$STRING_ITERATOR,
        string: $8184f16f0ff2a2de$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $6dbf7b6b6b246ec9$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $d4d5662e9d66c792$exports(undefined, true);
    point = $6dbf7b6b6b246ec9$require$charAt(string, index);
    state.index += point.length;
    return $d4d5662e9d66c792$exports(point, false);
});


"use strict";
"use strict";
var $6408370b3c24565b$exports = {};
"use strict";

$6408370b3c24565b$exports = !$3c2ab9b4ea4760df$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $6451382f667b5670$exports = {};
"use strict";

$6451382f667b5670$exports = function(target, src, options) {
    for(var key in src)$c9272b287f1d50a0$exports(target, key, src[key], options);
    return target;
};


var $43e71fdc1619f930$exports = {};

var $3J8Kb = parcelRequire("3J8Kb");
"use strict";






var $43e71fdc1619f930$require$defineProperty = $324f102fb15ae006$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $915be9931e0bc886$export$2d1720544b23b823;
"use strict";



var $915be9931e0bc886$require$$getOwnPropertyNames = $9c72f18da8c8234d$export$2d1720544b23b823;
var $70de421722b1d1a4$exports = {};
"use strict";

$70de421722b1d1a4$exports = $cc682aa152788262$exports([].slice);


var $915be9931e0bc886$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $915be9931e0bc886$var$getWindowNames = function getWindowNames(it) {
    try {
        return $915be9931e0bc886$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $70de421722b1d1a4$exports($915be9931e0bc886$var$windowNames);
    }
};
$915be9931e0bc886$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $915be9931e0bc886$var$windowNames && $6d78dcf79704944a$exports(it) === "Window" ? $915be9931e0bc886$var$getWindowNames(it) : $915be9931e0bc886$require$$getOwnPropertyNames($e2ddf11d05308d2c$exports(it));
};


var $de52dec80b7bebf0$exports = {};
"use strict";



var $6f19758626e2bb2a$exports = {};
"use strict";

$6f19758626e2bb2a$exports = $3c2ab9b4ea4760df$exports(function() {
    if (typeof ArrayBuffer == "function") {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, "a", {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $de52dec80b7bebf0$var$$isExtensible = Object.isExtensible;
var $de52dec80b7bebf0$var$FAILS_ON_PRIMITIVES = $3c2ab9b4ea4760df$exports(function() {
    $de52dec80b7bebf0$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$de52dec80b7bebf0$exports = $de52dec80b7bebf0$var$FAILS_ON_PRIMITIVES || $6f19758626e2bb2a$exports ? function isExtensible(it) {
    if (!$843e5056f67bf37c$exports(it)) return false;
    if ($6f19758626e2bb2a$exports && $6d78dcf79704944a$exports(it) === "ArrayBuffer") return false;
    return $de52dec80b7bebf0$var$$isExtensible ? $de52dec80b7bebf0$var$$isExtensible(it) : true;
} : $de52dec80b7bebf0$var$$isExtensible;




var $43e71fdc1619f930$var$REQUIRED = false;
var $43e71fdc1619f930$var$METADATA = $ca2a6c13ba9e533d$exports("meta");
var $43e71fdc1619f930$var$id = 0;
var $43e71fdc1619f930$var$setMetadata = function setMetadata(it) {
    $43e71fdc1619f930$require$defineProperty(it, $43e71fdc1619f930$var$METADATA, {
        value: {
            objectID: "O" + $43e71fdc1619f930$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $43e71fdc1619f930$var$fastKey = function fastKey(it, create) {
    // return a primitive with prefix
    if (!$843e5056f67bf37c$exports(it)) return (typeof it === "undefined" ? "undefined" : (0, $3J8Kb._)(it)) == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$f54d86fb147e81a3$exports(it, $43e71fdc1619f930$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$de52dec80b7bebf0$exports(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $43e71fdc1619f930$var$setMetadata(it);
    // return object ID
    }
    return it[$43e71fdc1619f930$var$METADATA].objectID;
};
var $43e71fdc1619f930$var$getWeakData = function getWeakData(it, create) {
    if (!$f54d86fb147e81a3$exports(it, $43e71fdc1619f930$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$de52dec80b7bebf0$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $43e71fdc1619f930$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$43e71fdc1619f930$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $43e71fdc1619f930$var$onFreeze = function onFreeze(it) {
    if ($6408370b3c24565b$exports && $43e71fdc1619f930$var$REQUIRED && $de52dec80b7bebf0$exports(it) && !$f54d86fb147e81a3$exports(it, $43e71fdc1619f930$var$METADATA)) $43e71fdc1619f930$var$setMetadata(it);
    return it;
};
var $43e71fdc1619f930$var$enable = function enable() {
    $43e71fdc1619f930$var$meta.enable = function() {};
    $43e71fdc1619f930$var$REQUIRED = true;
    var getOwnPropertyNames = $9c72f18da8c8234d$export$2d1720544b23b823;
    var splice = $cc682aa152788262$exports([].splice);
    var test = {};
    test[$43e71fdc1619f930$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $9c72f18da8c8234d$export$2d1720544b23b823 = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $43e71fdc1619f930$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $6341b48e77c95e91$exports({
            target: "Object",
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $915be9931e0bc886$export$2d1720544b23b823
        });
    }
};
var $43e71fdc1619f930$var$meta = $43e71fdc1619f930$exports = {
    enable: $43e71fdc1619f930$var$enable,
    fastKey: $43e71fdc1619f930$var$fastKey,
    getWeakData: $43e71fdc1619f930$var$getWeakData,
    onFreeze: $43e71fdc1619f930$var$onFreeze
};
$fd3671a46f760b77$exports[$43e71fdc1619f930$var$METADATA] = true;


var $d2b7e6a9fabdb0fe$exports = {};
"use strict";






var $9dd670687fd45ddf$exports = {};
"use strict";




var $771df4c15184bd4b$exports = {};
"use strict";


var $771df4c15184bd4b$var$ITERATOR = $131460ececef5983$exports("iterator");
var $771df4c15184bd4b$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$771df4c15184bd4b$exports = function(it) {
    return it !== undefined && ($7ab5974c8ad6de09$exports.Array === it || $771df4c15184bd4b$var$ArrayPrototype[$771df4c15184bd4b$var$ITERATOR] === it);
};




var $8c5648f157e4cc97$exports = {};
"use strict";




var $d6a17fafff3676fa$exports = {};
"use strict";





var $d6a17fafff3676fa$var$ITERATOR = $131460ececef5983$exports("iterator");
$d6a17fafff3676fa$exports = function(it) {
    if (!$50fb4e8da6ee0e0a$exports(it)) return $a76fffc2ea20877e$exports(it, $d6a17fafff3676fa$var$ITERATOR) || $a76fffc2ea20877e$exports(it, "@@iterator") || $7ab5974c8ad6de09$exports[$0348a0c2acd6d4c4$exports(it)];
};


var $8c5648f157e4cc97$var$$TypeError = TypeError;
$8c5648f157e4cc97$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $d6a17fafff3676fa$exports(argument) : usingIterator;
    if ($936bc4e7e1b39b6f$exports(iteratorMethod)) return $2d779c9560717a35$exports($a34142376931cf1e$exports(iteratorMethod, argument));
    throw new $8c5648f157e4cc97$var$$TypeError($a9ce0b3d37830bdf$exports(argument) + " is not iterable");
};



var $8a353477a4fe5e41$exports = {};
"use strict";



$8a353477a4fe5e41$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $2d779c9560717a35$exports(iterator);
    try {
        innerResult = $a76fffc2ea20877e$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $a34142376931cf1e$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $2d779c9560717a35$exports(innerResult);
    return value;
};


var $9dd670687fd45ddf$var$$TypeError = TypeError;
var $9dd670687fd45ddf$var$Result = function Result(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $9dd670687fd45ddf$var$ResultPrototype = $9dd670687fd45ddf$var$Result.prototype;
$9dd670687fd45ddf$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $7a45353897a24c5c$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function stop(condition) {
        if (iterator) $8a353477a4fe5e41$exports(iterator, "normal", condition);
        return new $9dd670687fd45ddf$var$Result(true, condition);
    };
    var callFn = function callFn(value) {
        if (AS_ENTRIES) {
            $2d779c9560717a35$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $d6a17fafff3676fa$exports(iterable);
        if (!iterFn) throw new $9dd670687fd45ddf$var$$TypeError($a9ce0b3d37830bdf$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($771df4c15184bd4b$exports(iterFn)) {
            for(index = 0, length = $e7355fbb94fc5d58$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $1101a6759fe6d6c0$exports($9dd670687fd45ddf$var$ResultPrototype, result)) return result;
            }
            return new $9dd670687fd45ddf$var$Result(false);
        }
        iterator = $8c5648f157e4cc97$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $a34142376931cf1e$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $8a353477a4fe5e41$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $1101a6759fe6d6c0$exports($9dd670687fd45ddf$var$ResultPrototype, result)) return result;
    }
    return new $9dd670687fd45ddf$var$Result(false);
};


var $9cfc2f5f7d0ef54c$exports = {};
"use strict";

var $9cfc2f5f7d0ef54c$var$$TypeError = TypeError;
$9cfc2f5f7d0ef54c$exports = function(it, Prototype) {
    if ($1101a6759fe6d6c0$exports(Prototype, it)) return it;
    throw new $9cfc2f5f7d0ef54c$var$$TypeError("Incorrect invocation");
};






var $ded5f530bdb6950e$exports = {};
"use strict";

var $ded5f530bdb6950e$var$ITERATOR = $131460ececef5983$exports("iterator");
var $ded5f530bdb6950e$var$SAFE_CLOSING = false;
try {
    var $ded5f530bdb6950e$var$called = 0;
    var $ded5f530bdb6950e$var$iteratorWithReturn = {
        next: function next() {
            return {
                done: !!$ded5f530bdb6950e$var$called++
            };
        },
        "return": function() {
            $ded5f530bdb6950e$var$SAFE_CLOSING = true;
        }
    };
    $ded5f530bdb6950e$var$iteratorWithReturn[$ded5f530bdb6950e$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($ded5f530bdb6950e$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$ded5f530bdb6950e$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$ded5f530bdb6950e$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$ded5f530bdb6950e$var$ITERATOR] = function() {
            return {
                next: function next() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $9a6ec2c8e4ac3bce$exports = {};
"use strict";



// makes subclassing work correct for wrapped built-ins
$9a6ec2c8e4ac3bce$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $d96f80f3c6c6c6e0$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $999204e0caa7c0da$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $843e5056f67bf37c$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $d96f80f3c6c6c6e0$exports($this, NewTargetPrototype);
    return $this;
};


$d2b7e6a9fabdb0fe$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
    var ADDER = IS_MAP ? "set" : "add";
    var NativeConstructor = $605c5cd9c3aed513$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function fixMethod(KEY) {
        var uncurriedNativeMethod = $cc682aa152788262$exports(NativePrototype[KEY]);
        $c9272b287f1d50a0$exports(NativePrototype, KEY, KEY === "add" ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === "delete" ? function(key) {
            return IS_WEAK && !$843e5056f67bf37c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "get" ? function get(key) {
            return IS_WEAK && !$843e5056f67bf37c$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === "has" ? function has(key) {
            return IS_WEAK && !$843e5056f67bf37c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $20b751cdc07e213d$exports(CONSTRUCTOR_NAME, !$999204e0caa7c0da$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$3c2ab9b4ea4760df$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $43e71fdc1619f930$exports.enable();
    } else if ($20b751cdc07e213d$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $3c2ab9b4ea4760df$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $ded5f530bdb6950e$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $3c2ab9b4ea4760df$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $9cfc2f5f7d0ef54c$exports(dummy, NativePrototype);
                var that = $9a6ec2c8e4ac3bce$exports(new NativeConstructor(), dummy, Constructor);
                if (!$50fb4e8da6ee0e0a$exports(iterable)) $9dd670687fd45ddf$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $6341b48e77c95e91$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $709128e4e81623f2$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $2e5931aa8a6878a6$exports = {};
"use strict";



var $2e5931aa8a6878a6$require$getWeakData = $43e71fdc1619f930$exports.getWeakData;








var $2e5931aa8a6878a6$var$setInternalState = $8c7995ce54ba35ed$exports.set;
var $2e5931aa8a6878a6$var$internalStateGetterFor = $8c7995ce54ba35ed$exports.getterFor;
var $2e5931aa8a6878a6$var$find = $cfd9d595464d1cfe$exports.find;
var $2e5931aa8a6878a6$var$findIndex = $cfd9d595464d1cfe$exports.findIndex;
var $2e5931aa8a6878a6$var$splice = $cc682aa152788262$exports([].splice);
var $2e5931aa8a6878a6$var$id = 0;
// fallback for uncaught frozen keys
var $2e5931aa8a6878a6$var$uncaughtFrozenStore = function uncaughtFrozenStore(state) {
    return state.frozen || (state.frozen = new $2e5931aa8a6878a6$var$UncaughtFrozenStore());
};
var $2e5931aa8a6878a6$var$UncaughtFrozenStore = function UncaughtFrozenStore() {
    this.entries = [];
};
var $2e5931aa8a6878a6$var$findUncaughtFrozen = function findUncaughtFrozen(store, key) {
    return $2e5931aa8a6878a6$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$2e5931aa8a6878a6$var$UncaughtFrozenStore.prototype = {
    get: function get(key) {
        var entry = $2e5931aa8a6878a6$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function has(key) {
        return !!$2e5931aa8a6878a6$var$findUncaughtFrozen(this, key);
    },
    set: function set(key, value) {
        var entry = $2e5931aa8a6878a6$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    "delete": function(key) {
        var index = $2e5931aa8a6878a6$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $2e5931aa8a6878a6$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$2e5931aa8a6878a6$exports = {
    getConstructor: function getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $9cfc2f5f7d0ef54c$exports(that, Prototype);
            $2e5931aa8a6878a6$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $2e5931aa8a6878a6$var$id++,
                frozen: undefined
            });
            if (!$50fb4e8da6ee0e0a$exports(iterable)) $9dd670687fd45ddf$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $2e5931aa8a6878a6$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function define(that, key, value) {
            var state = getInternalState(that);
            var data = $2e5931aa8a6878a6$require$getWeakData($2d779c9560717a35$exports(key), true);
            if (data === true) $2e5931aa8a6878a6$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $6451382f667b5670$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            "delete": function(key) {
                var state = getInternalState(this);
                if (!$843e5056f67bf37c$exports(key)) return false;
                var data = $2e5931aa8a6878a6$require$getWeakData(key);
                if (data === true) return $2e5931aa8a6878a6$var$uncaughtFrozenStore(state)["delete"](key);
                return data && $f54d86fb147e81a3$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$843e5056f67bf37c$exports(key)) return false;
                var data = $2e5931aa8a6878a6$require$getWeakData(key);
                if (data === true) return $2e5931aa8a6878a6$var$uncaughtFrozenStore(state).has(key);
                return data && $f54d86fb147e81a3$exports(data, state.id);
            }
        });
        $6451382f667b5670$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($843e5056f67bf37c$exports(key)) {
                    var data = $2e5931aa8a6878a6$require$getWeakData(key);
                    if (data === true) return $2e5931aa8a6878a6$var$uncaughtFrozenStore(state).get(key);
                    return data ? data[state.id] : undefined;
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $bdffd8e320aaecbe$require$enforceInternalState = $8c7995ce54ba35ed$exports.enforce;


var $bdffd8e320aaecbe$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $bdffd8e320aaecbe$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $bdffd8e320aaecbe$var$isExtensible = $bdffd8e320aaecbe$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $bdffd8e320aaecbe$var$isFrozen = $bdffd8e320aaecbe$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $bdffd8e320aaecbe$var$isSealed = $bdffd8e320aaecbe$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $bdffd8e320aaecbe$var$freeze = $bdffd8e320aaecbe$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $bdffd8e320aaecbe$var$seal = $bdffd8e320aaecbe$var$$Object.seal;
var $bdffd8e320aaecbe$var$IS_IE11 = !$605c5cd9c3aed513$exports.ActiveXObject && "ActiveXObject" in $605c5cd9c3aed513$exports;
var $bdffd8e320aaecbe$var$InternalWeakMap;
var $bdffd8e320aaecbe$var$wrapper = function wrapper(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $bdffd8e320aaecbe$var$$WeakMap = $d2b7e6a9fabdb0fe$exports("WeakMap", $bdffd8e320aaecbe$var$wrapper, $2e5931aa8a6878a6$exports);
var $bdffd8e320aaecbe$var$WeakMapPrototype = $bdffd8e320aaecbe$var$$WeakMap.prototype;
var $bdffd8e320aaecbe$var$nativeSet = $cc682aa152788262$exports($bdffd8e320aaecbe$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $bdffd8e320aaecbe$var$hasMSEdgeFreezingBug = function hasMSEdgeFreezingBug() {
    return $6408370b3c24565b$exports && $3c2ab9b4ea4760df$exports(function() {
        var frozenArray = $bdffd8e320aaecbe$var$freeze([]);
        $bdffd8e320aaecbe$var$nativeSet(new $bdffd8e320aaecbe$var$$WeakMap(), frozenArray, 1);
        return !$bdffd8e320aaecbe$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($96b33fd05a185b6e$exports) {
    if ($bdffd8e320aaecbe$var$IS_IE11) {
        $bdffd8e320aaecbe$var$InternalWeakMap = $2e5931aa8a6878a6$exports.getConstructor($bdffd8e320aaecbe$var$wrapper, "WeakMap", true);
        $43e71fdc1619f930$exports.enable();
        var $bdffd8e320aaecbe$var$nativeDelete = $cc682aa152788262$exports($bdffd8e320aaecbe$var$WeakMapPrototype["delete"]);
        var $bdffd8e320aaecbe$var$nativeHas = $cc682aa152788262$exports($bdffd8e320aaecbe$var$WeakMapPrototype.has);
        var $bdffd8e320aaecbe$var$nativeGet = $cc682aa152788262$exports($bdffd8e320aaecbe$var$WeakMapPrototype.get);
        $6451382f667b5670$exports($bdffd8e320aaecbe$var$WeakMapPrototype, {
            "delete": function(key) {
                if ($843e5056f67bf37c$exports(key) && !$bdffd8e320aaecbe$var$isExtensible(key)) {
                    var state = $bdffd8e320aaecbe$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bdffd8e320aaecbe$var$InternalWeakMap();
                    return $bdffd8e320aaecbe$var$nativeDelete(this, key) || state.frozen["delete"](key);
                }
                return $bdffd8e320aaecbe$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($843e5056f67bf37c$exports(key) && !$bdffd8e320aaecbe$var$isExtensible(key)) {
                    var state = $bdffd8e320aaecbe$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bdffd8e320aaecbe$var$InternalWeakMap();
                    return $bdffd8e320aaecbe$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $bdffd8e320aaecbe$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($843e5056f67bf37c$exports(key) && !$bdffd8e320aaecbe$var$isExtensible(key)) {
                    var state = $bdffd8e320aaecbe$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bdffd8e320aaecbe$var$InternalWeakMap();
                    return $bdffd8e320aaecbe$var$nativeHas(this, key) ? $bdffd8e320aaecbe$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $bdffd8e320aaecbe$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($843e5056f67bf37c$exports(key) && !$bdffd8e320aaecbe$var$isExtensible(key)) {
                    var state = $bdffd8e320aaecbe$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $bdffd8e320aaecbe$var$InternalWeakMap();
                    $bdffd8e320aaecbe$var$nativeHas(this, key) ? $bdffd8e320aaecbe$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $bdffd8e320aaecbe$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($bdffd8e320aaecbe$var$hasMSEdgeFreezingBug()) $6451382f667b5670$exports($bdffd8e320aaecbe$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($bdffd8e320aaecbe$var$isArray(key)) {
                if ($bdffd8e320aaecbe$var$isFrozen(key)) arrayIntegrityLevel = $bdffd8e320aaecbe$var$freeze;
                else if ($bdffd8e320aaecbe$var$isSealed(key)) arrayIntegrityLevel = $bdffd8e320aaecbe$var$seal;
            }
            $bdffd8e320aaecbe$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




"use strict";







var $cb9c134a3806e1cc$var$ITERATOR = $131460ececef5983$exports("iterator");
var $cb9c134a3806e1cc$var$ArrayValues = $e20e87ec735d26e0$exports.values;
var $cb9c134a3806e1cc$var$handlePrototype = function handlePrototype(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$cb9c134a3806e1cc$var$ITERATOR] !== $cb9c134a3806e1cc$var$ArrayValues) try {
            $d4687f5727b08995$exports(CollectionPrototype, $cb9c134a3806e1cc$var$ITERATOR, $cb9c134a3806e1cc$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$cb9c134a3806e1cc$var$ITERATOR] = $cb9c134a3806e1cc$var$ArrayValues;
        }
        $709128e4e81623f2$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($641c2b904096fda5$exports[COLLECTION_NAME]) for(var METHOD_NAME in $e20e87ec735d26e0$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $e20e87ec735d26e0$exports[METHOD_NAME]) try {
                $d4687f5727b08995$exports(CollectionPrototype, METHOD_NAME, $e20e87ec735d26e0$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $e20e87ec735d26e0$exports[METHOD_NAME];
            }
        }
    }
};
for(var $cb9c134a3806e1cc$var$COLLECTION_NAME in $641c2b904096fda5$exports)$cb9c134a3806e1cc$var$handlePrototype($605c5cd9c3aed513$exports[$cb9c134a3806e1cc$var$COLLECTION_NAME] && $605c5cd9c3aed513$exports[$cb9c134a3806e1cc$var$COLLECTION_NAME].prototype, $cb9c134a3806e1cc$var$COLLECTION_NAME);
$cb9c134a3806e1cc$var$handlePrototype($e097927bd9e0dd3a$exports, "DOMTokenList");


var $7cf75cb0f1be9192$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $3J8Kb = parcelRequire("3J8Kb");
var $7cf75cb0f1be9192$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $7cf75cb0f1be9192$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $7cf75cb0f1be9192$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $7cf75cb0f1be9192$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $7cf75cb0f1be9192$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $7cf75cb0f1be9192$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $7cf75cb0f1be9192$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $7cf75cb0f1be9192$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $7cf75cb0f1be9192$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $7cf75cb0f1be9192$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $7cf75cb0f1be9192$var$root = $7cf75cb0f1be9192$var$freeGlobal || $7cf75cb0f1be9192$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $7cf75cb0f1be9192$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7cf75cb0f1be9192$var$objectToString = $7cf75cb0f1be9192$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7cf75cb0f1be9192$var$nativeMax = Math.max, $7cf75cb0f1be9192$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $7cf75cb0f1be9192$var$now = function now() {
    return $7cf75cb0f1be9192$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $7cf75cb0f1be9192$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($7cf75cb0f1be9192$var$FUNC_ERROR_TEXT);
    wait = $7cf75cb0f1be9192$var$toNumber(wait) || 0;
    if ($7cf75cb0f1be9192$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $7cf75cb0f1be9192$var$nativeMax($7cf75cb0f1be9192$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $7cf75cb0f1be9192$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $7cf75cb0f1be9192$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($7cf75cb0f1be9192$var$now());
    }
    function debounced() {
        var time = $7cf75cb0f1be9192$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $7cf75cb0f1be9192$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($7cf75cb0f1be9192$var$FUNC_ERROR_TEXT);
    if ($7cf75cb0f1be9192$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $7cf75cb0f1be9192$var$debounce(func, wait, {
        leading: leading,
        maxWait: wait,
        trailing: trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $7cf75cb0f1be9192$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $7cf75cb0f1be9192$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $7cf75cb0f1be9192$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value)) == "symbol" || $7cf75cb0f1be9192$var$isObjectLike(value) && $7cf75cb0f1be9192$var$objectToString.call(value) == $7cf75cb0f1be9192$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $7cf75cb0f1be9192$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($7cf75cb0f1be9192$var$isSymbol(value)) return $7cf75cb0f1be9192$var$NAN;
    if ($7cf75cb0f1be9192$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $7cf75cb0f1be9192$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($7cf75cb0f1be9192$var$reTrim, "");
    var isBinary = $7cf75cb0f1be9192$var$reIsBinary.test(value);
    return isBinary || $7cf75cb0f1be9192$var$reIsOctal.test(value) ? $7cf75cb0f1be9192$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $7cf75cb0f1be9192$var$reIsBadHex.test(value) ? $7cf75cb0f1be9192$var$NAN : +value;
}
$7cf75cb0f1be9192$exports = $7cf75cb0f1be9192$var$throttle;


var $c12adf08fdfff334$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $3J8Kb = parcelRequire("3J8Kb");
var $c12adf08fdfff334$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $c12adf08fdfff334$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $c12adf08fdfff334$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $c12adf08fdfff334$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $c12adf08fdfff334$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $c12adf08fdfff334$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $c12adf08fdfff334$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $c12adf08fdfff334$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $c12adf08fdfff334$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $c12adf08fdfff334$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $c12adf08fdfff334$var$root = $c12adf08fdfff334$var$freeGlobal || $c12adf08fdfff334$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $c12adf08fdfff334$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c12adf08fdfff334$var$objectToString = $c12adf08fdfff334$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c12adf08fdfff334$var$nativeMax = Math.max, $c12adf08fdfff334$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $c12adf08fdfff334$var$now = function now() {
    return $c12adf08fdfff334$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c12adf08fdfff334$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($c12adf08fdfff334$var$FUNC_ERROR_TEXT);
    wait = $c12adf08fdfff334$var$toNumber(wait) || 0;
    if ($c12adf08fdfff334$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $c12adf08fdfff334$var$nativeMax($c12adf08fdfff334$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $c12adf08fdfff334$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $c12adf08fdfff334$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($c12adf08fdfff334$var$now());
    }
    function debounced() {
        var time = $c12adf08fdfff334$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $c12adf08fdfff334$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value);
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c12adf08fdfff334$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $c12adf08fdfff334$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value)) == "symbol" || $c12adf08fdfff334$var$isObjectLike(value) && $c12adf08fdfff334$var$objectToString.call(value) == $c12adf08fdfff334$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $c12adf08fdfff334$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($c12adf08fdfff334$var$isSymbol(value)) return $c12adf08fdfff334$var$NAN;
    if ($c12adf08fdfff334$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $c12adf08fdfff334$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($c12adf08fdfff334$var$reTrim, "");
    var isBinary = $c12adf08fdfff334$var$reIsBinary.test(value);
    return isBinary || $c12adf08fdfff334$var$reIsOctal.test(value) ? $c12adf08fdfff334$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $c12adf08fdfff334$var$reIsBadHex.test(value) ? $c12adf08fdfff334$var$NAN : +value;
}
$c12adf08fdfff334$exports = $c12adf08fdfff334$var$debounce;


var $4a7448379b90077f$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $3J8Kb = parcelRequire("3J8Kb");
var $4a7448379b90077f$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var $4a7448379b90077f$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** `Object#toString` result references. */ var $4a7448379b90077f$var$funcTag = "[object Function]", $4a7448379b90077f$var$genTag = "[object GeneratorFunction]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $4a7448379b90077f$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $4a7448379b90077f$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $4a7448379b90077f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $4a7448379b90077f$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4a7448379b90077f$var$root = $4a7448379b90077f$var$freeGlobal || $4a7448379b90077f$var$freeSelf || Function("return this")();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4a7448379b90077f$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $4a7448379b90077f$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $4a7448379b90077f$var$arrayProto = Array.prototype, $4a7448379b90077f$var$funcProto = Function.prototype, $4a7448379b90077f$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $4a7448379b90077f$var$coreJsData = $4a7448379b90077f$var$root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var $4a7448379b90077f$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($4a7448379b90077f$var$coreJsData && $4a7448379b90077f$var$coreJsData.keys && $4a7448379b90077f$var$coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var $4a7448379b90077f$var$funcToString = $4a7448379b90077f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4a7448379b90077f$var$hasOwnProperty = $4a7448379b90077f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4a7448379b90077f$var$objectToString = $4a7448379b90077f$var$objectProto.toString;
/** Used to detect if a method is native. */ var $4a7448379b90077f$var$reIsNative = RegExp("^" + $4a7448379b90077f$var$funcToString.call($4a7448379b90077f$var$hasOwnProperty).replace($4a7448379b90077f$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var $4a7448379b90077f$var$splice = $4a7448379b90077f$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $4a7448379b90077f$var$Map = $4a7448379b90077f$var$getNative($4a7448379b90077f$var$root, "Map"), $4a7448379b90077f$var$nativeCreate = $4a7448379b90077f$var$getNative(Object, "create");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4a7448379b90077f$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $4a7448379b90077f$var$hashClear() {
    this.__data__ = $4a7448379b90077f$var$nativeCreate ? $4a7448379b90077f$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4a7448379b90077f$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4a7448379b90077f$var$hashGet(key) {
    var data = this.__data__;
    if ($4a7448379b90077f$var$nativeCreate) {
        var result = data[key];
        return result === $4a7448379b90077f$var$HASH_UNDEFINED ? undefined : result;
    }
    return $4a7448379b90077f$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4a7448379b90077f$var$hashHas(key) {
    var data = this.__data__;
    return $4a7448379b90077f$var$nativeCreate ? data[key] !== undefined : $4a7448379b90077f$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $4a7448379b90077f$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $4a7448379b90077f$var$nativeCreate && value === undefined ? $4a7448379b90077f$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$4a7448379b90077f$var$Hash.prototype.clear = $4a7448379b90077f$var$hashClear;
$4a7448379b90077f$var$Hash.prototype["delete"] = $4a7448379b90077f$var$hashDelete;
$4a7448379b90077f$var$Hash.prototype.get = $4a7448379b90077f$var$hashGet;
$4a7448379b90077f$var$Hash.prototype.has = $4a7448379b90077f$var$hashHas;
$4a7448379b90077f$var$Hash.prototype.set = $4a7448379b90077f$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4a7448379b90077f$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $4a7448379b90077f$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4a7448379b90077f$var$listCacheDelete(key) {
    var data = this.__data__, index = $4a7448379b90077f$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $4a7448379b90077f$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4a7448379b90077f$var$listCacheGet(key) {
    var data = this.__data__, index = $4a7448379b90077f$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4a7448379b90077f$var$listCacheHas(key) {
    return $4a7448379b90077f$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $4a7448379b90077f$var$listCacheSet(key, value) {
    var data = this.__data__, index = $4a7448379b90077f$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$4a7448379b90077f$var$ListCache.prototype.clear = $4a7448379b90077f$var$listCacheClear;
$4a7448379b90077f$var$ListCache.prototype["delete"] = $4a7448379b90077f$var$listCacheDelete;
$4a7448379b90077f$var$ListCache.prototype.get = $4a7448379b90077f$var$listCacheGet;
$4a7448379b90077f$var$ListCache.prototype.has = $4a7448379b90077f$var$listCacheHas;
$4a7448379b90077f$var$ListCache.prototype.set = $4a7448379b90077f$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4a7448379b90077f$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $4a7448379b90077f$var$mapCacheClear() {
    this.__data__ = {
        hash: new $4a7448379b90077f$var$Hash,
        map: new ($4a7448379b90077f$var$Map || $4a7448379b90077f$var$ListCache),
        string: new $4a7448379b90077f$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4a7448379b90077f$var$mapCacheDelete(key) {
    return $4a7448379b90077f$var$getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4a7448379b90077f$var$mapCacheGet(key) {
    return $4a7448379b90077f$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4a7448379b90077f$var$mapCacheHas(key) {
    return $4a7448379b90077f$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $4a7448379b90077f$var$mapCacheSet(key, value) {
    $4a7448379b90077f$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$4a7448379b90077f$var$MapCache.prototype.clear = $4a7448379b90077f$var$mapCacheClear;
$4a7448379b90077f$var$MapCache.prototype["delete"] = $4a7448379b90077f$var$mapCacheDelete;
$4a7448379b90077f$var$MapCache.prototype.get = $4a7448379b90077f$var$mapCacheGet;
$4a7448379b90077f$var$MapCache.prototype.has = $4a7448379b90077f$var$mapCacheHas;
$4a7448379b90077f$var$MapCache.prototype.set = $4a7448379b90077f$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4a7448379b90077f$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($4a7448379b90077f$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $4a7448379b90077f$var$baseIsNative(value) {
    if (!$4a7448379b90077f$var$isObject(value) || $4a7448379b90077f$var$isMasked(value)) return false;
    var pattern = $4a7448379b90077f$var$isFunction(value) || $4a7448379b90077f$var$isHostObject(value) ? $4a7448379b90077f$var$reIsNative : $4a7448379b90077f$var$reIsHostCtor;
    return pattern.test($4a7448379b90077f$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $4a7448379b90077f$var$getMapData(map, key) {
    var data = map.__data__;
    return $4a7448379b90077f$var$isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $4a7448379b90077f$var$getNative(object, key) {
    var value = $4a7448379b90077f$var$getValue(object, key);
    return $4a7448379b90077f$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $4a7448379b90077f$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value);
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $4a7448379b90077f$var$isMasked(func) {
    return !!$4a7448379b90077f$var$maskSrcKey && $4a7448379b90077f$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $4a7448379b90077f$var$toSource(func) {
    if (func != null) {
        try {
            return $4a7448379b90077f$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $4a7448379b90077f$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError($4a7448379b90077f$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($4a7448379b90077f$var$memoize.Cache || $4a7448379b90077f$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$4a7448379b90077f$var$memoize.Cache = $4a7448379b90077f$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4a7448379b90077f$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $4a7448379b90077f$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $4a7448379b90077f$var$isObject(value) ? $4a7448379b90077f$var$objectToString.call(value) : "";
    return tag == $4a7448379b90077f$var$funcTag || tag == $4a7448379b90077f$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $4a7448379b90077f$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $3J8Kb._)(value);
    return !!value && (type == "object" || type == "function");
}
$4a7448379b90077f$exports = $4a7448379b90077f$var$memoize;


var $c7278fb7e3fa422f$export$402e76927ebf6a24 = [];


var $9093ecebeeaa27eb$export$63c81bd924f89474 = function hasActiveObservations() {
    return (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $d48aea686b55b9ab$export$8ca35300535e324d = function hasSkippedObservations() {
    return (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $6b8d63a80be7ecbc$var$msg = "ResizeObserver loop completed with undelivered notifications.";
var $6b8d63a80be7ecbc$export$888cb69481582149 = function deliverResizeLoopError() {
    var event;
    if (typeof ErrorEvent === "function") event = new ErrorEvent("error", {
        message: $6b8d63a80be7ecbc$var$msg
    });
    else {
        event = document.createEvent("Event");
        event.initEvent("error", false, false);
        event.message = $6b8d63a80be7ecbc$var$msg;
    }
    window.dispatchEvent(event);
};



var $5dd61d9982045d02$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($5dd61d9982045d02$export$416d111b83cd1483 || ($5dd61d9982045d02$export$416d111b83cd1483 = {}));


var $4474feb7ebee4e7b$export$792f3d81ea979f55 = function freeze(obj) {
    return Object.freeze(obj);
};


var $01fedad67392dd59$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $e68640d1c4677d77$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $1630f4eb52cc1a5b$export$165b39ed277223c2 = function isSVG(target) {
    return target instanceof SVGElement && "getBBox" in target;
};
var $1630f4eb52cc1a5b$export$ee695c13482bb5dd = function isHidden(target) {
    if ($1630f4eb52cc1a5b$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $1630f4eb52cc1a5b$export$45a5e7f76e0caa8d = function isElement(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $1630f4eb52cc1a5b$export$a6eb60f7e7c182ba = function isReplacedElement(target) {
    switch(target.tagName){
        case "INPUT":
            if (target.type !== "image") break;
        case "VIDEO":
        case "AUDIO":
        case "EMBED":
        case "OBJECT":
        case "CANVAS":
        case "IFRAME":
        case "IMG":
            return true;
    }
    return false;
};



var $0ca450a62e4b0dcd$export$90b4d2ff6acb88af = typeof window !== "undefined" ? window : {};


var $238fb458882f4104$var$cache = new WeakMap();
var $238fb458882f4104$var$scrollRegexp = /auto|scroll/;
var $238fb458882f4104$var$verticalRegexp = /^tb|vertical/;
var $238fb458882f4104$var$IE = /msie|trident/i.test((0, $0ca450a62e4b0dcd$export$90b4d2ff6acb88af).navigator && (0, $0ca450a62e4b0dcd$export$90b4d2ff6acb88af).navigator.userAgent);
var $238fb458882f4104$var$parseDimension = function parseDimension(pixel) {
    return parseFloat(pixel || "0");
};
var $238fb458882f4104$var$size = function size(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $01fedad67392dd59$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $238fb458882f4104$var$zeroBoxes = (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $238fb458882f4104$var$size(),
    borderBoxSize: $238fb458882f4104$var$size(),
    contentBoxSize: $238fb458882f4104$var$size(),
    contentRect: new (0, $e68640d1c4677d77$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $238fb458882f4104$export$504d039a9c501c94 = function calculateBoxSizes(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($238fb458882f4104$var$cache.has(target) && !forceRecalculation) return $238fb458882f4104$var$cache.get(target);
    if ((0, $1630f4eb52cc1a5b$export$ee695c13482bb5dd)(target)) {
        $238fb458882f4104$var$cache.set(target, $238fb458882f4104$var$zeroBoxes);
        return $238fb458882f4104$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $1630f4eb52cc1a5b$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$238fb458882f4104$var$IE && cs.boxSizing === "border-box";
    var switchSizes = $238fb458882f4104$var$verticalRegexp.test(cs.writingMode || "");
    var canScrollVertically = !svg && $238fb458882f4104$var$scrollRegexp.test(cs.overflowY || "");
    var canScrollHorizontally = !svg && $238fb458882f4104$var$scrollRegexp.test(cs.overflowX || "");
    var paddingTop = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $238fb458882f4104$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $238fb458882f4104$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $238fb458882f4104$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $238fb458882f4104$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $238fb458882f4104$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $238fb458882f4104$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $e68640d1c4677d77$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $238fb458882f4104$var$cache.set(target, boxes);
    return boxes;
};
var $238fb458882f4104$export$1a78030b04106bdb = function calculateBoxSize(target, observedBox, forceRecalculation) {
    var _a = $238fb458882f4104$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $5dd61d9982045d02$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $5dd61d9982045d02$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $a0c3b81d1a77a62b$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $238fb458882f4104$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4474feb7ebee4e7b$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $05d99c23c30b7d5d$export$f8c8e3b5da1f41d2 = function calculateDepthForNode(node) {
    if ((0, $1630f4eb52cc1a5b$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $1f858e0fc0972a4c$export$9cac928141e5443b = function broadcastActiveObservations() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $a0c3b81d1a77a62b$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $05d99c23c30b7d5d$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $238fb458882f4104$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $ff3da9189f157433$export$9c17b8913a2a3572 = function gatherActiveObservationsAtDepth(depth) {
    (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $05d99c23c30b7d5d$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $37b46d16e1e8df17$export$e54fe5b0f43758f7 = function process() {
    var depth = 0;
    (0, $ff3da9189f157433$export$9c17b8913a2a3572)(depth);
    while((0, $9093ecebeeaa27eb$export$63c81bd924f89474)()){
        depth = (0, $1f858e0fc0972a4c$export$9cac928141e5443b)();
        (0, $ff3da9189f157433$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $d48aea686b55b9ab$export$8ca35300535e324d)()) (0, $6b8d63a80be7ecbc$export$888cb69481582149)();
    return depth > 0;
};



var $8ad2a7cdc8fab2ee$var$trigger;
var $8ad2a7cdc8fab2ee$var$callbacks = [];
var $8ad2a7cdc8fab2ee$var$notify = function notify() {
    return $8ad2a7cdc8fab2ee$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $8ad2a7cdc8fab2ee$export$4c995d4933c4abb = function queueMicroTask(callback) {
    if (!$8ad2a7cdc8fab2ee$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode("");
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $8ad2a7cdc8fab2ee$var$notify();
        }).observe(el_1, config);
        $8ad2a7cdc8fab2ee$var$trigger = function trigger() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $8ad2a7cdc8fab2ee$var$callbacks.push(callback);
    $8ad2a7cdc8fab2ee$var$trigger();
};


var $d70981704dea5058$export$5755c7b572e34c6 = function queueResizeObserver(cb) {
    (0, $8ad2a7cdc8fab2ee$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $33f4c41405f845bd$var$watching = 0;
var $33f4c41405f845bd$var$isWatching = function isWatching() {
    return !!$33f4c41405f845bd$var$watching;
};
var $33f4c41405f845bd$var$CATCH_PERIOD = 250;
var $33f4c41405f845bd$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $33f4c41405f845bd$var$events = [
    "resize",
    "load",
    "transitionend",
    "animationend",
    "animationstart",
    "animationiteration",
    "keyup",
    "keydown",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout",
    "blur",
    "focus"
];
var $33f4c41405f845bd$var$time = function time(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $33f4c41405f845bd$var$scheduled = false;
var $33f4c41405f845bd$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $33f4c41405f845bd$var$CATCH_PERIOD;
        if ($33f4c41405f845bd$var$scheduled) return;
        $33f4c41405f845bd$var$scheduled = true;
        var until = $33f4c41405f845bd$var$time(timeout);
        (0, $d70981704dea5058$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $37b46d16e1e8df17$export$e54fe5b0f43758f7)();
            } finally{
                $33f4c41405f845bd$var$scheduled = false;
                timeout = until - $33f4c41405f845bd$var$time();
                if (!$33f4c41405f845bd$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function cb() {
            return _this.observer && _this.observer.observe(document.body, $33f4c41405f845bd$var$observerConfig);
        };
        document.body ? cb() : (0, $0ca450a62e4b0dcd$export$90b4d2ff6acb88af).addEventListener("DOMContentLoaded", cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $33f4c41405f845bd$var$events.forEach(function(name) {
                return (0, $0ca450a62e4b0dcd$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $33f4c41405f845bd$var$events.forEach(function(name) {
                return (0, $0ca450a62e4b0dcd$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $33f4c41405f845bd$export$d30788f2c20241cd = new $33f4c41405f845bd$var$Scheduler();
var $33f4c41405f845bd$export$1f18a74d42722835 = function updateCount(n) {
    !$33f4c41405f845bd$var$watching && n > 0 && $33f4c41405f845bd$export$d30788f2c20241cd.start();
    $33f4c41405f845bd$var$watching += n;
    !$33f4c41405f845bd$var$watching && $33f4c41405f845bd$export$d30788f2c20241cd.stop();
};





var $bab5ce0cc26fcc68$var$skipNotifyOnElement = function skipNotifyOnElement(target) {
    return !(0, $1630f4eb52cc1a5b$export$165b39ed277223c2)(target) && !(0, $1630f4eb52cc1a5b$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === "inline";
};
var $bab5ce0cc26fcc68$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $5dd61d9982045d02$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $238fb458882f4104$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($bab5ce0cc26fcc68$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $ab839c1f9bd4820e$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $21cc36c27c8a8858$var$observerMap = new WeakMap();
var $21cc36c27c8a8858$var$getObservationIndex = function getObservationIndex(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $21cc36c27c8a8858$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $ab839c1f9bd4820e$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $21cc36c27c8a8858$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $21cc36c27c8a8858$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($21cc36c27c8a8858$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $bab5ce0cc26fcc68$export$fea412043713122)(target, options && options.box));
            (0, $33f4c41405f845bd$export$1f18a74d42722835)(1);
            (0, $33f4c41405f845bd$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $21cc36c27c8a8858$var$observerMap.get(resizeObserver);
        var index = $21cc36c27c8a8858$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $c7278fb7e3fa422f$export$402e76927ebf6a24).splice((0, $c7278fb7e3fa422f$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $33f4c41405f845bd$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $21cc36c27c8a8858$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $fc0f0e5fbeb59b20$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== "function") throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $21cc36c27c8a8858$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $1630f4eb52cc1a5b$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $21cc36c27c8a8858$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $1630f4eb52cc1a5b$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $21cc36c27c8a8858$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $21cc36c27c8a8858$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return "function ResizeObserver () { [polyfill code] }";
    };
    return ResizeObserver;
}();






"use strict";

var $e280af841fc59855$exports = {};
"use strict";




var $e280af841fc59855$var$$TypeError = TypeError;
var $e280af841fc59855$var$REDUCE_EMPTY = "Reduce of empty array with no initial value";
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $e280af841fc59855$var$createMethod = function createMethod(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $e2a51ca67adb8a11$exports(that);
        var self = $130c954dcf883841$exports(O);
        var length = $e7355fbb94fc5d58$exports(O);
        $936bc4e7e1b39b6f$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $e280af841fc59855$var$$TypeError($e280af841fc59855$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $e280af841fc59855$var$$TypeError($e280af841fc59855$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$e280af841fc59855$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $e280af841fc59855$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $e280af841fc59855$var$createMethod(true)
};


var $0bda8ab998c12051$require$$reduce = $e280af841fc59855$exports.left;


var $d03cbb82cb62287f$exports = {};
"use strict";


$d03cbb82cb62287f$exports = $6d78dcf79704944a$exports($605c5cd9c3aed513$exports.process) === "process";


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $0bda8ab998c12051$var$CHROME_BUG = !$d03cbb82cb62287f$exports && $d9b80d2e05132a69$exports > 79 && $d9b80d2e05132a69$exports < 83;
var $0bda8ab998c12051$var$FORCED = $0bda8ab998c12051$var$CHROME_BUG || !$2b4b1483b339e862$exports("reduce");
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$6341b48e77c95e91$exports({
    target: "Array",
    proto: true,
    forced: $0bda8ab998c12051$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $0bda8ab998c12051$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


"use strict";

var $a101ec6548bbbe5b$exports = {};
"use strict";



var $4c312e78d13eb04f$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$4c312e78d13eb04f$exports = function() {
    var that = $2d779c9560717a35$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};


var $612d021ff2a0e9c3$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $612d021ff2a0e9c3$var$$RegExp = $605c5cd9c3aed513$exports.RegExp;
var $612d021ff2a0e9c3$var$UNSUPPORTED_Y = $3c2ab9b4ea4760df$exports(function() {
    var re = $612d021ff2a0e9c3$var$$RegExp("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $612d021ff2a0e9c3$var$MISSED_STICKY = $612d021ff2a0e9c3$var$UNSUPPORTED_Y || $3c2ab9b4ea4760df$exports(function() {
    return !$612d021ff2a0e9c3$var$$RegExp("a", "y").sticky;
});
var $612d021ff2a0e9c3$var$BROKEN_CARET = $612d021ff2a0e9c3$var$UNSUPPORTED_Y || $3c2ab9b4ea4760df$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $612d021ff2a0e9c3$var$$RegExp("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") !== null;
});
$612d021ff2a0e9c3$exports = {
    BROKEN_CARET: $612d021ff2a0e9c3$var$BROKEN_CARET,
    MISSED_STICKY: $612d021ff2a0e9c3$var$MISSED_STICKY,
    UNSUPPORTED_Y: $612d021ff2a0e9c3$var$UNSUPPORTED_Y
};





var $a101ec6548bbbe5b$require$getInternalState = $8c7995ce54ba35ed$exports.get;
var $f6a7373b5fbb9906$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $f6a7373b5fbb9906$var$$RegExp = $605c5cd9c3aed513$exports.RegExp;
$f6a7373b5fbb9906$exports = $3c2ab9b4ea4760df$exports(function() {
    var re = $f6a7373b5fbb9906$var$$RegExp(".", "s");
    return !(re.dotAll && re.test("\n") && re.flags === "s");
});


var $15954d164a95b4a2$exports = {};
"use strict";


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $15954d164a95b4a2$var$$RegExp = $605c5cd9c3aed513$exports.RegExp;
$15954d164a95b4a2$exports = $3c2ab9b4ea4760df$exports(function() {
    var re = $15954d164a95b4a2$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});


var $a101ec6548bbbe5b$var$nativeReplace = $ad8a2fa7f3a3a6cd$exports("native-string-replace", String.prototype.replace);
var $a101ec6548bbbe5b$var$nativeExec = RegExp.prototype.exec;
var $a101ec6548bbbe5b$var$patchedExec = $a101ec6548bbbe5b$var$nativeExec;
var $a101ec6548bbbe5b$var$charAt = $cc682aa152788262$exports("".charAt);
var $a101ec6548bbbe5b$var$indexOf = $cc682aa152788262$exports("".indexOf);
var $a101ec6548bbbe5b$var$replace = $cc682aa152788262$exports("".replace);
var $a101ec6548bbbe5b$var$stringSlice = $cc682aa152788262$exports("".slice);
var $a101ec6548bbbe5b$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $a34142376931cf1e$exports($a101ec6548bbbe5b$var$nativeExec, re1, "a");
    $a34142376931cf1e$exports($a101ec6548bbbe5b$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $a101ec6548bbbe5b$var$UNSUPPORTED_Y = $612d021ff2a0e9c3$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $a101ec6548bbbe5b$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $a101ec6548bbbe5b$var$PATCH = $a101ec6548bbbe5b$var$UPDATES_LAST_INDEX_WRONG || $a101ec6548bbbe5b$var$NPCG_INCLUDED || $a101ec6548bbbe5b$var$UNSUPPORTED_Y || $f6a7373b5fbb9906$exports || $15954d164a95b4a2$exports;
if ($a101ec6548bbbe5b$var$PATCH) $a101ec6548bbbe5b$var$patchedExec = function exec(string) {
    var re = this;
    var state = $a101ec6548bbbe5b$require$getInternalState(re);
    var str = $8184f16f0ff2a2de$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $a34142376931cf1e$exports($a101ec6548bbbe5b$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $a101ec6548bbbe5b$var$UNSUPPORTED_Y && re.sticky;
    var flags = $a34142376931cf1e$exports($4c312e78d13eb04f$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $a101ec6548bbbe5b$var$replace(flags, "y", "");
        if ($a101ec6548bbbe5b$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $a101ec6548bbbe5b$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $a101ec6548bbbe5b$var$charAt(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($a101ec6548bbbe5b$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($a101ec6548bbbe5b$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $a34142376931cf1e$exports($a101ec6548bbbe5b$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $a101ec6548bbbe5b$var$stringSlice(match.input, charsAdded);
            match[0] = $a101ec6548bbbe5b$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($a101ec6548bbbe5b$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($a101ec6548bbbe5b$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $a34142376931cf1e$exports($a101ec6548bbbe5b$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $6d22990bd5a876d2$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$a101ec6548bbbe5b$exports = $a101ec6548bbbe5b$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$6341b48e77c95e91$exports({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $a101ec6548bbbe5b$exports
}, {
    exec: $a101ec6548bbbe5b$exports
});


"use strict";

var $337e84b924618b5e$exports = {};
"use strict";







var $337e84b924618b5e$var$SPECIES = $131460ececef5983$exports("species");
var $337e84b924618b5e$var$RegExpPrototype = RegExp.prototype;
$337e84b924618b5e$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $131460ececef5983$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$3c2ab9b4ea4760df$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$3c2ab9b4ea4760df$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$337e84b924618b5e$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $a101ec6548bbbe5b$exports || $exec === $337e84b924618b5e$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $a34142376931cf1e$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $a34142376931cf1e$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $c9272b287f1d50a0$exports(String.prototype, KEY, methods[0]);
        $c9272b287f1d50a0$exports($337e84b924618b5e$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $d4687f5727b08995$exports($337e84b924618b5e$var$RegExpPrototype[SYMBOL], "sham", true);
};








var $34f0fa9e4927f765$exports = {};
"use strict";

var $34f0fa9e4927f765$require$charAt = $843797b2b79f64a9$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$34f0fa9e4927f765$exports = function(S, index, unicode) {
    return index + (unicode ? $34f0fa9e4927f765$require$charAt(S, index).length : 1);
};


var $0c792b814f2e9ab5$exports = {};
"use strict";





var $0c792b814f2e9ab5$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$0c792b814f2e9ab5$exports = function(R, S) {
    var exec = R.exec;
    if ($999204e0caa7c0da$exports(exec)) {
        var result = $a34142376931cf1e$exports(exec, R, S);
        if (result !== null) $2d779c9560717a35$exports(result);
        return result;
    }
    if ($6d78dcf79704944a$exports(R) === "RegExp") return $a34142376931cf1e$exports($a101ec6548bbbe5b$exports, R, S);
    throw new $0c792b814f2e9ab5$var$$TypeError("RegExp#exec called on incompatible receiver");
};


// @@match logic
$337e84b924618b5e$exports("match", function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $845f3e9d2f4f3629$exports(this);
            var matcher = $50fb4e8da6ee0e0a$exports(regexp) ? undefined : $a76fffc2ea20877e$exports(regexp, MATCH);
            return matcher ? $a34142376931cf1e$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($8184f16f0ff2a2de$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $2d779c9560717a35$exports(this);
            var S = $8184f16f0ff2a2de$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $0c792b814f2e9ab5$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $0c792b814f2e9ab5$exports(rx, S)) !== null){
                var matchStr = $8184f16f0ff2a2de$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === "") rx.lastIndex = $34f0fa9e4927f765$exports(S, $22380859140abb43$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


"use strict";


var $3917958fbf7459f4$require$FUNCTION_NAME_EXISTS = $2356260dee87883e$exports.EXISTS;

var $4a304ecef14e31b5$exports = {};
"use strict";


$4a304ecef14e31b5$exports = function(target, name, descriptor) {
    if (descriptor.get) $8327a6fa4d840a5c$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $8327a6fa4d840a5c$exports(descriptor.set, name, {
        setter: true
    });
    return $324f102fb15ae006$export$2d1720544b23b823(target, name, descriptor);
};


var $3917958fbf7459f4$var$FunctionPrototype = Function.prototype;
var $3917958fbf7459f4$var$functionToString = $cc682aa152788262$exports($3917958fbf7459f4$var$FunctionPrototype.toString);
var $3917958fbf7459f4$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $3917958fbf7459f4$var$regExpExec = $cc682aa152788262$exports($3917958fbf7459f4$var$nameRE.exec);
var $3917958fbf7459f4$var$NAME = "name";
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($2708db8aa4e8f4d2$exports && !$3917958fbf7459f4$require$FUNCTION_NAME_EXISTS) $4a304ecef14e31b5$exports($3917958fbf7459f4$var$FunctionPrototype, $3917958fbf7459f4$var$NAME, {
    configurable: true,
    get: function get() {
        try {
            return $3917958fbf7459f4$var$regExpExec($3917958fbf7459f4$var$nameRE, $3917958fbf7459f4$var$functionToString(this))[1];
        } catch (error) {
            return "";
        }
    }
});


"use strict";
var $362bece367e70e05$exports = {};
"use strict";

var $362bece367e70e05$var$FunctionPrototype = Function.prototype;
var $362bece367e70e05$var$apply = $362bece367e70e05$var$FunctionPrototype.apply;
var $362bece367e70e05$var$call = $362bece367e70e05$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$362bece367e70e05$exports = typeof Reflect == "object" && Reflect.apply || ($0b224d9c80aa3e60$exports ? $362bece367e70e05$var$call.bind($362bece367e70e05$var$apply) : function() {
    return $362bece367e70e05$var$call.apply($362bece367e70e05$var$apply, arguments);
});















var $3b65af572a0d057e$exports = {};
"use strict";


var $3b65af572a0d057e$var$floor = Math.floor;
var $3b65af572a0d057e$var$charAt = $cc682aa152788262$exports("".charAt);
var $3b65af572a0d057e$var$replace = $cc682aa152788262$exports("".replace);
var $3b65af572a0d057e$var$stringSlice = $cc682aa152788262$exports("".slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $3b65af572a0d057e$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $3b65af572a0d057e$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$3b65af572a0d057e$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $3b65af572a0d057e$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $e2a51ca67adb8a11$exports(namedCaptures);
        symbols = $3b65af572a0d057e$var$SUBSTITUTION_SYMBOLS;
    }
    return $3b65af572a0d057e$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($3b65af572a0d057e$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $3b65af572a0d057e$var$stringSlice(str, 0, position);
            case "'":
                return $3b65af572a0d057e$var$stringSlice(str, tailPos);
            case "<":
                capture = namedCaptures[$3b65af572a0d057e$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $3b65af572a0d057e$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $3b65af572a0d057e$var$charAt(ch, 1) : captures[f - 1] + $3b65af572a0d057e$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};




var $06faf75e29b145dd$var$REPLACE = $131460ececef5983$exports("replace");
var $06faf75e29b145dd$var$max = Math.max;
var $06faf75e29b145dd$var$min = Math.min;
var $06faf75e29b145dd$var$concat = $cc682aa152788262$exports([].concat);
var $06faf75e29b145dd$var$push = $cc682aa152788262$exports([].push);
var $06faf75e29b145dd$var$stringIndexOf = $cc682aa152788262$exports("".indexOf);
var $06faf75e29b145dd$var$stringSlice = $cc682aa152788262$exports("".slice);
var $06faf75e29b145dd$var$maybeToString = function maybeToString(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $06faf75e29b145dd$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $06faf75e29b145dd$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$06faf75e29b145dd$var$REPLACE]) return /./[$06faf75e29b145dd$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $06faf75e29b145dd$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$3c2ab9b4ea4760df$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$337e84b924618b5e$exports("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $06faf75e29b145dd$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $845f3e9d2f4f3629$exports(this);
            var replacer = $50fb4e8da6ee0e0a$exports(searchValue) ? undefined : $a76fffc2ea20877e$exports(searchValue, $06faf75e29b145dd$var$REPLACE);
            return replacer ? $a34142376931cf1e$exports(replacer, searchValue, O, replaceValue) : $a34142376931cf1e$exports(nativeReplace, $8184f16f0ff2a2de$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $2d779c9560717a35$exports(this);
            var S = $8184f16f0ff2a2de$exports(string);
            if (typeof replaceValue == "string" && $06faf75e29b145dd$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $06faf75e29b145dd$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $999204e0caa7c0da$exports(replaceValue);
            if (!functionalReplace) replaceValue = $8184f16f0ff2a2de$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $0c792b814f2e9ab5$exports(rx, S);
                if (result === null) break;
                $06faf75e29b145dd$var$push(results, result);
                if (!global) break;
                var matchStr = $8184f16f0ff2a2de$exports(result[0]);
                if (matchStr === "") rx.lastIndex = $34f0fa9e4927f765$exports(S, $22380859140abb43$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $8184f16f0ff2a2de$exports(result[0]);
                var position = $06faf75e29b145dd$var$max($06faf75e29b145dd$var$min($b9228c0f0dfd3d8a$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$06faf75e29b145dd$var$push(captures, $06faf75e29b145dd$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $06faf75e29b145dd$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $06faf75e29b145dd$var$push(replacerArgs, namedCaptures);
                    replacement = $8184f16f0ff2a2de$exports($362bece367e70e05$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $3b65af572a0d057e$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $06faf75e29b145dd$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $06faf75e29b145dd$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$06faf75e29b145dd$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$06faf75e29b145dd$var$REPLACE_KEEPS_$0 || $06faf75e29b145dd$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


// Helper function to retrieve options from element attributes
var $62c05d8fa8cb928e$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case "true":
                    acc[key] = true;
                    break;
                case "false":
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
function $62c05d8fa8cb928e$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $62c05d8fa8cb928e$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $62c05d8fa8cb928e$var$cachedScrollbarWidth = null;
var $62c05d8fa8cb928e$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($67316715b856f0c7$exports))) window.addEventListener("resize", function() {
    if ($62c05d8fa8cb928e$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $62c05d8fa8cb928e$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $62c05d8fa8cb928e$var$cachedScrollbarWidth = null;
    }
});
function $62c05d8fa8cb928e$var$scrollbarWidth(el) {
    if ($62c05d8fa8cb928e$var$cachedScrollbarWidth === null) {
        var document1 = $62c05d8fa8cb928e$var$getElementDocument(el);
        if (typeof document1 === "undefined") {
            $62c05d8fa8cb928e$var$cachedScrollbarWidth = 0;
            return $62c05d8fa8cb928e$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement("div");
        box.classList.add("simplebar-hide-scrollbar");
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $62c05d8fa8cb928e$var$cachedScrollbarWidth = width;
    }
    return $62c05d8fa8cb928e$var$cachedScrollbarWidth;
}
var $62c05d8fa8cb928e$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $62c05d8fa8cb928e$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar("x");
                _this.positionScrollbar("x");
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar("y");
                _this.positionScrollbar("y");
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar("x");
            _this.showScrollbar("y");
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis("y");
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis("x");
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis("y");
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === "mousedown") {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, "x");
                        else _this.onTrackClick(e, "x");
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, "y");
                        else _this.onTrackClick(e, "y");
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === "y") eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === "x") {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $62c05d8fa8cb928e$var$getElementDocument(_this.el);
            var elWindow = $62c05d8fa8cb928e$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener("mousemove", _this.drag, true);
            elDocument.removeEventListener("mouseup", _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener("click", _this.preventClick, true);
                elDocument.removeEventListener("dblclick", _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($7cf75cb0f1be9192$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($7cf75cb0f1be9192$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($c12adf08fdfff334$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($c12adf08fdfff334$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($4a7448379b90077f$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement("div");
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $62c05d8fa8cb928e$var$getElementDocument(el);
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($67316715b856f0c7$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement("div");
            this.contentWrapperEl = document.createElement("div");
            this.offsetEl = document.createElement("div");
            this.maskEl = document.createElement("div");
            this.contentEl = document.createElement("div");
            this.placeholderEl = document.createElement("div");
            this.heightAutoObserverWrapperEl = document.createElement("div");
            this.heightAutoObserverEl = document.createElement("div");
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement("div");
            var scrollbar = document.createElement("div");
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute("data-simplebar", "init");
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || "scrollable content";
        this.contentWrapperEl.setAttribute("tabindex", "0");
        this.contentWrapperEl.setAttribute("role", "region");
        this.contentWrapperEl.setAttribute("aria-label", ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener("mousemove", this.onMouseMove);
        this.el.addEventListener("mouseleave", this.onMouseLeave);
        this.contentWrapperEl.addEventListener("scroll", this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener("resize", this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $fc0f0e5fbeb59b20$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === "rtl";
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? "auto" : "100%"; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : "auto";
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === "hidden" ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === "hidden" ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === "x" || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === "y" || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize("x");
        this.axis.y.scrollbar.size = this.getScrollbarSize("y");
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar("x");
        this.positionScrollbar("y");
        this.toggleTrackVisibility("x");
        this.toggleTrackVisibility("y");
    } /**
   * Calculate scrollbar size
   */ ;
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = "y";
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === "x" && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === "x" ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = "y";
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = "visible";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "scroll";
        } else {
            track.style.visibility = "hidden";
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = "hidden";
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = "block";
        else scrollbar.style.display = "none";
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? "left" : "right"] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    } /**
   * On scroll event handling
   */ ;
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = "y";
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = "y";
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    } /**
   * Hide Scrollbar
   */ ;
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = "y";
        var elDocument = $62c05d8fa8cb928e$var$getElementDocument(this.el);
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === "y" ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener("mousemove", this.drag, true);
        elDocument.addEventListener("mouseup", this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener("click", this.preventClick, true);
            elDocument.addEventListener("dblclick", this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    } /**
   * Drag scrollbar handle
   */ ;
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = "y";
        if (!this.options.clickOnTrack) return;
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === "y" ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    } /**
   * Getter for content element
   */ ;
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    } /**
   * Getter for original scrolling element
   */ ;
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar").display === "none" || "scrollbarWidth" in document.documentElement.style || "-ms-overflow-style" in document.documentElement.style) return 0;
            else return $62c05d8fa8cb928e$var$scrollbarWidth(this.el);
        } catch (e) {
            return $62c05d8fa8cb928e$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $62c05d8fa8cb928e$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener("mouseenter", this.onMouseEnter);
        [
            "mousedown",
            "click",
            "dblclick"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            "touchstart",
            "touchend",
            "touchmove"
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener("mousemove", this.onMouseMove);
        this.el.removeEventListener("mouseleave", this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener("scroll", this.onScroll);
        elWindow.removeEventListener("resize", this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    } /**
   * UnMount mutation observer and delete SimpleBar instance from DOM element
   */ ;
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances["delete"](this.el);
    } /**
   * Check if mouse is within bounds
   */ ;
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    } /**
   * Find element children matches query
   */ ;
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$62c05d8fa8cb928e$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: "simplebar-content",
        contentWrapper: "simplebar-content-wrapper",
        offset: "simplebar-offset",
        mask: "simplebar-mask",
        wrapper: "simplebar-wrapper",
        placeholder: "simplebar-placeholder",
        scrollbar: "simplebar-scrollbar",
        track: "simplebar-track",
        heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
        heightAutoObserverEl: "simplebar-height-auto-observer",
        visible: "simplebar-visible",
        horizontal: "simplebar-horizontal",
        vertical: "simplebar-vertical",
        hover: "simplebar-hover",
        dragging: "simplebar-dragging"
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$62c05d8fa8cb928e$var$SimpleBar.instances = new WeakMap();
$62c05d8fa8cb928e$var$SimpleBar.initDOMLoadedElements = function() {
    document.removeEventListener("DOMContentLoaded", this.initDOMLoadedElements);
    window.removeEventListener("load", this.initDOMLoadedElements);
    Array.prototype.forEach.call(document.querySelectorAll("[data-simplebar]"), function(el) {
        if (el.getAttribute("data-simplebar") !== "init" && !$62c05d8fa8cb928e$var$SimpleBar.instances.has(el)) new $62c05d8fa8cb928e$var$SimpleBar(el, $62c05d8fa8cb928e$var$getOptions(el.attributes));
    });
};
$62c05d8fa8cb928e$var$SimpleBar.removeObserver = function() {
    this.globalObserver.disconnect();
};
$62c05d8fa8cb928e$var$SimpleBar.initHtmlApi = function() {
    this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this); // MutationObserver is IE11+
    if (typeof MutationObserver !== "undefined") {
        // Mutation observer to observe dynamically added elements
        this.globalObserver = new MutationObserver($62c05d8fa8cb928e$var$SimpleBar.handleMutations);
        this.globalObserver.observe(document, {
            childList: true,
            subtree: true
        });
    } // Taken from jQuery `ready` function
    // Instantiate elements already present on the page
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
    window.setTimeout(this.initDOMLoadedElements);
    else {
        document.addEventListener("DOMContentLoaded", this.initDOMLoadedElements);
        window.addEventListener("load", this.initDOMLoadedElements);
    }
};
$62c05d8fa8cb928e$var$SimpleBar.handleMutations = function(mutations) {
    mutations.forEach(function(mutation) {
        Array.prototype.forEach.call(mutation.addedNodes, function(addedNode) {
            if (addedNode.nodeType === 1) {
                if (addedNode.hasAttribute("data-simplebar")) !$62c05d8fa8cb928e$var$SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new $62c05d8fa8cb928e$var$SimpleBar(addedNode, $62c05d8fa8cb928e$var$getOptions(addedNode.attributes));
                else Array.prototype.forEach.call(addedNode.querySelectorAll("[data-simplebar]"), function(el) {
                    if (el.getAttribute("data-simplebar") !== "init" && !$62c05d8fa8cb928e$var$SimpleBar.instances.has(el) && document.documentElement.contains(el)) new $62c05d8fa8cb928e$var$SimpleBar(el, $62c05d8fa8cb928e$var$getOptions(el.attributes));
                });
            }
        });
        Array.prototype.forEach.call(mutation.removedNodes, function(removedNode) {
            if (removedNode.nodeType === 1) {
                if (removedNode.getAttribute("data-simplebar") === "init") $62c05d8fa8cb928e$var$SimpleBar.instances.has(removedNode) && !document.documentElement.contains(removedNode) && $62c05d8fa8cb928e$var$SimpleBar.instances.get(removedNode).unMount();
                else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                    $62c05d8fa8cb928e$var$SimpleBar.instances.has(el) && !document.documentElement.contains(el) && $62c05d8fa8cb928e$var$SimpleBar.instances.get(el).unMount();
                });
            }
        });
    });
};
$62c05d8fa8cb928e$var$SimpleBar.getOptions = $62c05d8fa8cb928e$var$getOptions;
/**
 * HTML API
 * Called only in a browser env.
 */ if (0, (/*@__PURE__*/$parcel$interopDefault($67316715b856f0c7$exports))) $62c05d8fa8cb928e$var$SimpleBar.initHtmlApi();
var $62c05d8fa8cb928e$export$2e2bcd8739ae039 = $62c05d8fa8cb928e$var$SimpleBar;





var $4w9fm = parcelRequire("4w9fm");

(0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(document).ready(function() {
    function initimmolistslider() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".immoslider").flexslider({
            animation: "slide",
            controlNav: false,
            touch: true,
            slideshow: false,
            start: function start(item) {
                slideCounter(item);
            },
            after: function after(item) {
                slideCounter(item);
            }
        });
    }
    function slideCounter(item) {
        var $sliderItemTotal = item.find(".slider-item-total");
        var $sliderItemCurrent = item.find(".slider-item-current");
        $sliderItemCurrent.text(item.currentSlide + 1);
        $sliderItemTotal.text(item.find(".slides").find("li:not(.clone)").length);
    }
    function immolistFilterChange() {
        var district = "";
        var baseRentMax = "";
        var livingSpaceMax = "";
        var numberOfRoomsMax = "";
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterStadtteil").length) district = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterStadtteil").val();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterKaltmiete").length) baseRentMax = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterKaltmiete").val();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterWohnfl\xe4che").length) livingSpaceMax = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterWohnfl\xe4che").val();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterZimmerzahl").length) numberOfRoomsMax = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterZimmerzahl").val();
        var pageId = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#pageid").data("pageid");
        var form = new FormData();
        form.append("tx_uoimmo_uoimmo[__referrer][@extension]", "UoImmo");
        form.append("tx_uoimmo_uoimmo[__referrer][@controller]", "RealEstates");
        form.append("tx_uoimmo_uoimmo[__referrer][@action]", "list");
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId + "][realEstateType]", "apartmentRent");
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId + "][apartmentRent][district]", district);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId + "][apartmentRent][baseRentMax]", baseRentMax);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId + "][apartmentRent][livingSpaceMax]", livingSpaceMax);
        form.append("tx_uoimmo_uoimmo[uoimmo_" + pageId + "][apartmentRent][numberOfRoomsMax]", numberOfRoomsMax);
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm))).ajax({
            url: "?tx_uoimmo_uoimmo[action]=list&tx_uoimmo_uoimmo[controller]=RealEstates",
            data: form,
            method: "POST",
            processData: false,
            contentType: false,
            success: function success(data) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(data).find(".section-immolist #listenansicht").length && (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".section-immolist #listenansicht").length) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".section-immolist #listenansicht").html((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(data).find(".section-immolist #listenansicht").html());
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".immoslider").length) initimmolistslider();
                    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".realestate-count").html((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".immocard").length + " Treffer");
                    window.immolistmap();
                }
            }
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".immoslider").length) initimmolistslider();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("#filterStadtteil, #filterKaltmiete, #filterWohnfl\xe4che, #filterZimmerzahl").length) (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))("body").on("change", "#filterStadtteil, #filterKaltmiete, #filterWohnfl\xe4che, #filterZimmerzahl", function(e) {
        immolistFilterChange();
    });
});
function $d332e323e04bf058$var$createMarkers(markersToCreate) {
    if (markersToCreate.length > 0) {
        var element = markersToCreate[0];
        var infowindow = null;
        var infoText = "";
        var marker = null;
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            address: element.address + ", " + element.strasse + ", Germany"
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                marker = new google.maps.Marker({
                    map: immolistmapObject,
                    position: results[0].geometry.location,
                    labelOrigin: new google.maps.Point(0, 0)
                });
                window.myLatLng.push(new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()));
                infoText = '<div class="g-map-bubble"><ul><li>' + element.titel + "</li><li>" + element.strasse + "<br/>" + element.address + "</li><li>Kaltmiete: " + element.miete + "</li><li>Wohnfl\xe4che: " + element.qm + "</li><li>Zimmer: " + element.zimmer + '</li><li><a class="btn btn-outline-primary" href="' + element.detailpage + '">Details</a></li></div>';
                infowindow = new google.maps.InfoWindow({
                    content: infoText
                });
                google.maps.event.addListener(marker, "click", function() {
                    infowindow.open(immolistmapObject, marker);
                });
            } else console.log("Geocode was not successful for the following reason: " + status);
            markersToCreate.shift();
            if (markersToCreate.length > 0) setTimeout(function() {
                $d332e323e04bf058$var$createMarkers(markersToCreate);
            }, 250);
            else {
                var bounds = new google.maps.LatLngBounds();
                for(var i = 0; i < window.myLatLng.length; i++)bounds.extend(window.myLatLng[i]);
                immolistmapObject.fitBounds(bounds);
                immolistmapObject.setCenter(bounds.getCenter());
            }
        });
    }
}
window.immolistmap = function() {
    window.immolistmapObject = new google.maps.Map(document.getElementById("immolistmap"), {
        zoom: 13,
        scrollwheel: false,
        center: new google.maps.LatLng(document.getElementById("immolistmap").getAttribute("data-lng"), document.getElementById("immolistmap").getAttribute("data-lat")),
        fullscreenControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
            {
                featureType: "administrative",
                elementType: "all",
                stylers: [
                    {
                        saturation: "-100"
                    }
                ]
            },
            {
                featureType: "administrative.province",
                elementType: "all",
                stylers: [
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [
                    {
                        saturation: -100
                    },
                    {
                        lightness: 65
                    },
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "poi",
                elementType: "all",
                stylers: [
                    {
                        saturation: -100
                    },
                    {
                        lightness: "50"
                    },
                    {
                        visibility: "off"
                    }
                ]
            },
            {
                featureType: "road",
                elementType: "all",
                stylers: [
                    {
                        saturation: "-100"
                    }
                ]
            },
            {
                featureType: "road.highway",
                elementType: "all",
                stylers: [
                    {
                        visibility: "simplified"
                    }
                ]
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        lightness: "-13"
                    }
                ]
            },
            {
                featureType: "road.arterial",
                elementType: "all",
                stylers: [
                    {
                        lightness: "20"
                    }
                ]
            },
            {
                featureType: "road.arterial",
                elementType: "geometry.fill",
                stylers: [
                    {
                        lightness: "-21"
                    }
                ]
            },
            {
                featureType: "road.local",
                elementType: "all",
                stylers: [
                    {
                        lightness: "30"
                    }
                ]
            },
            {
                featureType: "transit",
                elementType: "all",
                stylers: [
                    {
                        saturation: -100
                    },
                    {
                        visibility: "simplified"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        hue: "#ffff00"
                    },
                    {
                        lightness: -25
                    },
                    {
                        saturation: -97
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry.fill",
                stylers: [
                    {
                        visibility: "on"
                    },
                    {
                        saturation: "-54"
                    },
                    {
                        lightness: "35"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        visibility: "on"
                    }
                ]
            },
            {
                featureType: "water",
                elementType: "labels",
                stylers: [
                    {
                        lightness: -25
                    },
                    {
                        saturation: -100
                    }
                ]
            }
        ]
    });
    var markersToCreate = [];
    window.myLatLng = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".listitem").each(function() {
        $this = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(this);
        markersToCreate.push({
            titel: $this.data("title"),
            strasse: $this.data("street"),
            address: $this.data("address"),
            miete: $this.data("miete"),
            qm: $this.data("qm"),
            zimmer: $this.data("zimmer"),
            detailpage: $this.data("detail")
        });
    });
    $d332e323e04bf058$var$createMarkers(markersToCreate);
};



var $4w9fm = parcelRequire("4w9fm");

// ==================================================
// fancyBox v3.5.7
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2019 fancyApps
//
// ==================================================
(function(window1, document1, $, undefined1) {
    "use strict";
    window1.console = window1.console || {
        info: function info(stuff) {}
    };
    // If there's no jQuery, fancyBox can't work
    // =========================================
    if (!$) return;
    // Check if fancyBox is already initialized
    // ========================================
    if ($.fn.fancybox) {
        console.info("fancyBox already initialized");
        return;
    }
    // Private default settings
    // ========================
    var defaults = {
        // Close existing modals
        // Set this to false if you do not need to stack multiple instances
        closeExisting: false,
        // Enable infinite gallery navigation
        loop: false,
        // Horizontal space between slides
        gutter: 50,
        // Enable keyboard navigation
        keyboard: true,
        // Should allow caption to overlap the content
        preventCaptionOverlap: true,
        // Should display navigation arrows at the screen edges
        arrows: true,
        // Should display counter at the top left corner
        infobar: true,
        // Should display close button (using `btnTpl.smallBtn` template) over the content
        // Can be true, false, "auto"
        // If "auto" - will be automatically enabled for "html", "inline" or "ajax" items
        smallBtn: "auto",
        // Should display toolbar (buttons at the top)
        // Can be true, false, "auto"
        // If "auto" - will be automatically hidden if "smallBtn" is enabled
        toolbar: "auto",
        // What buttons should appear in the top right corner.
        // Buttons will be created using templates from `btnTpl` option
        // and they will be placed into toolbar (class="fancybox-toolbar"` element)
        buttons: [
            "zoom",
            //"share",
            "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
        ],
        // Detect "idle" time in seconds
        idleTime: 3,
        // Disable right-click and use simple image protection for images
        protect: false,
        // Shortcut to make content "modal" - disable keyboard navigtion, hide buttons, etc
        modal: false,
        image: {
            // Wait for images to load before displaying
            //   true  - wait for image to load and then display;
            //   false - display thumbnail and load the full-sized image over top,
            //           requires predefined image dimensions (`data-width` and `data-height` attributes)
            preload: false
        },
        ajax: {
            // Object containing settings for ajax request
            settings: {
                // This helps to indicate that request comes from the modal
                // Feel free to change naming
                data: {
                    fancybox: true
                }
            }
        },
        iframe: {
            // Iframe template
            tpl: '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
            // Preload iframe before displaying it
            // This allows to calculate iframe content width and height
            // (note: Due to "Same Origin Policy", you can't get cross domain data).
            preload: true,
            // Custom CSS styling for iframe wrapping element
            // You can use this to set custom iframe dimensions
            css: {},
            // Iframe tag attributes
            attr: {
                scrolling: "auto"
            }
        },
        // For HTML5 video only
        video: {
            tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
            format: "",
            autoStart: true
        },
        // Default content type if cannot be detected automatically
        defaultType: "image",
        // Open/close animation type
        // Possible values:
        //   false            - disable
        //   "zoom"           - zoom images from/to thumbnail
        //   "fade"
        //   "zoom-in-out"
        //
        animationEffect: "zoom",
        // Duration in ms for open/close animation
        animationDuration: 366,
        // Should image change opacity while zooming
        // If opacity is "auto", then opacity will be changed if image and thumbnail have different aspect ratios
        zoomOpacity: "auto",
        // Transition effect between slides
        //
        // Possible values:
        //   false            - disable
        //   "fade'
        //   "slide'
        //   "circular'
        //   "tube'
        //   "zoom-in-out'
        //   "rotate'
        //
        transitionEffect: "fade",
        // Duration in ms for transition animation
        transitionDuration: 366,
        // Custom CSS class for slide element
        slideClass: "",
        // Custom CSS class for layout
        baseClass: "",
        // Base template for layout
        baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
        // Loading indicator template
        spinnerTpl: '<div class="fancybox-loading"></div>',
        // Error message template
        errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
        btnTpl: {
            download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
            zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
            close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
            // Arrows
            arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
            arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
            // This small close button will be appended to your html/inline/ajax content by default,
            // if "smallBtn" option is not set to false
            smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
        },
        // Container is injected into this element
        parentEl: "body",
        // Hide browser vertical scrollbars; use at your own risk
        hideScrollbar: true,
        // Focus handling
        // ==============
        // Try to focus on the first focusable element after opening
        autoFocus: true,
        // Put focus back to active element after closing
        backFocus: true,
        // Do not let user to focus on element outside modal content
        trapFocus: true,
        // Module specific options
        // =======================
        fullScreen: {
            autoStart: false
        },
        // Set `touch: false` to disable panning/swiping
        touch: {
            vertical: true,
            momentum: true // Continue movement after releasing mouse/touch when panning
        },
        // Hash value when initializing manually,
        // set `false` to disable hash change
        hash: null,
        // Customize or add new media types
        // Example:
        /*
      media : {
        youtube : {
          params : {
            autoplay : 0
          }
        }
      }
    */ media: {},
        slideShow: {
            autoStart: false,
            speed: 3000
        },
        thumbs: {
            autoStart: false,
            hideOnClose: true,
            parentEl: ".fancybox-container",
            axis: "y" // Vertical (y) or horizontal (x) scrolling
        },
        // Use mousewheel to navigate gallery
        // If 'auto' - enabled for images only
        wheel: "auto",
        // Callbacks
        //==========
        // See Documentation/API/Events for more information
        // Example:
        /*
      afterShow: function( instance, current ) {
        console.info( 'Clicked element:' );
        console.info( current.opts.$orig );
      }
    */ onInit: $.noop,
        beforeLoad: $.noop,
        afterLoad: $.noop,
        beforeShow: $.noop,
        afterShow: $.noop,
        beforeClose: $.noop,
        afterClose: $.noop,
        onActivate: $.noop,
        onDeactivate: $.noop,
        // Interaction
        // ===========
        // Use options below to customize taken action when user clicks or double clicks on the fancyBox area,
        // each option can be string or method that returns value.
        //
        // Possible values:
        //   "close"           - close instance
        //   "next"            - move to next gallery item
        //   "nextOrClose"     - move to next gallery item or close if gallery has only one item
        //   "toggleControls"  - show/hide controls
        //   "zoom"            - zoom image (if loaded)
        //   false             - do nothing
        // Clicked on the content
        clickContent: function clickContent(current, event) {
            return current.type === "image" ? "zoom" : false;
        },
        // Clicked on the slide
        clickSlide: "close",
        // Clicked on the background (backdrop) element;
        // if you have not changed the layout, then most likely you need to use `clickSlide` option
        clickOutside: "close",
        // Same as previous two, but for double click
        dblclickContent: false,
        dblclickSlide: false,
        dblclickOutside: false,
        // Custom options when mobile device is detected
        // =============================================
        mobile: {
            preventCaptionOverlap: false,
            idleTime: false,
            clickContent: function clickContent(current, event) {
                return current.type === "image" ? "toggleControls" : false;
            },
            clickSlide: function clickSlide(current, event) {
                return current.type === "image" ? "toggleControls" : "close";
            },
            dblclickContent: function dblclickContent(current, event) {
                return current.type === "image" ? "zoom" : false;
            },
            dblclickSlide: function dblclickSlide(current, event) {
                return current.type === "image" ? "zoom" : false;
            }
        },
        // Internationalization
        // ====================
        lang: "en",
        i18n: {
            en: {
                CLOSE: "Close",
                NEXT: "Next",
                PREV: "Previous",
                ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
                PLAY_START: "Start slideshow",
                PLAY_STOP: "Pause slideshow",
                FULL_SCREEN: "Full screen",
                THUMBS: "Thumbnails",
                DOWNLOAD: "Download",
                SHARE: "Share",
                ZOOM: "Zoom"
            },
            de: {
                CLOSE: "Schlie&szlig;en",
                NEXT: "Weiter",
                PREV: "Zur&uuml;ck",
                ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
                PLAY_START: "Diaschau starten",
                PLAY_STOP: "Diaschau beenden",
                FULL_SCREEN: "Vollbild",
                THUMBS: "Vorschaubilder",
                DOWNLOAD: "Herunterladen",
                SHARE: "Teilen",
                ZOOM: "Vergr&ouml;&szlig;ern"
            }
        }
    };
    // Few useful variables and methods
    // ================================
    var $W = $(window1);
    var $D = $(document1);
    var called = 0;
    // Check if an object is a jQuery object and not a native JavaScript object
    // ========================================================================
    var isQuery = function isQuery(obj) {
        return obj && obj.hasOwnProperty && obj instanceof $;
    };
    // Handle multiple browsers for "requestAnimationFrame" and "cancelAnimationFrame"
    // ===============================================================================
    var requestAFrame = function() {
        return window1.requestAnimationFrame || window1.webkitRequestAnimationFrame || window1.mozRequestAnimationFrame || window1.oRequestAnimationFrame || // if all else fails, use setTimeout
        function(callback) {
            return window1.setTimeout(callback, 1000 / 60);
        };
    }();
    var cancelAFrame = function() {
        return window1.cancelAnimationFrame || window1.webkitCancelAnimationFrame || window1.mozCancelAnimationFrame || window1.oCancelAnimationFrame || function(id) {
            window1.clearTimeout(id);
        };
    }();
    // Detect the supported transition-end event property name
    // =======================================================
    var transitionEnd = function() {
        var el = document1.createElement("fakeelement"), t;
        var transitions = {
            transition: "transitionend",
            OTransition: "oTransitionEnd",
            MozTransition: "transitionend",
            WebkitTransition: "webkitTransitionEnd"
        };
        for(t in transitions){
            if (el.style[t] !== undefined1) return transitions[t];
        }
        return "transitionend";
    }();
    // Force redraw on an element.
    // This helps in cases where the browser doesn't redraw an updated element properly
    // ================================================================================
    var forceRedraw = function forceRedraw($el) {
        return $el && $el.length && $el[0].offsetHeight;
    };
    // Exclude array (`buttons`) options from deep merging
    // ===================================================
    var mergeOpts = function mergeOpts(opts1, opts2) {
        var rez = $.extend(true, {}, opts1, opts2);
        $.each(opts2, function(key, value) {
            if ($.isArray(value)) rez[key] = value;
        });
        return rez;
    };
    // How much of an element is visible in viewport
    // =============================================
    var inViewport = function inViewport(elem) {
        var elemCenter, rez;
        if (!elem || elem.ownerDocument !== document1) return false;
        $(".fancybox-container").css("pointer-events", "none");
        elemCenter = {
            x: elem.getBoundingClientRect().left + elem.offsetWidth / 2,
            y: elem.getBoundingClientRect().top + elem.offsetHeight / 2
        };
        rez = document1.elementFromPoint(elemCenter.x, elemCenter.y) === elem;
        $(".fancybox-container").css("pointer-events", "");
        return rez;
    };
    // Class definition
    // ================
    var FancyBox = function FancyBox(content, opts, index) {
        var self = this;
        self.opts = mergeOpts({
            index: index
        }, $.fancybox.defaults);
        if ($.isPlainObject(opts)) self.opts = mergeOpts(self.opts, opts);
        if ($.fancybox.isMobile) self.opts = mergeOpts(self.opts, self.opts.mobile);
        self.id = self.opts.id || ++called;
        self.currIndex = parseInt(self.opts.index, 10) || 0;
        self.prevIndex = null;
        self.prevPos = null;
        self.currPos = 0;
        self.firstRun = true;
        // All group items
        self.group = [];
        // Existing slides (for current, next and previous gallery items)
        self.slides = {};
        // Create group elements
        self.addContent(content);
        if (!self.group.length) return;
        self.init();
    };
    $.extend(FancyBox.prototype, {
        // Create DOM structure
        // ====================
        init: function init() {
            var self = this, firstItem = self.group[self.currIndex], firstItemOpts = firstItem.opts, $container, buttonStr;
            if (firstItemOpts.closeExisting) $.fancybox.close(true);
            // Hide scrollbars
            // ===============
            $("body").addClass("fancybox-active");
            if (!$.fancybox.getInstance() && firstItemOpts.hideScrollbar !== false && !$.fancybox.isMobile && document1.body.scrollHeight > window1.innerHeight) {
                $("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (window1.innerWidth - document1.documentElement.clientWidth) + "px;}</style>");
                $("body").addClass("compensate-for-scrollbar");
            }
            // Build html markup and set references
            // ====================================
            // Build html code for buttons and insert into main template
            buttonStr = "";
            $.each(firstItemOpts.buttons, function(index, value) {
                buttonStr += firstItemOpts.btnTpl[value] || "";
            });
            // Create markup from base template, it will be initially hidden to
            // avoid unnecessary work like painting while initializing is not complete
            $container = $(self.translate(self, firstItemOpts.baseTpl.replace("{{buttons}}", buttonStr).replace("{{arrows}}", firstItemOpts.btnTpl.arrowLeft + firstItemOpts.btnTpl.arrowRight))).attr("id", "fancybox-container-" + self.id).addClass(firstItemOpts.baseClass).data("FancyBox", self).appendTo(firstItemOpts.parentEl);
            // Create object holding references to jQuery wrapped nodes
            self.$refs = {
                container: $container
            };
            [
                "bg",
                "inner",
                "infobar",
                "toolbar",
                "stage",
                "caption",
                "navigation"
            ].forEach(function(item) {
                self.$refs[item] = $container.find(".fancybox-" + item);
            });
            self.trigger("onInit");
            // Enable events, deactive previous instances
            self.activate();
            // Build slides, load and reveal content
            self.jumpTo(self.currIndex);
        },
        // Simple i18n support - replaces object keys found in template
        // with corresponding values
        // ============================================================
        translate: function translate(obj, str) {
            var arr = obj.opts.i18n[obj.opts.lang] || obj.opts.i18n.en;
            return str.replace(/\{\{(\w+)\}\}/g, function(match, n) {
                return arr[n] === undefined1 ? match : arr[n];
            });
        },
        // Populate current group with fresh content
        // Check if each object has valid type and content
        // ===============================================
        addContent: function addContent(content) {
            var self = this, items = $.makeArray(content), thumbs;
            $.each(items, function(i, item) {
                var obj = {}, opts = {}, $item, type, found, src, srcParts;
                // Step 1 - Make sure we have an object
                // ====================================
                if ($.isPlainObject(item)) {
                    // We probably have manual usage here, something like
                    // $.fancybox.open( [ { src : "image.jpg", type : "image" } ] )
                    obj = item;
                    opts = item.opts || item;
                } else if ($.type(item) === "object" && $(item).length) {
                    // Here we probably have jQuery collection returned by some selector
                    $item = $(item);
                    // Support attributes like `data-options='{"touch" : false}'` and `data-touch='false'`
                    opts = $item.data() || {};
                    opts = $.extend(true, {}, opts, opts.options);
                    // Here we store clicked element
                    opts.$orig = $item;
                    obj.src = self.opts.src || opts.src || $item.attr("href");
                    // Assume that simple syntax is used, for example:
                    //   `$.fancybox.open( $("#test"), {} );`
                    if (!obj.type && !obj.src) {
                        obj.type = "inline";
                        obj.src = item;
                    }
                } else // Assume we have a simple html code, for example:
                //   $.fancybox.open( '<div><h1>Hi!</h1></div>' );
                obj = {
                    type: "html",
                    src: item + ""
                };
                // Each gallery object has full collection of options
                obj.opts = $.extend(true, {}, self.opts, opts);
                // Do not merge buttons array
                if ($.isArray(opts.buttons)) obj.opts.buttons = opts.buttons;
                if ($.fancybox.isMobile && obj.opts.mobile) obj.opts = mergeOpts(obj.opts, obj.opts.mobile);
                // Step 2 - Make sure we have content type, if not - try to guess
                // ==============================================================
                type = obj.type || obj.opts.type;
                src = obj.src || "";
                if (!type && src) {
                    if (found = src.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) {
                        type = "video";
                        if (!obj.opts.video.format) obj.opts.video.format = "video/" + (found[1] === "ogv" ? "ogg" : found[1]);
                    } else if (src.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i)) type = "image";
                    else if (src.match(/\.(pdf)((\?|#).*)?$/i)) {
                        type = "iframe";
                        obj = $.extend(true, obj, {
                            contentType: "pdf",
                            opts: {
                                iframe: {
                                    preload: false
                                }
                            }
                        });
                    } else if (src.charAt(0) === "#") type = "inline";
                }
                if (type) obj.type = type;
                else self.trigger("objectNeedsType", obj);
                if (!obj.contentType) obj.contentType = $.inArray(obj.type, [
                    "html",
                    "inline",
                    "ajax"
                ]) > -1 ? "html" : obj.type;
                // Step 3 - Some adjustments
                // =========================
                obj.index = self.group.length;
                if (obj.opts.smallBtn == "auto") obj.opts.smallBtn = $.inArray(obj.type, [
                    "html",
                    "inline",
                    "ajax"
                ]) > -1;
                if (obj.opts.toolbar === "auto") obj.opts.toolbar = !obj.opts.smallBtn;
                // Find thumbnail image, check if exists and if is in the viewport
                obj.$thumb = obj.opts.$thumb || null;
                if (obj.opts.$trigger && obj.index === self.opts.index) {
                    obj.$thumb = obj.opts.$trigger.find("img:first");
                    if (obj.$thumb.length) obj.opts.$orig = obj.opts.$trigger;
                }
                if (!(obj.$thumb && obj.$thumb.length) && obj.opts.$orig) obj.$thumb = obj.opts.$orig.find("img:first");
                if (obj.$thumb && !obj.$thumb.length) obj.$thumb = null;
                obj.thumb = obj.opts.thumb || (obj.$thumb ? obj.$thumb[0].src : null);
                // "caption" is a "special" option, it can be used to customize caption per gallery item
                if ($.type(obj.opts.caption) === "function") obj.opts.caption = obj.opts.caption.apply(item, [
                    self,
                    obj
                ]);
                if ($.type(self.opts.caption) === "function") obj.opts.caption = self.opts.caption.apply(item, [
                    self,
                    obj
                ]);
                // Make sure we have caption as a string or jQuery object
                if (!(obj.opts.caption instanceof $)) obj.opts.caption = obj.opts.caption === undefined1 ? "" : obj.opts.caption + "";
                // Check if url contains "filter" used to filter the content
                // Example: "ajax.html #something"
                if (obj.type === "ajax") {
                    srcParts = src.split(/\s+/, 2);
                    if (srcParts.length > 1) {
                        obj.src = srcParts.shift();
                        obj.opts.filter = srcParts.shift();
                    }
                }
                // Hide all buttons and disable interactivity for modal items
                if (obj.opts.modal) obj.opts = $.extend(true, obj.opts, {
                    trapFocus: true,
                    // Remove buttons
                    infobar: 0,
                    toolbar: 0,
                    smallBtn: 0,
                    // Disable keyboard navigation
                    keyboard: 0,
                    // Disable some modules
                    slideShow: 0,
                    fullScreen: 0,
                    thumbs: 0,
                    touch: 0,
                    // Disable click event handlers
                    clickContent: false,
                    clickSlide: false,
                    clickOutside: false,
                    dblclickContent: false,
                    dblclickSlide: false,
                    dblclickOutside: false
                });
                // Step 4 - Add processed object to group
                // ======================================
                self.group.push(obj);
            });
            // Update controls if gallery is already opened
            if (Object.keys(self.slides).length) {
                self.updateControls();
                // Update thumbnails, if needed
                thumbs = self.Thumbs;
                if (thumbs && thumbs.isActive) {
                    thumbs.create();
                    thumbs.focus();
                }
            }
        },
        // Attach an event handler functions for:
        //   - navigation buttons
        //   - browser scrolling, resizing;
        //   - focusing
        //   - keyboard
        //   - detecting inactivity
        // ======================================
        addEvents: function addEvents() {
            var self = this;
            self.removeEvents();
            // Make navigation elements clickable
            // ==================================
            self.$refs.container.on("click.fb-close", "[data-fancybox-close]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.close(e);
            }).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.previous();
            }).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function(e) {
                e.stopPropagation();
                e.preventDefault();
                self.next();
            }).on("click.fb", "[data-fancybox-zoom]", function(e) {
                // Click handler for zoom button
                self[self.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
            });
            // Handle page scrolling and browser resizing
            // ==========================================
            $W.on("orientationchange.fb resize.fb", function(e) {
                if (e && e.originalEvent && e.originalEvent.type === "resize") {
                    if (self.requestId) cancelAFrame(self.requestId);
                    self.requestId = requestAFrame(function() {
                        self.update(e);
                    });
                } else {
                    if (self.current && self.current.type === "iframe") self.$refs.stage.hide();
                    setTimeout(function() {
                        self.$refs.stage.show();
                        self.update(e);
                    }, $.fancybox.isMobile ? 600 : 250);
                }
            });
            $D.on("keydown.fb", function(e) {
                var instance = $.fancybox ? $.fancybox.getInstance() : null, current = instance.current, keycode = e.keyCode || e.which;
                // Trap keyboard focus inside of the modal
                // =======================================
                if (keycode == 9) {
                    if (current.opts.trapFocus) self.focus(e);
                    return;
                }
                // Enable keyboard navigation
                // ==========================
                if (!current.opts.keyboard || e.ctrlKey || e.altKey || e.shiftKey || $(e.target).is("input,textarea,video,audio,select")) return;
                // Backspace and Esc keys
                if (keycode === 8 || keycode === 27) {
                    e.preventDefault();
                    self.close(e);
                    return;
                }
                // Left arrow and Up arrow
                if (keycode === 37 || keycode === 38) {
                    e.preventDefault();
                    self.previous();
                    return;
                }
                // Righ arrow and Down arrow
                if (keycode === 39 || keycode === 40) {
                    e.preventDefault();
                    self.next();
                    return;
                }
                self.trigger("afterKeydown", e, keycode);
            });
            // Hide controls after some inactivity period
            if (self.group[self.currIndex].opts.idleTime) {
                self.idleSecondsCounter = 0;
                $D.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function(e) {
                    self.idleSecondsCounter = 0;
                    if (self.isIdle) self.showControls();
                    self.isIdle = false;
                });
                self.idleInterval = window1.setInterval(function() {
                    self.idleSecondsCounter++;
                    if (self.idleSecondsCounter >= self.group[self.currIndex].opts.idleTime && !self.isDragging) {
                        self.isIdle = true;
                        self.idleSecondsCounter = 0;
                        self.hideControls();
                    }
                }, 1000);
            }
        },
        // Remove events added by the core
        // ===============================
        removeEvents: function removeEvents() {
            var self = this;
            $W.off("orientationchange.fb resize.fb");
            $D.off("keydown.fb .fb-idle");
            this.$refs.container.off(".fb-close .fb-prev .fb-next");
            if (self.idleInterval) {
                window1.clearInterval(self.idleInterval);
                self.idleInterval = null;
            }
        },
        // Change to previous gallery item
        // ===============================
        previous: function previous(duration) {
            return this.jumpTo(this.currPos - 1, duration);
        },
        // Change to next gallery item
        // ===========================
        next: function next(duration) {
            return this.jumpTo(this.currPos + 1, duration);
        },
        // Switch to selected gallery item
        // ===============================
        jumpTo: function jumpTo(pos, duration) {
            var self = this, groupLen = self.group.length, firstRun, isMoved, loop, current, previous, slidePos, stagePos, prop, diff;
            if (self.isDragging || self.isClosing || self.isAnimating && self.firstRun) return;
            // Should loop?
            pos = parseInt(pos, 10);
            loop = self.current ? self.current.opts.loop : self.opts.loop;
            if (!loop && (pos < 0 || pos >= groupLen)) return false;
            // Check if opening for the first time; this helps to speed things up
            firstRun = self.firstRun = !Object.keys(self.slides).length;
            // Create slides
            previous = self.current;
            self.prevIndex = self.currIndex;
            self.prevPos = self.currPos;
            current = self.createSlide(pos);
            if (groupLen > 1) {
                if (loop || current.index < groupLen - 1) self.createSlide(pos + 1);
                if (loop || current.index > 0) self.createSlide(pos - 1);
            }
            self.current = current;
            self.currIndex = current.index;
            self.currPos = current.pos;
            self.trigger("beforeShow", firstRun);
            self.updateControls();
            // Validate duration length
            current.forcedDuration = undefined1;
            if ($.isNumeric(duration)) current.forcedDuration = duration;
            else duration = current.opts[firstRun ? "animationDuration" : "transitionDuration"];
            duration = parseInt(duration, 10);
            // Check if user has swiped the slides or if still animating
            isMoved = self.isMoved(current);
            // Make sure current slide is visible
            current.$slide.addClass("fancybox-slide--current");
            // Fresh start - reveal container, current slide and start loading content
            if (firstRun) {
                if (current.opts.animationEffect && duration) self.$refs.container.css("transition-duration", duration + "ms");
                self.$refs.container.addClass("fancybox-is-open").trigger("focus");
                // Attempt to load content into slide
                // This will later call `afterLoad` -> `revealContent`
                self.loadSlide(current);
                self.preload("image");
                return;
            }
            // Get actual slide/stage positions (before cleaning up)
            slidePos = $.fancybox.getTranslate(previous.$slide);
            stagePos = $.fancybox.getTranslate(self.$refs.stage);
            // Clean up all slides
            $.each(self.slides, function(index, slide) {
                $.fancybox.stop(slide.$slide, true);
            });
            if (previous.pos !== current.pos) previous.isComplete = false;
            previous.$slide.removeClass("fancybox-slide--complete fancybox-slide--current");
            // If slides are out of place, then animate them to correct position
            if (isMoved) {
                // Calculate horizontal swipe distance
                diff = slidePos.left - (previous.pos * slidePos.width + previous.pos * previous.opts.gutter);
                $.each(self.slides, function(index, slide) {
                    slide.$slide.removeClass("fancybox-animated").removeClass(function(index, className) {
                        return (className.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                    });
                    // Make sure that each slide is in equal distance
                    // This is mostly needed for freshly added slides, because they are not yet positioned
                    var leftPos = slide.pos * slidePos.width + slide.pos * slide.opts.gutter;
                    $.fancybox.setTranslate(slide.$slide, {
                        top: 0,
                        left: leftPos - stagePos.left + diff
                    });
                    if (slide.pos !== current.pos) slide.$slide.addClass("fancybox-slide--" + (slide.pos > current.pos ? "next" : "previous"));
                    // Redraw to make sure that transition will start
                    forceRedraw(slide.$slide);
                    // Animate the slide
                    $.fancybox.animate(slide.$slide, {
                        top: 0,
                        left: (slide.pos - current.pos) * slidePos.width + (slide.pos - current.pos) * slide.opts.gutter
                    }, duration, function() {
                        slide.$slide.css({
                            transform: "",
                            opacity: ""
                        }).removeClass("fancybox-slide--next fancybox-slide--previous");
                        if (slide.pos === self.currPos) self.complete();
                    });
                });
            } else if (duration && current.opts.transitionEffect) {
                // Set transition effect for previously active slide
                prop = "fancybox-animated fancybox-fx-" + current.opts.transitionEffect;
                previous.$slide.addClass("fancybox-slide--" + (previous.pos > current.pos ? "next" : "previous"));
                $.fancybox.animate(previous.$slide, prop, duration, function() {
                    previous.$slide.removeClass(prop).removeClass("fancybox-slide--next fancybox-slide--previous");
                }, false);
            }
            if (current.isLoaded) self.revealContent(current);
            else self.loadSlide(current);
            self.preload("image");
        },
        // Create new "slide" element
        // These are gallery items  that are actually added to DOM
        // =======================================================
        createSlide: function createSlide(pos) {
            var self = this, $slide, index;
            index = pos % self.group.length;
            index = index < 0 ? self.group.length + index : index;
            if (!self.slides[pos] && self.group[index]) {
                $slide = $('<div class="fancybox-slide"></div>').appendTo(self.$refs.stage);
                self.slides[pos] = $.extend(true, {}, self.group[index], {
                    pos: pos,
                    $slide: $slide,
                    isLoaded: false
                });
                self.updateSlide(self.slides[pos]);
            }
            return self.slides[pos];
        },
        // Scale image to the actual size of the image;
        // x and y values should be relative to the slide
        // ==============================================
        scaleToActual: function scaleToActual(x, y, duration) {
            var self = this, current = self.current, $content = current.$content, canvasWidth = $.fancybox.getTranslate(current.$slide).width, canvasHeight = $.fancybox.getTranslate(current.$slide).height, newImgWidth = current.width, newImgHeight = current.height, imgPos, posX, posY, scaleX, scaleY;
            if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) return;
            self.isAnimating = true;
            $.fancybox.stop($content);
            x = x === undefined1 ? canvasWidth * 0.5 : x;
            y = y === undefined1 ? canvasHeight * 0.5 : y;
            imgPos = $.fancybox.getTranslate($content);
            imgPos.top -= $.fancybox.getTranslate(current.$slide).top;
            imgPos.left -= $.fancybox.getTranslate(current.$slide).left;
            scaleX = newImgWidth / imgPos.width;
            scaleY = newImgHeight / imgPos.height;
            // Get center position for original image
            posX = canvasWidth * 0.5 - newImgWidth * 0.5;
            posY = canvasHeight * 0.5 - newImgHeight * 0.5;
            // Make sure image does not move away from edges
            if (newImgWidth > canvasWidth) {
                posX = imgPos.left * scaleX - (x * scaleX - x);
                if (posX > 0) posX = 0;
                if (posX < canvasWidth - newImgWidth) posX = canvasWidth - newImgWidth;
            }
            if (newImgHeight > canvasHeight) {
                posY = imgPos.top * scaleY - (y * scaleY - y);
                if (posY > 0) posY = 0;
                if (posY < canvasHeight - newImgHeight) posY = canvasHeight - newImgHeight;
            }
            self.updateCursor(newImgWidth, newImgHeight);
            $.fancybox.animate($content, {
                top: posY,
                left: posX,
                scaleX: scaleX,
                scaleY: scaleY
            }, duration || 366, function() {
                self.isAnimating = false;
            });
            // Stop slideshow
            if (self.SlideShow && self.SlideShow.isActive) self.SlideShow.stop();
        },
        // Scale image to fit inside parent element
        // ========================================
        scaleToFit: function scaleToFit(duration) {
            var self = this, current = self.current, $content = current.$content, end;
            if (self.isAnimating || self.isMoved() || !$content || !(current.type == "image" && current.isLoaded && !current.hasError)) return;
            self.isAnimating = true;
            $.fancybox.stop($content);
            end = self.getFitPos(current);
            self.updateCursor(end.width, end.height);
            $.fancybox.animate($content, {
                top: end.top,
                left: end.left,
                scaleX: end.width / $content.width(),
                scaleY: end.height / $content.height()
            }, duration || 366, function() {
                self.isAnimating = false;
            });
        },
        // Calculate image size to fit inside viewport
        // ===========================================
        getFitPos: function getFitPos(slide) {
            var self = this, $content = slide.$content, $slide = slide.$slide, width = slide.width || slide.opts.width, height = slide.height || slide.opts.height, maxWidth, maxHeight, minRatio, aspectRatio, rez = {};
            if (!slide.isLoaded || !$content || !$content.length) return false;
            maxWidth = $.fancybox.getTranslate(self.$refs.stage).width;
            maxHeight = $.fancybox.getTranslate(self.$refs.stage).height;
            maxWidth -= parseFloat($slide.css("paddingLeft")) + parseFloat($slide.css("paddingRight")) + parseFloat($content.css("marginLeft")) + parseFloat($content.css("marginRight"));
            maxHeight -= parseFloat($slide.css("paddingTop")) + parseFloat($slide.css("paddingBottom")) + parseFloat($content.css("marginTop")) + parseFloat($content.css("marginBottom"));
            if (!width || !height) {
                width = maxWidth;
                height = maxHeight;
            }
            minRatio = Math.min(1, maxWidth / width, maxHeight / height);
            width = minRatio * width;
            height = minRatio * height;
            // Adjust width/height to precisely fit into container
            if (width > maxWidth - 0.5) width = maxWidth;
            if (height > maxHeight - 0.5) height = maxHeight;
            if (slide.type === "image") {
                rez.top = Math.floor((maxHeight - height) * 0.5) + parseFloat($slide.css("paddingTop"));
                rez.left = Math.floor((maxWidth - width) * 0.5) + parseFloat($slide.css("paddingLeft"));
            } else if (slide.contentType === "video") {
                // Force aspect ratio for the video
                // "I say the whole world must learn of our peaceful ways… by force!"
                aspectRatio = slide.opts.width && slide.opts.height ? width / height : slide.opts.ratio || 16 / 9;
                if (height > width / aspectRatio) height = width / aspectRatio;
                else if (width > height * aspectRatio) width = height * aspectRatio;
            }
            rez.width = width;
            rez.height = height;
            return rez;
        },
        // Update content size and position for all slides
        // ==============================================
        update: function update(e) {
            var self = this;
            $.each(self.slides, function(key, slide) {
                self.updateSlide(slide, e);
            });
        },
        // Update slide content position and size
        // ======================================
        updateSlide: function updateSlide(slide, e) {
            var self = this, $content = slide && slide.$content, width = slide.width || slide.opts.width, height = slide.height || slide.opts.height, $slide = slide.$slide;
            // First, prevent caption overlap, if needed
            self.adjustCaption(slide);
            // Then resize content to fit inside the slide
            if ($content && (width || height || slide.contentType === "video") && !slide.hasError) {
                $.fancybox.stop($content);
                $.fancybox.setTranslate($content, self.getFitPos(slide));
                if (slide.pos === self.currPos) {
                    self.isAnimating = false;
                    self.updateCursor();
                }
            }
            // Then some adjustments
            self.adjustLayout(slide);
            if ($slide.length) {
                $slide.trigger("refresh");
                if (slide.pos === self.currPos) self.$refs.toolbar.add(self.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", $slide.get(0).scrollHeight > $slide.get(0).clientHeight);
            }
            self.trigger("onUpdate", slide, e);
        },
        // Horizontally center slide
        // =========================
        centerSlide: function centerSlide(duration) {
            var self = this, current = self.current, $slide = current.$slide;
            if (self.isClosing || !current) return;
            $slide.siblings().css({
                transform: "",
                opacity: ""
            });
            $slide.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next");
            $.fancybox.animate($slide, {
                top: 0,
                left: 0,
                opacity: 1
            }, duration === undefined1 ? 0 : duration, function() {
                // Clean up
                $slide.css({
                    transform: "",
                    opacity: ""
                });
                if (!current.isComplete) self.complete();
            }, false);
        },
        // Check if current slide is moved (swiped)
        // ========================================
        isMoved: function isMoved(slide) {
            var current = slide || this.current, slidePos, stagePos;
            if (!current) return false;
            stagePos = $.fancybox.getTranslate(this.$refs.stage);
            slidePos = $.fancybox.getTranslate(current.$slide);
            return !current.$slide.hasClass("fancybox-animated") && (Math.abs(slidePos.top - stagePos.top) > 0.5 || Math.abs(slidePos.left - stagePos.left) > 0.5);
        },
        // Update cursor style depending if content can be zoomed
        // ======================================================
        updateCursor: function updateCursor(nextWidth, nextHeight) {
            var self = this, current = self.current, $container = self.$refs.container, canPan, isZoomable;
            if (!current || self.isClosing || !self.Guestures) return;
            $container.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan");
            canPan = self.canPan(nextWidth, nextHeight);
            isZoomable = canPan ? true : self.isZoomable();
            $container.toggleClass("fancybox-is-zoomable", isZoomable);
            $("[data-fancybox-zoom]").prop("disabled", !isZoomable);
            if (canPan) $container.addClass("fancybox-can-pan");
            else if (isZoomable && (current.opts.clickContent === "zoom" || $.isFunction(current.opts.clickContent) && current.opts.clickContent(current) == "zoom")) $container.addClass("fancybox-can-zoomIn");
            else if (current.opts.touch && (current.opts.touch.vertical || self.group.length > 1) && current.contentType !== "video") $container.addClass("fancybox-can-swipe");
        },
        // Check if current slide is zoomable
        // ==================================
        isZoomable: function isZoomable() {
            var self = this, current = self.current, fitPos;
            // Assume that slide is zoomable if:
            //   - image is still loading
            //   - actual size of the image is smaller than available area
            if (current && !self.isClosing && current.type === "image" && !current.hasError) {
                if (!current.isLoaded) return true;
                fitPos = self.getFitPos(current);
                if (fitPos && (current.width > fitPos.width || current.height > fitPos.height)) return true;
            }
            return false;
        },
        // Check if current image dimensions are smaller than actual
        // =========================================================
        isScaledDown: function isScaledDown(nextWidth, nextHeight) {
            var self = this, rez = false, current = self.current, $content = current.$content;
            if (nextWidth !== undefined1 && nextHeight !== undefined1) rez = nextWidth < current.width && nextHeight < current.height;
            else if ($content) {
                rez = $.fancybox.getTranslate($content);
                rez = rez.width < current.width && rez.height < current.height;
            }
            return rez;
        },
        // Check if image dimensions exceed parent element
        // ===============================================
        canPan: function canPan(nextWidth, nextHeight) {
            var self = this, current = self.current, pos = null, rez = false;
            if (current.type === "image" && (current.isComplete || nextWidth && nextHeight) && !current.hasError) {
                rez = self.getFitPos(current);
                if (nextWidth !== undefined1 && nextHeight !== undefined1) pos = {
                    width: nextWidth,
                    height: nextHeight
                };
                else if (current.isComplete) pos = $.fancybox.getTranslate(current.$content);
                if (pos && rez) rez = Math.abs(pos.width - rez.width) > 1.5 || Math.abs(pos.height - rez.height) > 1.5;
            }
            return rez;
        },
        // Load content into the slide
        // ===========================
        loadSlide: function loadSlide(slide) {
            var self = this, type, $slide, ajaxLoad;
            if (slide.isLoading || slide.isLoaded) return;
            slide.isLoading = true;
            if (self.trigger("beforeLoad", slide) === false) {
                slide.isLoading = false;
                return false;
            }
            type = slide.type;
            $slide = slide.$slide;
            $slide.off("refresh").trigger("onReset").addClass(slide.opts.slideClass);
            // Create content depending on the type
            switch(type){
                case "image":
                    self.setImage(slide);
                    break;
                case "iframe":
                    self.setIframe(slide);
                    break;
                case "html":
                    self.setContent(slide, slide.src || slide.content);
                    break;
                case "video":
                    self.setContent(slide, slide.opts.video.tpl.replace(/\{\{src\}\}/gi, slide.src).replace("{{format}}", slide.opts.videoFormat || slide.opts.video.format || "").replace("{{poster}}", slide.thumb || ""));
                    break;
                case "inline":
                    if ($(slide.src).length) self.setContent(slide, $(slide.src));
                    else self.setError(slide);
                    break;
                case "ajax":
                    self.showLoading(slide);
                    ajaxLoad = $.ajax($.extend({}, slide.opts.ajax.settings, {
                        url: slide.src,
                        success: function success(data, textStatus) {
                            if (textStatus === "success") self.setContent(slide, data);
                        },
                        error: function error(jqXHR, textStatus) {
                            if (jqXHR && textStatus !== "abort") self.setError(slide);
                        }
                    }));
                    $slide.one("onReset", function() {
                        ajaxLoad.abort();
                    });
                    break;
                default:
                    self.setError(slide);
                    break;
            }
            return true;
        },
        // Use thumbnail image, if possible
        // ================================
        setImage: function setImage(slide) {
            var self = this, ghost;
            // Check if need to show loading icon
            setTimeout(function() {
                var $img = slide.$image;
                if (!self.isClosing && slide.isLoading && (!$img || !$img.length || !$img[0].complete) && !slide.hasError) self.showLoading(slide);
            }, 50);
            //Check if image has srcset
            self.checkSrcset(slide);
            // This will be wrapper containing both ghost and actual image
            slide.$content = $('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(slide.$slide.addClass("fancybox-slide--image"));
            // If we have a thumbnail, we can display it while actual image is loading
            // Users will not stare at black screen and actual image will appear gradually
            if (slide.opts.preload !== false && slide.opts.width && slide.opts.height && slide.thumb) {
                slide.width = slide.opts.width;
                slide.height = slide.opts.height;
                ghost = document1.createElement("img");
                ghost.onerror = function() {
                    $(this).remove();
                    slide.$ghost = null;
                };
                ghost.onload = function() {
                    self.afterLoad(slide);
                };
                slide.$ghost = $(ghost).addClass("fancybox-image").appendTo(slide.$content).attr("src", slide.thumb);
            }
            // Start loading actual image
            self.setBigImage(slide);
        },
        // Check if image has srcset and get the source
        // ============================================
        checkSrcset: function checkSrcset(slide) {
            var srcset = slide.opts.srcset || slide.opts.image.srcset, found, temp, pxRatio, windowWidth;
            // If we have "srcset", then we need to find first matching "src" value.
            // This is necessary, because when you set an src attribute, the browser will preload the image
            // before any javascript or even CSS is applied.
            if (srcset) {
                pxRatio = window1.devicePixelRatio || 1;
                windowWidth = window1.innerWidth * pxRatio;
                temp = srcset.split(",").map(function(el) {
                    var ret = {};
                    el.trim().split(/\s+/).forEach(function(el, i) {
                        var value = parseInt(el.substring(0, el.length - 1), 10);
                        if (i === 0) return ret.url = el;
                        if (value) {
                            ret.value = value;
                            ret.postfix = el[el.length - 1];
                        }
                    });
                    return ret;
                });
                // Sort by value
                temp.sort(function(a, b) {
                    return a.value - b.value;
                });
                // Ok, now we have an array of all srcset values
                for(var j = 0; j < temp.length; j++){
                    var el = temp[j];
                    if (el.postfix === "w" && el.value >= windowWidth || el.postfix === "x" && el.value >= pxRatio) {
                        found = el;
                        break;
                    }
                }
                // If not found, take the last one
                if (!found && temp.length) found = temp[temp.length - 1];
                if (found) {
                    slide.src = found.url;
                    // If we have default width/height values, we can calculate height for matching source
                    if (slide.width && slide.height && found.postfix == "w") {
                        slide.height = slide.width / slide.height * found.value;
                        slide.width = found.value;
                    }
                    slide.opts.srcset = srcset;
                }
            }
        },
        // Create full-size image
        // ======================
        setBigImage: function setBigImage(slide) {
            var self = this, img = document1.createElement("img"), $img = $(img);
            slide.$image = $img.one("error", function() {
                self.setError(slide);
            }).one("load", function() {
                var sizes;
                if (!slide.$ghost) {
                    self.resolveImageSlideSize(slide, this.naturalWidth, this.naturalHeight);
                    self.afterLoad(slide);
                }
                if (self.isClosing) return;
                if (slide.opts.srcset) {
                    sizes = slide.opts.sizes;
                    if (!sizes || sizes === "auto") sizes = (slide.width / slide.height > 1 && $W.width() / $W.height() > 1 ? "100" : Math.round(slide.width / slide.height * 100)) + "vw";
                    $img.attr("sizes", sizes).attr("srcset", slide.opts.srcset);
                }
                // Hide temporary image after some delay
                if (slide.$ghost) setTimeout(function() {
                    if (slide.$ghost && !self.isClosing) slide.$ghost.hide();
                }, Math.min(300, Math.max(1000, slide.height / 1600)));
                self.hideLoading(slide);
            }).addClass("fancybox-image").attr("src", slide.src).appendTo(slide.$content);
            if ((img.complete || img.readyState == "complete") && $img.naturalWidth && $img.naturalHeight) $img.trigger("load");
            else if (img.error) $img.trigger("error");
        },
        // Computes the slide size from image size and maxWidth/maxHeight
        // ==============================================================
        resolveImageSlideSize: function resolveImageSlideSize(slide, imgWidth, imgHeight) {
            var maxWidth = parseInt(slide.opts.width, 10), maxHeight = parseInt(slide.opts.height, 10);
            // Sets the default values from the image
            slide.width = imgWidth;
            slide.height = imgHeight;
            if (maxWidth > 0) {
                slide.width = maxWidth;
                slide.height = Math.floor(maxWidth * imgHeight / imgWidth);
            }
            if (maxHeight > 0) {
                slide.width = Math.floor(maxHeight * imgWidth / imgHeight);
                slide.height = maxHeight;
            }
        },
        // Create iframe wrapper, iframe and bindings
        // ==========================================
        setIframe: function setIframe(slide) {
            var self = this, opts = slide.opts.iframe, $slide = slide.$slide, $iframe;
            slide.$content = $('<div class="fancybox-content' + (opts.preload ? " fancybox-is-hidden" : "") + '"></div>').css(opts.css).appendTo($slide);
            $slide.addClass("fancybox-slide--" + slide.contentType);
            slide.$iframe = $iframe = $(opts.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr(opts.attr).appendTo(slide.$content);
            if (opts.preload) {
                self.showLoading(slide);
                // Unfortunately, it is not always possible to determine if iframe is successfully loaded
                // (due to browser security policy)
                $iframe.on("load.fb error.fb", function(e) {
                    this.isReady = 1;
                    slide.$slide.trigger("refresh");
                    self.afterLoad(slide);
                });
                // Recalculate iframe content size
                // ===============================
                $slide.on("refresh.fb", function() {
                    var $content = slide.$content, frameWidth = opts.css.width, frameHeight = opts.css.height, $contents, $body;
                    if ($iframe[0].isReady !== 1) return;
                    try {
                        $contents = $iframe.contents();
                        $body = $contents.find("body");
                    } catch (ignore) {}
                    // Calculate content dimensions, if it is accessible
                    if ($body && $body.length && $body.children().length) {
                        // Avoid scrolling to top (if multiple instances)
                        $slide.css("overflow", "visible");
                        $content.css({
                            width: "100%",
                            "max-width": "100%",
                            height: "9999px"
                        });
                        if (frameWidth === undefined1) frameWidth = Math.ceil(Math.max($body[0].clientWidth, $body.outerWidth(true)));
                        $content.css("width", frameWidth ? frameWidth : "").css("max-width", "");
                        if (frameHeight === undefined1) frameHeight = Math.ceil(Math.max($body[0].clientHeight, $body.outerHeight(true)));
                        $content.css("height", frameHeight ? frameHeight : "");
                        $slide.css("overflow", "auto");
                    }
                    $content.removeClass("fancybox-is-hidden");
                });
            } else self.afterLoad(slide);
            $iframe.attr("src", slide.src);
            // Remove iframe if closing or changing gallery item
            $slide.one("onReset", function() {
                // This helps IE not to throw errors when closing
                try {
                    $(this).find("iframe").hide().unbind().attr("src", "//about:blank");
                } catch (ignore) {}
                $(this).off("refresh.fb").empty();
                slide.isLoaded = false;
                slide.isRevealed = false;
            });
        },
        // Wrap and append content to the slide
        // ======================================
        setContent: function setContent(slide, content) {
            var self = this;
            if (self.isClosing) return;
            self.hideLoading(slide);
            if (slide.$content) $.fancybox.stop(slide.$content);
            slide.$slide.empty();
            // If content is a jQuery object, then it will be moved to the slide.
            // The placeholder is created so we will know where to put it back.
            if (isQuery(content) && content.parent().length) {
                // Make sure content is not already moved to fancyBox
                if (content.hasClass("fancybox-content") || content.parent().hasClass("fancybox-content")) content.parents(".fancybox-slide").trigger("onReset");
                // Create temporary element marking original place of the content
                slide.$placeholder = $("<div>").hide().insertAfter(content);
                // Make sure content is visible
                content.css("display", "inline-block");
            } else if (!slide.hasError) {
                // If content is just a plain text, try to convert it to html
                if ($.type(content) === "string") content = $("<div>").append($.trim(content)).contents();
                // If "filter" option is provided, then filter content
                if (slide.opts.filter) content = $("<div>").html(content).find(slide.opts.filter);
            }
            slide.$slide.one("onReset", function() {
                // Pause all html5 video/audio
                $(this).find("video,audio").trigger("pause");
                // Put content back
                if (slide.$placeholder) {
                    slide.$placeholder.after(content.removeClass("fancybox-content").hide()).remove();
                    slide.$placeholder = null;
                }
                // Remove custom close button
                if (slide.$smallBtn) {
                    slide.$smallBtn.remove();
                    slide.$smallBtn = null;
                }
                // Remove content and mark slide as not loaded
                if (!slide.hasError) {
                    $(this).empty();
                    slide.isLoaded = false;
                    slide.isRevealed = false;
                }
            });
            $(content).appendTo(slide.$slide);
            if ($(content).is("video,audio")) {
                $(content).addClass("fancybox-video");
                $(content).wrap("<div></div>");
                slide.contentType = "video";
                slide.opts.width = slide.opts.width || $(content).attr("width");
                slide.opts.height = slide.opts.height || $(content).attr("height");
            }
            slide.$content = slide.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first();
            slide.$content.siblings().hide();
            // Re-check if there is a valid content
            // (in some cases, ajax response can contain various elements or plain text)
            if (!slide.$content.length) slide.$content = slide.$slide.wrapInner("<div></div>").children().first();
            slide.$content.addClass("fancybox-content");
            slide.$slide.addClass("fancybox-slide--" + slide.contentType);
            self.afterLoad(slide);
        },
        // Display error message
        // =====================
        setError: function setError(slide) {
            slide.hasError = true;
            slide.$slide.trigger("onReset").removeClass("fancybox-slide--" + slide.contentType).addClass("fancybox-slide--error");
            slide.contentType = "html";
            this.setContent(slide, this.translate(slide, slide.opts.errorTpl));
            if (slide.pos === this.currPos) this.isAnimating = false;
        },
        // Show loading icon inside the slide
        // ==================================
        showLoading: function showLoading(slide) {
            var self = this;
            slide = slide || self.current;
            if (slide && !slide.$spinner) slide.$spinner = $(self.translate(self, self.opts.spinnerTpl)).appendTo(slide.$slide).hide().fadeIn("fast");
        },
        // Remove loading icon from the slide
        // ==================================
        hideLoading: function hideLoading(slide) {
            var self = this;
            slide = slide || self.current;
            if (slide && slide.$spinner) {
                slide.$spinner.stop().remove();
                delete slide.$spinner;
            }
        },
        // Adjustments after slide content has been loaded
        // ===============================================
        afterLoad: function afterLoad(slide) {
            var self = this;
            if (self.isClosing) return;
            slide.isLoading = false;
            slide.isLoaded = true;
            self.trigger("afterLoad", slide);
            self.hideLoading(slide);
            // Add small close button
            if (slide.opts.smallBtn && (!slide.$smallBtn || !slide.$smallBtn.length)) slide.$smallBtn = $(self.translate(slide, slide.opts.btnTpl.smallBtn)).appendTo(slide.$content);
            // Disable right click
            if (slide.opts.protect && slide.$content && !slide.hasError) {
                slide.$content.on("contextmenu.fb", function(e) {
                    if (e.button == 2) e.preventDefault();
                    return true;
                });
                // Add fake element on top of the image
                // This makes a bit harder for user to select image
                if (slide.type === "image") $('<div class="fancybox-spaceball"></div>').appendTo(slide.$content);
            }
            self.adjustCaption(slide);
            self.adjustLayout(slide);
            if (slide.pos === self.currPos) self.updateCursor();
            self.revealContent(slide);
        },
        // Prevent caption overlap,
        // fix css inconsistency across browsers
        // =====================================
        adjustCaption: function adjustCaption(slide) {
            var self = this, current = slide || self.current, caption = current.opts.caption, preventOverlap = current.opts.preventCaptionOverlap, $caption = self.$refs.caption, $clone, captionH = false;
            $caption.toggleClass("fancybox-caption--separate", preventOverlap);
            if (preventOverlap && caption && caption.length) {
                if (current.pos !== self.currPos) {
                    $clone = $caption.clone().appendTo($caption.parent());
                    $clone.children().eq(0).empty().html(caption);
                    captionH = $clone.outerHeight(true);
                    $clone.empty().remove();
                } else if (self.$caption) captionH = self.$caption.outerHeight(true);
                current.$slide.css("padding-bottom", captionH || "");
            }
        },
        // Simple hack to fix inconsistency across browsers, described here (affects Edge, too):
        // https://bugzilla.mozilla.org/show_bug.cgi?id=748518
        // ====================================================================================
        adjustLayout: function adjustLayout(slide) {
            var self = this, current = slide || self.current, scrollHeight, marginBottom, inlinePadding, actualPadding;
            if (current.isLoaded && current.opts.disableLayoutFix !== true) {
                current.$content.css("margin-bottom", "");
                // If we would always set margin-bottom for the content,
                // then it would potentially break vertical align
                if (current.$content.outerHeight() > current.$slide.height() + 0.5) {
                    inlinePadding = current.$slide[0].style["padding-bottom"];
                    actualPadding = current.$slide.css("padding-bottom");
                    if (parseFloat(actualPadding) > 0) {
                        scrollHeight = current.$slide[0].scrollHeight;
                        current.$slide.css("padding-bottom", 0);
                        if (Math.abs(scrollHeight - current.$slide[0].scrollHeight) < 1) marginBottom = actualPadding;
                        current.$slide.css("padding-bottom", inlinePadding);
                    }
                }
                current.$content.css("margin-bottom", marginBottom);
            }
        },
        // Make content visible
        // This method is called right after content has been loaded or
        // user navigates gallery and transition should start
        // ============================================================
        revealContent: function revealContent(slide) {
            var self = this, $slide = slide.$slide, end = false, start = false, isMoved = self.isMoved(slide), isRevealed = slide.isRevealed, effect, effectClassName, duration, opacity;
            slide.isRevealed = true;
            effect = slide.opts[self.firstRun ? "animationEffect" : "transitionEffect"];
            duration = slide.opts[self.firstRun ? "animationDuration" : "transitionDuration"];
            duration = parseInt(slide.forcedDuration === undefined1 ? duration : slide.forcedDuration, 10);
            if (isMoved || slide.pos !== self.currPos || !duration) effect = false;
            // Check if can zoom
            if (effect === "zoom") {
                if (slide.pos === self.currPos && duration && slide.type === "image" && !slide.hasError && (start = self.getThumbPos(slide))) end = self.getFitPos(slide);
                else effect = "fade";
            }
            // Zoom animation
            // ==============
            if (effect === "zoom") {
                self.isAnimating = true;
                end.scaleX = end.width / start.width;
                end.scaleY = end.height / start.height;
                // Check if we need to animate opacity
                opacity = slide.opts.zoomOpacity;
                if (opacity == "auto") opacity = Math.abs(slide.width / slide.height - start.width / start.height) > 0.1;
                if (opacity) {
                    start.opacity = 0.1;
                    end.opacity = 1;
                }
                // Draw image at start position
                $.fancybox.setTranslate(slide.$content.removeClass("fancybox-is-hidden"), start);
                forceRedraw(slide.$content);
                // Start animation
                $.fancybox.animate(slide.$content, end, duration, function() {
                    self.isAnimating = false;
                    self.complete();
                });
                return;
            }
            self.updateSlide(slide);
            // Simply show content if no effect
            // ================================
            if (!effect) {
                slide.$content.removeClass("fancybox-is-hidden");
                if (!isRevealed && isMoved && slide.type === "image" && !slide.hasError) slide.$content.hide().fadeIn("fast");
                if (slide.pos === self.currPos) self.complete();
                return;
            }
            // Prepare for CSS transiton
            // =========================
            $.fancybox.stop($slide);
            //effectClassName = "fancybox-animated fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-fx-" + effect;
            effectClassName = "fancybox-slide--" + (slide.pos >= self.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + effect;
            $slide.addClass(effectClassName).removeClass("fancybox-slide--current"); //.addClass(effectClassName);
            slide.$content.removeClass("fancybox-is-hidden");
            // Force reflow
            forceRedraw($slide);
            if (slide.type !== "image") slide.$content.hide().show(0);
            $.fancybox.animate($slide, "fancybox-slide--current", duration, function() {
                $slide.removeClass(effectClassName).css({
                    transform: "",
                    opacity: ""
                });
                if (slide.pos === self.currPos) self.complete();
            }, true);
        },
        // Check if we can and have to zoom from thumbnail
        //================================================
        getThumbPos: function getThumbPos(slide) {
            var rez = false, $thumb = slide.$thumb, thumbPos, btw, brw, bbw, blw;
            if (!$thumb || !inViewport($thumb[0])) return false;
            thumbPos = $.fancybox.getTranslate($thumb);
            btw = parseFloat($thumb.css("border-top-width") || 0);
            brw = parseFloat($thumb.css("border-right-width") || 0);
            bbw = parseFloat($thumb.css("border-bottom-width") || 0);
            blw = parseFloat($thumb.css("border-left-width") || 0);
            rez = {
                top: thumbPos.top + btw,
                left: thumbPos.left + blw,
                width: thumbPos.width - brw - blw,
                height: thumbPos.height - btw - bbw,
                scaleX: 1,
                scaleY: 1
            };
            return thumbPos.width > 0 && thumbPos.height > 0 ? rez : false;
        },
        // Final adjustments after current gallery item is moved to position
        // and it`s content is loaded
        // ==================================================================
        complete: function complete() {
            var self = this, current = self.current, slides = {}, $el;
            if (self.isMoved() || !current.isLoaded) return;
            if (!current.isComplete) {
                current.isComplete = true;
                current.$slide.siblings().trigger("onReset");
                self.preload("inline");
                // Trigger any CSS transiton inside the slide
                forceRedraw(current.$slide);
                current.$slide.addClass("fancybox-slide--complete");
                // Remove unnecessary slides
                $.each(self.slides, function(key, slide) {
                    if (slide.pos >= self.currPos - 1 && slide.pos <= self.currPos + 1) slides[slide.pos] = slide;
                    else if (slide) {
                        $.fancybox.stop(slide.$slide);
                        slide.$slide.off().remove();
                    }
                });
                self.slides = slides;
            }
            self.isAnimating = false;
            self.updateCursor();
            self.trigger("afterShow");
            // Autoplay first html5 video/audio
            if (!!current.opts.video.autoStart) current.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", function() {
                if (Document.exitFullscreen) Document.exitFullscreen();
                else if (this.webkitExitFullscreen) this.webkitExitFullscreen();
                self.next();
            });
            // Try to focus on the first focusable element
            if (current.opts.autoFocus && current.contentType === "html") {
                // Look for the first input with autofocus attribute
                $el = current.$content.find("input[autofocus]:enabled:visible:first");
                if ($el.length) $el.trigger("focus");
                else self.focus(null, true);
            }
            // Avoid jumping
            current.$slide.scrollTop(0).scrollLeft(0);
        },
        // Preload next and previous slides
        // ================================
        preload: function preload(type) {
            var self = this, prev, next;
            if (self.group.length < 2) return;
            next = self.slides[self.currPos + 1];
            prev = self.slides[self.currPos - 1];
            if (prev && prev.type === type) self.loadSlide(prev);
            if (next && next.type === type) self.loadSlide(next);
        },
        // Try to find and focus on the first focusable element
        // ====================================================
        focus: function focus(e, firstRun) {
            var self = this, focusableStr = [
                "a[href]",
                "area[href]",
                'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
                "select:not([disabled]):not([aria-hidden])",
                "textarea:not([disabled]):not([aria-hidden])",
                "button:not([disabled]):not([aria-hidden])",
                "iframe",
                "object",
                "embed",
                "video",
                "audio",
                "[contenteditable]",
                '[tabindex]:not([tabindex^="-"])'
            ].join(","), focusableItems, focusedItemIndex;
            if (self.isClosing) return;
            if (e || !self.current || !self.current.isComplete) // Focus on any element inside fancybox
            focusableItems = self.$refs.container.find("*:visible");
            else // Focus inside current slide
            focusableItems = self.current.$slide.find("*:visible" + (firstRun ? ":not(.fancybox-close-small)" : ""));
            focusableItems = focusableItems.filter(focusableStr).filter(function() {
                return $(this).css("visibility") !== "hidden" && !$(this).hasClass("disabled");
            });
            if (focusableItems.length) {
                focusedItemIndex = focusableItems.index(document1.activeElement);
                if (e && e.shiftKey) // Back tab
                {
                    if (focusedItemIndex < 0 || focusedItemIndex == 0) {
                        e.preventDefault();
                        focusableItems.eq(focusableItems.length - 1).trigger("focus");
                    }
                } else // Outside or Forward tab
                if (focusedItemIndex < 0 || focusedItemIndex == focusableItems.length - 1) {
                    if (e) e.preventDefault();
                    focusableItems.eq(0).trigger("focus");
                }
            } else self.$refs.container.trigger("focus");
        },
        // Activates current instance - brings container to the front and enables keyboard,
        // notifies other instances about deactivating
        // =================================================================================
        activate: function activate() {
            var self = this;
            // Deactivate all instances
            $(".fancybox-container").each(function() {
                var instance = $(this).data("FancyBox");
                // Skip self and closing instances
                if (instance && instance.id !== self.id && !instance.isClosing) {
                    instance.trigger("onDeactivate");
                    instance.removeEvents();
                    instance.isVisible = false;
                }
            });
            self.isVisible = true;
            if (self.current || self.isIdle) {
                self.update();
                self.updateControls();
            }
            self.trigger("onActivate");
            self.addEvents();
        },
        // Start closing procedure
        // This will start "zoom-out" animation if needed and clean everything up afterwards
        // =================================================================================
        close: function close(e, d) {
            var self = this, current = self.current, effect, duration, $content, domRect, opacity, start, end;
            var done = function done() {
                self.cleanUp(e);
            };
            if (self.isClosing) return false;
            self.isClosing = true;
            // If beforeClose callback prevents closing, make sure content is centered
            if (self.trigger("beforeClose", e) === false) {
                self.isClosing = false;
                requestAFrame(function() {
                    self.update();
                });
                return false;
            }
            // Remove all events
            // If there are multiple instances, they will be set again by "activate" method
            self.removeEvents();
            $content = current.$content;
            effect = current.opts.animationEffect;
            duration = $.isNumeric(d) ? d : effect ? current.opts.animationDuration : 0;
            current.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated");
            if (e !== true) $.fancybox.stop(current.$slide);
            else effect = false;
            // Remove other slides
            current.$slide.siblings().trigger("onReset").remove();
            // Trigger animations
            if (duration) self.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", duration + "ms");
            // Clean up
            self.hideLoading(current);
            self.hideControls(true);
            self.updateCursor();
            // Check if possible to zoom-out
            if (effect === "zoom" && !($content && duration && current.type === "image" && !self.isMoved() && !current.hasError && (end = self.getThumbPos(current)))) effect = "fade";
            if (effect === "zoom") {
                $.fancybox.stop($content);
                domRect = $.fancybox.getTranslate($content);
                start = {
                    top: domRect.top,
                    left: domRect.left,
                    scaleX: domRect.width / end.width,
                    scaleY: domRect.height / end.height,
                    width: end.width,
                    height: end.height
                };
                // Check if we need to animate opacity
                opacity = current.opts.zoomOpacity;
                if (opacity == "auto") opacity = Math.abs(current.width / current.height - end.width / end.height) > 0.1;
                if (opacity) end.opacity = 0;
                $.fancybox.setTranslate($content, start);
                forceRedraw($content);
                $.fancybox.animate($content, end, duration, done);
                return true;
            }
            if (effect && duration) $.fancybox.animate(current.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + effect, duration, done);
            else // If skip animation
            if (e === true) setTimeout(done, duration);
            else done();
            return true;
        },
        // Final adjustments after removing the instance
        // =============================================
        cleanUp: function cleanUp(e) {
            var self = this, instance, $focus = self.current.opts.$orig, x, y;
            self.current.$slide.trigger("onReset");
            self.$refs.container.empty().remove();
            self.trigger("afterClose", e);
            // Place back focus
            if (!!self.current.opts.backFocus) {
                if (!$focus || !$focus.length || !$focus.is(":visible")) $focus = self.$trigger;
                if ($focus && $focus.length) {
                    x = window1.scrollX;
                    y = window1.scrollY;
                    $focus.trigger("focus");
                    $("html, body").scrollTop(y).scrollLeft(x);
                }
            }
            self.current = null;
            // Check if there are other instances
            instance = $.fancybox.getInstance();
            if (instance) instance.activate();
            else {
                $("body").removeClass("fancybox-active compensate-for-scrollbar");
                $("#fancybox-style-noscroll").remove();
            }
        },
        // Call callback and trigger an event
        // ==================================
        trigger: function trigger(name, slide) {
            var args = Array.prototype.slice.call(arguments, 1), self = this, obj = slide && slide.opts ? slide : self.current, rez;
            if (obj) args.unshift(obj);
            else obj = self;
            args.unshift(self);
            if ($.isFunction(obj.opts[name])) rez = obj.opts[name].apply(obj, args);
            if (rez === false) return rez;
            if (name === "afterClose" || !self.$refs) $D.trigger(name + ".fb", args);
            else self.$refs.container.trigger(name + ".fb", args);
        },
        // Update infobar values, navigation button states and reveal caption
        // ==================================================================
        updateControls: function updateControls() {
            var self = this, current = self.current, index = current.index, $container = self.$refs.container, $caption = self.$refs.caption, caption = current.opts.caption;
            // Recalculate content dimensions
            current.$slide.trigger("refresh");
            // Set caption
            if (caption && caption.length) {
                self.$caption = $caption;
                $caption.children().eq(0).html(caption);
            } else self.$caption = null;
            if (!self.hasHiddenControls && !self.isIdle) self.showControls();
            // Update info and navigation elements
            $container.find("[data-fancybox-count]").html(self.group.length);
            $container.find("[data-fancybox-index]").html(index + 1);
            $container.find("[data-fancybox-prev]").prop("disabled", !current.opts.loop && index <= 0);
            $container.find("[data-fancybox-next]").prop("disabled", !current.opts.loop && index >= self.group.length - 1);
            if (current.type === "image") // Re-enable buttons; update download button source
            $container.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", current.opts.image.src || current.src).show();
            else if (current.opts.toolbar) $container.find("[data-fancybox-download],[data-fancybox-zoom]").hide();
            // Make sure focus is not on disabled button/element
            if ($(document1.activeElement).is(":hidden,[disabled]")) self.$refs.container.trigger("focus");
        },
        // Hide toolbar and caption
        // ========================
        hideControls: function hideControls(andCaption) {
            var self = this, arr = [
                "infobar",
                "toolbar",
                "nav"
            ];
            if (andCaption || !self.current.opts.preventCaptionOverlap) arr.push("caption");
            this.$refs.container.removeClass(arr.map(function(i) {
                return "fancybox-show-" + i;
            }).join(" "));
            this.hasHiddenControls = true;
        },
        showControls: function showControls() {
            var self = this, opts = self.current ? self.current.opts : self.opts, $container = self.$refs.container;
            self.hasHiddenControls = false;
            self.idleSecondsCounter = 0;
            $container.toggleClass("fancybox-show-toolbar", !!(opts.toolbar && opts.buttons)).toggleClass("fancybox-show-infobar", !!(opts.infobar && self.group.length > 1)).toggleClass("fancybox-show-caption", !!self.$caption).toggleClass("fancybox-show-nav", !!(opts.arrows && self.group.length > 1)).toggleClass("fancybox-is-modal", !!opts.modal);
        },
        // Toggle toolbar and caption
        // ==========================
        toggleControls: function toggleControls() {
            if (this.hasHiddenControls) this.showControls();
            else this.hideControls();
        }
    });
    $.fancybox = {
        version: "3.5.7",
        defaults: defaults,
        // Get current instance and execute a command.
        //
        // Examples of usage:
        //
        //   $instance = $.fancybox.getInstance();
        //   $.fancybox.getInstance().jumpTo( 1 );
        //   $.fancybox.getInstance( 'jumpTo', 1 );
        //   $.fancybox.getInstance( function() {
        //       console.info( this.currIndex );
        //   });
        // ======================================================
        getInstance: function getInstance(command) {
            var instance = $('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"), args = Array.prototype.slice.call(arguments, 1);
            if (instance instanceof FancyBox) {
                if ($.type(command) === "string") instance[command].apply(instance, args);
                else if ($.type(command) === "function") command.apply(instance, args);
                return instance;
            }
            return false;
        },
        // Create new instance
        // ===================
        open: function open(items, opts, index) {
            return new FancyBox(items, opts, index);
        },
        // Close current or all instances
        // ==============================
        close: function close(all) {
            var instance = this.getInstance();
            if (instance) {
                instance.close();
                // Try to find and close next instance
                if (all === true) this.close(all);
            }
        },
        // Close all instances and unbind all events
        // =========================================
        destroy: function destroy() {
            this.close(true);
            $D.add("body").off("click.fb-start", "**");
        },
        // Try to detect mobile devices
        // ============================
        isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        // Detect if 'translate3d' support is available
        // ============================================
        use3d: function() {
            var div = document1.createElement("div");
            return window1.getComputedStyle && window1.getComputedStyle(div) && window1.getComputedStyle(div).getPropertyValue("transform") && !(document1.documentMode && document1.documentMode < 11);
        }(),
        // Helper function to get current visual state of an element
        // returns array[ top, left, horizontal-scale, vertical-scale, opacity ]
        // =====================================================================
        getTranslate: function getTranslate($el) {
            var domRect;
            if (!$el || !$el.length) return false;
            domRect = $el[0].getBoundingClientRect();
            return {
                top: domRect.top || 0,
                left: domRect.left || 0,
                width: domRect.width,
                height: domRect.height,
                opacity: parseFloat($el.css("opacity"))
            };
        },
        // Shortcut for setting "translate3d" properties for element
        // Can set be used to set opacity, too
        // ========================================================
        setTranslate: function setTranslate($el, props) {
            var str = "", css = {};
            if (!$el || !props) return;
            if (props.left !== undefined1 || props.top !== undefined1) {
                str = (props.left === undefined1 ? $el.position().left : props.left) + "px, " + (props.top === undefined1 ? $el.position().top : props.top) + "px";
                if (this.use3d) str = "translate3d(" + str + ", 0px)";
                else str = "translate(" + str + ")";
            }
            if (props.scaleX !== undefined1 && props.scaleY !== undefined1) str += " scale(" + props.scaleX + ", " + props.scaleY + ")";
            else if (props.scaleX !== undefined1) str += " scaleX(" + props.scaleX + ")";
            if (str.length) css.transform = str;
            if (props.opacity !== undefined1) css.opacity = props.opacity;
            if (props.width !== undefined1) css.width = props.width;
            if (props.height !== undefined1) css.height = props.height;
            return $el.css(css);
        },
        // Simple CSS transition handler
        // =============================
        animate: function animate($el, to, duration, callback, leaveAnimationName) {
            var self = this, from;
            if ($.isFunction(duration)) {
                callback = duration;
                duration = null;
            }
            self.stop($el);
            from = self.getTranslate($el);
            $el.on(transitionEnd, function(e) {
                // Skip events from child elements and z-index change
                if (e && e.originalEvent && (!$el.is(e.originalEvent.target) || e.originalEvent.propertyName == "z-index")) return;
                self.stop($el);
                if ($.isNumeric(duration)) $el.css("transition-duration", "");
                if ($.isPlainObject(to)) {
                    if (to.scaleX !== undefined1 && to.scaleY !== undefined1) self.setTranslate($el, {
                        top: to.top,
                        left: to.left,
                        width: from.width * to.scaleX,
                        height: from.height * to.scaleY,
                        scaleX: 1,
                        scaleY: 1
                    });
                } else if (leaveAnimationName !== true) $el.removeClass(to);
                if ($.isFunction(callback)) callback(e);
            });
            if ($.isNumeric(duration)) $el.css("transition-duration", duration + "ms");
            // Start animation by changing CSS properties or class name
            if ($.isPlainObject(to)) {
                if (to.scaleX !== undefined1 && to.scaleY !== undefined1) {
                    delete to.width;
                    delete to.height;
                    if ($el.parent().hasClass("fancybox-slide--image")) $el.parent().addClass("fancybox-is-scaling");
                }
                $.fancybox.setTranslate($el, to);
            } else $el.addClass(to);
            // Make sure that `transitionend` callback gets fired
            $el.data("timer", setTimeout(function() {
                $el.trigger(transitionEnd);
            }, duration + 33));
        },
        stop: function stop($el, callCallback) {
            if ($el && $el.length) {
                clearTimeout($el.data("timer"));
                if (callCallback) $el.trigger(transitionEnd);
                $el.off(transitionEnd).css("transition-duration", "");
                $el.parent().removeClass("fancybox-is-scaling");
            }
        }
    };
    // Default click handler for "fancyboxed" links
    // ============================================
    function _run(e, opts) {
        var items = [], index = 0, $target, value, instance;
        // Avoid opening multiple times
        if (e && e.isDefaultPrevented()) return;
        e.preventDefault();
        opts = opts || {};
        if (e && e.data) opts = mergeOpts(e.data.options, opts);
        $target = opts.$target || $(e.currentTarget).trigger("blur");
        instance = $.fancybox.getInstance();
        if (instance && instance.$trigger && instance.$trigger.is($target)) return;
        if (opts.selector) items = $(opts.selector);
        else {
            // Get all related items and find index for clicked one
            value = $target.attr("data-fancybox") || "";
            if (value) {
                items = e.data ? e.data.items : [];
                items = items.length ? items.filter('[data-fancybox="' + value + '"]') : $('[data-fancybox="' + value + '"]');
            } else items = [
                $target
            ];
        }
        index = $(items).index($target);
        // Sometimes current item can not be found
        if (index < 0) index = 0;
        instance = $.fancybox.open(items, opts, index);
        // Save last active element
        instance.$trigger = $target;
    }
    // Create a jQuery plugin
    // ======================
    $.fn.fancybox = function(options) {
        var selector;
        options = options || {};
        selector = options.selector || false;
        if (selector) // Use body element instead of document so it executes first
        $("body").off("click.fb-start", selector).on("click.fb-start", selector, {
            options: options
        }, _run);
        else this.off("click.fb-start").on("click.fb-start", {
            items: this,
            options: options
        }, _run);
        return this;
    };
    // Self initializing plugin for all elements having `data-fancybox` attribute
    // ==========================================================================
    $D.on("click.fb-start", "[data-fancybox]", _run);
    // Enable "trigger elements"
    // =========================
    $D.on("click.fb-start", "[data-fancybox-trigger]", function(e) {
        $('[data-fancybox="' + $(this).attr("data-fancybox-trigger") + '"]').eq($(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
            $trigger: $(this)
        });
    });
    // Track focus event for better accessibility styling
    // ==================================================
    (function() {
        var buttonStr = ".fancybox-button", focusStr = "fancybox-focus", $pressed = null;
        $D.on("mousedown mouseup focus blur", buttonStr, function(e) {
            switch(e.type){
                case "mousedown":
                    $pressed = $(this);
                    break;
                case "mouseup":
                    $pressed = null;
                    break;
                case "focusin":
                    $(buttonStr).removeClass(focusStr);
                    if (!$(this).is($pressed) && !$(this).is("[disabled]")) $(this).addClass(focusStr);
                    break;
                case "focusout":
                    $(buttonStr).removeClass(focusStr);
                    break;
            }
        });
    })();
})(window, document, jQuery);
// ==========================================================================
//
// Media
// Adds additional media type support
//
// ==========================================================================
(function($) {
    "use strict";
    // Object containing properties for each media type
    var defaults = {
        youtube: {
            matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
            params: {
                autoplay: 1,
                autohide: 1,
                fs: 1,
                rel: 0,
                hd: 1,
                wmode: "transparent",
                enablejsapi: 1,
                html5: 1
            },
            paramPlace: 8,
            type: "iframe",
            url: "https://www.youtube-nocookie.com/embed/$4",
            thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
        },
        vimeo: {
            matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
            params: {
                autoplay: 1,
                hd: 1,
                show_title: 1,
                show_byline: 1,
                show_portrait: 0,
                fullscreen: 1
            },
            paramPlace: 3,
            type: "iframe",
            url: "//player.vimeo.com/video/$2"
        },
        instagram: {
            matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
            type: "image",
            url: "//$1/p/$2/media/?size=l"
        },
        // Examples:
        // http://maps.google.com/?ll=48.857995,2.294297&spn=0.007666,0.021136&t=m&z=16
        // https://www.google.com/maps/@37.7852006,-122.4146355,14.65z
        // https://www.google.com/maps/@52.2111123,2.9237542,6.61z?hl=en
        // https://www.google.com/maps/place/Googleplex/@37.4220041,-122.0833494,17z/data=!4m5!3m4!1s0x0:0x6c296c66619367e0!8m2!3d37.4219998!4d-122.0840572
        gmap_place: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
            type: "iframe",
            url: function url(rez) {
                return "//maps.google." + rez[2] + "/?ll=" + (rez[9] ? rez[9] + "&z=" + Math.floor(rez[10]) + (rez[12] ? rez[12].replace(/^\//, "&") : "") : rez[12] + "").replace(/\?/, "&") + "&output=" + (rez[12] && rez[12].indexOf("layer=c") > 0 ? "svembed" : "embed");
            }
        },
        // Examples:
        // https://www.google.com/maps/search/Empire+State+Building/
        // https://www.google.com/maps/search/?api=1&query=centurylink+field
        // https://www.google.com/maps/search/?api=1&query=47.5951518,-122.3316393
        gmap_search: {
            matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
            type: "iframe",
            url: function url(rez) {
                return "//maps.google." + rez[2] + "/maps?q=" + rez[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
            }
        }
    };
    // Formats matching url to final form
    var format = function format(url, rez, params) {
        if (!url) return;
        params = params || "";
        if ($.type(params) === "object") params = $.param(params, true);
        $.each(rez, function(key, value) {
            url = url.replace("$" + key, value || "");
        });
        if (params.length) url += (url.indexOf("?") > 0 ? "&" : "?") + params;
        return url;
    };
    $(document).on("objectNeedsType.fb", function(e, instance, item) {
        var url = item.src || "", type = false, media, thumb, rez, params, urlParams, paramObj, provider;
        media = $.extend(true, {}, defaults, item.opts.media);
        // Look for any matching media type
        $.each(media, function(providerName, providerOpts) {
            rez = url.match(providerOpts.matcher);
            if (!rez) return;
            type = providerOpts.type;
            provider = providerName;
            paramObj = {};
            if (providerOpts.paramPlace && rez[providerOpts.paramPlace]) {
                urlParams = rez[providerOpts.paramPlace];
                if (urlParams[0] == "?") urlParams = urlParams.substring(1);
                urlParams = urlParams.split("&");
                for(var m = 0; m < urlParams.length; ++m){
                    var p = urlParams[m].split("=", 2);
                    if (p.length == 2) paramObj[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
                }
            }
            params = $.extend(true, {}, providerOpts.params, item.opts[providerName], paramObj);
            url = $.type(providerOpts.url) === "function" ? providerOpts.url.call(this, rez, params, item) : format(providerOpts.url, rez, params);
            thumb = $.type(providerOpts.thumb) === "function" ? providerOpts.thumb.call(this, rez, params, item) : format(providerOpts.thumb, rez);
            if (providerName === "youtube") url = url.replace(/&t=((\d+)m)?(\d+)s/, function(match, p1, m, s) {
                return "&start=" + ((m ? parseInt(m, 10) * 60 : 0) + parseInt(s, 10));
            });
            else if (providerName === "vimeo") url = url.replace("&%23", "#");
            return false;
        });
        // If it is found, then change content type and update the url
        if (type) {
            if (!item.opts.thumb && !(item.opts.$thumb && item.opts.$thumb.length)) item.opts.thumb = thumb;
            if (type === "iframe") item.opts = $.extend(true, item.opts, {
                iframe: {
                    preload: false,
                    attr: {
                        scrolling: "no"
                    }
                }
            });
            $.extend(item, {
                type: type,
                src: url,
                origSrc: item.src,
                contentSource: provider,
                contentType: type === "image" ? "image" : provider == "gmap_place" || provider == "gmap_search" ? "map" : "video"
            });
        } else if (url) item.type = item.opts.defaultType;
    });
    // Load YouTube/Video API on request to detect when video finished playing
    var VideoAPILoader = {
        youtube: {
            src: "https://www.youtube.com/iframe_api",
            "class": "YT",
            loading: false,
            loaded: false
        },
        vimeo: {
            src: "https://player.vimeo.com/api/player.js",
            "class": "Vimeo",
            loading: false,
            loaded: false
        },
        load: function load(vendor) {
            var _this = this, script;
            if (this[vendor].loaded) {
                setTimeout(function() {
                    _this.done(vendor);
                });
                return;
            }
            if (this[vendor].loading) return;
            this[vendor].loading = true;
            script = document.createElement("script");
            script.type = "text/javascript";
            script.src = this[vendor].src;
            if (vendor === "youtube") window.onYouTubeIframeAPIReady = function() {
                _this[vendor].loaded = true;
                _this.done(vendor);
            };
            else script.onload = function() {
                _this[vendor].loaded = true;
                _this.done(vendor);
            };
            document.body.appendChild(script);
        },
        done: function done(vendor) {
            var instance, $el, player;
            if (vendor === "youtube") delete window.onYouTubeIframeAPIReady;
            instance = $.fancybox.getInstance();
            if (instance) {
                $el = instance.current.$content.find("iframe");
                if (vendor === "youtube" && YT !== undefined && YT) player = new YT.Player($el.attr("id"), {
                    events: {
                        onStateChange: function onStateChange(e) {
                            if (e.data == 0) instance.next();
                        }
                    }
                });
                else if (vendor === "vimeo" && Vimeo !== undefined && Vimeo) {
                    player = new Vimeo.Player($el);
                    player.on("ended", function() {
                        instance.next();
                    });
                }
            }
        }
    };
    $(document).on({
        "afterShow.fb": function(e, instance, current) {
            if (instance.group.length > 1 && (current.contentSource === "youtube" || current.contentSource === "vimeo")) VideoAPILoader.load(current.contentSource);
        }
    });
})(jQuery);
// ==========================================================================
//
// Guestures
// Adds touch guestures, handles click and tap events
//
// ==========================================================================
(function(window1, document1, $) {
    "use strict";
    var requestAFrame = function() {
        return window1.requestAnimationFrame || window1.webkitRequestAnimationFrame || window1.mozRequestAnimationFrame || window1.oRequestAnimationFrame || // if all else fails, use setTimeout
        function(callback) {
            return window1.setTimeout(callback, 1000 / 60);
        };
    }();
    var cancelAFrame = function() {
        return window1.cancelAnimationFrame || window1.webkitCancelAnimationFrame || window1.mozCancelAnimationFrame || window1.oCancelAnimationFrame || function(id) {
            window1.clearTimeout(id);
        };
    }();
    var getPointerXY = function getPointerXY(e) {
        var result = [];
        e = e.originalEvent || e || window1.e;
        e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [
            e
        ];
        for(var key in e){
            if (e[key].pageX) result.push({
                x: e[key].pageX,
                y: e[key].pageY
            });
            else if (e[key].clientX) result.push({
                x: e[key].clientX,
                y: e[key].clientY
            });
        }
        return result;
    };
    var distance = function distance(point2, point1, what) {
        if (!point1 || !point2) return 0;
        if (what === "x") return point2.x - point1.x;
        else if (what === "y") return point2.y - point1.y;
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
    };
    var isClickable = function isClickable($el) {
        if ($el.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || $.isFunction($el.get(0).onclick) || $el.data("selectable")) return true;
        // Check for attributes like data-fancybox-next or data-fancybox-close
        for(var i = 0, atts = $el[0].attributes, n = atts.length; i < n; i++){
            if (atts[i].nodeName.substr(0, 14) === "data-fancybox-") return true;
        }
        return false;
    };
    var hasScrollbars = function hasScrollbars(el) {
        var overflowY = window1.getComputedStyle(el)["overflow-y"], overflowX = window1.getComputedStyle(el)["overflow-x"], vertical = (overflowY === "scroll" || overflowY === "auto") && el.scrollHeight > el.clientHeight, horizontal = (overflowX === "scroll" || overflowX === "auto") && el.scrollWidth > el.clientWidth;
        return vertical || horizontal;
    };
    var isScrollable = function isScrollable($el) {
        var rez = false;
        while(true){
            rez = hasScrollbars($el.get(0));
            if (rez) break;
            $el = $el.parent();
            if (!$el.length || $el.hasClass("fancybox-stage") || $el.is("body")) break;
        }
        return rez;
    };
    var Guestures = function Guestures(instance) {
        var self = this;
        self.instance = instance;
        self.$bg = instance.$refs.bg;
        self.$stage = instance.$refs.stage;
        self.$container = instance.$refs.container;
        self.destroy();
        self.$container.on("touchstart.fb.touch mousedown.fb.touch", $.proxy(self, "ontouchstart"));
    };
    Guestures.prototype.destroy = function() {
        var self = this;
        self.$container.off(".fb.touch");
        $(document1).off(".fb.touch");
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        if (self.tapped) {
            clearTimeout(self.tapped);
            self.tapped = null;
        }
    };
    Guestures.prototype.ontouchstart = function(e) {
        var self = this, $target = $(e.target), instance = self.instance, current = instance.current, $slide = current.$slide, $content = current.$content, isTouchDevice = e.type == "touchstart";
        // Do not respond to both (touch and mouse) events
        if (isTouchDevice) self.$container.off("mousedown.fb.touch");
        // Ignore right click
        if (e.originalEvent && e.originalEvent.button == 2) return;
        // Ignore taping on links, buttons, input elements
        if (!$slide.length || !$target.length || isClickable($target) || isClickable($target.parent())) return;
        // Ignore clicks on the scrollbar
        if (!$target.is("img") && e.originalEvent.clientX > $target[0].clientWidth + $target.offset().left) return;
        // Ignore clicks while zooming or closing
        if (!current || instance.isAnimating || current.$slide.hasClass("fancybox-animated")) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        self.realPoints = self.startPoints = getPointerXY(e);
        if (!self.startPoints.length) return;
        // Allow other scripts to catch touch event if "touch" is set to false
        if (current.touch) e.stopPropagation();
        self.startEvent = e;
        self.canTap = true;
        self.$target = $target;
        self.$content = $content;
        self.opts = current.opts.touch;
        self.isPanning = false;
        self.isSwiping = false;
        self.isZooming = false;
        self.isScrolling = false;
        self.canPan = instance.canPan();
        self.startTime = new Date().getTime();
        self.distanceX = self.distanceY = self.distance = 0;
        self.canvasWidth = Math.round($slide[0].clientWidth);
        self.canvasHeight = Math.round($slide[0].clientHeight);
        self.contentLastPos = null;
        self.contentStartPos = $.fancybox.getTranslate(self.$content) || {
            top: 0,
            left: 0
        };
        self.sliderStartPos = $.fancybox.getTranslate($slide);
        // Since position will be absolute, but we need to make it relative to the stage
        self.stagePos = $.fancybox.getTranslate(instance.$refs.stage);
        self.sliderStartPos.top -= self.stagePos.top;
        self.sliderStartPos.left -= self.stagePos.left;
        self.contentStartPos.top -= self.stagePos.top;
        self.contentStartPos.left -= self.stagePos.left;
        $(document1).off(".fb.touch").on(isTouchDevice ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", $.proxy(self, "ontouchend")).on(isTouchDevice ? "touchmove.fb.touch" : "mousemove.fb.touch", $.proxy(self, "ontouchmove"));
        if ($.fancybox.isMobile) document1.addEventListener("scroll", self.onscroll, true);
        // Skip if clicked outside the sliding area
        if (!(self.opts || self.canPan) || !($target.is(self.$stage) || self.$stage.find($target).length)) {
            if ($target.is(".fancybox-image")) e.preventDefault();
            if (!($.fancybox.isMobile && $target.parents(".fancybox-caption").length)) return;
        }
        self.isScrollable = isScrollable($target) || isScrollable($target.parent());
        // Check if element is scrollable and try to prevent default behavior (scrolling)
        if (!($.fancybox.isMobile && self.isScrollable)) e.preventDefault();
        // One finger or mouse click - swipe or pan an image
        if (self.startPoints.length === 1 || current.hasError) {
            if (self.canPan) {
                $.fancybox.stop(self.$content);
                self.isPanning = true;
            } else self.isSwiping = true;
            self.$container.addClass("fancybox-is-grabbing");
        }
        // Two fingers - zoom image
        if (self.startPoints.length === 2 && current.type === "image" && (current.isLoaded || current.$ghost)) {
            self.canTap = false;
            self.isSwiping = false;
            self.isPanning = false;
            self.isZooming = true;
            $.fancybox.stop(self.$content);
            self.centerPointStartX = (self.startPoints[0].x + self.startPoints[1].x) * 0.5 - $(window1).scrollLeft();
            self.centerPointStartY = (self.startPoints[0].y + self.startPoints[1].y) * 0.5 - $(window1).scrollTop();
            self.percentageOfImageAtPinchPointX = (self.centerPointStartX - self.contentStartPos.left) / self.contentStartPos.width;
            self.percentageOfImageAtPinchPointY = (self.centerPointStartY - self.contentStartPos.top) / self.contentStartPos.height;
            self.startDistanceBetweenFingers = distance(self.startPoints[0], self.startPoints[1]);
        }
    };
    Guestures.prototype.onscroll = function(e) {
        var self = this;
        self.isScrolling = true;
        document1.removeEventListener("scroll", self.onscroll, true);
    };
    Guestures.prototype.ontouchmove = function(e) {
        var self = this;
        // Make sure user has not released over iframe or disabled element
        if (e.originalEvent.buttons !== undefined && e.originalEvent.buttons === 0) {
            self.ontouchend(e);
            return;
        }
        if (self.isScrolling) {
            self.canTap = false;
            return;
        }
        self.newPoints = getPointerXY(e);
        if (!(self.opts || self.canPan) || !self.newPoints.length || !self.newPoints.length) return;
        if (!(self.isSwiping && self.isSwiping === true)) e.preventDefault();
        self.distanceX = distance(self.newPoints[0], self.startPoints[0], "x");
        self.distanceY = distance(self.newPoints[0], self.startPoints[0], "y");
        self.distance = distance(self.newPoints[0], self.startPoints[0]);
        // Skip false ontouchmove events (Chrome)
        if (self.distance > 0) {
            if (self.isSwiping) self.onSwipe(e);
            else if (self.isPanning) self.onPan();
            else if (self.isZooming) self.onZoom();
        }
    };
    Guestures.prototype.onSwipe = function(e) {
        var self = this, instance = self.instance, swiping = self.isSwiping, left = self.sliderStartPos.left || 0, angle;
        // If direction is not yet determined
        if (swiping === true) {
            // We need at least 10px distance to correctly calculate an angle
            if (Math.abs(self.distance) > 10) {
                self.canTap = false;
                if (instance.group.length < 2 && self.opts.vertical) self.isSwiping = "y";
                else if (instance.isDragging || self.opts.vertical === false || self.opts.vertical === "auto" && $(window1).width() > 800) self.isSwiping = "x";
                else {
                    angle = Math.abs(Math.atan2(self.distanceY, self.distanceX) * 180 / Math.PI);
                    self.isSwiping = angle > 45 && angle < 135 ? "y" : "x";
                }
                if (self.isSwiping === "y" && $.fancybox.isMobile && self.isScrollable) {
                    self.isScrolling = true;
                    return;
                }
                instance.isDragging = self.isSwiping;
                // Reset points to avoid jumping, because we dropped first swipes to calculate the angle
                self.startPoints = self.newPoints;
                $.each(instance.slides, function(index, slide) {
                    var slidePos, stagePos;
                    $.fancybox.stop(slide.$slide);
                    slidePos = $.fancybox.getTranslate(slide.$slide);
                    stagePos = $.fancybox.getTranslate(instance.$refs.stage);
                    slide.$slide.css({
                        transform: "",
                        opacity: "",
                        "transition-duration": ""
                    }).removeClass("fancybox-animated").removeClass(function(index, className) {
                        return (className.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
                    });
                    if (slide.pos === instance.current.pos) {
                        self.sliderStartPos.top = slidePos.top - stagePos.top;
                        self.sliderStartPos.left = slidePos.left - stagePos.left;
                    }
                    $.fancybox.setTranslate(slide.$slide, {
                        top: slidePos.top - stagePos.top,
                        left: slidePos.left - stagePos.left
                    });
                });
                // Stop slideshow
                if (instance.SlideShow && instance.SlideShow.isActive) instance.SlideShow.stop();
            }
            return;
        }
        // Sticky edges
        if (swiping == "x") {
            if (self.distanceX > 0 && (self.instance.group.length < 2 || self.instance.current.index === 0 && !self.instance.current.opts.loop)) left = left + Math.pow(self.distanceX, 0.8);
            else if (self.distanceX < 0 && (self.instance.group.length < 2 || self.instance.current.index === self.instance.group.length - 1 && !self.instance.current.opts.loop)) left = left - Math.pow(-self.distanceX, 0.8);
            else left = left + self.distanceX;
        }
        self.sliderLastPos = {
            top: swiping == "x" ? 0 : self.sliderStartPos.top + self.distanceY,
            left: left
        };
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        self.requestId = requestAFrame(function() {
            if (self.sliderLastPos) {
                $.each(self.instance.slides, function(index, slide) {
                    var pos = slide.pos - self.instance.currPos;
                    $.fancybox.setTranslate(slide.$slide, {
                        top: self.sliderLastPos.top,
                        left: self.sliderLastPos.left + pos * self.canvasWidth + pos * slide.opts.gutter
                    });
                });
                self.$container.addClass("fancybox-is-sliding");
            }
        });
    };
    Guestures.prototype.onPan = function() {
        var self = this;
        // Prevent accidental movement (sometimes, when tapping casually, finger can move a bit)
        if (distance(self.newPoints[0], self.realPoints[0]) < ($.fancybox.isMobile ? 10 : 5)) {
            self.startPoints = self.newPoints;
            return;
        }
        self.canTap = false;
        self.contentLastPos = self.limitMovement();
        if (self.requestId) cancelAFrame(self.requestId);
        self.requestId = requestAFrame(function() {
            $.fancybox.setTranslate(self.$content, self.contentLastPos);
        });
    };
    // Make panning sticky to the edges
    Guestures.prototype.limitMovement = function() {
        var self = this;
        var canvasWidth = self.canvasWidth;
        var canvasHeight = self.canvasHeight;
        var distanceX = self.distanceX;
        var distanceY = self.distanceY;
        var contentStartPos = self.contentStartPos;
        var currentOffsetX = contentStartPos.left;
        var currentOffsetY = contentStartPos.top;
        var currentWidth = contentStartPos.width;
        var currentHeight = contentStartPos.height;
        var minTranslateX, minTranslateY, maxTranslateX, maxTranslateY, newOffsetX, newOffsetY;
        if (currentWidth > canvasWidth) newOffsetX = currentOffsetX + distanceX;
        else newOffsetX = currentOffsetX;
        newOffsetY = currentOffsetY + distanceY;
        // Slow down proportionally to traveled distance
        minTranslateX = Math.max(0, canvasWidth * 0.5 - currentWidth * 0.5);
        minTranslateY = Math.max(0, canvasHeight * 0.5 - currentHeight * 0.5);
        maxTranslateX = Math.min(canvasWidth - currentWidth, canvasWidth * 0.5 - currentWidth * 0.5);
        maxTranslateY = Math.min(canvasHeight - currentHeight, canvasHeight * 0.5 - currentHeight * 0.5);
        //   ->
        if (distanceX > 0 && newOffsetX > minTranslateX) newOffsetX = minTranslateX - 1 + Math.pow(-minTranslateX + currentOffsetX + distanceX, 0.8) || 0;
        //    <-
        if (distanceX < 0 && newOffsetX < maxTranslateX) newOffsetX = maxTranslateX + 1 - Math.pow(maxTranslateX - currentOffsetX - distanceX, 0.8) || 0;
        //   \/
        if (distanceY > 0 && newOffsetY > minTranslateY) newOffsetY = minTranslateY - 1 + Math.pow(-minTranslateY + currentOffsetY + distanceY, 0.8) || 0;
        //   /\
        if (distanceY < 0 && newOffsetY < maxTranslateY) newOffsetY = maxTranslateY + 1 - Math.pow(maxTranslateY - currentOffsetY - distanceY, 0.8) || 0;
        return {
            top: newOffsetY,
            left: newOffsetX
        };
    };
    Guestures.prototype.limitPosition = function(newOffsetX, newOffsetY, newWidth, newHeight) {
        var self = this;
        var canvasWidth = self.canvasWidth;
        var canvasHeight = self.canvasHeight;
        if (newWidth > canvasWidth) {
            newOffsetX = newOffsetX > 0 ? 0 : newOffsetX;
            newOffsetX = newOffsetX < canvasWidth - newWidth ? canvasWidth - newWidth : newOffsetX;
        } else // Center horizontally
        newOffsetX = Math.max(0, canvasWidth / 2 - newWidth / 2);
        if (newHeight > canvasHeight) {
            newOffsetY = newOffsetY > 0 ? 0 : newOffsetY;
            newOffsetY = newOffsetY < canvasHeight - newHeight ? canvasHeight - newHeight : newOffsetY;
        } else // Center vertically
        newOffsetY = Math.max(0, canvasHeight / 2 - newHeight / 2);
        return {
            top: newOffsetY,
            left: newOffsetX
        };
    };
    Guestures.prototype.onZoom = function() {
        var self = this;
        // Calculate current distance between points to get pinch ratio and new width and height
        var contentStartPos = self.contentStartPos;
        var currentWidth = contentStartPos.width;
        var currentHeight = contentStartPos.height;
        var currentOffsetX = contentStartPos.left;
        var currentOffsetY = contentStartPos.top;
        var endDistanceBetweenFingers = distance(self.newPoints[0], self.newPoints[1]);
        var pinchRatio = endDistanceBetweenFingers / self.startDistanceBetweenFingers;
        var newWidth = Math.floor(currentWidth * pinchRatio);
        var newHeight = Math.floor(currentHeight * pinchRatio);
        // This is the translation due to pinch-zooming
        var translateFromZoomingX = (currentWidth - newWidth) * self.percentageOfImageAtPinchPointX;
        var translateFromZoomingY = (currentHeight - newHeight) * self.percentageOfImageAtPinchPointY;
        // Point between the two touches
        var centerPointEndX = (self.newPoints[0].x + self.newPoints[1].x) / 2 - $(window1).scrollLeft();
        var centerPointEndY = (self.newPoints[0].y + self.newPoints[1].y) / 2 - $(window1).scrollTop();
        // And this is the translation due to translation of the centerpoint
        // between the two fingers
        var translateFromTranslatingX = centerPointEndX - self.centerPointStartX;
        var translateFromTranslatingY = centerPointEndY - self.centerPointStartY;
        // The new offset is the old/current one plus the total translation
        var newOffsetX = currentOffsetX + (translateFromZoomingX + translateFromTranslatingX);
        var newOffsetY = currentOffsetY + (translateFromZoomingY + translateFromTranslatingY);
        var newPos = {
            top: newOffsetY,
            left: newOffsetX,
            scaleX: pinchRatio,
            scaleY: pinchRatio
        };
        self.canTap = false;
        self.newWidth = newWidth;
        self.newHeight = newHeight;
        self.contentLastPos = newPos;
        if (self.requestId) cancelAFrame(self.requestId);
        self.requestId = requestAFrame(function() {
            $.fancybox.setTranslate(self.$content, self.contentLastPos);
        });
    };
    Guestures.prototype.ontouchend = function(e) {
        var self = this;
        var swiping = self.isSwiping;
        var panning = self.isPanning;
        var zooming = self.isZooming;
        var scrolling = self.isScrolling;
        self.endPoints = getPointerXY(e);
        self.dMs = Math.max(new Date().getTime() - self.startTime, 1);
        self.$container.removeClass("fancybox-is-grabbing");
        $(document1).off(".fb.touch");
        document1.removeEventListener("scroll", self.onscroll, true);
        if (self.requestId) {
            cancelAFrame(self.requestId);
            self.requestId = null;
        }
        self.isSwiping = false;
        self.isPanning = false;
        self.isZooming = false;
        self.isScrolling = false;
        self.instance.isDragging = false;
        if (self.canTap) return self.onTap(e);
        self.speed = 100;
        // Speed in px/ms
        self.velocityX = self.distanceX / self.dMs * 0.5;
        self.velocityY = self.distanceY / self.dMs * 0.5;
        if (panning) self.endPanning();
        else if (zooming) self.endZooming();
        else self.endSwiping(swiping, scrolling);
        return;
    };
    Guestures.prototype.endSwiping = function(swiping, scrolling) {
        var self = this, ret = false, len = self.instance.group.length, distanceX = Math.abs(self.distanceX), canAdvance = swiping == "x" && len > 1 && (self.dMs > 130 && distanceX > 10 || distanceX > 50), speedX = 300;
        self.sliderLastPos = null;
        // Close if swiped vertically / navigate if horizontally
        if (swiping == "y" && !scrolling && Math.abs(self.distanceY) > 50) {
            // Continue vertical movement
            $.fancybox.animate(self.instance.current.$slide, {
                top: self.sliderStartPos.top + self.distanceY + self.velocityY * 150,
                opacity: 0
            }, 200);
            ret = self.instance.close(true, 250);
        } else if (canAdvance && self.distanceX > 0) ret = self.instance.previous(speedX);
        else if (canAdvance && self.distanceX < 0) ret = self.instance.next(speedX);
        if (ret === false && (swiping == "x" || swiping == "y")) self.instance.centerSlide(200);
        self.$container.removeClass("fancybox-is-sliding");
    };
    // Limit panning from edges
    // ========================
    Guestures.prototype.endPanning = function() {
        var self = this, newOffsetX, newOffsetY, newPos;
        if (!self.contentLastPos) return;
        if (self.opts.momentum === false || self.dMs > 350) {
            newOffsetX = self.contentLastPos.left;
            newOffsetY = self.contentLastPos.top;
        } else {
            // Continue movement
            newOffsetX = self.contentLastPos.left + self.velocityX * 500;
            newOffsetY = self.contentLastPos.top + self.velocityY * 500;
        }
        newPos = self.limitPosition(newOffsetX, newOffsetY, self.contentStartPos.width, self.contentStartPos.height);
        newPos.width = self.contentStartPos.width;
        newPos.height = self.contentStartPos.height;
        $.fancybox.animate(self.$content, newPos, 366);
    };
    Guestures.prototype.endZooming = function() {
        var self = this;
        var current = self.instance.current;
        var newOffsetX, newOffsetY, newPos, reset;
        var newWidth = self.newWidth;
        var newHeight = self.newHeight;
        if (!self.contentLastPos) return;
        newOffsetX = self.contentLastPos.left;
        newOffsetY = self.contentLastPos.top;
        reset = {
            top: newOffsetY,
            left: newOffsetX,
            width: newWidth,
            height: newHeight,
            scaleX: 1,
            scaleY: 1
        };
        // Reset scalex/scaleY values; this helps for perfomance and does not break animation
        $.fancybox.setTranslate(self.$content, reset);
        if (newWidth < self.canvasWidth && newHeight < self.canvasHeight) self.instance.scaleToFit(150);
        else if (newWidth > current.width || newHeight > current.height) self.instance.scaleToActual(self.centerPointStartX, self.centerPointStartY, 150);
        else {
            newPos = self.limitPosition(newOffsetX, newOffsetY, newWidth, newHeight);
            $.fancybox.animate(self.$content, newPos, 150);
        }
    };
    Guestures.prototype.onTap = function(e) {
        var self = this;
        var $target = $(e.target);
        var instance = self.instance;
        var current = instance.current;
        var endPoints = e && getPointerXY(e) || self.startPoints;
        var tapX = endPoints[0] ? endPoints[0].x - $(window1).scrollLeft() - self.stagePos.left : 0;
        var tapY = endPoints[0] ? endPoints[0].y - $(window1).scrollTop() - self.stagePos.top : 0;
        var where;
        var process = function process(prefix) {
            var action = current.opts[prefix];
            if ($.isFunction(action)) action = action.apply(instance, [
                current,
                e
            ]);
            if (!action) return;
            switch(action){
                case "close":
                    instance.close(self.startEvent);
                    break;
                case "toggleControls":
                    instance.toggleControls();
                    break;
                case "next":
                    instance.next();
                    break;
                case "nextOrClose":
                    if (instance.group.length > 1) instance.next();
                    else instance.close(self.startEvent);
                    break;
                case "zoom":
                    if (current.type == "image" && (current.isLoaded || current.$ghost)) {
                        if (instance.canPan()) instance.scaleToFit();
                        else if (instance.isScaledDown()) instance.scaleToActual(tapX, tapY);
                        else if (instance.group.length < 2) instance.close(self.startEvent);
                    }
                    break;
            }
        };
        // Ignore right click
        if (e.originalEvent && e.originalEvent.button == 2) return;
        // Skip if clicked on the scrollbar
        if (!$target.is("img") && tapX > $target[0].clientWidth + $target.offset().left) return;
        // Check where is clicked
        if ($target.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) where = "Outside";
        else if ($target.is(".fancybox-slide")) where = "Slide";
        else if (instance.current.$content && instance.current.$content.find($target).addBack().filter($target).length) where = "Content";
        else return;
        // Check if this is a double tap
        if (self.tapped) {
            // Stop previously created single tap
            clearTimeout(self.tapped);
            self.tapped = null;
            // Skip if distance between taps is too big
            if (Math.abs(tapX - self.tapX) > 50 || Math.abs(tapY - self.tapY) > 50) return this;
            // OK, now we assume that this is a double-tap
            process("dblclick" + where);
        } else {
            // Single tap will be processed if user has not clicked second time within 300ms
            // or there is no need to wait for double-tap
            self.tapX = tapX;
            self.tapY = tapY;
            if (current.opts["dblclick" + where] && current.opts["dblclick" + where] !== current.opts["click" + where]) self.tapped = setTimeout(function() {
                self.tapped = null;
                if (!instance.isAnimating) process("click" + where);
            }, 500);
            else process("click" + where);
        }
        return this;
    };
    $(document1).on("onActivate.fb", function(e, instance) {
        if (instance && !instance.Guestures) instance.Guestures = new Guestures(instance);
    }).on("beforeClose.fb", function(e, instance) {
        if (instance && instance.Guestures) instance.Guestures.destroy();
    });
})(window, document, jQuery);
// ==========================================================================
//
// SlideShow
// Enables slideshow functionality
//
// Example of usage:
// $.fancybox.getInstance().SlideShow.start()
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    $.extend(true, $.fancybox.defaults, {
        btnTpl: {
            slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
        },
        slideShow: {
            autoStart: false,
            speed: 3000,
            progress: true
        }
    });
    var SlideShow = function SlideShow(instance) {
        this.instance = instance;
        this.init();
    };
    $.extend(SlideShow.prototype, {
        timer: null,
        isActive: false,
        $button: null,
        init: function init() {
            var self = this, instance = self.instance, opts = instance.group[instance.currIndex].opts.slideShow;
            self.$button = instance.$refs.toolbar.find("[data-fancybox-play]").on("click", function() {
                self.toggle();
            });
            if (instance.group.length < 2 || !opts) self.$button.hide();
            else if (opts.progress) self.$progress = $('<div class="fancybox-progress"></div>').appendTo(instance.$refs.inner);
        },
        set: function set(force) {
            var self = this, instance = self.instance, current = instance.current;
            // Check if reached last element
            if (current && (force === true || current.opts.loop || instance.currIndex < instance.group.length - 1)) {
                if (self.isActive && current.contentType !== "video") {
                    if (self.$progress) $.fancybox.animate(self.$progress.show(), {
                        scaleX: 1
                    }, current.opts.slideShow.speed);
                    self.timer = setTimeout(function() {
                        if (!instance.current.opts.loop && instance.current.index == instance.group.length - 1) instance.jumpTo(0);
                        else instance.next();
                    }, current.opts.slideShow.speed);
                }
            } else {
                self.stop();
                instance.idleSecondsCounter = 0;
                instance.showControls();
            }
        },
        clear: function clear() {
            var self = this;
            clearTimeout(self.timer);
            self.timer = null;
            if (self.$progress) self.$progress.removeAttr("style").hide();
        },
        start: function start() {
            var self = this, current = self.instance.current;
            if (current) {
                self.$button.attr("title", (current.opts.i18n[current.opts.lang] || current.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause");
                self.isActive = true;
                if (current.isComplete) self.set(true);
                self.instance.trigger("onSlideShowChange", true);
            }
        },
        stop: function stop() {
            var self = this, current = self.instance.current;
            self.clear();
            self.$button.attr("title", (current.opts.i18n[current.opts.lang] || current.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play");
            self.isActive = false;
            self.instance.trigger("onSlideShowChange", false);
            if (self.$progress) self.$progress.removeAttr("style").hide();
        },
        toggle: function toggle() {
            var self = this;
            if (self.isActive) self.stop();
            else self.start();
        }
    });
    $(document1).on({
        "onInit.fb": function(e, instance) {
            if (instance && !instance.SlideShow) instance.SlideShow = new SlideShow(instance);
        },
        "beforeShow.fb": function(e, instance, current, firstRun) {
            var SlideShow = instance && instance.SlideShow;
            if (firstRun) {
                if (SlideShow && current.opts.slideShow.autoStart) SlideShow.start();
            } else if (SlideShow && SlideShow.isActive) SlideShow.clear();
        },
        "afterShow.fb": function(e, instance, current) {
            var SlideShow = instance && instance.SlideShow;
            if (SlideShow && SlideShow.isActive) SlideShow.set();
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            var SlideShow = instance && instance.SlideShow;
            // "P" or Spacebar
            if (SlideShow && current.opts.slideShow && (keycode === 80 || keycode === 32) && !$(document1.activeElement).is("button,a,input")) {
                keypress.preventDefault();
                SlideShow.toggle();
            }
        },
        "beforeClose.fb onDeactivate.fb": function(e, instance) {
            var SlideShow = instance && instance.SlideShow;
            if (SlideShow) SlideShow.stop();
        }
    });
    // Page Visibility API to pause slideshow when window is not active
    $(document1).on("visibilitychange", function() {
        var instance = $.fancybox.getInstance(), SlideShow = instance && instance.SlideShow;
        if (SlideShow && SlideShow.isActive) {
            if (document1.hidden) SlideShow.clear();
            else SlideShow.set();
        }
    });
})(document, jQuery);
// ==========================================================================
//
// FullScreen
// Adds fullscreen functionality
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    // Collection of methods supported by user browser
    var fn = function() {
        var fnMap = [
            [
                "requestFullscreen",
                "exitFullscreen",
                "fullscreenElement",
                "fullscreenEnabled",
                "fullscreenchange",
                "fullscreenerror"
            ],
            // new WebKit
            [
                "webkitRequestFullscreen",
                "webkitExitFullscreen",
                "webkitFullscreenElement",
                "webkitFullscreenEnabled",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            // old WebKit (Safari 5.1)
            [
                "webkitRequestFullScreen",
                "webkitCancelFullScreen",
                "webkitCurrentFullScreenElement",
                "webkitCancelFullScreen",
                "webkitfullscreenchange",
                "webkitfullscreenerror"
            ],
            [
                "mozRequestFullScreen",
                "mozCancelFullScreen",
                "mozFullScreenElement",
                "mozFullScreenEnabled",
                "mozfullscreenchange",
                "mozfullscreenerror"
            ],
            [
                "msRequestFullscreen",
                "msExitFullscreen",
                "msFullscreenElement",
                "msFullscreenEnabled",
                "MSFullscreenChange",
                "MSFullscreenError"
            ]
        ];
        var ret = {};
        for(var i = 0; i < fnMap.length; i++){
            var val = fnMap[i];
            if (val && val[1] in document1) {
                for(var j = 0; j < val.length; j++)ret[fnMap[0][j]] = val[j];
                return ret;
            }
        }
        return false;
    }();
    if (fn) {
        var FullScreen = {
            request: function request(elem) {
                elem = elem || document1.documentElement;
                elem[fn.requestFullscreen](elem.ALLOW_KEYBOARD_INPUT);
            },
            exit: function exit() {
                document1[fn.exitFullscreen]();
            },
            toggle: function toggle(elem) {
                elem = elem || document1.documentElement;
                if (this.isFullscreen()) this.exit();
                else this.request(elem);
            },
            isFullscreen: function isFullscreen() {
                return Boolean(document1[fn.fullscreenElement]);
            },
            enabled: function enabled() {
                return Boolean(document1[fn.fullscreenEnabled]);
            }
        };
        $.extend(true, $.fancybox.defaults, {
            btnTpl: {
                fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
            },
            fullScreen: {
                autoStart: false
            }
        });
        $(document1).on(fn.fullscreenchange, function() {
            var isFullscreen = FullScreen.isFullscreen(), instance = $.fancybox.getInstance();
            if (instance) {
                // If image is zooming, then force to stop and reposition properly
                if (instance.current && instance.current.type === "image" && instance.isAnimating) {
                    instance.isAnimating = false;
                    instance.update(true, true, 0);
                    if (!instance.isComplete) instance.complete();
                }
                instance.trigger("onFullscreenChange", isFullscreen);
                instance.$refs.container.toggleClass("fancybox-is-fullscreen", isFullscreen);
                instance.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !isFullscreen).toggleClass("fancybox-button--fsexit", isFullscreen);
            }
        });
    }
    $(document1).on({
        "onInit.fb": function(e, instance) {
            var $container;
            if (!fn) {
                instance.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
                return;
            }
            if (instance && instance.group[instance.currIndex].opts.fullScreen) {
                $container = instance.$refs.container;
                $container.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    FullScreen.toggle();
                });
                if (instance.opts.fullScreen && instance.opts.fullScreen.autoStart === true) FullScreen.request();
                // Expose API
                instance.FullScreen = FullScreen;
            } else if (instance) instance.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            // "F"
            if (instance && instance.FullScreen && keycode === 70) {
                keypress.preventDefault();
                instance.FullScreen.toggle();
            }
        },
        "beforeClose.fb": function(e, instance) {
            if (instance && instance.FullScreen && instance.$refs.container.hasClass("fancybox-is-fullscreen")) FullScreen.exit();
        }
    });
})(document, jQuery);
// ==========================================================================
//
// Thumbs
// Displays thumbnails in a grid
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    var CLASS = "fancybox-thumbs", CLASS_ACTIVE = CLASS + "-active";
    // Make sure there are default values
    $.fancybox.defaults = $.extend(true, {
        btnTpl: {
            thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
        },
        thumbs: {
            autoStart: false,
            hideOnClose: true,
            parentEl: ".fancybox-container",
            axis: "y" // Vertical (y) or horizontal (x) scrolling
        }
    }, $.fancybox.defaults);
    var FancyThumbs = function FancyThumbs(instance) {
        this.init(instance);
    };
    $.extend(FancyThumbs.prototype, {
        $button: null,
        $grid: null,
        $list: null,
        isVisible: false,
        isActive: false,
        init: function init(instance) {
            var self = this, group = instance.group, enabled = 0;
            self.instance = instance;
            self.opts = group[instance.currIndex].opts.thumbs;
            instance.Thumbs = self;
            self.$button = instance.$refs.toolbar.find("[data-fancybox-thumbs]");
            // Enable thumbs if at least two group items have thumbnails
            for(var i = 0, len = group.length; i < len; i++){
                if (group[i].thumb) enabled++;
                if (enabled > 1) break;
            }
            if (enabled > 1 && !!self.opts) {
                self.$button.removeAttr("style").on("click", function() {
                    self.toggle();
                });
                self.isActive = true;
            } else self.$button.hide();
        },
        create: function create() {
            var self = this, instance = self.instance, parentEl = self.opts.parentEl, list = [], src;
            if (!self.$grid) {
                // Create main element
                self.$grid = $('<div class="' + CLASS + " " + CLASS + "-" + self.opts.axis + '"></div>').appendTo(instance.$refs.container.find(parentEl).addBack().filter(parentEl));
                // Add "click" event that performs gallery navigation
                self.$grid.on("click", "a", function() {
                    instance.jumpTo($(this).attr("data-index"));
                });
            }
            // Build the list
            if (!self.$list) self.$list = $('<div class="' + CLASS + '__list">').appendTo(self.$grid);
            $.each(instance.group, function(i, item) {
                src = item.thumb;
                if (!src && item.type === "image") src = item.src;
                list.push('<a href="javascript:;" tabindex="0" data-index="' + i + '"' + (src && src.length ? ' style="background-image:url(' + src + ')"' : 'class="fancybox-thumbs-missing"') + "></a>");
            });
            self.$list[0].innerHTML = list.join("");
            if (self.opts.axis === "x") // Set fixed width for list element to enable horizontal scrolling
            self.$list.width(parseInt(self.$grid.css("padding-right"), 10) + instance.group.length * self.$list.children().eq(0).outerWidth(true));
        },
        focus: function focus(duration) {
            var self = this, $list = self.$list, $grid = self.$grid, thumb, thumbPos;
            if (!self.instance.current) return;
            thumb = $list.children().removeClass(CLASS_ACTIVE).filter('[data-index="' + self.instance.current.index + '"]').addClass(CLASS_ACTIVE);
            thumbPos = thumb.position();
            // Check if need to scroll to make current thumb visible
            if (self.opts.axis === "y" && (thumbPos.top < 0 || thumbPos.top > $list.height() - thumb.outerHeight())) $list.stop().animate({
                scrollTop: $list.scrollTop() + thumbPos.top
            }, duration);
            else if (self.opts.axis === "x" && (thumbPos.left < $grid.scrollLeft() || thumbPos.left > $grid.scrollLeft() + ($grid.width() - thumb.outerWidth()))) $list.parent().stop().animate({
                scrollLeft: thumbPos.left
            }, duration);
        },
        update: function update() {
            var that = this;
            that.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible);
            if (that.isVisible) {
                if (!that.$grid) that.create();
                that.instance.trigger("onThumbsShow");
                that.focus(0);
            } else if (that.$grid) that.instance.trigger("onThumbsHide");
            // Update content position
            that.instance.update();
        },
        hide: function hide() {
            this.isVisible = false;
            this.update();
        },
        show: function show() {
            this.isVisible = true;
            this.update();
        },
        toggle: function toggle() {
            this.isVisible = !this.isVisible;
            this.update();
        }
    });
    $(document1).on({
        "onInit.fb": function(e, instance) {
            var Thumbs;
            if (instance && !instance.Thumbs) {
                Thumbs = new FancyThumbs(instance);
                if (Thumbs.isActive && Thumbs.opts.autoStart === true) Thumbs.show();
            }
        },
        "beforeShow.fb": function(e, instance, item, firstRun) {
            var Thumbs = instance && instance.Thumbs;
            if (Thumbs && Thumbs.isVisible) Thumbs.focus(firstRun ? 0 : 250);
        },
        "afterKeydown.fb": function(e, instance, current, keypress, keycode) {
            var Thumbs = instance && instance.Thumbs;
            // "G"
            if (Thumbs && Thumbs.isActive && keycode === 71) {
                keypress.preventDefault();
                Thumbs.toggle();
            }
        },
        "beforeClose.fb": function(e, instance) {
            var Thumbs = instance && instance.Thumbs;
            if (Thumbs && Thumbs.isVisible && Thumbs.opts.hideOnClose !== false) Thumbs.$grid.hide();
        }
    });
})(document, jQuery);
//// ==========================================================================
//
// Share
// Displays simple form for sharing current url
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    $.extend(true, $.fancybox.defaults, {
        btnTpl: {
            share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
        },
        share: {
            url: function url(instance, item) {
                return (!instance.currentHash && !(item.type === "inline" || item.type === "html") ? item.origSrc || item.src : false) || window.location;
            },
            tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
        }
    });
    function escapeHtml(string) {
        var entityMap = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
            "`": "&#x60;",
            "=": "&#x3D;"
        };
        return String(string).replace(/[&<>"'`=\/]/g, function(s) {
            return entityMap[s];
        });
    }
    $(document1).on("click", "[data-fancybox-share]", function() {
        var instance = $.fancybox.getInstance(), current = instance.current || null, url, tpl;
        if (!current) return;
        if ($.type(current.opts.share.url) === "function") url = current.opts.share.url.apply(current, [
            instance,
            current
        ]);
        tpl = current.opts.share.tpl.replace(/\{\{media\}\}/g, current.type === "image" ? encodeURIComponent(current.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(url)).replace(/\{\{url_raw\}\}/g, escapeHtml(url)).replace(/\{\{descr\}\}/g, instance.$caption ? encodeURIComponent(instance.$caption.text()) : "");
        $.fancybox.open({
            src: instance.translate(instance, tpl),
            type: "html",
            opts: {
                touch: false,
                animationEffect: false,
                afterLoad: function afterLoad(shareInstance, shareCurrent) {
                    // Close self if parent instance is closing
                    instance.$refs.container.one("beforeClose.fb", function() {
                        shareInstance.close(null, 0);
                    });
                    // Opening links in a popup window
                    shareCurrent.$content.find(".fancybox-share__button").click(function() {
                        window.open(this.href, "Share", "width=550, height=450");
                        return false;
                    });
                },
                mobile: {
                    autoFocus: false
                }
            }
        });
    });
})(document, jQuery);
// ==========================================================================
//
// Hash
// Enables linking to each modal
//
// ==========================================================================
(function(window1, document1, $) {
    "use strict";
    // Simple $.escapeSelector polyfill (for jQuery prior v3)
    if (!$.escapeSelector) $.escapeSelector = function(sel) {
        var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
        var fcssescape = function fcssescape(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        };
        return (sel + "").replace(rcssescape, fcssescape);
    };
    // Get info about gallery name and current index from url
    function parseUrl() {
        var hash = window1.location.hash.substr(1), rez = hash.split("-"), index = rez.length > 1 && /^\+?\d+$/.test(rez[rez.length - 1]) ? parseInt(rez.pop(-1), 10) || 1 : 1, gallery = rez.join("-");
        return {
            hash: hash,
            /* Index is starting from 1 */ index: index < 1 ? 1 : index,
            gallery: gallery
        };
    }
    // Trigger click evnt on links to open new fancyBox instance
    function triggerFromUrl(url) {
        if (url.gallery !== "") // If we can find element matching 'data-fancybox' atribute,
        // then triggering click event should start fancyBox
        $("[data-fancybox='" + $.escapeSelector(url.gallery) + "']").eq(url.index - 1).focus().trigger("click.fb-start");
    }
    // Get gallery name from current instance
    function getGalleryID(instance) {
        var opts, ret;
        if (!instance) return false;
        opts = instance.current ? instance.current.opts : instance.opts;
        ret = opts.hash || (opts.$orig ? opts.$orig.data("fancybox") || opts.$orig.data("fancybox-trigger") : "");
        return ret === "" ? false : ret;
    }
    // Start when DOM becomes ready
    $(function() {
        // Check if user has disabled this module
        if ($.fancybox.defaults.hash === false) return;
        // Update hash when opening/closing fancyBox
        $(document1).on({
            "onInit.fb": function(e, instance) {
                var url, gallery;
                if (instance.group[instance.currIndex].opts.hash === false) return;
                url = parseUrl();
                gallery = getGalleryID(instance);
                // Make sure gallery start index matches index from hash
                if (gallery && url.gallery && gallery == url.gallery) instance.currIndex = url.index - 1;
            },
            "beforeShow.fb": function(e, instance, current, firstRun) {
                var gallery;
                if (!current || current.opts.hash === false) return;
                // Check if need to update window hash
                gallery = getGalleryID(instance);
                if (!gallery) return;
                // Variable containing last hash value set by fancyBox
                // It will be used to determine if fancyBox needs to close after hash change is detected
                instance.currentHash = gallery + (instance.group.length > 1 ? "-" + (current.index + 1) : "");
                // If current hash is the same (this instance most likely is opened by hashchange), then do nothing
                if (window1.location.hash === "#" + instance.currentHash) return;
                if (firstRun && !instance.origHash) instance.origHash = window1.location.hash;
                if (instance.hashTimer) clearTimeout(instance.hashTimer);
                // Update hash
                instance.hashTimer = setTimeout(function() {
                    if ("replaceState" in window1.history) {
                        window1.history[firstRun ? "pushState" : "replaceState"]({}, document1.title, window1.location.pathname + window1.location.search + "#" + instance.currentHash);
                        if (firstRun) instance.hasCreatedHistory = true;
                    } else window1.location.hash = instance.currentHash;
                    instance.hashTimer = null;
                }, 300);
            },
            "beforeClose.fb": function(e, instance, current) {
                if (!current || current.opts.hash === false) return;
                clearTimeout(instance.hashTimer);
                // Goto previous history entry
                if (instance.currentHash && instance.hasCreatedHistory) window1.history.back();
                else if (instance.currentHash) {
                    if ("replaceState" in window1.history) window1.history.replaceState({}, document1.title, window1.location.pathname + window1.location.search + (instance.origHash || ""));
                    else window1.location.hash = instance.origHash;
                }
                instance.currentHash = null;
            }
        });
        // Check if need to start/close after url has changed
        $(window1).on("hashchange.fb", function() {
            var url = parseUrl(), fb = null;
            // Find last fancyBox instance that has "hash"
            $.each($(".fancybox-container").get().reverse(), function(index, value) {
                var tmp = $(value).data("FancyBox");
                if (tmp && tmp.currentHash) {
                    fb = tmp;
                    return false;
                }
            });
            if (fb) // Now, compare hash values
            {
                if (fb.currentHash !== url.gallery + "-" + url.index && !(url.index === 1 && fb.currentHash == url.gallery)) {
                    fb.currentHash = null;
                    fb.close();
                }
            } else if (url.gallery !== "") triggerFromUrl(url);
        });
        // Check current hash and trigger click event on matching element to start fancyBox, if needed
        setTimeout(function() {
            if (!$.fancybox.getInstance()) triggerFromUrl(parseUrl());
        }, 50);
    });
})(window, document, jQuery);
// ==========================================================================
//
// Wheel
// Basic mouse weheel support for gallery navigation
//
// ==========================================================================
(function(document1, $) {
    "use strict";
    var prevTime = new Date().getTime();
    $(document1).on({
        "onInit.fb": function(e, instance, current) {
            instance.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function(e) {
                var current = instance.current, currTime = new Date().getTime();
                if (instance.group.length < 2 || current.opts.wheel === false || current.opts.wheel === "auto" && current.type !== "image") return;
                e.preventDefault();
                e.stopPropagation();
                if (current.$slide.hasClass("fancybox-animated")) return;
                e = e.originalEvent || e;
                if (currTime - prevTime < 250) return;
                prevTime = currTime;
                instance[(-e.deltaY || -e.deltaX || e.wheelDelta || -e.detail) < 0 ? "next" : "previous"]();
            });
        }
    });
})(document, jQuery);


(0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(document).ready(function() {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".zoomslider").length) {
        var slideCounter = function slideCounter(item) {
            $sliderItemCurrent.text(item.currentSlide + 1);
            $sliderItemTotal.text(item.count);
        };
        var $sliderItemTotal = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".slider-item-total"), $sliderItemCurrent = (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".slider-item-current");
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))(".zoomslider").flexslider({
            animation: "slide",
            controlNav: false,
            touch: true,
            slideshow: false,
            start: function start(item) {
                slideCounter(item);
            },
            after: function after(item) {
                slideCounter(item);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($4w9fm)))().fancybox({
            selector: ".slides li:not(.clone) a",
            buttons: [
                "zoom",
                //"share",
                // "slideShow",
                //"fullScreen",
                //"download",
                "thumbs",
                "close"
            ],
            transitionEffect: "slide",
            hash: false,
            share: false,
            thumbs: {
                autoStart: false
            }
        });
    }
});
window.exposemap = function() {
    clearInterval(window.googleCheck);
    if (document.getElementById("exposemap")) {
        var map = new google.maps.Map(document.getElementById("exposemap"), {
            zoom: 17,
            scrollwheel: false,
            // Es gibt keine lat und lng in diesem Fall -> Adresse wird verwendet
            center: new google.maps.LatLng(document.getElementById("exposemap").getAttribute("data-lng"), document.getElementById("exposemap").getAttribute("data-lat")),
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    featureType: "administrative",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100"
                        }
                    ]
                },
                {
                    featureType: "administrative.province",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "landscape",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100
                        },
                        {
                            lightness: 65
                        },
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "poi",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100
                        },
                        {
                            lightness: "50"
                        },
                        {
                            visibility: "off"
                        }
                    ]
                },
                {
                    featureType: "road",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: "-100"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "all",
                    stylers: [
                        {
                            visibility: "simplified"
                        }
                    ]
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            lightness: "-13"
                        }
                    ]
                },
                {
                    featureType: "road.arterial",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "20"
                        }
                    ]
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            lightness: "-21"
                        }
                    ]
                },
                {
                    featureType: "road.local",
                    elementType: "all",
                    stylers: [
                        {
                            lightness: "30"
                        }
                    ]
                },
                {
                    featureType: "transit",
                    elementType: "all",
                    stylers: [
                        {
                            saturation: -100
                        },
                        {
                            visibility: "simplified"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [
                        {
                            hue: "#ffff00"
                        },
                        {
                            lightness: -25
                        },
                        {
                            saturation: -97
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry.fill",
                    stylers: [
                        {
                            visibility: "on"
                        },
                        {
                            saturation: "-54"
                        },
                        {
                            lightness: "35"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "geometry.stroke",
                    stylers: [
                        {
                            visibility: "on"
                        }
                    ]
                },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [
                        {
                            lightness: -25
                        },
                        {
                            saturation: -100
                        }
                    ]
                }
            ]
        });
        var strasse = document.getElementById("exposemap").getAttribute("data-street"); // strasse
        var address = document.getElementById("exposemap").getAttribute("data-address"); // stadt
        var miete = document.getElementById("exposemap").getAttribute("data-miete"); // miete
        var qm = document.getElementById("exposemap").getAttribute("data-qm"); // qm Fläche
        var zimmer = document.getElementById("exposemap").getAttribute("data-zimmer"); // zimmer
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            address: address + ", " + strasse + ", Germany"
        }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                // locations.push(results[0].geometry.location);
                //locations[i] = results[0].geometry.location;
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location,
                    // url: document.getElementById('exposemapmarker').getAttribute('src'),
                    labelOrigin: new google.maps.Point(0, 0)
                });
                var infoText = "<div class='g-map-bubble'><ul><li>" + strasse + "<br/>" + address + "</li><li>Kaltmiete: " + miete + "</li><li>Wohnfl\xe4che: " + qm + "</li><li>Zimmer: " + zimmer + "</li></div>";
                var infowindow = new google.maps.InfoWindow({
                    content: infoText
                });
                google.maps.event.addListener(marker, "click", function() {
                    infowindow.open(map, marker);
                });
                // addMarker(marker);
                map.setCenter(results[0].geometry.location);
                map.setZoom(17);
            } else alert("Geocode was not successful for the following reason: " + status);
        });
    }
};
window.deferGoogle = function(callback) {
    window.googleCheck = setInterval(function() {
        if (typeof window.google !== "undefined") {
            clearInterval(window.googleCheck);
            if (typeof window[callback] === "function") // console.log('callback');
            window[callback]();
        }
    }, 100);
}; /*if(document.querySelector("#exposemap") != null){
    setTimeout(function() {
        exposemap();
    }, 500);
    deferGoogle(exposemap);  
    
} */ 



})();
//# sourceMappingURL=modules.js.map
